import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** String in Base64 */
  Base64: { input: any; output: any; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  CFDateTime: { input: any; output: any; }
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  CFDimension: { input: any; output: any; }
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  CFHexColor: { input: any; output: any; }
  /** JSON Object scalar from Contentful */
  CFJSON: { input: any; output: any; }
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  CFQuality: { input: any; output: any; }
  /** Date custom scalar type. Format YYYY-MM-DD */
  Date: { input: any; output: any; }
  /** DateTime custom scalar type. Format YYYY-MM-DD HH:mm:ss */
  DateTime: { input: any; output: any; }
  /** Decimal custom scalar with a string representation */
  Decimal: { input: any; output: any; }
  /** Represents a feature managment condition expression */
  FeatureManagementCondition: { input: any; output: any; }
  /** Represents the result of a feature */
  FeatureManagementResult: { input: any; output: any; }
  /** The `UUID` scalar type represents UUID values as specified by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any; }
};

export type ActivateDigitalGiftCardInput = {
  linkCode: Scalars['String']['input'];
};

export type AdConfig = {
  __typename?: 'AdConfig';
  impressionEvents: Maybe<Array<Maybe<ImpressionEvent>>>;
  sponsor: Scalars['String']['output'];
};

export type AdConfigType = {
  __typename?: 'AdConfigType';
  impressionEvents: Maybe<Array<Maybe<ImpressionEventType>>>;
  sponsor: Maybe<Scalars['String']['output']>;
};

export type AddBillingDetails = {
  address1: Scalars['String']['input'];
  address2: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: InputMaybe<Scalars['String']['input']>;
  postCode: Scalars['String']['input'];
  state: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};

export type AddLoyaltyProgramMembershipInput = {
  barcodeValue: InputMaybe<Scalars['String']['input']>;
  cardNumber: InputMaybe<Scalars['String']['input']>;
  contentfulLoyaltyProgramId: InputMaybe<Scalars['String']['input']>;
  customCardName: InputMaybe<Scalars['String']['input']>;
  membershipNumber: InputMaybe<Scalars['String']['input']>;
  scannedBarcodeFormat: InputMaybe<Scalars['String']['input']>;
  scentregroupId: InputMaybe<Scalars['String']['input']>;
};

export type AddNoteToOrderInput = {
  note: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type AddPlateInput = {
  currentCentreId: Scalars['String']['input'];
  plate: Scalars['String']['input'];
  registeredIn: Scalars['String']['input'];
};

/** Input for adding a product to a cart. */
export type AddProductToCartInput = {
  /** The optional id of the cart to add to. If not provided a new cart will be created. */
  id: InputMaybe<Scalars['ID']['input']>;
  /** Optional itemId for cart product updates. When provided an update will be attempted, when omitted a new item will be created and added to the cart */
  itemId: InputMaybe<Scalars['UUID']['input']>;
  /** The `MarketplaceItem` to add to the cart. */
  marketplaceItem: InputMaybe<MarketplaceItemInput>;
  /** The `PhysicalGiftCardItem` to add to the cart. */
  physicalGiftCardItem: InputMaybe<PhysicalGiftCardItemInput>;
  /** The `ProductItem` to add to the cart. */
  productItem: InputMaybe<ProductItemInput>;
  /** The `VirtualGiftCardItem` to add to the cart. */
  virtualGiftCardItem: InputMaybe<VirtualGiftCardItemInput>;
};

export type AddSavedCardIframe = {
  __typename?: 'AddSavedCardIframe';
  sessionId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  stateCode: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type AddressDetails = {
  __typename?: 'AddressDetails';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The last time this address was made the default */
  defaultAt: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  /** Identifier of this address */
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressInput = {
  /** Country (code) */
  country: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Postcode */
  postcode: Scalars['String']['input'];
  /** State */
  state: Scalars['String']['input'];
  /** Street number and name */
  streetAddress: Scalars['String']['input'];
  /** Suburb */
  suburb: Scalars['String']['input'];
};

export type AddressPrediction = {
  __typename?: 'AddressPrediction';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AddressPredictionDetails = {
  __typename?: 'AddressPredictionDetails';
  country: Scalars['String']['output'];
  countryIso2: Scalars['String']['output'];
  municipality: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  postcodeSuburbMatch: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type ApplePushProvisioning = {
  __typename?: 'ApplePushProvisioning';
  activationData: Scalars['Base64']['output'];
  encryptedPassData: Scalars['Base64']['output'];
  ephemeralPublicKey: Scalars['Base64']['output'];
};

export type ApplePushProvisioningCertificates = {
  leafCertificate: Scalars['Base64']['input'];
  subCACertificate: Scalars['Base64']['input'];
};

export type ApplyParkingCinemaValidation = {
  centreId: Scalars['String']['input'];
  otp: Array<Scalars['String']['input']>;
};

export type AustralianSuburb = {
  __typename?: 'AustralianSuburb';
  coordinate: Maybe<Coordinate>;
  name: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type AustralianSuburbInput = {
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export enum Auth0ConnectionType {
  Password = 'PASSWORD',
  Passwordless = 'PASSWORDLESS'
}

export type Auth0Customer = {
  __typename?: 'Auth0Customer';
  defaultConnection: Maybe<Auth0ConnectionType>;
};

export enum BigCommerceOrderStatus {
  AwaitingFulfillment = 'AWAITING_FULFILLMENT',
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingPickup = 'AWAITING_PICKUP',
  AwaitingShipment = 'AWAITING_SHIPMENT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Dispute = 'DISPUTE',
  Incomplete = 'INCOMPLETE',
  ManualVerificationRequired = 'MANUAL_VERIFICATION_REQUIRED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Shipped = 'SHIPPED'
}

export type BookingInfoFailure = {
  __typename?: 'BookingInfoFailure';
  errorCategory: Maybe<BookingInfoFailureMessage>;
};

export enum BookingInfoFailureMessage {
  NoSuchBookableEvent = 'NO_SUCH_BOOKABLE_EVENT',
  OccurrencesRequired = 'OCCURRENCES_REQUIRED',
  SingleCentreRequired = 'SINGLE_CENTRE_REQUIRED',
  UnexpectedRequestShape = 'UNEXPECTED_REQUEST_SHAPE'
}

export type BookingInfoResult = BookingInfoFailure | BookingInfoServerError | BookingInfoSetupError | BookingInfoSuccess;

export type BookingInfoServerError = {
  __typename?: 'BookingInfoServerError';
  errorCategory: Maybe<BookingInfoServerErrorMessage>;
};

export enum BookingInfoServerErrorMessage {
  ServerError = 'SERVER_ERROR'
}

export type BookingInfoSetupError = {
  __typename?: 'BookingInfoSetupError';
  errorCategory: Maybe<BookingInfoSetupErrorMessage>;
};

export enum BookingInfoSetupErrorMessage {
  CentreCategoryNotFound = 'CENTRE_CATEGORY_NOT_FOUND',
  InvalidParentCategory = 'INVALID_PARENT_CATEGORY',
  VariantsOccurrencesLengthsMismatch = 'VARIANTS_OCCURRENCES_LENGTHS_MISMATCH',
  VariantNotFoundForOccurrence = 'VARIANT_NOT_FOUND_FOR_OCCURRENCE'
}

export type BookingInfoSuccess = {
  __typename?: 'BookingInfoSuccess';
  maxTickets: Scalars['Int']['output'];
  occurrencesBookability: Maybe<Array<OccurrenceBookingInfo>>;
};

export type BulkCartItem = {
  __typename?: 'BulkCartItem';
  amount: Scalars['Float']['output'];
  deliveryDate: Scalars['Date']['output'];
  message: Maybe<Scalars['String']['output']>;
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
};

export type BulkCartItems = {
  __typename?: 'BulkCartItems';
  amount: Maybe<Scalars['Float']['output']>;
  deliveryDate: Maybe<Scalars['DateTime']['output']>;
  message: Maybe<Scalars['String']['output']>;
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  senderName: Maybe<Scalars['String']['output']>;
};

export type BulkCartProcessResponse = {
  __typename?: 'BulkCartProcessResponse';
  cards: Maybe<Array<Maybe<BulkCartItem>>>;
  cartReference: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  submittedBy: Maybe<Scalars['String']['output']>;
  totalCards: Maybe<Scalars['Float']['output']>;
  totalValue: Maybe<Scalars['Float']['output']>;
};

export type BulkCartResponse = {
  __typename?: 'BulkCartResponse';
  addServiceFee: Maybe<Scalars['Boolean']['output']>;
  billingDetails: Maybe<CommerceAdminAddressDetails>;
  cardSku: Maybe<Scalars['String']['output']>;
  cartReference: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<BulkCartItems>>>;
  numberOfCards: Maybe<Scalars['Int']['output']>;
  serviceFeeSku: Maybe<Scalars['String']['output']>;
  submittedBy: Maybe<Scalars['String']['output']>;
  totalCardValue: Maybe<Scalars['Float']['output']>;
};

export type BulkCartUploadUrlResponse = {
  __typename?: 'BulkCartUploadUrlResponse';
  cartReference: Scalars['String']['output'];
  detailUrl: Scalars['String']['output'];
  summaryUrl: Scalars['String']['output'];
};

export enum BulkOrderReviewStatus {
  Approved = 'APPROVED',
  ClearanceDeclined = 'CLEARANCE_DECLINED',
  NotCleared = 'NOT_CLEARED',
  NotReviewed = 'NOT_REVIEWED',
  ReviewDeclined = 'REVIEW_DECLINED'
}

export type BulkOrderReviewStatusFilter = {
  is: InputMaybe<BulkOrderReviewStatus>;
};

export type BurnMessage = {
  __typename?: 'BurnMessage';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/answer) */
export type CfAnswer = CfEntry & {
  __typename?: 'CFAnswer';
  _id: Scalars['ID']['output'];
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfAnswerLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/answer) */
export type CfAnswerLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/answer) */
export type CfAnswerSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/answer) */
export type CfAnswerSubtitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/answer) */
export type CfAnswerTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfAnswerCollection = {
  __typename?: 'CFAnswerCollection';
  items: Array<Maybe<CfAnswer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfAnswerFilter = {
  AND: InputMaybe<Array<InputMaybe<CfAnswerFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfAnswerFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle: InputMaybe<Scalars['String']['input']>;
  subtitle_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfAnswerLinkingCollections = {
  __typename?: 'CFAnswerLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  questionCollection: Maybe<CfQuestionCollection>;
};


export type CfAnswerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAnswerLinkingCollectionsQuestionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAnswerLinkingCollectionsQuestionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfAnswerLinkingCollectionsQuestionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfAnswerOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type CfAsset = {
  __typename?: 'CFAsset';
  contentType: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<CfAssetLinkingCollections>;
  size: Maybe<Scalars['Int']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetContentTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetFileNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetHeightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetSizeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  transform: InputMaybe<CfImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type CfAssetWidthArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfAssetCollection = {
  __typename?: 'CFAssetCollection';
  items: Array<Maybe<CfAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<CfAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfAssetFilter>>>;
  contentType: InputMaybe<Scalars['String']['input']>;
  contentType_contains: InputMaybe<Scalars['String']['input']>;
  contentType_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains: InputMaybe<Scalars['String']['input']>;
  contentType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName: InputMaybe<Scalars['String']['input']>;
  fileName_contains: InputMaybe<Scalars['String']['input']>;
  fileName_exists: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains: InputMaybe<Scalars['String']['input']>;
  fileName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height: InputMaybe<Scalars['Int']['input']>;
  height_exists: InputMaybe<Scalars['Boolean']['input']>;
  height_gt: InputMaybe<Scalars['Int']['input']>;
  height_gte: InputMaybe<Scalars['Int']['input']>;
  height_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt: InputMaybe<Scalars['Int']['input']>;
  height_lte: InputMaybe<Scalars['Int']['input']>;
  height_not: InputMaybe<Scalars['Int']['input']>;
  height_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size: InputMaybe<Scalars['Int']['input']>;
  size_exists: InputMaybe<Scalars['Boolean']['input']>;
  size_gt: InputMaybe<Scalars['Int']['input']>;
  size_gte: InputMaybe<Scalars['Int']['input']>;
  size_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt: InputMaybe<Scalars['Int']['input']>;
  size_lte: InputMaybe<Scalars['Int']['input']>;
  size_not: InputMaybe<Scalars['Int']['input']>;
  size_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width: InputMaybe<Scalars['Int']['input']>;
  width_exists: InputMaybe<Scalars['Boolean']['input']>;
  width_gt: InputMaybe<Scalars['Int']['input']>;
  width_gte: InputMaybe<Scalars['Int']['input']>;
  width_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt: InputMaybe<Scalars['Int']['input']>;
  width_lte: InputMaybe<Scalars['Int']['input']>;
  width_not: InputMaybe<Scalars['Int']['input']>;
  width_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CfAssetLinkingCollections = {
  __typename?: 'CFAssetLinkingCollections';
  centreCollection: Maybe<CfCentreCollection>;
  centrePatternImageSetCollection: Maybe<CfCentrePatternImageSetCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  heroImageSetCollection: Maybe<CfHeroImageSetCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  profileCollection: Maybe<CfProfileCollection>;
  promotionCollection: Maybe<CfPromotionCollection>;
  retailerLogoSetCollection: Maybe<CfRetailerLogoSetCollection>;
  storeCollection: Maybe<CfStoreCollection>;
  supportingImageSetCollection: Maybe<CfSupportingImageSetCollection>;
  topStripCollection: Maybe<CfTopStripCollection>;
};


export type CfAssetLinkingCollectionsCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsCentrePatternImageSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsHeroImageSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsPromotionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsRetailerLogoSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsSupportingImageSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAssetLinkingCollectionsTopStripCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfAssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollection = CfEntry & {
  __typename?: 'CFAutomatedCollection';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentLimit: Maybe<Scalars['Int']['output']>;
  contentTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: CfContentfulMetadata;
  displayMode: Maybe<Scalars['String']['output']>;
  displayModeV2: Maybe<Scalars['String']['output']>;
  experiencesCollection: Maybe<CfAutomatedCollectionExperiencesCollection>;
  linkedFrom: Maybe<CfAutomatedCollectionLinkingCollections>;
  relatedContent: Maybe<Scalars['CFJSON']['output']>;
  retailCategoriesCollection: Maybe<CfAutomatedCollectionRetailCategoriesCollection>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfAutomatedCollectionTopicsCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionCallToActionAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionContentLimitArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionContentTypesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionDisplayModeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionDisplayModeV2Args = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedCollectionExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionRelatedContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedCollectionRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedCollection) */
export type CfAutomatedCollectionTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedCollectionTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};

export type CfAutomatedCollectionCollection = {
  __typename?: 'CFAutomatedCollectionCollection';
  items: Array<Maybe<CfAutomatedCollection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfAutomatedCollectionExperiencesCollection = {
  __typename?: 'CFAutomatedCollectionExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedCollectionExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfAutomatedCollectionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfAutomatedCollectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfAutomatedCollectionFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentLimit: InputMaybe<Scalars['Int']['input']>;
  contentLimit_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentLimit_gt: InputMaybe<Scalars['Int']['input']>;
  contentLimit_gte: InputMaybe<Scalars['Int']['input']>;
  contentLimit_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contentLimit_lt: InputMaybe<Scalars['Int']['input']>;
  contentLimit_lte: InputMaybe<Scalars['Int']['input']>;
  contentLimit_not: InputMaybe<Scalars['Int']['input']>;
  contentLimit_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contentTypes_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displayMode: InputMaybe<Scalars['String']['input']>;
  displayModeV2: InputMaybe<Scalars['String']['input']>;
  displayModeV2_contains: InputMaybe<Scalars['String']['input']>;
  displayModeV2_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayModeV2_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayModeV2_not: InputMaybe<Scalars['String']['input']>;
  displayModeV2_not_contains: InputMaybe<Scalars['String']['input']>;
  displayModeV2_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayMode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_not: InputMaybe<Scalars['String']['input']>;
  displayMode_not_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfAutomatedCollectionLinkingCollections = {
  __typename?: 'CFAutomatedCollectionLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfAutomatedCollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfAutomatedCollectionLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedCollectionLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfAutomatedCollectionLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfAutomatedCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  ContentLimitAsc = 'contentLimit_ASC',
  ContentLimitDesc = 'contentLimit_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfAutomatedCollectionRetailCategoriesCollection = {
  __typename?: 'CFAutomatedCollectionRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedCollectionRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfAutomatedCollectionTopicsCollection = {
  __typename?: 'CFAutomatedCollectionTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedCollectionTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSource = CfEntry & {
  __typename?: 'CFAutomatedContentSource';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfAutomatedContentSourceCentresCollection>;
  contentTemplatesCollection: Maybe<CfAutomatedContentSourceContentTemplatesCollection>;
  contentTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: CfContentfulMetadata;
  count: Maybe<Scalars['Int']['output']>;
  experiencesCollection: Maybe<CfAutomatedContentSourceExperiencesCollection>;
  linkedFrom: Maybe<CfAutomatedContentSourceLinkingCollections>;
  prioritiseItemsRelevantToday: Maybe<Scalars['Boolean']['output']>;
  rotateContentTypes: Maybe<Scalars['Boolean']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  topicsCollection: Maybe<CfAutomatedContentSourceTopicsCollection>;
  topicsSortOrFilter: Maybe<Scalars['String']['output']>;
  variant: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceContentTemplatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceContentTemplatesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentTemplateFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceContentTypesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceCountArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourcePrioritiseItemsRelevantTodayArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceRotateContentTypesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceTopicsSortOrFilterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/automatedContentSource) */
export type CfAutomatedContentSourceVariantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfAutomatedContentSourceCentresCollection = {
  __typename?: 'CFAutomatedContentSourceCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedContentSourceCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfAutomatedContentSourceCollection = {
  __typename?: 'CFAutomatedContentSourceCollection';
  items: Array<Maybe<CfAutomatedContentSource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfAutomatedContentSourceContentTemplatesCollection = {
  __typename?: 'CFAutomatedContentSourceContentTemplatesCollection';
  items: Array<Maybe<CfContentTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedContentSourceContentTemplatesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfAutomatedContentSourceExperiencesCollection = {
  __typename?: 'CFAutomatedContentSourceExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedContentSourceExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfAutomatedContentSourceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTemplates: InputMaybe<CfCfContentTemplateNestedFilter>;
  contentTemplatesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTypes_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  count: InputMaybe<Scalars['Int']['input']>;
  count_exists: InputMaybe<Scalars['Boolean']['input']>;
  count_gt: InputMaybe<Scalars['Int']['input']>;
  count_gte: InputMaybe<Scalars['Int']['input']>;
  count_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_lt: InputMaybe<Scalars['Int']['input']>;
  count_lte: InputMaybe<Scalars['Int']['input']>;
  count_not: InputMaybe<Scalars['Int']['input']>;
  count_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  prioritiseItemsRelevantToday: InputMaybe<Scalars['Boolean']['input']>;
  prioritiseItemsRelevantToday_exists: InputMaybe<Scalars['Boolean']['input']>;
  prioritiseItemsRelevantToday_not: InputMaybe<Scalars['Boolean']['input']>;
  rotateContentTypes: InputMaybe<Scalars['Boolean']['input']>;
  rotateContentTypes_exists: InputMaybe<Scalars['Boolean']['input']>;
  rotateContentTypes_not: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  topicsSortOrFilter: InputMaybe<Scalars['String']['input']>;
  topicsSortOrFilter_contains: InputMaybe<Scalars['String']['input']>;
  topicsSortOrFilter_exists: InputMaybe<Scalars['Boolean']['input']>;
  topicsSortOrFilter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicsSortOrFilter_not: InputMaybe<Scalars['String']['input']>;
  topicsSortOrFilter_not_contains: InputMaybe<Scalars['String']['input']>;
  topicsSortOrFilter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfAutomatedContentSourceLinkingCollections = {
  __typename?: 'CFAutomatedContentSourceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfAutomatedContentSourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfAutomatedContentSourceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  PrioritiseItemsRelevantTodayAsc = 'prioritiseItemsRelevantToday_ASC',
  PrioritiseItemsRelevantTodayDesc = 'prioritiseItemsRelevantToday_DESC',
  RotateContentTypesAsc = 'rotateContentTypes_ASC',
  RotateContentTypesDesc = 'rotateContentTypes_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TopicsSortOrFilterAsc = 'topicsSortOrFilter_ASC',
  TopicsSortOrFilterDesc = 'topicsSortOrFilter_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfAutomatedContentSourceTopicsCollection = {
  __typename?: 'CFAutomatedContentSourceTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfAutomatedContentSourceTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContent = CfEntry & {
  __typename?: 'CFBasicContent';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  callsToActionCollection: Maybe<CfBasicContentCallsToActionCollection>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfBasicContentLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContentBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContentBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContentCallsToActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentCallsToActionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCallToActionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContentLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContentShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/basicContent) */
export type CfBasicContentTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfBasicContentCallsToActionCollection = {
  __typename?: 'CFBasicContentCallsToActionCollection';
  items: Array<Maybe<CfCallToAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfBasicContentCallsToActionCollectionOrder {
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfBasicContentCollection = {
  __typename?: 'CFBasicContentCollection';
  items: Array<Maybe<CfBasicContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfBasicContentFilter = {
  AND: InputMaybe<Array<InputMaybe<CfBasicContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfBasicContentFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callsToAction: InputMaybe<CfCfCallToActionNestedFilter>;
  callsToActionCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBasicContentLinkingCollections = {
  __typename?: 'CFBasicContentLinkingCollections';
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  nationalStorefrontCollection: Maybe<CfNationalStorefrontCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfBasicContentLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfBasicContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfBasicContentLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfBasicContentLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfBasicContentLinkingCollectionsNationalStorefrontCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentLinkingCollectionsNationalStorefrontCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfBasicContentLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfBasicContentLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfBasicContentLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfBasicContentLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfBasicContentLinkingCollectionsNationalStorefrontCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfBasicContentLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfBasicContentOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BodyCopyAsc = 'bodyCopy_ASC',
  BodyCopyDesc = 'bodyCopy_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrand = CfEntry & {
  __typename?: 'CFBrand';
  _id: Scalars['ID']['output'];
  allowAutoSurface: Maybe<Scalars['Boolean']['output']>;
  backendTitle: Maybe<Scalars['String']['output']>;
  brandLinkUrl: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfBrandLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrandAllowAutoSurfaceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrandBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrandBrandLinkUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrandLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrandSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/brand) */
export type CfBrandTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfBrandCollection = {
  __typename?: 'CFBrandCollection';
  items: Array<Maybe<CfBrand>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfBrandFilter = {
  AND: InputMaybe<Array<InputMaybe<CfBrandFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfBrandFilter>>>;
  allowAutoSurface: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoSurface_exists: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoSurface_not: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandLinkUrl: InputMaybe<Scalars['String']['input']>;
  brandLinkUrl_contains: InputMaybe<Scalars['String']['input']>;
  brandLinkUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  brandLinkUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandLinkUrl_not: InputMaybe<Scalars['String']['input']>;
  brandLinkUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  brandLinkUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBrandLinkingCollections = {
  __typename?: 'CFBrandLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfBrandLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfBrandOrder {
  AllowAutoSurfaceAsc = 'allowAutoSurface_ASC',
  AllowAutoSurfaceDesc = 'allowAutoSurface_DESC',
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BrandLinkUrlAsc = 'brandLinkUrl_ASC',
  BrandLinkUrlDesc = 'brandLinkUrl_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/callToAction) */
export type CfCallToAction = CfEntry & {
  __typename?: 'CFCallToAction';
  _id: Scalars['ID']['output'];
  address: Maybe<Scalars['String']['output']>;
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  category: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfCallToActionLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/callToAction) */
export type CfCallToActionAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/callToAction) */
export type CfCallToActionCategoryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/callToAction) */
export type CfCallToActionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCallToActionCollection = {
  __typename?: 'CFCallToActionCollection';
  items: Array<Maybe<CfCallToAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCallToActionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCallToActionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCallToActionFilter>>>;
  address: InputMaybe<Scalars['String']['input']>;
  address_contains: InputMaybe<Scalars['String']['input']>;
  address_exists: InputMaybe<Scalars['Boolean']['input']>;
  address_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  address_not: InputMaybe<Scalars['String']['input']>;
  address_not_contains: InputMaybe<Scalars['String']['input']>;
  address_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category: InputMaybe<Scalars['String']['input']>;
  category_contains: InputMaybe<Scalars['String']['input']>;
  category_exists: InputMaybe<Scalars['Boolean']['input']>;
  category_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_not: InputMaybe<Scalars['String']['input']>;
  category_not_contains: InputMaybe<Scalars['String']['input']>;
  category_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCallToActionLinkingCollections = {
  __typename?: 'CFCallToActionLinkingCollections';
  basicContentCollection: Maybe<CfBasicContentCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
  storeCollection: Maybe<CfStoreCollection>;
};


export type CfCallToActionLinkingCollectionsBasicContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCallToActionLinkingCollectionsBasicContentCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCallToActionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCallToActionLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCallToActionLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCallToActionLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCallToActionLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCallToActionLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCallToActionLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCallToActionLinkingCollectionsBasicContentCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BodyCopyAsc = 'bodyCopy_ASC',
  BodyCopyDesc = 'bodyCopy_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCallToActionLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCallToActionLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfCallToActionLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfCallToActionOrder {
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearch = CfEntry & {
  __typename?: 'CFCannedSearch';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfCannedSearchLinkingCollections>;
  linksCollection: Maybe<CfCannedSearchLinksCollection>;
  seoBlurb: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearchBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearchLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearchLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCannedSearchLinksFilter>;
};


/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearchSeoBlurbArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearchSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Create canned search terms in categories and product collections [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cannedSearch) */
export type CfCannedSearchTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfCannedSearchCollection = {
  __typename?: 'CFCannedSearchCollection';
  items: Array<Maybe<CfCannedSearch>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCannedSearchFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCannedSearchFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCannedSearchFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  links: InputMaybe<CfCflinksMultiTypeNestedFilter>;
  linksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoBlurb: InputMaybe<Scalars['String']['input']>;
  seoBlurb_contains: InputMaybe<Scalars['String']['input']>;
  seoBlurb_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoBlurb_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoBlurb_not: InputMaybe<Scalars['String']['input']>;
  seoBlurb_not_contains: InputMaybe<Scalars['String']['input']>;
  seoBlurb_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCannedSearchLinkingCollections = {
  __typename?: 'CFCannedSearchLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfCannedSearchLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfCannedSearchLinksCollection = {
  __typename?: 'CFCannedSearchLinksCollection';
  items: Array<Maybe<CfCannedSearchLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCannedSearchLinksFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCannedSearchLinksFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCannedSearchLinksFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbBody: InputMaybe<Scalars['String']['input']>;
  blurbBody_contains: InputMaybe<Scalars['String']['input']>;
  blurbBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  blurbBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbBody_not: InputMaybe<Scalars['String']['input']>;
  blurbBody_not_contains: InputMaybe<Scalars['String']['input']>;
  blurbBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbTitle: InputMaybe<Scalars['String']['input']>;
  blurbTitle_contains: InputMaybe<Scalars['String']['input']>;
  blurbTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  blurbTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbTitle_not: InputMaybe<Scalars['String']['input']>;
  blurbTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  blurbTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  h1Header: InputMaybe<Scalars['String']['input']>;
  h1Header_contains: InputMaybe<Scalars['String']['input']>;
  h1Header_exists: InputMaybe<Scalars['Boolean']['input']>;
  h1Header_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  h1Header_not: InputMaybe<Scalars['String']['input']>;
  h1Header_not_contains: InputMaybe<Scalars['String']['input']>;
  h1Header_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCannedSearchLinksItem = CfDirectCategory | CfProductCollection;

export enum CfCannedSearchOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarPark = CfEntry & {
  __typename?: 'CFCarPark';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  bestParkingForCollection: Maybe<CfCarParkBestParkingForCollection>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  entrance: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  linkedFrom: Maybe<CfCarParkLinkingCollections>;
  location: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  parkAssistMetadata: Maybe<Scalars['CFJSON']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkBestParkingForCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCarParkBestParkingForCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkEntranceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkLatitudeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkLocationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkLongitudeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkParkAssistMetadataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carPark) */
export type CfCarParkTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfCarParkBestParkingForCollection = {
  __typename?: 'CFCarParkBestParkingForCollection';
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfCarParkBestParkingForCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfCarParkCollection = {
  __typename?: 'CFCarParkCollection';
  items: Array<Maybe<CfCarPark>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCarParkFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCarParkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCarParkFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bestParkingFor: InputMaybe<CfCfStoreNestedFilter>;
  bestParkingForCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  entrance: InputMaybe<Scalars['String']['input']>;
  entrance_contains: InputMaybe<Scalars['String']['input']>;
  entrance_exists: InputMaybe<Scalars['Boolean']['input']>;
  entrance_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entrance_not: InputMaybe<Scalars['String']['input']>;
  entrance_not_contains: InputMaybe<Scalars['String']['input']>;
  entrance_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  latitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  latitude_gt: InputMaybe<Scalars['Float']['input']>;
  latitude_gte: InputMaybe<Scalars['Float']['input']>;
  latitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  latitude_lt: InputMaybe<Scalars['Float']['input']>;
  latitude_lte: InputMaybe<Scalars['Float']['input']>;
  latitude_not: InputMaybe<Scalars['Float']['input']>;
  latitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  location: InputMaybe<Scalars['String']['input']>;
  location_contains: InputMaybe<Scalars['String']['input']>;
  location_exists: InputMaybe<Scalars['Boolean']['input']>;
  location_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_not: InputMaybe<Scalars['String']['input']>;
  location_not_contains: InputMaybe<Scalars['String']['input']>;
  location_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  longitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  longitude_gt: InputMaybe<Scalars['Float']['input']>;
  longitude_gte: InputMaybe<Scalars['Float']['input']>;
  longitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  longitude_lt: InputMaybe<Scalars['Float']['input']>;
  longitude_lte: InputMaybe<Scalars['Float']['input']>;
  longitude_not: InputMaybe<Scalars['Float']['input']>;
  longitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  parkAssistMetadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A list of Car Parks associated to a Centre [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carParkGroup) */
export type CfCarParkGroup = CfEntry & {
  __typename?: 'CFCarParkGroup';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  carParksCollection: Maybe<CfCarParkGroupCarParksCollection>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfCarParkGroupLinkingCollections>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** A list of Car Parks associated to a Centre [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carParkGroup) */
export type CfCarParkGroupBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** A list of Car Parks associated to a Centre [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carParkGroup) */
export type CfCarParkGroupCarParksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCarParkGroupCarParksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCarParkFilter>;
};


/** A list of Car Parks associated to a Centre [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carParkGroup) */
export type CfCarParkGroupCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** A list of Car Parks associated to a Centre [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carParkGroup) */
export type CfCarParkGroupLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A list of Car Parks associated to a Centre [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/carParkGroup) */
export type CfCarParkGroupTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfCarParkGroupCarParksCollection = {
  __typename?: 'CFCarParkGroupCarParksCollection';
  items: Array<Maybe<CfCarPark>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfCarParkGroupCarParksCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EntranceAsc = 'entrance_ASC',
  EntranceDesc = 'entrance_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfCarParkGroupCollection = {
  __typename?: 'CFCarParkGroupCollection';
  items: Array<Maybe<CfCarParkGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCarParkGroupFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCarParkGroupFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCarParkGroupFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carParks: InputMaybe<CfCfCarParkNestedFilter>;
  carParksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCarParkGroupLinkingCollections = {
  __typename?: 'CFCarParkGroupLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  parkingTemplateCollection: Maybe<CfParkingTemplateCollection>;
};


export type CfCarParkGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCarParkGroupLinkingCollectionsParkingTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCarParkGroupLinkingCollectionsParkingTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCarParkGroupLinkingCollectionsParkingTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCarParkGroupOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfCarParkLinkingCollections = {
  __typename?: 'CFCarParkLinkingCollections';
  carParkGroupCollection: Maybe<CfCarParkGroupCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfCarParkLinkingCollectionsCarParkGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCarParkLinkingCollectionsCarParkGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCarParkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCarParkLinkingCollectionsCarParkGroupCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCarParkOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EntranceAsc = 'entrance_ASC',
  EntranceDesc = 'entrance_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOffer = CfEntry & {
  __typename?: 'CFCardLinkedOffer';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  cloOfferId: Maybe<Scalars['String']['output']>;
  cloRewardType: Maybe<Scalars['String']['output']>;
  cloRewardValue: Maybe<Scalars['Float']['output']>;
  cloTransactionValueMaximum: Maybe<Scalars['Float']['output']>;
  cloTransactionValueMinimum: Maybe<Scalars['Float']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfCardLinkedOfferLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferCloOfferIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferCloRewardTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferCloRewardValueArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferCloTransactionValueMaximumArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferCloTransactionValueMinimumArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/cardLinkedOffer) */
export type CfCardLinkedOfferLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCardLinkedOfferCollection = {
  __typename?: 'CFCardLinkedOfferCollection';
  items: Array<Maybe<CfCardLinkedOffer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCardLinkedOfferFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCardLinkedOfferFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCardLinkedOfferFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloOfferId: InputMaybe<Scalars['String']['input']>;
  cloOfferId_contains: InputMaybe<Scalars['String']['input']>;
  cloOfferId_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloOfferId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloOfferId_not: InputMaybe<Scalars['String']['input']>;
  cloOfferId_not_contains: InputMaybe<Scalars['String']['input']>;
  cloOfferId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloRewardType: InputMaybe<Scalars['String']['input']>;
  cloRewardType_contains: InputMaybe<Scalars['String']['input']>;
  cloRewardType_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloRewardType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloRewardType_not: InputMaybe<Scalars['String']['input']>;
  cloRewardType_not_contains: InputMaybe<Scalars['String']['input']>;
  cloRewardType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloRewardValue: InputMaybe<Scalars['Float']['input']>;
  cloRewardValue_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloRewardValue_gt: InputMaybe<Scalars['Float']['input']>;
  cloRewardValue_gte: InputMaybe<Scalars['Float']['input']>;
  cloRewardValue_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cloRewardValue_lt: InputMaybe<Scalars['Float']['input']>;
  cloRewardValue_lte: InputMaybe<Scalars['Float']['input']>;
  cloRewardValue_not: InputMaybe<Scalars['Float']['input']>;
  cloRewardValue_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cloTransactionValueMaximum: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMaximum_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloTransactionValueMaximum_gt: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMaximum_gte: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMaximum_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cloTransactionValueMaximum_lt: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMaximum_lte: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMaximum_not: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMaximum_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cloTransactionValueMinimum: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMinimum_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloTransactionValueMinimum_gt: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMinimum_gte: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMinimum_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cloTransactionValueMinimum_lt: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMinimum_lte: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMinimum_not: InputMaybe<Scalars['Float']['input']>;
  cloTransactionValueMinimum_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCardLinkedOfferLinkingCollections = {
  __typename?: 'CFCardLinkedOfferLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  offerCollection: Maybe<CfOfferCollection>;
};


export type CfCardLinkedOfferLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCardLinkedOfferLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCardLinkedOfferLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCardLinkedOfferLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCardLinkedOfferOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CloRewardTypeAsc = 'cloRewardType_ASC',
  CloRewardTypeDesc = 'cloRewardType_DESC',
  CloRewardValueAsc = 'cloRewardValue_ASC',
  CloRewardValueDesc = 'cloRewardValue_DESC',
  CloTransactionValueMaximumAsc = 'cloTransactionValueMaximum_ASC',
  CloTransactionValueMaximumDesc = 'cloTransactionValueMaximum_DESC',
  CloTransactionValueMinimumAsc = 'cloTransactionValueMinimum_ASC',
  CloTransactionValueMinimumDesc = 'cloTransactionValueMinimum_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentre = CfEntry & {
  __typename?: 'CFCentre';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  boundaries: Maybe<Scalars['CFJSON']['output']>;
  businessUnitCode: Maybe<Scalars['String']['output']>;
  bynderCentreFrontImage: Maybe<Scalars['CFJSON']['output']>;
  bynderDeckBackground: Maybe<Scalars['CFJSON']['output']>;
  carParkType: Maybe<Scalars['String']['output']>;
  centreFrontImage: Maybe<CfAsset>;
  centrePatternImageSet: Maybe<CfCentrePatternImageSet>;
  cinema: Maybe<CfStore>;
  conciergeService: Maybe<CfService>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Scalars['String']['output']>;
  deckBackground: Maybe<CfAsset>;
  distanceFrom: Maybe<Scalars['Int']['output']>;
  emailAddress: Maybe<Scalars['String']['output']>;
  event: Maybe<CfEvent>;
  facebook: Maybe<Scalars['String']['output']>;
  featureFlagsData: Maybe<Scalars['CFJSON']['output']>;
  features: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  googlePlacesId: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  jibestreamVenueId: Maybe<Scalars['Int']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  linkedFrom: Maybe<CfCentreLinkingCollections>;
  longitude: Maybe<Scalars['Float']['output']>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  news: Maybe<CfNews>;
  offer: Maybe<CfOffer>;
  parkingAvailabilityDescription: Maybe<Scalars['String']['output']>;
  parkingOccupancy: Maybe<Scalars['CFJSON']['output']>;
  parkingRulesCollection: Maybe<CfCentreParkingRulesCollection>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
  reputationCode: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  telephoneNumber: Maybe<Scalars['String']['output']>;
  themeColour: Maybe<Scalars['String']['output']>;
  timeZone: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  todayItemCollection: Maybe<TodayItemCollection>;
  twitter: Maybe<Scalars['String']['output']>;
  utilityBoxRetailerCategoriesCollection: Maybe<CfCentreUtilityBoxRetailerCategoriesCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreBoundariesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreBusinessUnitCodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreBynderCentreFrontImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreBynderDeckBackgroundArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreCarParkTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreCentreFrontImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreCentrePatternImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentrePatternImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreCinemaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreConciergeServiceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfServiceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreDeckBackgroundArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreDistanceFromArgs = {
  coordinate: InputMaybe<CoordinateInput>;
  suburb: InputMaybe<AustralianSuburbInput>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreEmailAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreEventArgs = {
  id: Scalars['String']['input'];
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreFacebookArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreFeatureFlagsDataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreFeaturesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreGooglePlacesIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreInstagramArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreJibestreamVenueIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreLatitudeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreLongitudeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreNavigationMenuArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreNewsArgs = {
  id: Scalars['String']['input'];
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreOfferArgs = {
  id: Scalars['String']['input'];
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreParkingAvailabilityDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreParkingOccupancyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreParkingRulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreParkingRulesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingRulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentrePhysicalAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentrePostcodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreReputationCodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreStateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreSuburbArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreTelephoneNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreThemeColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreTimeZoneArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreTodayItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  variant: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreTwitterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centre) */
export type CfCentreUtilityBoxRetailerCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreUtilityBoxRetailerCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};

export type CfCentreCollection = {
  __typename?: 'CFCentreCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCentreFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCentreFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCentreFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boundaries_exists: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitCode: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_contains: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  businessUnitCode_not: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_not_contains: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderCentreFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderDeckBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  carParkType: InputMaybe<Scalars['String']['input']>;
  carParkType_contains: InputMaybe<Scalars['String']['input']>;
  carParkType_exists: InputMaybe<Scalars['Boolean']['input']>;
  carParkType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carParkType_not: InputMaybe<Scalars['String']['input']>;
  carParkType_not_contains: InputMaybe<Scalars['String']['input']>;
  carParkType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centreFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  centrePatternImageSet: InputMaybe<CfCfCentrePatternImageSetNestedFilter>;
  centrePatternImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  cinema: InputMaybe<CfCfStoreNestedFilter>;
  cinema_exists: InputMaybe<Scalars['Boolean']['input']>;
  conciergeService: InputMaybe<CfCfServiceNestedFilter>;
  conciergeService_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country: InputMaybe<Scalars['String']['input']>;
  country_contains: InputMaybe<Scalars['String']['input']>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  country_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_not: InputMaybe<Scalars['String']['input']>;
  country_not_contains: InputMaybe<Scalars['String']['input']>;
  country_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deckBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress: InputMaybe<Scalars['String']['input']>;
  emailAddress_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress_not: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureFlagsData_exists: InputMaybe<Scalars['Boolean']['input']>;
  features_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_exists: InputMaybe<Scalars['Boolean']['input']>;
  googlePlacesId: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_contains: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_exists: InputMaybe<Scalars['Boolean']['input']>;
  googlePlacesId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googlePlacesId_not: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_not_contains: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jibestreamVenueId: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_exists: InputMaybe<Scalars['Boolean']['input']>;
  jibestreamVenueId_gt: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_gte: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  jibestreamVenueId_lt: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_lte: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_not: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  latitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  latitude_gt: InputMaybe<Scalars['Float']['input']>;
  latitude_gte: InputMaybe<Scalars['Float']['input']>;
  latitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  latitude_lt: InputMaybe<Scalars['Float']['input']>;
  latitude_lte: InputMaybe<Scalars['Float']['input']>;
  latitude_not: InputMaybe<Scalars['Float']['input']>;
  latitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  longitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  longitude_gt: InputMaybe<Scalars['Float']['input']>;
  longitude_gte: InputMaybe<Scalars['Float']['input']>;
  longitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  longitude_lt: InputMaybe<Scalars['Float']['input']>;
  longitude_lte: InputMaybe<Scalars['Float']['input']>;
  longitude_not: InputMaybe<Scalars['Float']['input']>;
  longitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  navigationMenu_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingAvailabilityDescription: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_contains: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingAvailabilityDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingAvailabilityDescription_not: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingOccupancy_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingRules: InputMaybe<CfCfParkingRulesNestedFilter>;
  parkingRulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcode: InputMaybe<Scalars['String']['input']>;
  postcode_contains: InputMaybe<Scalars['String']['input']>;
  postcode_exists: InputMaybe<Scalars['Boolean']['input']>;
  postcode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcode_not: InputMaybe<Scalars['String']['input']>;
  postcode_not_contains: InputMaybe<Scalars['String']['input']>;
  postcode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode: InputMaybe<Scalars['String']['input']>;
  reputationCode_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  reputationCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode_not: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: InputMaybe<Scalars['String']['input']>;
  state_contains: InputMaybe<Scalars['String']['input']>;
  state_exists: InputMaybe<Scalars['Boolean']['input']>;
  state_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_not: InputMaybe<Scalars['String']['input']>;
  state_not_contains: InputMaybe<Scalars['String']['input']>;
  state_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  status_contains: InputMaybe<Scalars['String']['input']>;
  status_exists: InputMaybe<Scalars['Boolean']['input']>;
  status_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_not: InputMaybe<Scalars['String']['input']>;
  status_not_contains: InputMaybe<Scalars['String']['input']>;
  status_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suburb: InputMaybe<Scalars['String']['input']>;
  suburb_contains: InputMaybe<Scalars['String']['input']>;
  suburb_exists: InputMaybe<Scalars['Boolean']['input']>;
  suburb_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suburb_not: InputMaybe<Scalars['String']['input']>;
  suburb_not_contains: InputMaybe<Scalars['String']['input']>;
  suburb_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  telephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  themeColour: InputMaybe<Scalars['String']['input']>;
  themeColour_contains: InputMaybe<Scalars['String']['input']>;
  themeColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  themeColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  themeColour_not: InputMaybe<Scalars['String']['input']>;
  themeColour_not_contains: InputMaybe<Scalars['String']['input']>;
  themeColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone: InputMaybe<Scalars['String']['input']>;
  timeZone_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_exists: InputMaybe<Scalars['Boolean']['input']>;
  timeZone_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone_not: InputMaybe<Scalars['String']['input']>;
  timeZone_not_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utilityBoxRetailerCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  utilityBoxRetailerCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCentreLinkingCollections = {
  __typename?: 'CFCentreLinkingCollections';
  automatedContentSourceCollection: Maybe<CfAutomatedContentSourceCollection>;
  carParkCollection: Maybe<CfCarParkCollection>;
  carParkGroupCollection: Maybe<CfCarParkGroupCollection>;
  contentTemplateCollection: Maybe<CfContentTemplateCollection>;
  digitalDirectoryCollection: Maybe<CfDigitalDirectoryCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  parkingTemplateCollection: Maybe<CfParkingTemplateCollection>;
  pathTemplateCollection: Maybe<CfTemplateCollection>;
  personalisedContentSourceCollection: Maybe<CfPersonalisedContentSourceCollection>;
  searchSuggestionsCollection: Maybe<CfSearchSuggestionsCollection>;
  serviceCollection: Maybe<CfServiceCollection>;
  solusTemplateCollection: Maybe<CfSolusTemplateCollection>;
  storeCollection: Maybe<CfStoreCollection>;
  storyCollection: Maybe<CfStoryCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
  topStripCollection: Maybe<CfTopStripCollection>;
  topicCollection: Maybe<CfTopicCollection>;
  whatsHappeningFiltersCollection: Maybe<CfWhatsHappeningFiltersCollection>;
};


export type CfCentreLinkingCollectionsAutomatedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsAutomatedContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsCarParkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsCarParkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsCarParkGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsCarParkGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsContentTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsContentTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsDigitalDirectoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsDigitalDirectoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsParkingTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsParkingTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsPathTemplateCollectionArgs = {
  centreSlug: Scalars['String']['input'];
  contentOptions?: InputMaybe<ContentOptions>;
  ignoreEntriesWithIds: Array<InputMaybe<Scalars['String']['input']>>;
  path: Scalars['String']['input'];
};


export type CfCentreLinkingCollectionsPersonalisedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsPersonalisedContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsSearchSuggestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsSearchSuggestionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsServiceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsSolusTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsSolusTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsTopStripCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsTopStripCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsTopicCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsTopicCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreLinkingCollectionsWhatsHappeningFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreLinkingCollectionsWhatsHappeningFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCentreLinkingCollectionsAutomatedContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  PrioritiseItemsRelevantTodayAsc = 'prioritiseItemsRelevantToday_ASC',
  PrioritiseItemsRelevantTodayDesc = 'prioritiseItemsRelevantToday_DESC',
  RotateContentTypesAsc = 'rotateContentTypes_ASC',
  RotateContentTypesDesc = 'rotateContentTypes_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TopicsSortOrFilterAsc = 'topicsSortOrFilter_ASC',
  TopicsSortOrFilterDesc = 'topicsSortOrFilter_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfCentreLinkingCollectionsCarParkCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EntranceAsc = 'entrance_ASC',
  EntranceDesc = 'entrance_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreLinkingCollectionsCarParkGroupCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreLinkingCollectionsContentTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfCentreLinkingCollectionsDigitalDirectoryCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC'
}

export enum CfCentreLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCentreLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfCentreLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfCentreLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfCentreLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCentreLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCentreLinkingCollectionsParkingTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreLinkingCollectionsPersonalisedContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  MethodAsc = 'method_ASC',
  MethodDesc = 'method_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfCentreLinkingCollectionsSearchSuggestionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ContextAsc = 'context_ASC',
  ContextDesc = 'context_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfCentreLinkingCollectionsServiceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreLinkingCollectionsSolusTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubjectAsc = 'subject_ASC',
  SubjectDesc = 'subject_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfCentreLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfCentreLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCentreLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreLinkingCollectionsTopStripCollectionOrder {
  ActionTextAsc = 'actionText_ASC',
  ActionTextDesc = 'actionText_DESC',
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BackgroundColourAsc = 'backgroundColour_ASC',
  BackgroundColourDesc = 'backgroundColour_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum CfCentreLinkingCollectionsTopicCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreLinkingCollectionsWhatsHappeningFiltersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfCentreOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfCentreParkingRulesCollection = {
  __typename?: 'CFCentreParkingRulesCollection';
  items: Array<Maybe<CfParkingRules>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfCentreParkingRulesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  FreeEntryTimeAsc = 'freeEntryTime_ASC',
  FreeEntryTimeDesc = 'freeEntryTime_DESC',
  FreeExitTimeAsc = 'freeExitTime_ASC',
  FreeExitTimeDesc = 'freeExitTime_DESC',
  SpecialConditionsAsc = 'specialConditions_ASC',
  SpecialConditionsDesc = 'specialConditions_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSet = CfEntry & {
  __typename?: 'CFCentrePatternImageSet';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderLarge: Maybe<Scalars['CFJSON']['output']>;
  bynderSmall: Maybe<Scalars['CFJSON']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  large: Maybe<CfAsset>;
  linkedFrom: Maybe<CfCentrePatternImageSetLinkingCollections>;
  small: Maybe<CfAsset>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSetBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSetBynderLargeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSetBynderSmallArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSetLargeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centrePatternImageSet) */
export type CfCentrePatternImageSetSmallArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCentrePatternImageSetCollection = {
  __typename?: 'CFCentrePatternImageSetCollection';
  items: Array<Maybe<CfCentrePatternImageSet>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCentrePatternImageSetFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCentrePatternImageSetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCentrePatternImageSetFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderLarge_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderSmall_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  large_exists: InputMaybe<Scalars['Boolean']['input']>;
  small_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCentrePatternImageSetLinkingCollections = {
  __typename?: 'CFCentrePatternImageSetLinkingCollections';
  centreCollection: Maybe<CfCentreCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfCentrePatternImageSetLinkingCollectionsCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentrePatternImageSetLinkingCollectionsCentreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentrePatternImageSetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCentrePatternImageSetLinkingCollectionsCentreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export enum CfCentrePatternImageSetOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centreReviews) */
export type CfCentreReviews = CfEntry & {
  __typename?: 'CFCentreReviews';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfCentreReviewsLinkingCollections>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centreReviews) */
export type CfCentreReviewsBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centreReviews) */
export type CfCentreReviewsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/centreReviews) */
export type CfCentreReviewsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfCentreReviewsCollection = {
  __typename?: 'CFCentreReviewsCollection';
  items: Array<Maybe<CfCentreReviews>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCentreReviewsFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCentreReviewsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCentreReviewsFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCentreReviewsLinkingCollections = {
  __typename?: 'CFCentreReviewsLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfCentreReviewsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCentreReviewsLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreReviewsLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCentreReviewsLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfCentreReviewsOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfCentreUtilityBoxRetailerCategoriesCollection = {
  __typename?: 'CFCentreUtilityBoxRetailerCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfCentreUtilityBoxRetailerCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfCfAnswerNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfAnswerNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfAnswerNestedFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle: InputMaybe<Scalars['String']['input']>;
  subtitle_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfCallToActionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfCallToActionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfCallToActionNestedFilter>>>;
  address: InputMaybe<Scalars['String']['input']>;
  address_contains: InputMaybe<Scalars['String']['input']>;
  address_exists: InputMaybe<Scalars['Boolean']['input']>;
  address_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  address_not: InputMaybe<Scalars['String']['input']>;
  address_not_contains: InputMaybe<Scalars['String']['input']>;
  address_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category: InputMaybe<Scalars['String']['input']>;
  category_contains: InputMaybe<Scalars['String']['input']>;
  category_exists: InputMaybe<Scalars['Boolean']['input']>;
  category_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_not: InputMaybe<Scalars['String']['input']>;
  category_not_contains: InputMaybe<Scalars['String']['input']>;
  category_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfCarParkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfCarParkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfCarParkNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bestParkingForCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  entrance: InputMaybe<Scalars['String']['input']>;
  entrance_contains: InputMaybe<Scalars['String']['input']>;
  entrance_exists: InputMaybe<Scalars['Boolean']['input']>;
  entrance_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entrance_not: InputMaybe<Scalars['String']['input']>;
  entrance_not_contains: InputMaybe<Scalars['String']['input']>;
  entrance_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  latitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  latitude_gt: InputMaybe<Scalars['Float']['input']>;
  latitude_gte: InputMaybe<Scalars['Float']['input']>;
  latitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  latitude_lt: InputMaybe<Scalars['Float']['input']>;
  latitude_lte: InputMaybe<Scalars['Float']['input']>;
  latitude_not: InputMaybe<Scalars['Float']['input']>;
  latitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  location: InputMaybe<Scalars['String']['input']>;
  location_contains: InputMaybe<Scalars['String']['input']>;
  location_exists: InputMaybe<Scalars['Boolean']['input']>;
  location_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location_not: InputMaybe<Scalars['String']['input']>;
  location_not_contains: InputMaybe<Scalars['String']['input']>;
  location_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  longitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  longitude_gt: InputMaybe<Scalars['Float']['input']>;
  longitude_gte: InputMaybe<Scalars['Float']['input']>;
  longitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  longitude_lt: InputMaybe<Scalars['Float']['input']>;
  longitude_lte: InputMaybe<Scalars['Float']['input']>;
  longitude_not: InputMaybe<Scalars['Float']['input']>;
  longitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  parkAssistMetadata_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfCentreNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfCentreNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfCentreNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boundaries_exists: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitCode: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_contains: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  businessUnitCode_not: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_not_contains: InputMaybe<Scalars['String']['input']>;
  businessUnitCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderCentreFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderDeckBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  carParkType: InputMaybe<Scalars['String']['input']>;
  carParkType_contains: InputMaybe<Scalars['String']['input']>;
  carParkType_exists: InputMaybe<Scalars['Boolean']['input']>;
  carParkType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carParkType_not: InputMaybe<Scalars['String']['input']>;
  carParkType_not_contains: InputMaybe<Scalars['String']['input']>;
  carParkType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centreFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  centrePatternImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  cinema_exists: InputMaybe<Scalars['Boolean']['input']>;
  conciergeService_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country: InputMaybe<Scalars['String']['input']>;
  country_contains: InputMaybe<Scalars['String']['input']>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  country_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_not: InputMaybe<Scalars['String']['input']>;
  country_not_contains: InputMaybe<Scalars['String']['input']>;
  country_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deckBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress: InputMaybe<Scalars['String']['input']>;
  emailAddress_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress_not: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureFlagsData_exists: InputMaybe<Scalars['Boolean']['input']>;
  features_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  features_exists: InputMaybe<Scalars['Boolean']['input']>;
  googlePlacesId: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_contains: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_exists: InputMaybe<Scalars['Boolean']['input']>;
  googlePlacesId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googlePlacesId_not: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_not_contains: InputMaybe<Scalars['String']['input']>;
  googlePlacesId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jibestreamVenueId: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_exists: InputMaybe<Scalars['Boolean']['input']>;
  jibestreamVenueId_gt: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_gte: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  jibestreamVenueId_lt: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_lte: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_not: InputMaybe<Scalars['Int']['input']>;
  jibestreamVenueId_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  latitude: InputMaybe<Scalars['Float']['input']>;
  latitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  latitude_gt: InputMaybe<Scalars['Float']['input']>;
  latitude_gte: InputMaybe<Scalars['Float']['input']>;
  latitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  latitude_lt: InputMaybe<Scalars['Float']['input']>;
  latitude_lte: InputMaybe<Scalars['Float']['input']>;
  latitude_not: InputMaybe<Scalars['Float']['input']>;
  latitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  longitude: InputMaybe<Scalars['Float']['input']>;
  longitude_exists: InputMaybe<Scalars['Boolean']['input']>;
  longitude_gt: InputMaybe<Scalars['Float']['input']>;
  longitude_gte: InputMaybe<Scalars['Float']['input']>;
  longitude_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  longitude_lt: InputMaybe<Scalars['Float']['input']>;
  longitude_lte: InputMaybe<Scalars['Float']['input']>;
  longitude_not: InputMaybe<Scalars['Float']['input']>;
  longitude_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  navigationMenu_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingAvailabilityDescription: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_contains: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingAvailabilityDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingAvailabilityDescription_not: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  parkingAvailabilityDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingOccupancy_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingRulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcode: InputMaybe<Scalars['String']['input']>;
  postcode_contains: InputMaybe<Scalars['String']['input']>;
  postcode_exists: InputMaybe<Scalars['Boolean']['input']>;
  postcode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcode_not: InputMaybe<Scalars['String']['input']>;
  postcode_not_contains: InputMaybe<Scalars['String']['input']>;
  postcode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode: InputMaybe<Scalars['String']['input']>;
  reputationCode_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  reputationCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode_not: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state: InputMaybe<Scalars['String']['input']>;
  state_contains: InputMaybe<Scalars['String']['input']>;
  state_exists: InputMaybe<Scalars['Boolean']['input']>;
  state_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_not: InputMaybe<Scalars['String']['input']>;
  state_not_contains: InputMaybe<Scalars['String']['input']>;
  state_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  status_contains: InputMaybe<Scalars['String']['input']>;
  status_exists: InputMaybe<Scalars['Boolean']['input']>;
  status_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_not: InputMaybe<Scalars['String']['input']>;
  status_not_contains: InputMaybe<Scalars['String']['input']>;
  status_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suburb: InputMaybe<Scalars['String']['input']>;
  suburb_contains: InputMaybe<Scalars['String']['input']>;
  suburb_exists: InputMaybe<Scalars['Boolean']['input']>;
  suburb_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suburb_not: InputMaybe<Scalars['String']['input']>;
  suburb_not_contains: InputMaybe<Scalars['String']['input']>;
  suburb_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  telephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  themeColour: InputMaybe<Scalars['String']['input']>;
  themeColour_contains: InputMaybe<Scalars['String']['input']>;
  themeColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  themeColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  themeColour_not: InputMaybe<Scalars['String']['input']>;
  themeColour_not_contains: InputMaybe<Scalars['String']['input']>;
  themeColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone: InputMaybe<Scalars['String']['input']>;
  timeZone_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_exists: InputMaybe<Scalars['Boolean']['input']>;
  timeZone_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone_not: InputMaybe<Scalars['String']['input']>;
  timeZone_not_contains: InputMaybe<Scalars['String']['input']>;
  timeZone_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utilityBoxRetailerCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCfCentrePatternImageSetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfCentrePatternImageSetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfCentrePatternImageSetNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderLarge_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderSmall_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  large_exists: InputMaybe<Scalars['Boolean']['input']>;
  small_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfComparisonItemNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfComparisonItemNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfComparisonItemNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToAction_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  productName: InputMaybe<Scalars['String']['input']>;
  productName_contains: InputMaybe<Scalars['String']['input']>;
  productName_exists: InputMaybe<Scalars['Boolean']['input']>;
  productName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productName_not: InputMaybe<Scalars['String']['input']>;
  productName_not_contains: InputMaybe<Scalars['String']['input']>;
  productName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  utilityPanel_exists: InputMaybe<Scalars['Boolean']['input']>;
  valuePropositions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuePropositions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuePropositions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuePropositions_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCfContentTemplateNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfContentTemplateNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfContentTemplateNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  channel: InputMaybe<Scalars['String']['input']>;
  channel_contains: InputMaybe<Scalars['String']['input']>;
  channel_exists: InputMaybe<Scalars['Boolean']['input']>;
  channel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channel_not: InputMaybe<Scalars['String']['input']>;
  channel_not_contains: InputMaybe<Scalars['String']['input']>;
  channel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  data_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope: InputMaybe<Scalars['String']['input']>;
  scope_contains: InputMaybe<Scalars['String']['input']>;
  scope_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_not: InputMaybe<Scalars['String']['input']>;
  scope_not_contains: InputMaybe<Scalars['String']['input']>;
  scope_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfDirectCategoryRelatedLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfDirectCategoryRelatedLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfDirectCategoryRelatedLinkNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displayMode: InputMaybe<Scalars['String']['input']>;
  displayMode_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayMode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_not: InputMaybe<Scalars['String']['input']>;
  displayMode_not_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfExperienceNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfExperienceNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfExperienceNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfFeaturedLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfFeaturedLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfFeaturedLinkNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  textColour: InputMaybe<Scalars['String']['input']>;
  textColour_contains: InputMaybe<Scalars['String']['input']>;
  textColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  textColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColour_not: InputMaybe<Scalars['String']['input']>;
  textColour_not_contains: InputMaybe<Scalars['String']['input']>;
  textColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfHeroImageSetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfHeroImageSetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfHeroImageSetNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderMasterCinemagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderMaster_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderPoster_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderSquare_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderStandard_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masterCinemagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  masterSupportingColour: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_contains: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  masterSupportingColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masterSupportingColour_not: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_not_contains: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  master_exists: InputMaybe<Scalars['Boolean']['input']>;
  poster_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishableStatus: InputMaybe<Scalars['String']['input']>;
  publishableStatus_contains: InputMaybe<Scalars['String']['input']>;
  publishableStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishableStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishableStatus_not: InputMaybe<Scalars['String']['input']>;
  publishableStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  publishableStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  squareSupportingColour: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_contains: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  squareSupportingColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  squareSupportingColour_not: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_not_contains: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  square_exists: InputMaybe<Scalars['Boolean']['input']>;
  standardSupportingColour: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_contains: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  standardSupportingColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  standardSupportingColour_not: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_not_contains: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  standard_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfJourneyBannerNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfJourneyBannerNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfJourneyBannerNestedFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  offerToOpen_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfLoyaltyProgramNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfLoyaltyProgramNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfLoyaltyProgramNestedFilter>>>;
  androidAppBundleId: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_contains: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_exists: InputMaybe<Scalars['Boolean']['input']>;
  androidAppBundleId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  androidAppBundleId_not: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_not_contains: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandBackgroundColor: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_contains: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_exists: InputMaybe<Scalars['Boolean']['input']>;
  brandBackgroundColor_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandBackgroundColor_not: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_not_contains: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canAddMembership: InputMaybe<Scalars['Boolean']['input']>;
  canAddMembership_exists: InputMaybe<Scalars['Boolean']['input']>;
  canAddMembership_not: InputMaybe<Scalars['Boolean']['input']>;
  canSignup: InputMaybe<Scalars['Boolean']['input']>;
  canSignup_exists: InputMaybe<Scalars['Boolean']['input']>;
  canSignup_not: InputMaybe<Scalars['Boolean']['input']>;
  cardAssetImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAccountLogin: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountLogin_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountLogin_not: InputMaybe<Scalars['Boolean']['input']>;
  hasBarcode: InputMaybe<Scalars['Boolean']['input']>;
  hasBarcode_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasBarcode_not: InputMaybe<Scalars['Boolean']['input']>;
  hasCard: InputMaybe<Scalars['Boolean']['input']>;
  hasCardNumber: InputMaybe<Scalars['Boolean']['input']>;
  hasCardNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasCardNumber_not: InputMaybe<Scalars['Boolean']['input']>;
  hasCard_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasCard_not: InputMaybe<Scalars['Boolean']['input']>;
  hasMembershipNumber: InputMaybe<Scalars['Boolean']['input']>;
  hasMembershipNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasMembershipNumber_not: InputMaybe<Scalars['Boolean']['input']>;
  iosAppName: InputMaybe<Scalars['String']['input']>;
  iosAppName_contains: InputMaybe<Scalars['String']['input']>;
  iosAppName_exists: InputMaybe<Scalars['Boolean']['input']>;
  iosAppName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppName_not: InputMaybe<Scalars['String']['input']>;
  iosAppName_not_contains: InputMaybe<Scalars['String']['input']>;
  iosAppName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppStoreId: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_contains: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_exists: InputMaybe<Scalars['Boolean']['input']>;
  iosAppStoreId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppStoreId_not: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_not_contains: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppUrlScheme: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_contains: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_exists: InputMaybe<Scalars['Boolean']['input']>;
  iosAppUrlScheme_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppUrlScheme_not: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_not_contains: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInverse: InputMaybe<Scalars['Boolean']['input']>;
  isInverse_exists: InputMaybe<Scalars['Boolean']['input']>;
  isInverse_not: InputMaybe<Scalars['Boolean']['input']>;
  legacyCardAssetImage: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_contains: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  legacyCardAssetImage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyCardAssetImage_not: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_not_contains: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loginUrl: InputMaybe<Scalars['String']['input']>;
  loginUrl_contains: InputMaybe<Scalars['String']['input']>;
  loginUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loginUrl_not: InputMaybe<Scalars['String']['input']>;
  loginUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  loginUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  membershipBarcodeFormat: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_contains: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_exists: InputMaybe<Scalars['Boolean']['input']>;
  membershipBarcodeFormat_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  membershipBarcodeFormat_not: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_not_contains: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signupUrl: InputMaybe<Scalars['String']['input']>;
  signupUrl_contains: InputMaybe<Scalars['String']['input']>;
  signupUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  signupUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signupUrl_not: InputMaybe<Scalars['String']['input']>;
  signupUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  signupUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfNationalHomepageNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfNationalHomepageNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfNationalHomepageNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderWDeviceLarge_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderWDeviceSmall_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuredCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuredRetailersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicy_not: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionModule_exists: InputMaybe<Scalars['Boolean']['input']>;
  promotionModulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsVersion: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditionsVersion_gt: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_gte: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  termsAndConditionsVersion_lt: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_lte: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_not: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  termsAndConditions_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions_not: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wDeviceLarge_exists: InputMaybe<Scalars['Boolean']['input']>;
  wDeviceSmall_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCfOccurrenceNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfOccurrenceNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfOccurrenceNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfOfferNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfOfferNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfOfferNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchDeepLink: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_contains: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  branchDeepLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchDeepLink_not: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_not_contains: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchFallbackUrl: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_contains: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  branchFallbackUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchFallbackUrl_not: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloOfferId: InputMaybe<Scalars['String']['input']>;
  cloOfferId_contains: InputMaybe<Scalars['String']['input']>;
  cloOfferId_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloOfferId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloOfferId_not: InputMaybe<Scalars['String']['input']>;
  cloOfferId_not_contains: InputMaybe<Scalars['String']['input']>;
  cloOfferId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  ctaType: InputMaybe<Scalars['String']['input']>;
  ctaType_contains: InputMaybe<Scalars['String']['input']>;
  ctaType_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading: InputMaybe<Scalars['String']['input']>;
  edmSubheading_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubheading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading_not: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle: InputMaybe<Scalars['String']['input']>;
  edmTitle_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle_not: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  faq: InputMaybe<Scalars['String']['input']>;
  faq_contains: InputMaybe<Scalars['String']['input']>;
  faq_exists: InputMaybe<Scalars['Boolean']['input']>;
  faq_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq_not: InputMaybe<Scalars['String']['input']>;
  faq_not_contains: InputMaybe<Scalars['String']['input']>;
  faq_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasModeratedImages: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_not: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  inCentrePresenceCheck: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_exists: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_not: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_not: InputMaybe<Scalars['Boolean']['input']>;
  journeyBanner_exists: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_exists: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_not: InputMaybe<Scalars['Boolean']['input']>;
  popupLocation: InputMaybe<Scalars['String']['input']>;
  popupLocation_contains: InputMaybe<Scalars['String']['input']>;
  popupLocation_exists: InputMaybe<Scalars['Boolean']['input']>;
  popupLocation_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  popupLocation_not: InputMaybe<Scalars['String']['input']>;
  popupLocation_not_contains: InputMaybe<Scalars['String']['input']>;
  popupLocation_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoQrCode: InputMaybe<Scalars['String']['input']>;
  promoQrCode_contains: InputMaybe<Scalars['String']['input']>;
  promoQrCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  promoQrCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoQrCode_not: InputMaybe<Scalars['String']['input']>;
  promoQrCode_not_contains: InputMaybe<Scalars['String']['input']>;
  promoQrCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessBody: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  promoSuccessBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessBody_not: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_not_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessTitle: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  promoSuccessTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessTitle_not: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionType: InputMaybe<Scalars['String']['input']>;
  promotionType_contains: InputMaybe<Scalars['String']['input']>;
  promotionType_exists: InputMaybe<Scalars['Boolean']['input']>;
  promotionType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionType_not: InputMaybe<Scalars['String']['input']>;
  promotionType_not_contains: InputMaybe<Scalars['String']['input']>;
  promotionType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redeemablePromotion_exists: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan_exists: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan_not: InputMaybe<Scalars['Boolean']['input']>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus: InputMaybe<Scalars['String']['input']>;
  reviewStatus_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewStatus_not: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sendSuccessEmail: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_not: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy_not: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supportingImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  surfaceContentInChannel_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsFile_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions_not: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption: InputMaybe<Scalars['String']['input']>;
  viewOption_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewOption_not: InputMaybe<Scalars['String']['input']>;
  viewOption_not_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfParkingRateNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfParkingRateNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfParkingRateNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  rate: InputMaybe<Scalars['Float']['input']>;
  rate_exists: InputMaybe<Scalars['Boolean']['input']>;
  rate_gt: InputMaybe<Scalars['Float']['input']>;
  rate_gte: InputMaybe<Scalars['Float']['input']>;
  rate_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rate_lt: InputMaybe<Scalars['Float']['input']>;
  rate_lte: InputMaybe<Scalars['Float']['input']>;
  rate_not: InputMaybe<Scalars['Float']['input']>;
  rate_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  toInMinutes: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_exists: InputMaybe<Scalars['Boolean']['input']>;
  toInMinutes_gt: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_gte: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toInMinutes_lt: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_lte: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_not: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CfCfParkingRatesCardNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfParkingRatesCardNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfParkingRatesCardNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  days_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days_exists: InputMaybe<Scalars['Boolean']['input']>;
  overnightRate: InputMaybe<Scalars['Float']['input']>;
  overnightRate_exists: InputMaybe<Scalars['Boolean']['input']>;
  overnightRate_gt: InputMaybe<Scalars['Float']['input']>;
  overnightRate_gte: InputMaybe<Scalars['Float']['input']>;
  overnightRate_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  overnightRate_lt: InputMaybe<Scalars['Float']['input']>;
  overnightRate_lte: InputMaybe<Scalars['Float']['input']>;
  overnightRate_not: InputMaybe<Scalars['Float']['input']>;
  overnightRate_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ratesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfParkingRulesNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfParkingRulesNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfParkingRulesNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cinemaValidation: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_contains: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_exists: InputMaybe<Scalars['Boolean']['input']>;
  cinemaValidation_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cinemaValidation_not: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_not_contains: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  freeEntryTime: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_contains: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  freeEntryTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeEntryTime_not: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_not_contains: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeExitTime: InputMaybe<Scalars['String']['input']>;
  freeExitTime_contains: InputMaybe<Scalars['String']['input']>;
  freeExitTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  freeExitTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeExitTime_not: InputMaybe<Scalars['String']['input']>;
  freeExitTime_not_contains: InputMaybe<Scalars['String']['input']>;
  freeExitTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ratesCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  specialConditions: InputMaybe<Scalars['String']['input']>;
  specialConditions_contains: InputMaybe<Scalars['String']['input']>;
  specialConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  specialConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialConditions_not: InputMaybe<Scalars['String']['input']>;
  specialConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  specialConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfProfileNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfProfileNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfProfileNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderProfileImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  fullName: InputMaybe<Scalars['String']['input']>;
  fullName_contains: InputMaybe<Scalars['String']['input']>;
  fullName_exists: InputMaybe<Scalars['Boolean']['input']>;
  fullName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullName_not: InputMaybe<Scalars['String']['input']>;
  fullName_not_contains: InputMaybe<Scalars['String']['input']>;
  fullName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  profileType: InputMaybe<Scalars['String']['input']>;
  profileType_contains: InputMaybe<Scalars['String']['input']>;
  profileType_exists: InputMaybe<Scalars['Boolean']['input']>;
  profileType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileType_not: InputMaybe<Scalars['String']['input']>;
  profileType_not_contains: InputMaybe<Scalars['String']['input']>;
  profileType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfPromotionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfPromotionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfPromotionNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfQuestionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfQuestionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfQuestionNestedFilter>>>;
  answersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle: InputMaybe<Scalars['String']['input']>;
  subtitle_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfRetailCategoryNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfRetailCategoryNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfRetailCategoryNestedFilter>>>;
  aliases_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  level: InputMaybe<Scalars['Int']['input']>;
  level_exists: InputMaybe<Scalars['Boolean']['input']>;
  level_gt: InputMaybe<Scalars['Int']['input']>;
  level_gte: InputMaybe<Scalars['Int']['input']>;
  level_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  level_lt: InputMaybe<Scalars['Int']['input']>;
  level_lte: InputMaybe<Scalars['Int']['input']>;
  level_not: InputMaybe<Scalars['Int']['input']>;
  level_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parentCategory_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoContentSchema_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle: InputMaybe<Scalars['String']['input']>;
  seoTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoTitle_not: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfRetailerLogoSetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfRetailerLogoSetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfRetailerLogoSetNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderColoured_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderTileBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderTransparent_exists: InputMaybe<Scalars['Boolean']['input']>;
  coloured_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  tileBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  transparent_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCfRetailerNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfRetailerNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfRetailerNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callsToActionCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country: InputMaybe<Scalars['String']['input']>;
  country_contains: InputMaybe<Scalars['String']['input']>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  country_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_not: InputMaybe<Scalars['String']['input']>;
  country_not_contains: InputMaybe<Scalars['String']['input']>;
  country_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredFacetsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_not: InputMaybe<Scalars['Boolean']['input']>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyIdentifier: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_exists: InputMaybe<Scalars['Boolean']['input']>;
  legacyIdentifier_gt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_gte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  legacyIdentifier_lt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_lte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  longDescription: InputMaybe<Scalars['String']['input']>;
  longDescription_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  longDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longDescription_not: InputMaybe<Scalars['String']['input']>;
  longDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loyaltyProgramsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShopId: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_exists: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShopId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceShopId_not: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_not_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceShopSlug: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_exists: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShopSlug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceShopSlug_not: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_not_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription: InputMaybe<Scalars['String']['input']>;
  priceDescription_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription_not: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailerLogoSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailerSizeGuide: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_contains: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailerSizeGuide_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailerSizeGuide_not: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_not_contains: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_exists: InputMaybe<Scalars['Boolean']['input']>;
  settings: InputMaybe<Scalars['String']['input']>;
  settings_contains: InputMaybe<Scalars['String']['input']>;
  settings_exists: InputMaybe<Scalars['Boolean']['input']>;
  settings_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings_not: InputMaybe<Scalars['String']['input']>;
  settings_not_contains: InputMaybe<Scalars['String']['input']>;
  settings_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress: InputMaybe<Scalars['String']['input']>;
  websiteAddress_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  websiteAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress_not: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfServiceNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfServiceNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfServiceNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category: InputMaybe<Scalars['String']['input']>;
  category_contains: InputMaybe<Scalars['String']['input']>;
  category_exists: InputMaybe<Scalars['Boolean']['input']>;
  category_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_not: InputMaybe<Scalars['String']['input']>;
  category_not_contains: InputMaybe<Scalars['String']['input']>;
  category_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  landmarkDescription: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  landmarkDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription_not: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  store_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  telephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfStoreNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfStoreNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfStoreNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderStoreFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  callsToActionCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  emailAddress: InputMaybe<Scalars['String']['input']>;
  emailAddress_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress_not: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideReviews: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_not: InputMaybe<Scalars['Boolean']['input']>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  landmarkDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription_not: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyIdentifier: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_exists: InputMaybe<Scalars['Boolean']['input']>;
  legacyIdentifier_gt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_gte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  legacyIdentifier_lt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_lte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  level: InputMaybe<Scalars['String']['input']>;
  level_contains: InputMaybe<Scalars['String']['input']>;
  level_exists: InputMaybe<Scalars['Boolean']['input']>;
  level_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not: InputMaybe<Scalars['String']['input']>;
  level_not_contains: InputMaybe<Scalars['String']['input']>;
  level_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longDescription: InputMaybe<Scalars['String']['input']>;
  longDescription_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  longDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longDescription_not: InputMaybe<Scalars['String']['input']>;
  longDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openAt: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  openAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  openAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  parkingInstructions: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_contains: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingInstructions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingInstructions_not: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_not_contains: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription: InputMaybe<Scalars['String']['input']>;
  priceDescription_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription_not: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode: InputMaybe<Scalars['String']['input']>;
  reputationCode_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  reputationCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode_not: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailer_exists: InputMaybe<Scalars['Boolean']['input']>;
  services_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_exists: InputMaybe<Scalars['Boolean']['input']>;
  shopNumber: InputMaybe<Scalars['String']['input']>;
  shopNumber_contains: InputMaybe<Scalars['String']['input']>;
  shopNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  shopNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shopNumber_not: InputMaybe<Scalars['String']['input']>;
  shopNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  shopNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialStatus: InputMaybe<Scalars['String']['input']>;
  specialStatus_contains: InputMaybe<Scalars['String']['input']>;
  specialStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  specialStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialStatus_not: InputMaybe<Scalars['String']['input']>;
  specialStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  specialStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  status_contains: InputMaybe<Scalars['String']['input']>;
  status_exists: InputMaybe<Scalars['Boolean']['input']>;
  status_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_not: InputMaybe<Scalars['String']['input']>;
  status_not_contains: InputMaybe<Scalars['String']['input']>;
  status_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storeFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  storeType: InputMaybe<Scalars['String']['input']>;
  storeType_contains: InputMaybe<Scalars['String']['input']>;
  storeType_exists: InputMaybe<Scalars['Boolean']['input']>;
  storeType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storeType_not: InputMaybe<Scalars['String']['input']>;
  storeType_not_contains: InputMaybe<Scalars['String']['input']>;
  storeType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  telephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  waypoint: InputMaybe<Scalars['String']['input']>;
  waypoint_contains: InputMaybe<Scalars['String']['input']>;
  waypoint_exists: InputMaybe<Scalars['Boolean']['input']>;
  waypoint_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  waypoint_not: InputMaybe<Scalars['String']['input']>;
  waypoint_not_contains: InputMaybe<Scalars['String']['input']>;
  waypoint_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress: InputMaybe<Scalars['String']['input']>;
  websiteAddress_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  websiteAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress_not: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfSupportingImageSetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfSupportingImageSetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfSupportingImageSetNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderMedia_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfTopicNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfTopicNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfTopicNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  parentTopic_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfCfUtilityPanelNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfUtilityPanelNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfUtilityPanelNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentEntriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfcontentEntriesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfcontentEntriesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfcontentEntriesMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCffeaturedCollectionsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCffeaturedCollectionsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCffeaturedCollectionsMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCffeaturesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCffeaturesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCffeaturesMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCffemaleCorpusMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCffemaleCorpusMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCffemaleCorpusMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfheroFeaturesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfheroFeaturesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfheroFeaturesMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCflinksMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCflinksMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCflinksMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfmaleCorpusMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfmaleCorpusMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfmaleCorpusMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfmanualCorpusMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfmanualCorpusMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfmanualCorpusMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCfmodulesMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfmodulesMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfmodulesMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfCfunknownCorpusMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCfunknownCorpusMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCfunknownCorpusMultiTypeNestedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItem = CfEntry & {
  __typename?: 'CFComparisonItem';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  callToAction: Maybe<CfFeaturedLink>;
  contentfulMetadata: CfContentfulMetadata;
  heroImageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfComparisonItemLinkingCollections>;
  productName: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  utilityPanel: Maybe<CfUtilityPanel>;
  valuePropositions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemCallToActionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfFeaturedLinkFilter>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemProductNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemUtilityPanelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfUtilityPanelFilter>;
};


/** Item for use in comparison module [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonItem) */
export type CfComparisonItemValuePropositionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfComparisonItemCollection = {
  __typename?: 'CFComparisonItemCollection';
  items: Array<Maybe<CfComparisonItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfComparisonItemFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComparisonItemFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComparisonItemFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToAction: InputMaybe<CfCfFeaturedLinkNestedFilter>;
  callToAction_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  productName: InputMaybe<Scalars['String']['input']>;
  productName_contains: InputMaybe<Scalars['String']['input']>;
  productName_exists: InputMaybe<Scalars['Boolean']['input']>;
  productName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productName_not: InputMaybe<Scalars['String']['input']>;
  productName_not_contains: InputMaybe<Scalars['String']['input']>;
  productName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  utilityPanel: InputMaybe<CfCfUtilityPanelNestedFilter>;
  utilityPanel_exists: InputMaybe<Scalars['Boolean']['input']>;
  valuePropositions_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuePropositions_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuePropositions_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuePropositions_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfComparisonItemLinkingCollections = {
  __typename?: 'CFComparisonItemLinkingCollections';
  comparisonModuleCollection: Maybe<CfComparisonModuleCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfComparisonItemLinkingCollectionsComparisonModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfComparisonItemLinkingCollectionsComparisonModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfComparisonItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfComparisonItemLinkingCollectionsComparisonModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfComparisonItemOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ProductNameAsc = 'productName_ASC',
  ProductNameDesc = 'productName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Comparison of multiple comparison item types [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonModule) */
export type CfComparisonModule = CfEntry & {
  __typename?: 'CFComparisonModule';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  comparisonModuleCollection: Maybe<CfComparisonModuleComparisonModuleCollection>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfComparisonModuleLinkingCollections>;
  sys: CfSys;
};


/** Comparison of multiple comparison item types [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonModule) */
export type CfComparisonModuleBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Comparison of multiple comparison item types [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonModule) */
export type CfComparisonModuleComparisonModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfComparisonModuleComparisonModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfComparisonItemFilter>;
};


/** Comparison of multiple comparison item types [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/comparisonModule) */
export type CfComparisonModuleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComparisonModuleCollection = {
  __typename?: 'CFComparisonModuleCollection';
  items: Array<Maybe<CfComparisonModule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfComparisonModuleComparisonModuleCollection = {
  __typename?: 'CFComparisonModuleComparisonModuleCollection';
  items: Array<Maybe<CfComparisonItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfComparisonModuleComparisonModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ProductNameAsc = 'productName_ASC',
  ProductNameDesc = 'productName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfComparisonModuleFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComparisonModuleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComparisonModuleFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comparisonModule: InputMaybe<CfCfComparisonItemNestedFilter>;
  comparisonModuleCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfComparisonModuleLinkingCollections = {
  __typename?: 'CFComparisonModuleLinkingCollections';
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  promotionalTemplateCollection: Maybe<CfPromotionalTemplateCollection>;
};


export type CfComparisonModuleLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfComparisonModuleLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfComparisonModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfComparisonModuleLinkingCollectionsPromotionalTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfComparisonModuleLinkingCollectionsPromotionalTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfComparisonModuleLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfComparisonModuleLinkingCollectionsPromotionalTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfComparisonModuleOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetition = CfEntry & {
  __typename?: 'CFCompetition';
  _id: Scalars['ID']['output'];
  contentfulMetadata: CfContentfulMetadata;
  faqUrl: Maybe<Scalars['String']['output']>;
  inCentrePresenceCheck: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<CfCompetitionLinkingCollections>;
  questionsCollection: Maybe<CfCompetitionQuestionsCollection>;
  requiresQrCodeScan: Maybe<Scalars['Boolean']['output']>;
  sendSuccessEmail: Maybe<Scalars['Boolean']['output']>;
  successBody: Maybe<Scalars['String']['output']>;
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  successTitle: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionFaqUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionInCentrePresenceCheckArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionQuestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCompetitionQuestionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfQuestionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionRequiresQrCodeScanArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionSendSuccessEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionSuccessBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionSuccessEmailAdditionalCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionSuccessTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/competition) */
export type CfCompetitionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfCompetitionCollection = {
  __typename?: 'CFCompetitionCollection';
  items: Array<Maybe<CfCompetition>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfCompetitionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCompetitionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCompetitionFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  faqUrl: InputMaybe<Scalars['String']['input']>;
  faqUrl_contains: InputMaybe<Scalars['String']['input']>;
  faqUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  faqUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqUrl_not: InputMaybe<Scalars['String']['input']>;
  faqUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  faqUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inCentrePresenceCheck: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_exists: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_not: InputMaybe<Scalars['Boolean']['input']>;
  questions: InputMaybe<CfCfQuestionNestedFilter>;
  questionsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan_exists: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan_not: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_not: InputMaybe<Scalars['Boolean']['input']>;
  successBody: InputMaybe<Scalars['String']['input']>;
  successBody_contains: InputMaybe<Scalars['String']['input']>;
  successBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  successBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successBody_not: InputMaybe<Scalars['String']['input']>;
  successBody_not_contains: InputMaybe<Scalars['String']['input']>;
  successBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy_not: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitle: InputMaybe<Scalars['String']['input']>;
  successTitle_contains: InputMaybe<Scalars['String']['input']>;
  successTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  successTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitle_not: InputMaybe<Scalars['String']['input']>;
  successTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  successTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCompetitionLinkingCollections = {
  __typename?: 'CFCompetitionLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  offerCollection: Maybe<CfOfferCollection>;
};


export type CfCompetitionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfCompetitionLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCompetitionLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfCompetitionLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfCompetitionOrder {
  FaqUrlAsc = 'faqUrl_ASC',
  FaqUrlDesc = 'faqUrl_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  SuccessTitleAsc = 'successTitle_ASC',
  SuccessTitleDesc = 'successTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfCompetitionQuestionsCollection = {
  __typename?: 'CFCompetitionQuestionsCollection';
  items: Array<Maybe<CfQuestion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfCompetitionQuestionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentBlock) */
export type CfContentBlock = CfEntry & {
  __typename?: 'CFContentBlock';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfContentBlockLinkingCollections>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentBlock) */
export type CfContentBlockBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentBlock) */
export type CfContentBlockBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentBlock) */
export type CfContentBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentBlock) */
export type CfContentBlockTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfContentBlockCollection = {
  __typename?: 'CFContentBlockCollection';
  items: Array<Maybe<CfContentBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfContentBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<CfContentBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfContentBlockFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentBlockLinkingCollections = {
  __typename?: 'CFContentBlockLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  giftcardTemplateCollection: Maybe<CfGiftcardTemplateCollection>;
  parkingTemplateCollection: Maybe<CfParkingTemplateCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfContentBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentBlockLinkingCollectionsGiftcardTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentBlockLinkingCollectionsGiftcardTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentBlockLinkingCollectionsParkingTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentBlockLinkingCollectionsParkingTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentBlockLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentBlockLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfContentBlockLinkingCollectionsGiftcardTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionMetaDescriptionAsc = 'shortDescriptionMetaDescription_ASC',
  ShortDescriptionMetaDescriptionDesc = 'shortDescriptionMetaDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfContentBlockLinkingCollectionsParkingTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfContentBlockLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfContentBlockOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPage = CfEntry & {
  __typename?: 'CFContentPage';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom: Maybe<CfContentPageLinkingCollections>;
  metaTitle: Maybe<Scalars['String']['output']>;
  modulesCollection: Maybe<CfContentPageModulesCollection>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  path: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageMetaTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentPageModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageNavigationMenuArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPagePathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentPage) */
export type CfContentPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfContentPageCollection = {
  __typename?: 'CFContentPageCollection';
  items: Array<Maybe<CfContentPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfContentPageFilter = {
  AND: InputMaybe<Array<InputMaybe<CfContentPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfContentPageFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu_exists: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentPageLinkingCollections = {
  __typename?: 'CFContentPageLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfContentPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfContentPageModulesCollection = {
  __typename?: 'CFContentPageModulesCollection';
  items: Array<Maybe<CfContentPageModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfContentPageModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfContentPageModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfContentPageModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfContentPageModulesItem = CfBasicContent | CfComparisonModule | CfDynamicContent | CfManualCollection | CfProductCollection | CfPromotion | CfTerms;

export enum CfContentPageOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplate = CfEntry & {
  __typename?: 'CFContentTemplate';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfContentTemplateCentresCollection>;
  channel: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  data: Maybe<Scalars['CFJSON']['output']>;
  linkedFrom: Maybe<CfContentTemplateLinkingCollections>;
  scope: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  variant: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateChannelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateDataArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateScopeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/contentTemplate) */
export type CfContentTemplateVariantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfContentTemplateCentresCollection = {
  __typename?: 'CFContentTemplateCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfContentTemplateCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfContentTemplateCollection = {
  __typename?: 'CFContentTemplateCollection';
  items: Array<Maybe<CfContentTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfContentTemplateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfContentTemplateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfContentTemplateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  channel: InputMaybe<Scalars['String']['input']>;
  channel_contains: InputMaybe<Scalars['String']['input']>;
  channel_exists: InputMaybe<Scalars['Boolean']['input']>;
  channel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channel_not: InputMaybe<Scalars['String']['input']>;
  channel_not_contains: InputMaybe<Scalars['String']['input']>;
  channel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  data_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope: InputMaybe<Scalars['String']['input']>;
  scope_contains: InputMaybe<Scalars['String']['input']>;
  scope_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_not: InputMaybe<Scalars['String']['input']>;
  scope_not_contains: InputMaybe<Scalars['String']['input']>;
  scope_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentTemplateLinkingCollections = {
  __typename?: 'CFContentTemplateLinkingCollections';
  automatedContentSourceCollection: Maybe<CfAutomatedContentSourceCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  personalisedContentSourceCollection: Maybe<CfPersonalisedContentSourceCollection>;
};


export type CfContentTemplateLinkingCollectionsAutomatedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateLinkingCollectionsAutomatedContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentTemplateLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentTemplateLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentTemplateLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfContentTemplateLinkingCollectionsPersonalisedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateLinkingCollectionsPersonalisedContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfContentTemplateLinkingCollectionsAutomatedContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  PrioritiseItemsRelevantTodayAsc = 'prioritiseItemsRelevantToday_ASC',
  PrioritiseItemsRelevantTodayDesc = 'prioritiseItemsRelevantToday_DESC',
  RotateContentTypesAsc = 'rotateContentTypes_ASC',
  RotateContentTypesDesc = 'rotateContentTypes_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TopicsSortOrFilterAsc = 'topicsSortOrFilter_ASC',
  TopicsSortOrFilterDesc = 'topicsSortOrFilter_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfContentTemplateLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfContentTemplateLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfContentTemplateLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfContentTemplateLinkingCollectionsPersonalisedContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  MethodAsc = 'method_ASC',
  MethodDesc = 'method_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfContentTemplateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfContentfulMetadata = {
  __typename?: 'CFContentfulMetadata';
  tags: Array<Maybe<CfContentfulTag>>;
};

export type CfContentfulMetadataFilter = {
  tags: InputMaybe<CfContentfulMetadataTagsFilter>;
  tags_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfContentfulMetadataTagsFilter = {
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type CfContentfulTag = {
  __typename?: 'CFContentfulTag';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/digitalDirectory) */
export type CfDigitalDirectory = CfEntry & {
  __typename?: 'CFDigitalDirectory';
  _id: Scalars['ID']['output'];
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfDigitalDirectoryLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  waypoint: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/digitalDirectory) */
export type CfDigitalDirectoryCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/digitalDirectory) */
export type CfDigitalDirectoryLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/digitalDirectory) */
export type CfDigitalDirectorySlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/digitalDirectory) */
export type CfDigitalDirectoryTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/digitalDirectory) */
export type CfDigitalDirectoryWaypointArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfDigitalDirectoryCollection = {
  __typename?: 'CFDigitalDirectoryCollection';
  items: Array<Maybe<CfDigitalDirectory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfDigitalDirectoryFilter = {
  AND: InputMaybe<Array<InputMaybe<CfDigitalDirectoryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfDigitalDirectoryFilter>>>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  waypoint: InputMaybe<Scalars['String']['input']>;
  waypoint_contains: InputMaybe<Scalars['String']['input']>;
  waypoint_exists: InputMaybe<Scalars['Boolean']['input']>;
  waypoint_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  waypoint_not: InputMaybe<Scalars['String']['input']>;
  waypoint_not_contains: InputMaybe<Scalars['String']['input']>;
  waypoint_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfDigitalDirectoryLinkingCollections = {
  __typename?: 'CFDigitalDirectoryLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfDigitalDirectoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfDigitalDirectoryOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC'
}

/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategory = CfEntry & {
  __typename?: 'CFDirectCategory';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  blurbBody: Maybe<Scalars['String']['output']>;
  blurbTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  categoryPath: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  displaySiblingLinks: Maybe<Scalars['Boolean']['output']>;
  h1Header: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<CfDirectCategoryLinkingCollections>;
  metaDescription: Maybe<Scalars['String']['output']>;
  pageTitle: Maybe<Scalars['String']['output']>;
  relatedLinksCollection: Maybe<CfDirectCategoryRelatedLinksCollection>;
  sys: CfSys;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryBlurbBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryBlurbTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryDisplaySiblingLinksArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryH1HeaderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryLevelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryMetaDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add title and metadata information to Westfield Direct categories [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategory) */
export type CfDirectCategoryRelatedLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDirectCategoryRelatedLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfDirectCategoryRelatedLinkFilter>;
};

export type CfDirectCategoryCollection = {
  __typename?: 'CFDirectCategoryCollection';
  items: Array<Maybe<CfDirectCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfDirectCategoryFilter = {
  AND: InputMaybe<Array<InputMaybe<CfDirectCategoryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfDirectCategoryFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbBody: InputMaybe<Scalars['String']['input']>;
  blurbBody_contains: InputMaybe<Scalars['String']['input']>;
  blurbBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  blurbBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbBody_not: InputMaybe<Scalars['String']['input']>;
  blurbBody_not_contains: InputMaybe<Scalars['String']['input']>;
  blurbBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbTitle: InputMaybe<Scalars['String']['input']>;
  blurbTitle_contains: InputMaybe<Scalars['String']['input']>;
  blurbTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  blurbTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbTitle_not: InputMaybe<Scalars['String']['input']>;
  blurbTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  blurbTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryPath: InputMaybe<Scalars['String']['input']>;
  categoryPath_contains: InputMaybe<Scalars['String']['input']>;
  categoryPath_exists: InputMaybe<Scalars['Boolean']['input']>;
  categoryPath_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryPath_not: InputMaybe<Scalars['String']['input']>;
  categoryPath_not_contains: InputMaybe<Scalars['String']['input']>;
  categoryPath_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displaySiblingLinks: InputMaybe<Scalars['Boolean']['input']>;
  displaySiblingLinks_exists: InputMaybe<Scalars['Boolean']['input']>;
  displaySiblingLinks_not: InputMaybe<Scalars['Boolean']['input']>;
  h1Header: InputMaybe<Scalars['String']['input']>;
  h1Header_contains: InputMaybe<Scalars['String']['input']>;
  h1Header_exists: InputMaybe<Scalars['Boolean']['input']>;
  h1Header_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  h1Header_not: InputMaybe<Scalars['String']['input']>;
  h1Header_not_contains: InputMaybe<Scalars['String']['input']>;
  h1Header_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level: InputMaybe<Scalars['Int']['input']>;
  level_exists: InputMaybe<Scalars['Boolean']['input']>;
  level_gt: InputMaybe<Scalars['Int']['input']>;
  level_gte: InputMaybe<Scalars['Int']['input']>;
  level_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  level_lt: InputMaybe<Scalars['Int']['input']>;
  level_lte: InputMaybe<Scalars['Int']['input']>;
  level_not: InputMaybe<Scalars['Int']['input']>;
  level_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  metaDescription: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedLinks: InputMaybe<CfCfDirectCategoryRelatedLinkNestedFilter>;
  relatedLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfDirectCategoryLinkingCollections = {
  __typename?: 'CFDirectCategoryLinkingCollections';
  cannedSearchCollection: Maybe<CfCannedSearchCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfDirectCategoryLinkingCollectionsCannedSearchCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDirectCategoryLinkingCollectionsCannedSearchCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDirectCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfDirectCategoryLinkingCollectionsCannedSearchCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfDirectCategoryOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BlurbTitleAsc = 'blurbTitle_ASC',
  BlurbTitleDesc = 'blurbTitle_DESC',
  CategoryPathAsc = 'categoryPath_ASC',
  CategoryPathDesc = 'categoryPath_DESC',
  DisplaySiblingLinksAsc = 'displaySiblingLinks_ASC',
  DisplaySiblingLinksDesc = 'displaySiblingLinks_DESC',
  H1HeaderAsc = 'h1Header_ASC',
  H1HeaderDesc = 'h1Header_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Item for use in Westfield Direct Category > Related Links [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategoryRelatedLink) */
export type CfDirectCategoryRelatedLink = CfEntry & {
  __typename?: 'CFDirectCategoryRelatedLink';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  displayMode: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfDirectCategoryRelatedLinkLinkingCollections>;
  path: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** Item for use in Westfield Direct Category > Related Links [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategoryRelatedLink) */
export type CfDirectCategoryRelatedLinkBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Item for use in Westfield Direct Category > Related Links [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategoryRelatedLink) */
export type CfDirectCategoryRelatedLinkDisplayModeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Item for use in Westfield Direct Category > Related Links [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategoryRelatedLink) */
export type CfDirectCategoryRelatedLinkLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Item for use in Westfield Direct Category > Related Links [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategoryRelatedLink) */
export type CfDirectCategoryRelatedLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Item for use in Westfield Direct Category > Related Links [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directCategoryRelatedLink) */
export type CfDirectCategoryRelatedLinkPathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfDirectCategoryRelatedLinkCollection = {
  __typename?: 'CFDirectCategoryRelatedLinkCollection';
  items: Array<Maybe<CfDirectCategoryRelatedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfDirectCategoryRelatedLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<CfDirectCategoryRelatedLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfDirectCategoryRelatedLinkFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displayMode: InputMaybe<Scalars['String']['input']>;
  displayMode_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayMode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_not: InputMaybe<Scalars['String']['input']>;
  displayMode_not_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfDirectCategoryRelatedLinkLinkingCollections = {
  __typename?: 'CFDirectCategoryRelatedLinkLinkingCollections';
  directCategoryCollection: Maybe<CfDirectCategoryCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfDirectCategoryRelatedLinkLinkingCollectionsDirectCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDirectCategoryRelatedLinkLinkingCollectionsDirectCategoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDirectCategoryRelatedLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfDirectCategoryRelatedLinkLinkingCollectionsDirectCategoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BlurbTitleAsc = 'blurbTitle_ASC',
  BlurbTitleDesc = 'blurbTitle_DESC',
  CategoryPathAsc = 'categoryPath_ASC',
  CategoryPathDesc = 'categoryPath_DESC',
  DisplaySiblingLinksAsc = 'displaySiblingLinks_ASC',
  DisplaySiblingLinksDesc = 'displaySiblingLinks_DESC',
  H1HeaderAsc = 'h1Header_ASC',
  H1HeaderDesc = 'h1Header_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfDirectCategoryRelatedLinkOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfDirectCategoryRelatedLinksCollection = {
  __typename?: 'CFDirectCategoryRelatedLinksCollection';
  items: Array<Maybe<CfDirectCategoryRelatedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfDirectCategoryRelatedLinksCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotion = CfEntry & {
  __typename?: 'CFDirectPromotion';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  endDate: Maybe<Scalars['CFDateTime']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfDirectPromotionLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['CFDateTime']['output']>;
  sys: CfSys;
  talonOneId: Maybe<Scalars['String']['output']>;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionEndDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionStartDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionTalonOneIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionTermsAndConditionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/directPromotion) */
export type CfDirectPromotionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfDirectPromotionCollection = {
  __typename?: 'CFDirectPromotionCollection';
  items: Array<Maybe<CfDirectPromotion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfDirectPromotionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfDirectPromotionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfDirectPromotionFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  endDate: InputMaybe<Scalars['CFDateTime']['input']>;
  endDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  endDate_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endDate_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endDate_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endDate_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endDate_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endDate_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endDate_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: InputMaybe<Scalars['CFDateTime']['input']>;
  startDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  startDate_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startDate_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startDate_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startDate_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startDate_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startDate_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startDate_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  talonOneId: InputMaybe<Scalars['String']['input']>;
  talonOneId_contains: InputMaybe<Scalars['String']['input']>;
  talonOneId_exists: InputMaybe<Scalars['Boolean']['input']>;
  talonOneId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  talonOneId_not: InputMaybe<Scalars['String']['input']>;
  talonOneId_not_contains: InputMaybe<Scalars['String']['input']>;
  talonOneId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions_not: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfDirectPromotionLinkingCollections = {
  __typename?: 'CFDirectPromotionLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfDirectPromotionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfDirectPromotionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TalonOneIdAsc = 'talonOneId_ASC',
  TalonOneIdDesc = 'talonOneId_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/dynamicContent) */
export type CfDynamicContent = CfEntry & {
  __typename?: 'CFDynamicContent';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfDynamicContentLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/dynamicContent) */
export type CfDynamicContentBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/dynamicContent) */
export type CfDynamicContentLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfDynamicContentCollection = {
  __typename?: 'CFDynamicContentCollection';
  items: Array<Maybe<CfDynamicContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfDynamicContentFilter = {
  AND: InputMaybe<Array<InputMaybe<CfDynamicContentFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfDynamicContentFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfDynamicContentLinkingCollections = {
  __typename?: 'CFDynamicContentLinkingCollections';
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  nationalStorefrontCollection: Maybe<CfNationalStorefrontCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfDynamicContentLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDynamicContentLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDynamicContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDynamicContentLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDynamicContentLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDynamicContentLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDynamicContentLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDynamicContentLinkingCollectionsNationalStorefrontCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDynamicContentLinkingCollectionsNationalStorefrontCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfDynamicContentLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDynamicContentLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfDynamicContentLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfDynamicContentLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfDynamicContentLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfDynamicContentLinkingCollectionsNationalStorefrontCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfDynamicContentLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfDynamicContentOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfEntry = {
  contentfulMetadata: CfContentfulMetadata;
  sys: CfSys;
};

export type CfEntryCollection = {
  __typename?: 'CFEntryCollection';
  items: Array<Maybe<CfEntry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfEntryFilter = {
  AND: InputMaybe<Array<InputMaybe<CfEntryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfEntryFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export enum CfEntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfEntryTodayItem = {
  __typename?: 'CFEntryTodayItem';
  entry: CfEntryTodayItemEntry;
};

export type CfEntryTodayItemEntry = CfEvent | CfNews | CfOffer | CfStore | SgGenericTodayItemEntry;

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEvent = CfEntry & {
  __typename?: 'CFEvent';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  bookingDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated Event bookings is not ready for production and will be revisited in the future. */
  bookingInfo: Maybe<BookingInfoResult>;
  callsToActionCollection: Maybe<CfEventCallsToActionCollection>;
  centresCollection: Maybe<CfEventCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  endAt: Maybe<Scalars['CFDateTime']['output']>;
  experiencesCollection: Maybe<CfEventExperiencesCollection>;
  hasModeratedImages: Maybe<Scalars['Boolean']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  highlightAttribute: Maybe<HighlightAttributes>;
  hosted: Maybe<Scalars['String']['output']>;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  landmarkDescription: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfEventLinkingCollections>;
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  occurrenceMeta: Maybe<Scalars['CFJSON']['output']>;
  occurrencesCollection: Maybe<CfEventOccurrencesCollection>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  priceDescription: Maybe<Scalars['String']['output']>;
  retailCategoriesCollection: Maybe<CfEventRetailCategoriesCollection>;
  reviewStatus: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  showAt: Maybe<Scalars['CFDateTime']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sponsored: Maybe<Scalars['Boolean']['output']>;
  startAt: Maybe<Scalars['CFDateTime']['output']>;
  storesCollection: Maybe<CfEventStoresCollection>;
  supportingImageSet: Maybe<CfSupportingImageSet>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: CfSys;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfEventTopicsCollection>;
  viewOption: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventBookingDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventCallsToActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventCallsToActionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCallToActionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventEdmSubheadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventEdmSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventEdmTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventEndAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventHasModeratedImagesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventHostedArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventIsSensitiveContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventLandmarkDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventLevelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventMemberExclusiveArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventOccurrenceMetaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventOccurrencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventOccurrencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfOccurrenceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventPhysicalAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventPriceDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventReviewStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventShowAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventSponsoredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventStartAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventSupportingImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfSupportingImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventSurfaceContentInChannelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventTermsAndConditionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/event) */
export type CfEventViewOptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfEventCallsToActionCollection = {
  __typename?: 'CFEventCallsToActionCollection';
  items: Array<Maybe<CfCallToAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfEventCallsToActionCollectionOrder {
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfEventCentresCollection = {
  __typename?: 'CFEventCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfEventCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfEventCollection = {
  __typename?: 'CFEventCollection';
  items: Array<Maybe<CfEvent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfEventExperiencesCollection = {
  __typename?: 'CFEventExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfEventExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfEventFilter = {
  AND: InputMaybe<Array<InputMaybe<CfEventFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfEventFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bookingDescription: InputMaybe<Scalars['String']['input']>;
  bookingDescription_contains: InputMaybe<Scalars['String']['input']>;
  bookingDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  bookingDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bookingDescription_not: InputMaybe<Scalars['String']['input']>;
  bookingDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  bookingDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callsToAction: InputMaybe<CfCfCallToActionNestedFilter>;
  callsToActionCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubheading: InputMaybe<Scalars['String']['input']>;
  edmSubheading_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubheading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading_not: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle: InputMaybe<Scalars['String']['input']>;
  edmTitle_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle_not: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_not: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hosted: InputMaybe<Scalars['String']['input']>;
  hosted_contains: InputMaybe<Scalars['String']['input']>;
  hosted_exists: InputMaybe<Scalars['Boolean']['input']>;
  hosted_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hosted_not: InputMaybe<Scalars['String']['input']>;
  hosted_not_contains: InputMaybe<Scalars['String']['input']>;
  hosted_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSensitiveContent: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_not: InputMaybe<Scalars['Boolean']['input']>;
  landmarkDescription: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  landmarkDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription_not: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level: InputMaybe<Scalars['String']['input']>;
  level_contains: InputMaybe<Scalars['String']['input']>;
  level_exists: InputMaybe<Scalars['Boolean']['input']>;
  level_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not: InputMaybe<Scalars['String']['input']>;
  level_not_contains: InputMaybe<Scalars['String']['input']>;
  level_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  memberExclusive: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_exists: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_not: InputMaybe<Scalars['Boolean']['input']>;
  occurrenceMeta_exists: InputMaybe<Scalars['Boolean']['input']>;
  occurrences: InputMaybe<CfCfOccurrenceNestedFilter>;
  occurrencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription: InputMaybe<Scalars['String']['input']>;
  priceDescription_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription_not: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus: InputMaybe<Scalars['String']['input']>;
  reviewStatus_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewStatus_not: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  supportingImageSet: InputMaybe<CfCfSupportingImageSetNestedFilter>;
  supportingImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  surfaceContentInChannel_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions_not: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption: InputMaybe<Scalars['String']['input']>;
  viewOption_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewOption_not: InputMaybe<Scalars['String']['input']>;
  viewOption_not_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfEventLinkingCollections = {
  __typename?: 'CFEventLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
};


export type CfEventLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfEventLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfEventLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfEventLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfEventLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfEventLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfEventLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfEventLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfEventLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfEventLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfEventLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfEventLinkingCollectionsPartnerPortalPermissionCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type CfEventOccurrencesCollection = {
  __typename?: 'CFEventOccurrencesCollection';
  items: Array<Maybe<CfOccurrence>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfEventOccurrencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfEventOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export type CfEventRetailCategoriesCollection = {
  __typename?: 'CFEventRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfEventRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfEventStoresCollection = {
  __typename?: 'CFEventStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfEventStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfEventStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfEventTopicsCollection = {
  __typename?: 'CFEventTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfEventTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSource = CfEntry & {
  __typename?: 'CFExclusionsContentSource';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfExclusionsContentSourceCentresCollection>;
  contentTemplatesCollection: Maybe<CfExclusionsContentSourceContentTemplatesCollection>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfExclusionsContentSourceLinkingCollections>;
  manualCorpusCollection: Maybe<CfExclusionsContentSourceManualCorpusCollection>;
  sys: CfSys;
  variant: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSourceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSourceCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSourceContentTemplatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceContentTemplatesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentTemplateFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSourceManualCorpusCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExclusionsContentSourceManualCorpusFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/exclusionsContentSource) */
export type CfExclusionsContentSourceVariantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfExclusionsContentSourceCentresCollection = {
  __typename?: 'CFExclusionsContentSourceCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfExclusionsContentSourceCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfExclusionsContentSourceCollection = {
  __typename?: 'CFExclusionsContentSourceCollection';
  items: Array<Maybe<CfExclusionsContentSource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfExclusionsContentSourceContentTemplatesCollection = {
  __typename?: 'CFExclusionsContentSourceContentTemplatesCollection';
  items: Array<Maybe<CfContentTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfExclusionsContentSourceContentTemplatesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfExclusionsContentSourceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTemplates: InputMaybe<CfCfContentTemplateNestedFilter>;
  contentTemplatesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  manualCorpus: InputMaybe<CfCfmanualCorpusMultiTypeNestedFilter>;
  manualCorpusCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfExclusionsContentSourceLinkingCollections = {
  __typename?: 'CFExclusionsContentSourceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfExclusionsContentSourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfExclusionsContentSourceManualCorpusCollection = {
  __typename?: 'CFExclusionsContentSourceManualCorpusCollection';
  items: Array<Maybe<CfExclusionsContentSourceManualCorpusItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfExclusionsContentSourceManualCorpusFilter = {
  AND: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceManualCorpusFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceManualCorpusFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfExclusionsContentSourceManualCorpusItem = CfEvent | CfFeaturedLink | CfNews | CfOffer | CfProductCollection | CfStory;

export enum CfExclusionsContentSourceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperience = CfEntry & {
  __typename?: 'CFExperience';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  heroImageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfExperienceLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/experience) */
export type CfExperienceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfExperienceCollection = {
  __typename?: 'CFExperienceCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfExperienceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfExperienceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfExperienceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfExperienceLinkingCollections = {
  __typename?: 'CFExperienceLinkingCollections';
  automatedCollectionCollection: Maybe<CfAutomatedCollectionCollection>;
  automatedContentSourceCollection: Maybe<CfAutomatedContentSourceCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  featuredCommerceCollection: Maybe<CfFeaturedCommerceCollection>;
  introductionsCollection: Maybe<CfIntroductionsCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
  storeCollection: Maybe<CfStoreCollection>;
  storyCollection: Maybe<CfStoryCollection>;
  whatsHappeningFiltersCollection: Maybe<CfWhatsHappeningFiltersCollection>;
};


export type CfExperienceLinkingCollectionsAutomatedCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsAutomatedCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsAutomatedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsAutomatedContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsFeaturedCommerceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsFeaturedCommerceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsIntroductionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsIntroductionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfExperienceLinkingCollectionsWhatsHappeningFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceLinkingCollectionsWhatsHappeningFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfExperienceLinkingCollectionsAutomatedCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  ContentLimitAsc = 'contentLimit_ASC',
  ContentLimitDesc = 'contentLimit_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfExperienceLinkingCollectionsAutomatedContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  PrioritiseItemsRelevantTodayAsc = 'prioritiseItemsRelevantToday_ASC',
  PrioritiseItemsRelevantTodayDesc = 'prioritiseItemsRelevantToday_DESC',
  RotateContentTypesAsc = 'rotateContentTypes_ASC',
  RotateContentTypesDesc = 'rotateContentTypes_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TopicsSortOrFilterAsc = 'topicsSortOrFilter_ASC',
  TopicsSortOrFilterDesc = 'topicsSortOrFilter_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfExperienceLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfExperienceLinkingCollectionsFeaturedCommerceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfExperienceLinkingCollectionsIntroductionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfExperienceLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfExperienceLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfExperienceLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfExperienceLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfExperienceLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfExperienceLinkingCollectionsWhatsHappeningFiltersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfExperienceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featureManagement) */
export type CfFeatureManagement = CfEntry & {
  __typename?: 'CFFeatureManagement';
  _id: Scalars['ID']['output'];
  contentfulMetadata: CfContentfulMetadata;
  featureSlug: Maybe<Scalars['String']['output']>;
  json: Maybe<Scalars['CFJSON']['output']>;
  linkedFrom: Maybe<CfFeatureManagementLinkingCollections>;
  scope: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featureManagement) */
export type CfFeatureManagementFeatureSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featureManagement) */
export type CfFeatureManagementJsonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featureManagement) */
export type CfFeatureManagementLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featureManagement) */
export type CfFeatureManagementScopeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfFeatureManagementCollection = {
  __typename?: 'CFFeatureManagementCollection';
  items: Array<Maybe<CfFeatureManagement>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfFeatureManagementFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFeatureManagementFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFeatureManagementFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  featureSlug: InputMaybe<Scalars['String']['input']>;
  featureSlug_contains: InputMaybe<Scalars['String']['input']>;
  featureSlug_exists: InputMaybe<Scalars['Boolean']['input']>;
  featureSlug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureSlug_not: InputMaybe<Scalars['String']['input']>;
  featureSlug_not_contains: InputMaybe<Scalars['String']['input']>;
  featureSlug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  json_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope: InputMaybe<Scalars['String']['input']>;
  scope_contains: InputMaybe<Scalars['String']['input']>;
  scope_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_not: InputMaybe<Scalars['String']['input']>;
  scope_not_contains: InputMaybe<Scalars['String']['input']>;
  scope_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfFeatureManagementLinkingCollections = {
  __typename?: 'CFFeatureManagementLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfFeatureManagementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfFeatureManagementOrder {
  FeatureSlugAsc = 'featureSlug_ASC',
  FeatureSlugDesc = 'featureSlug_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerce = CfEntry & {
  __typename?: 'CFFeaturedCommerce';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  experiencesCollection: Maybe<CfFeaturedCommerceExperiencesCollection>;
  externalLink: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  linkedFrom: Maybe<CfFeaturedCommerceLinkingCollections>;
  priceDescription: Maybe<Scalars['String']['output']>;
  retailCategoriesCollection: Maybe<CfFeaturedCommerceRetailCategoriesCollection>;
  shortDescription: Maybe<Scalars['String']['output']>;
  storesCollection: Maybe<CfFeaturedCommerceStoresCollection>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfFeaturedCommerceTopicsCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedCommerceExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceExternalLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommercePriceDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedCommerceRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedCommerceStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredCommerce) */
export type CfFeaturedCommerceTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedCommerceTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};

export type CfFeaturedCommerceCollection = {
  __typename?: 'CFFeaturedCommerceCollection';
  items: Array<Maybe<CfFeaturedCommerce>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfFeaturedCommerceExperiencesCollection = {
  __typename?: 'CFFeaturedCommerceExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfFeaturedCommerceExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfFeaturedCommerceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFeaturedCommerceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFeaturedCommerceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  externalLink: InputMaybe<Scalars['String']['input']>;
  externalLink_contains: InputMaybe<Scalars['String']['input']>;
  externalLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  externalLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalLink_not: InputMaybe<Scalars['String']['input']>;
  externalLink_not_contains: InputMaybe<Scalars['String']['input']>;
  externalLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  priceDescription: InputMaybe<Scalars['String']['input']>;
  priceDescription_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription_not: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfFeaturedCommerceLinkingCollections = {
  __typename?: 'CFFeaturedCommerceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfFeaturedCommerceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfFeaturedCommerceLinkingCollectionsPartnerPortalPermissionCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum CfFeaturedCommerceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfFeaturedCommerceRetailCategoriesCollection = {
  __typename?: 'CFFeaturedCommerceRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfFeaturedCommerceRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfFeaturedCommerceStoresCollection = {
  __typename?: 'CFFeaturedCommerceStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfFeaturedCommerceStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfFeaturedCommerceStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfFeaturedCommerceTopicsCollection = {
  __typename?: 'CFFeaturedCommerceTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfFeaturedCommerceTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfFeaturedEntryTodayItem = {
  __typename?: 'CFFeaturedEntryTodayItem';
  entries: Array<Maybe<CfEntryTodayItemEntry>>;
  leadEntry: Maybe<CfEntryTodayItemEntry>;
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLink = CfEntry & {
  __typename?: 'CFFeaturedLink';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  edmSubject: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfFeaturedLinkLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  textColour: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkEdmSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkTextColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/featuredLink) */
export type CfFeaturedLinkUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfFeaturedLinkCollection = {
  __typename?: 'CFFeaturedLinkCollection';
  items: Array<Maybe<CfFeaturedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfFeaturedLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFeaturedLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFeaturedLinkFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  textColour: InputMaybe<Scalars['String']['input']>;
  textColour_contains: InputMaybe<Scalars['String']['input']>;
  textColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  textColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textColour_not: InputMaybe<Scalars['String']['input']>;
  textColour_not_contains: InputMaybe<Scalars['String']['input']>;
  textColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfFeaturedLinkLinkingCollections = {
  __typename?: 'CFFeaturedLinkLinkingCollections';
  comparisonItemCollection: Maybe<CfComparisonItemCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  introductionsCollection: Maybe<CfIntroductionsCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
  searchSuggestionsCollection: Maybe<CfSearchSuggestionsCollection>;
  utilityPanelCollection: Maybe<CfUtilityPanelCollection>;
};


export type CfFeaturedLinkLinkingCollectionsComparisonItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsComparisonItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsIntroductionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsIntroductionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsSearchSuggestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsSearchSuggestionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfFeaturedLinkLinkingCollectionsUtilityPanelCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkLinkingCollectionsUtilityPanelCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfFeaturedLinkLinkingCollectionsComparisonItemCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ProductNameAsc = 'productName_ASC',
  ProductNameDesc = 'productName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsIntroductionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsSearchSuggestionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ContextAsc = 'context_ASC',
  ContextDesc = 'context_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfFeaturedLinkLinkingCollectionsUtilityPanelCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfFeaturedLinkOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColourAsc = 'textColour_ASC',
  TextColourDesc = 'textColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSource = CfEntry & {
  __typename?: 'CFGenderSegmentedManualContentSource';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfGenderSegmentedManualContentSourceCentresCollection>;
  contentTemplatesCollection: Maybe<CfGenderSegmentedManualContentSourceContentTemplatesCollection>;
  contentfulMetadata: CfContentfulMetadata;
  count: Maybe<Scalars['Int']['output']>;
  femaleCorpusCollection: Maybe<CfGenderSegmentedManualContentSourceFemaleCorpusCollection>;
  linkedFrom: Maybe<CfGenderSegmentedManualContentSourceLinkingCollections>;
  maleCorpusCollection: Maybe<CfGenderSegmentedManualContentSourceMaleCorpusCollection>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  unknownCorpusCollection: Maybe<CfGenderSegmentedManualContentSourceUnknownCorpusCollection>;
  variant: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceContentTemplatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceContentTemplatesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentTemplateFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceCountArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceFemaleCorpusCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGenderSegmentedManualContentSourceFemaleCorpusFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceMaleCorpusCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGenderSegmentedManualContentSourceMaleCorpusFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceUnknownCorpusCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGenderSegmentedManualContentSourceUnknownCorpusFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genderSegmentedManualContentSource) */
export type CfGenderSegmentedManualContentSourceVariantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfGenderSegmentedManualContentSourceCentresCollection = {
  __typename?: 'CFGenderSegmentedManualContentSourceCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfGenderSegmentedManualContentSourceCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfGenderSegmentedManualContentSourceCollection = {
  __typename?: 'CFGenderSegmentedManualContentSourceCollection';
  items: Array<Maybe<CfGenderSegmentedManualContentSource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGenderSegmentedManualContentSourceContentTemplatesCollection = {
  __typename?: 'CFGenderSegmentedManualContentSourceContentTemplatesCollection';
  items: Array<Maybe<CfContentTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfGenderSegmentedManualContentSourceContentTemplatesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfGenderSegmentedManualContentSourceFemaleCorpusCollection = {
  __typename?: 'CFGenderSegmentedManualContentSourceFemaleCorpusCollection';
  items: Array<Maybe<CfGenderSegmentedManualContentSourceFemaleCorpusItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGenderSegmentedManualContentSourceFemaleCorpusFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceFemaleCorpusFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceFemaleCorpusFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfGenderSegmentedManualContentSourceFemaleCorpusItem = CfEvent | CfFeaturedLink | CfGenericAdZone | CfNews | CfOffer | CfProductCollection | CfRetailer | CfService | CfStore | CfStory;

export type CfGenderSegmentedManualContentSourceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTemplates: InputMaybe<CfCfContentTemplateNestedFilter>;
  contentTemplatesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  count: InputMaybe<Scalars['Int']['input']>;
  count_exists: InputMaybe<Scalars['Boolean']['input']>;
  count_gt: InputMaybe<Scalars['Int']['input']>;
  count_gte: InputMaybe<Scalars['Int']['input']>;
  count_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_lt: InputMaybe<Scalars['Int']['input']>;
  count_lte: InputMaybe<Scalars['Int']['input']>;
  count_not: InputMaybe<Scalars['Int']['input']>;
  count_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  femaleCorpus: InputMaybe<CfCffemaleCorpusMultiTypeNestedFilter>;
  femaleCorpusCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  maleCorpus: InputMaybe<CfCfmaleCorpusMultiTypeNestedFilter>;
  maleCorpusCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  unknownCorpus: InputMaybe<CfCfunknownCorpusMultiTypeNestedFilter>;
  unknownCorpusCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGenderSegmentedManualContentSourceLinkingCollections = {
  __typename?: 'CFGenderSegmentedManualContentSourceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfGenderSegmentedManualContentSourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfGenderSegmentedManualContentSourceMaleCorpusCollection = {
  __typename?: 'CFGenderSegmentedManualContentSourceMaleCorpusCollection';
  items: Array<Maybe<CfGenderSegmentedManualContentSourceMaleCorpusItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGenderSegmentedManualContentSourceMaleCorpusFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceMaleCorpusFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceMaleCorpusFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfGenderSegmentedManualContentSourceMaleCorpusItem = CfEvent | CfFeaturedLink | CfGenericAdZone | CfNews | CfOffer | CfProductCollection | CfRetailer | CfService | CfStore | CfStory;

export enum CfGenderSegmentedManualContentSourceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfGenderSegmentedManualContentSourceUnknownCorpusCollection = {
  __typename?: 'CFGenderSegmentedManualContentSourceUnknownCorpusCollection';
  items: Array<Maybe<CfGenderSegmentedManualContentSourceUnknownCorpusItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGenderSegmentedManualContentSourceUnknownCorpusFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceUnknownCorpusFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceUnknownCorpusFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfGenderSegmentedManualContentSourceUnknownCorpusItem = CfEvent | CfFeaturedLink | CfGenericAdZone | CfNews | CfOffer | CfProductCollection | CfRetailer | CfService | CfStore | CfStory;

/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZone = CfEntry & {
  __typename?: 'CFGenericAdZone';
  _id: Scalars['ID']['output'];
  adTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom: Maybe<CfGenericAdZoneLinkingCollections>;
  siteId: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  zoneId: Maybe<Scalars['String']['output']>;
};


/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZoneAdTypesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZoneBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZoneKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZoneLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZoneSiteIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Generic ad zone to act as a sentinel for a adserver ad [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/genericAdZone) */
export type CfGenericAdZoneZoneIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfGenericAdZoneCollection = {
  __typename?: 'CFGenericAdZoneCollection';
  items: Array<Maybe<CfGenericAdZone>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGenericAdZoneFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGenericAdZoneFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGenericAdZoneFilter>>>;
  adTypes_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adTypes_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adTypes_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adTypes_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  keywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  siteId: InputMaybe<Scalars['String']['input']>;
  siteId_contains: InputMaybe<Scalars['String']['input']>;
  siteId_exists: InputMaybe<Scalars['Boolean']['input']>;
  siteId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId_not: InputMaybe<Scalars['String']['input']>;
  siteId_not_contains: InputMaybe<Scalars['String']['input']>;
  siteId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  zoneId: InputMaybe<Scalars['String']['input']>;
  zoneId_contains: InputMaybe<Scalars['String']['input']>;
  zoneId_exists: InputMaybe<Scalars['Boolean']['input']>;
  zoneId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoneId_not: InputMaybe<Scalars['String']['input']>;
  zoneId_not_contains: InputMaybe<Scalars['String']['input']>;
  zoneId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGenericAdZoneLinkingCollections = {
  __typename?: 'CFGenericAdZoneLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
};


export type CfGenericAdZoneLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfGenericAdZoneLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenericAdZoneLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfGenericAdZoneLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenericAdZoneLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfGenericAdZoneLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenericAdZoneLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfGenericAdZoneLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfGenericAdZoneLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfGenericAdZoneLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfGenericAdZoneOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SiteIdAsc = 'siteId_ASC',
  SiteIdDesc = 'siteId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ZoneIdAsc = 'zoneId_ASC',
  ZoneIdDesc = 'zoneId_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplate = CfEntry & {
  __typename?: 'CFGiftcardTemplate';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfGiftcardTemplateLinkingCollections>;
  modulesCollection: Maybe<CfGiftcardTemplateModulesCollection>;
  path: Maybe<Scalars['String']['output']>;
  shortDescriptionMetaDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplateModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGiftcardTemplateModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplatePathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplateShortDescriptionMetaDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/giftcardTemplate) */
export type CfGiftcardTemplateTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfGiftcardTemplateCollection = {
  __typename?: 'CFGiftcardTemplateCollection';
  items: Array<Maybe<CfGiftcardTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGiftcardTemplateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGiftcardTemplateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGiftcardTemplateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescriptionMetaDescription: InputMaybe<Scalars['String']['input']>;
  shortDescriptionMetaDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescriptionMetaDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescriptionMetaDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescriptionMetaDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescriptionMetaDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescriptionMetaDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGiftcardTemplateLinkingCollections = {
  __typename?: 'CFGiftcardTemplateLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfGiftcardTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfGiftcardTemplateModulesCollection = {
  __typename?: 'CFGiftcardTemplateModulesCollection';
  items: Array<Maybe<CfGiftcardTemplateModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfGiftcardTemplateModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfGiftcardTemplateModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfGiftcardTemplateModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfGiftcardTemplateModulesItem = CfContentBlock | CfManualCollection | CfSection;

export enum CfGiftcardTemplateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionMetaDescriptionAsc = 'shortDescriptionMetaDescription_ASC',
  ShortDescriptionMetaDescriptionDesc = 'shortDescriptionMetaDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSet = CfEntry & {
  __typename?: 'CFHeroImageSet';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderMaster: Maybe<Scalars['CFJSON']['output']>;
  bynderMasterCinemagraph: Maybe<Scalars['CFJSON']['output']>;
  bynderPoster: Maybe<Scalars['CFJSON']['output']>;
  bynderSquare: Maybe<Scalars['CFJSON']['output']>;
  bynderStandard: Maybe<Scalars['CFJSON']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfHeroImageSetLinkingCollections>;
  master: Maybe<CfAsset>;
  masterCinemagraph: Maybe<CfAsset>;
  masterSupportingColour: Maybe<Scalars['String']['output']>;
  poster: Maybe<CfAsset>;
  publishableStatus: Maybe<Scalars['String']['output']>;
  square: Maybe<CfAsset>;
  squareSupportingColour: Maybe<Scalars['String']['output']>;
  standard: Maybe<CfAsset>;
  standardSupportingColour: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetBynderMasterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetBynderMasterCinemagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetBynderPosterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetBynderSquareArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetBynderStandardArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetMasterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetMasterCinemagraphArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetMasterSupportingColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetPosterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetPublishableStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetSquareArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetSquareSupportingColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetStandardArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/heroImageSet) */
export type CfHeroImageSetStandardSupportingColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfHeroImageSetCollection = {
  __typename?: 'CFHeroImageSetCollection';
  items: Array<Maybe<CfHeroImageSet>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfHeroImageSetFilter = {
  AND: InputMaybe<Array<InputMaybe<CfHeroImageSetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfHeroImageSetFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderMasterCinemagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderMaster_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderPoster_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderSquare_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderStandard_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masterCinemagraph_exists: InputMaybe<Scalars['Boolean']['input']>;
  masterSupportingColour: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_contains: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  masterSupportingColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  masterSupportingColour_not: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_not_contains: InputMaybe<Scalars['String']['input']>;
  masterSupportingColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  master_exists: InputMaybe<Scalars['Boolean']['input']>;
  poster_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishableStatus: InputMaybe<Scalars['String']['input']>;
  publishableStatus_contains: InputMaybe<Scalars['String']['input']>;
  publishableStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishableStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishableStatus_not: InputMaybe<Scalars['String']['input']>;
  publishableStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  publishableStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  squareSupportingColour: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_contains: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  squareSupportingColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  squareSupportingColour_not: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_not_contains: InputMaybe<Scalars['String']['input']>;
  squareSupportingColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  square_exists: InputMaybe<Scalars['Boolean']['input']>;
  standardSupportingColour: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_contains: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  standardSupportingColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  standardSupportingColour_not: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_not_contains: InputMaybe<Scalars['String']['input']>;
  standardSupportingColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  standard_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfHeroImageSetLinkingCollections = {
  __typename?: 'CFHeroImageSetLinkingCollections';
  comparisonItemCollection: Maybe<CfComparisonItemCollection>;
  directPromotionCollection: Maybe<CfDirectPromotionCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  experienceCollection: Maybe<CfExperienceCollection>;
  featuredCommerceCollection: Maybe<CfFeaturedCommerceCollection>;
  featuredLinkCollection: Maybe<CfFeaturedLinkCollection>;
  journeyBannerCollection: Maybe<CfJourneyBannerCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  productCollectionCollection: Maybe<CfProductCollectionCollection>;
  retailCategoryCollection: Maybe<CfRetailCategoryCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
  serviceCollection: Maybe<CfServiceCollection>;
  storeCollection: Maybe<CfStoreCollection>;
  storyCollection: Maybe<CfStoryCollection>;
  topicCollection: Maybe<CfTopicCollection>;
};


export type CfHeroImageSetLinkingCollectionsComparisonItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsComparisonItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsDirectPromotionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsDirectPromotionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsExperienceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsExperienceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsFeaturedCommerceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsFeaturedCommerceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsFeaturedLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsFeaturedLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsJourneyBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsJourneyBannerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsProductCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsProductCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsRetailCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsRetailCategoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsServiceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfHeroImageSetLinkingCollectionsTopicCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetLinkingCollectionsTopicCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfHeroImageSetLinkingCollectionsComparisonItemCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ProductNameAsc = 'productName_ASC',
  ProductNameDesc = 'productName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfHeroImageSetLinkingCollectionsDirectPromotionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TalonOneIdAsc = 'talonOneId_ASC',
  TalonOneIdDesc = 'talonOneId_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfHeroImageSetLinkingCollectionsExperienceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsFeaturedCommerceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsFeaturedLinkCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColourAsc = 'textColour_ASC',
  TextColourDesc = 'textColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum CfHeroImageSetLinkingCollectionsJourneyBannerCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfHeroImageSetLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfHeroImageSetLinkingCollectionsProductCollectionCollectionOrder {
  AllowAutoSurfaceAsc = 'allowAutoSurface_ASC',
  AllowAutoSurfaceDesc = 'allowAutoSurface_DESC',
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BlurbTitleAsc = 'blurbTitle_ASC',
  BlurbTitleDesc = 'blurbTitle_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  H1HeaderAsc = 'h1Header_ASC',
  H1HeaderDesc = 'h1Header_DESC',
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsRetailCategoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfHeroImageSetLinkingCollectionsServiceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfHeroImageSetLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfHeroImageSetLinkingCollectionsTopicCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfHeroImageSetOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  MasterSupportingColourAsc = 'masterSupportingColour_ASC',
  MasterSupportingColourDesc = 'masterSupportingColour_DESC',
  PublishableStatusAsc = 'publishableStatus_ASC',
  PublishableStatusDesc = 'publishableStatus_DESC',
  SquareSupportingColourAsc = 'squareSupportingColour_ASC',
  SquareSupportingColourDesc = 'squareSupportingColour_DESC',
  StandardSupportingColourAsc = 'standardSupportingColour_ASC',
  StandardSupportingColourDesc = 'standardSupportingColour_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum CfImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum CfImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type CfImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor: InputMaybe<Scalars['CFHexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format: InputMaybe<CfImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height: InputMaybe<Scalars['CFDimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality: InputMaybe<Scalars['CFQuality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus: InputMaybe<CfImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy: InputMaybe<CfImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width: InputMaybe<Scalars['CFDimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDraw = CfEntry & {
  __typename?: 'CFInstantDraw';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  callToAction: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  drumRollAnimation: Maybe<Scalars['String']['output']>;
  faqUrl: Maybe<Scalars['String']['output']>;
  inCentrePresenceCheck: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<CfInstantDrawLinkingCollections>;
  prizeCount: Maybe<Scalars['Float']['output']>;
  sendSuccessEmail: Maybe<Scalars['Boolean']['output']>;
  successBody: Maybe<Scalars['String']['output']>;
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  successTitle: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  unluckyScreenAnimation: Maybe<Scalars['String']['output']>;
  unluckySubTitle: Maybe<Scalars['String']['output']>;
  unluckyTitle: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawCallToActionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawDrumRollAnimationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawFaqUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawInCentrePresenceCheckArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawPrizeCountArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawSendSuccessEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawSuccessBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawSuccessEmailAdditionalCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawSuccessTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawUnluckyScreenAnimationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawUnluckySubTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantDraw) */
export type CfInstantDrawUnluckyTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfInstantDrawCollection = {
  __typename?: 'CFInstantDrawCollection';
  items: Array<Maybe<CfInstantDraw>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfInstantDrawFilter = {
  AND: InputMaybe<Array<InputMaybe<CfInstantDrawFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfInstantDrawFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToAction: InputMaybe<Scalars['String']['input']>;
  callToAction_contains: InputMaybe<Scalars['String']['input']>;
  callToAction_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToAction_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToAction_not: InputMaybe<Scalars['String']['input']>;
  callToAction_not_contains: InputMaybe<Scalars['String']['input']>;
  callToAction_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  drumRollAnimation: InputMaybe<Scalars['String']['input']>;
  drumRollAnimation_contains: InputMaybe<Scalars['String']['input']>;
  drumRollAnimation_exists: InputMaybe<Scalars['Boolean']['input']>;
  drumRollAnimation_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  drumRollAnimation_not: InputMaybe<Scalars['String']['input']>;
  drumRollAnimation_not_contains: InputMaybe<Scalars['String']['input']>;
  drumRollAnimation_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqUrl: InputMaybe<Scalars['String']['input']>;
  faqUrl_contains: InputMaybe<Scalars['String']['input']>;
  faqUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  faqUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqUrl_not: InputMaybe<Scalars['String']['input']>;
  faqUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  faqUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inCentrePresenceCheck: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_exists: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_not: InputMaybe<Scalars['Boolean']['input']>;
  prizeCount: InputMaybe<Scalars['Float']['input']>;
  prizeCount_exists: InputMaybe<Scalars['Boolean']['input']>;
  prizeCount_gt: InputMaybe<Scalars['Float']['input']>;
  prizeCount_gte: InputMaybe<Scalars['Float']['input']>;
  prizeCount_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prizeCount_lt: InputMaybe<Scalars['Float']['input']>;
  prizeCount_lte: InputMaybe<Scalars['Float']['input']>;
  prizeCount_not: InputMaybe<Scalars['Float']['input']>;
  prizeCount_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sendSuccessEmail: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_not: InputMaybe<Scalars['Boolean']['input']>;
  successBody: InputMaybe<Scalars['String']['input']>;
  successBody_contains: InputMaybe<Scalars['String']['input']>;
  successBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  successBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successBody_not: InputMaybe<Scalars['String']['input']>;
  successBody_not_contains: InputMaybe<Scalars['String']['input']>;
  successBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy_not: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitle: InputMaybe<Scalars['String']['input']>;
  successTitle_contains: InputMaybe<Scalars['String']['input']>;
  successTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  successTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitle_not: InputMaybe<Scalars['String']['input']>;
  successTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  successTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  unluckyScreenAnimation: InputMaybe<Scalars['String']['input']>;
  unluckyScreenAnimation_contains: InputMaybe<Scalars['String']['input']>;
  unluckyScreenAnimation_exists: InputMaybe<Scalars['Boolean']['input']>;
  unluckyScreenAnimation_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unluckyScreenAnimation_not: InputMaybe<Scalars['String']['input']>;
  unluckyScreenAnimation_not_contains: InputMaybe<Scalars['String']['input']>;
  unluckyScreenAnimation_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unluckySubTitle: InputMaybe<Scalars['String']['input']>;
  unluckySubTitle_contains: InputMaybe<Scalars['String']['input']>;
  unluckySubTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  unluckySubTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unluckySubTitle_not: InputMaybe<Scalars['String']['input']>;
  unluckySubTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  unluckySubTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unluckyTitle: InputMaybe<Scalars['String']['input']>;
  unluckyTitle_contains: InputMaybe<Scalars['String']['input']>;
  unluckyTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  unluckyTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unluckyTitle_not: InputMaybe<Scalars['String']['input']>;
  unluckyTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  unluckyTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfInstantDrawLinkingCollections = {
  __typename?: 'CFInstantDrawLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  offerCollection: Maybe<CfOfferCollection>;
};


export type CfInstantDrawLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfInstantDrawLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfInstantDrawLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfInstantDrawLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfInstantDrawOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAsc = 'callToAction_ASC',
  CallToActionDesc = 'callToAction_DESC',
  DrumRollAnimationAsc = 'drumRollAnimation_ASC',
  DrumRollAnimationDesc = 'drumRollAnimation_DESC',
  FaqUrlAsc = 'faqUrl_ASC',
  FaqUrlDesc = 'faqUrl_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  PrizeCountAsc = 'prizeCount_ASC',
  PrizeCountDesc = 'prizeCount_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  SuccessBodyAsc = 'successBody_ASC',
  SuccessBodyDesc = 'successBody_DESC',
  SuccessTitleAsc = 'successTitle_ASC',
  SuccessTitleDesc = 'successTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UnluckyScreenAnimationAsc = 'unluckyScreenAnimation_ASC',
  UnluckyScreenAnimationDesc = 'unluckyScreenAnimation_DESC',
  UnluckySubTitleAsc = 'unluckySubTitle_ASC',
  UnluckySubTitleDesc = 'unluckySubTitle_DESC',
  UnluckyTitleAsc = 'unluckyTitle_ASC',
  UnluckyTitleDesc = 'unluckyTitle_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantEarn) */
export type CfInstantEarn = CfEntry & {
  __typename?: 'CFInstantEarn';
  _id: Scalars['ID']['output'];
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfInstantEarnLinkingCollections>;
  successBody: Maybe<Scalars['String']['output']>;
  successTitle: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantEarn) */
export type CfInstantEarnLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantEarn) */
export type CfInstantEarnSuccessBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/instantEarn) */
export type CfInstantEarnSuccessTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfInstantEarnCollection = {
  __typename?: 'CFInstantEarnCollection';
  items: Array<Maybe<CfInstantEarn>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfInstantEarnFilter = {
  AND: InputMaybe<Array<InputMaybe<CfInstantEarnFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfInstantEarnFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  successBody: InputMaybe<Scalars['String']['input']>;
  successBody_contains: InputMaybe<Scalars['String']['input']>;
  successBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  successBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successBody_not: InputMaybe<Scalars['String']['input']>;
  successBody_not_contains: InputMaybe<Scalars['String']['input']>;
  successBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitle: InputMaybe<Scalars['String']['input']>;
  successTitle_contains: InputMaybe<Scalars['String']['input']>;
  successTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  successTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitle_not: InputMaybe<Scalars['String']['input']>;
  successTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  successTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfInstantEarnLinkingCollections = {
  __typename?: 'CFInstantEarnLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  offerCollection: Maybe<CfOfferCollection>;
};


export type CfInstantEarnLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfInstantEarnLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfInstantEarnLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfInstantEarnLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfInstantEarnOrder {
  SuccessBodyAsc = 'successBody_ASC',
  SuccessBodyDesc = 'successBody_DESC',
  SuccessTitleAsc = 'successTitle_ASC',
  SuccessTitleDesc = 'successTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/introductions) */
export type CfIntroductions = CfEntry & {
  __typename?: 'CFIntroductions';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  entry: Maybe<CfIntroductionsEntry>;
  linkedFrom: Maybe<CfIntroductionsLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/introductions) */
export type CfIntroductionsBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/introductions) */
export type CfIntroductionsEntryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/introductions) */
export type CfIntroductionsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfIntroductionsCollection = {
  __typename?: 'CFIntroductionsCollection';
  items: Array<Maybe<CfIntroductions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfIntroductionsEntry = CfExperience | CfFeaturedLink | CfTopic;

export type CfIntroductionsFilter = {
  AND: InputMaybe<Array<InputMaybe<CfIntroductionsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfIntroductionsFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  entry_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfIntroductionsLinkingCollections = {
  __typename?: 'CFIntroductionsLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfIntroductionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfIntroductionsLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfIntroductionsLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfIntroductionsLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfIntroductionsOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Branch Journey Banner [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/journeyBanner) */
export type CfJourneyBanner = CfEntry & {
  __typename?: 'CFJourneyBanner';
  _id: Scalars['ID']['output'];
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  imageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfJourneyBannerLinkingCollections>;
  offerToOpen: Maybe<CfOffer>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** Branch Journey Banner [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/journeyBanner) */
export type CfJourneyBannerDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Branch Journey Banner [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/journeyBanner) */
export type CfJourneyBannerImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** Branch Journey Banner [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/journeyBanner) */
export type CfJourneyBannerLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Branch Journey Banner [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/journeyBanner) */
export type CfJourneyBannerOfferToOpenArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfOfferFilter>;
};


/** Branch Journey Banner [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/journeyBanner) */
export type CfJourneyBannerTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfJourneyBannerCollection = {
  __typename?: 'CFJourneyBannerCollection';
  items: Array<Maybe<CfJourneyBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfJourneyBannerFilter = {
  AND: InputMaybe<Array<InputMaybe<CfJourneyBannerFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfJourneyBannerFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  imageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  offerToOpen: InputMaybe<CfCfOfferNestedFilter>;
  offerToOpen_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfJourneyBannerLinkingCollections = {
  __typename?: 'CFJourneyBannerLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  offerCollection: Maybe<CfOfferCollection>;
};


export type CfJourneyBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfJourneyBannerLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfJourneyBannerLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfJourneyBannerLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfJourneyBannerOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgram = CfEntry & {
  __typename?: 'CFLoyaltyProgram';
  _id: Scalars['ID']['output'];
  androidAppBundleId: Maybe<Scalars['String']['output']>;
  backendTitle: Maybe<Scalars['String']['output']>;
  brandBackgroundColor: Maybe<Scalars['String']['output']>;
  canAddMembership: Maybe<Scalars['Boolean']['output']>;
  canSignup: Maybe<Scalars['Boolean']['output']>;
  cardAssetImage: Maybe<Scalars['CFJSON']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  hasAccountLogin: Maybe<Scalars['Boolean']['output']>;
  hasBarcode: Maybe<Scalars['Boolean']['output']>;
  hasCard: Maybe<Scalars['Boolean']['output']>;
  hasCardNumber: Maybe<Scalars['Boolean']['output']>;
  hasMembershipNumber: Maybe<Scalars['Boolean']['output']>;
  iosAppName: Maybe<Scalars['String']['output']>;
  iosAppStoreId: Maybe<Scalars['String']['output']>;
  iosAppUrlScheme: Maybe<Scalars['String']['output']>;
  isInverse: Maybe<Scalars['Boolean']['output']>;
  legacyCardAssetImage: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfLoyaltyProgramLinkingCollections>;
  loginUrl: Maybe<Scalars['String']['output']>;
  membershipBarcodeFormat: Maybe<Scalars['String']['output']>;
  signupUrl: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramAndroidAppBundleIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramBrandBackgroundColorArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramCanAddMembershipArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramCanSignupArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramCardAssetImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramHasAccountLoginArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramHasBarcodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramHasCardArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramHasCardNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramHasMembershipNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramIosAppNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramIosAppStoreIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramIosAppUrlSchemeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramIsInverseArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramLegacyCardAssetImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramLoginUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramMembershipBarcodeFormatArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramSignupUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/loyaltyProgram) */
export type CfLoyaltyProgramTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfLoyaltyProgramCollection = {
  __typename?: 'CFLoyaltyProgramCollection';
  items: Array<Maybe<CfLoyaltyProgram>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfLoyaltyProgramFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLoyaltyProgramFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLoyaltyProgramFilter>>>;
  androidAppBundleId: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_contains: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_exists: InputMaybe<Scalars['Boolean']['input']>;
  androidAppBundleId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  androidAppBundleId_not: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_not_contains: InputMaybe<Scalars['String']['input']>;
  androidAppBundleId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandBackgroundColor: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_contains: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_exists: InputMaybe<Scalars['Boolean']['input']>;
  brandBackgroundColor_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandBackgroundColor_not: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_not_contains: InputMaybe<Scalars['String']['input']>;
  brandBackgroundColor_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canAddMembership: InputMaybe<Scalars['Boolean']['input']>;
  canAddMembership_exists: InputMaybe<Scalars['Boolean']['input']>;
  canAddMembership_not: InputMaybe<Scalars['Boolean']['input']>;
  canSignup: InputMaybe<Scalars['Boolean']['input']>;
  canSignup_exists: InputMaybe<Scalars['Boolean']['input']>;
  canSignup_not: InputMaybe<Scalars['Boolean']['input']>;
  cardAssetImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAccountLogin: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountLogin_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountLogin_not: InputMaybe<Scalars['Boolean']['input']>;
  hasBarcode: InputMaybe<Scalars['Boolean']['input']>;
  hasBarcode_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasBarcode_not: InputMaybe<Scalars['Boolean']['input']>;
  hasCard: InputMaybe<Scalars['Boolean']['input']>;
  hasCardNumber: InputMaybe<Scalars['Boolean']['input']>;
  hasCardNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasCardNumber_not: InputMaybe<Scalars['Boolean']['input']>;
  hasCard_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasCard_not: InputMaybe<Scalars['Boolean']['input']>;
  hasMembershipNumber: InputMaybe<Scalars['Boolean']['input']>;
  hasMembershipNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasMembershipNumber_not: InputMaybe<Scalars['Boolean']['input']>;
  iosAppName: InputMaybe<Scalars['String']['input']>;
  iosAppName_contains: InputMaybe<Scalars['String']['input']>;
  iosAppName_exists: InputMaybe<Scalars['Boolean']['input']>;
  iosAppName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppName_not: InputMaybe<Scalars['String']['input']>;
  iosAppName_not_contains: InputMaybe<Scalars['String']['input']>;
  iosAppName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppStoreId: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_contains: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_exists: InputMaybe<Scalars['Boolean']['input']>;
  iosAppStoreId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppStoreId_not: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_not_contains: InputMaybe<Scalars['String']['input']>;
  iosAppStoreId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppUrlScheme: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_contains: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_exists: InputMaybe<Scalars['Boolean']['input']>;
  iosAppUrlScheme_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iosAppUrlScheme_not: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_not_contains: InputMaybe<Scalars['String']['input']>;
  iosAppUrlScheme_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInverse: InputMaybe<Scalars['Boolean']['input']>;
  isInverse_exists: InputMaybe<Scalars['Boolean']['input']>;
  isInverse_not: InputMaybe<Scalars['Boolean']['input']>;
  legacyCardAssetImage: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_contains: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  legacyCardAssetImage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyCardAssetImage_not: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_not_contains: InputMaybe<Scalars['String']['input']>;
  legacyCardAssetImage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loginUrl: InputMaybe<Scalars['String']['input']>;
  loginUrl_contains: InputMaybe<Scalars['String']['input']>;
  loginUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loginUrl_not: InputMaybe<Scalars['String']['input']>;
  loginUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  loginUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  membershipBarcodeFormat: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_contains: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_exists: InputMaybe<Scalars['Boolean']['input']>;
  membershipBarcodeFormat_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  membershipBarcodeFormat_not: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_not_contains: InputMaybe<Scalars['String']['input']>;
  membershipBarcodeFormat_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signupUrl: InputMaybe<Scalars['String']['input']>;
  signupUrl_contains: InputMaybe<Scalars['String']['input']>;
  signupUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  signupUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signupUrl_not: InputMaybe<Scalars['String']['input']>;
  signupUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  signupUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfLoyaltyProgramLinkingCollections = {
  __typename?: 'CFLoyaltyProgramLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
};


export type CfLoyaltyProgramLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfLoyaltyProgramLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfLoyaltyProgramLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfLoyaltyProgramLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfLoyaltyProgramOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BrandBackgroundColorAsc = 'brandBackgroundColor_ASC',
  BrandBackgroundColorDesc = 'brandBackgroundColor_DESC',
  CanAddMembershipAsc = 'canAddMembership_ASC',
  CanAddMembershipDesc = 'canAddMembership_DESC',
  CanSignupAsc = 'canSignup_ASC',
  CanSignupDesc = 'canSignup_DESC',
  HasAccountLoginAsc = 'hasAccountLogin_ASC',
  HasAccountLoginDesc = 'hasAccountLogin_DESC',
  HasBarcodeAsc = 'hasBarcode_ASC',
  HasBarcodeDesc = 'hasBarcode_DESC',
  HasCardNumberAsc = 'hasCardNumber_ASC',
  HasCardNumberDesc = 'hasCardNumber_DESC',
  HasCardAsc = 'hasCard_ASC',
  HasCardDesc = 'hasCard_DESC',
  HasMembershipNumberAsc = 'hasMembershipNumber_ASC',
  HasMembershipNumberDesc = 'hasMembershipNumber_DESC',
  IsInverseAsc = 'isInverse_ASC',
  IsInverseDesc = 'isInverse_DESC',
  LegacyCardAssetImageAsc = 'legacyCardAssetImage_ASC',
  LegacyCardAssetImageDesc = 'legacyCardAssetImage_DESC',
  LoginUrlAsc = 'loginUrl_ASC',
  LoginUrlDesc = 'loginUrl_DESC',
  MembershipBarcodeFormatAsc = 'membershipBarcodeFormat_ASC',
  MembershipBarcodeFormatDesc = 'membershipBarcodeFormat_DESC',
  SignupUrlAsc = 'signupUrl_ASC',
  SignupUrlDesc = 'signupUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollection = CfEntry & {
  __typename?: 'CFManualCollection';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentEntriesCollection: Maybe<CfManualCollectionContentEntriesCollection>;
  contentfulMetadata: CfContentfulMetadata;
  displayMode: Maybe<Scalars['String']['output']>;
  displayModeV2: Maybe<Scalars['String']['output']>;
  leadEntry: Maybe<CfManualCollectionLeadEntry>;
  linkedFrom: Maybe<CfManualCollectionLinkingCollections>;
  relatedContent: Maybe<Scalars['CFJSON']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionCallToActionAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionContentEntriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfManualCollectionContentEntriesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionDisplayModeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionDisplayModeV2Args = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionLeadEntryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionRelatedContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualCollection) */
export type CfManualCollectionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfManualCollectionCollection = {
  __typename?: 'CFManualCollectionCollection';
  items: Array<Maybe<CfManualCollection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfManualCollectionContentEntriesCollection = {
  __typename?: 'CFManualCollectionContentEntriesCollection';
  items: Array<Maybe<CfManualCollectionContentEntriesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfManualCollectionContentEntriesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfManualCollectionContentEntriesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfManualCollectionContentEntriesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfManualCollectionContentEntriesItem = CfEvent | CfFeaturedLink | CfGenericAdZone | CfNews | CfOffer | CfRetailer | CfService | CfStore | CfStory | CfTopic;

export type CfManualCollectionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfManualCollectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfManualCollectionFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentEntries: InputMaybe<CfCfcontentEntriesMultiTypeNestedFilter>;
  contentEntriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displayMode: InputMaybe<Scalars['String']['input']>;
  displayModeV2: InputMaybe<Scalars['String']['input']>;
  displayModeV2_contains: InputMaybe<Scalars['String']['input']>;
  displayModeV2_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayModeV2_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayModeV2_not: InputMaybe<Scalars['String']['input']>;
  displayModeV2_not_contains: InputMaybe<Scalars['String']['input']>;
  displayModeV2_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayMode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_not: InputMaybe<Scalars['String']['input']>;
  displayMode_not_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadEntry_exists: InputMaybe<Scalars['Boolean']['input']>;
  relatedContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfManualCollectionLeadEntry = CfEvent | CfNews | CfOffer;

export type CfManualCollectionLinkingCollections = {
  __typename?: 'CFManualCollectionLinkingCollections';
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  giftcardTemplateCollection: Maybe<CfGiftcardTemplateCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  nationalStorefrontCollection: Maybe<CfNationalStorefrontCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfManualCollectionLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualCollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualCollectionLinkingCollectionsGiftcardTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionLinkingCollectionsGiftcardTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualCollectionLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualCollectionLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualCollectionLinkingCollectionsNationalStorefrontCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionLinkingCollectionsNationalStorefrontCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualCollectionLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfManualCollectionLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfManualCollectionLinkingCollectionsGiftcardTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionMetaDescriptionAsc = 'shortDescriptionMetaDescription_ASC',
  ShortDescriptionMetaDescriptionDesc = 'shortDescriptionMetaDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfManualCollectionLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfManualCollectionLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfManualCollectionLinkingCollectionsNationalStorefrontCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfManualCollectionLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfManualCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSource = CfEntry & {
  __typename?: 'CFManualContentSource';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfManualContentSourceCentresCollection>;
  contentTemplatesCollection: Maybe<CfManualContentSourceContentTemplatesCollection>;
  contentfulMetadata: CfContentfulMetadata;
  count: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<CfManualContentSourceLinkingCollections>;
  manualCorpusCollection: Maybe<CfManualContentSourceManualCorpusCollection>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  variant: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualContentSourceCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceContentTemplatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualContentSourceContentTemplatesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentTemplateFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceCountArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceManualCorpusCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfManualContentSourceManualCorpusFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualContentSource) */
export type CfManualContentSourceVariantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfManualContentSourceCentresCollection = {
  __typename?: 'CFManualContentSourceCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfManualContentSourceCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfManualContentSourceCollection = {
  __typename?: 'CFManualContentSourceCollection';
  items: Array<Maybe<CfManualContentSource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfManualContentSourceContentTemplatesCollection = {
  __typename?: 'CFManualContentSourceContentTemplatesCollection';
  items: Array<Maybe<CfContentTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfManualContentSourceContentTemplatesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfManualContentSourceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfManualContentSourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfManualContentSourceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTemplates: InputMaybe<CfCfContentTemplateNestedFilter>;
  contentTemplatesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  count: InputMaybe<Scalars['Int']['input']>;
  count_exists: InputMaybe<Scalars['Boolean']['input']>;
  count_gt: InputMaybe<Scalars['Int']['input']>;
  count_gte: InputMaybe<Scalars['Int']['input']>;
  count_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_lt: InputMaybe<Scalars['Int']['input']>;
  count_lte: InputMaybe<Scalars['Int']['input']>;
  count_not: InputMaybe<Scalars['Int']['input']>;
  count_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  manualCorpus: InputMaybe<CfCfmanualCorpusMultiTypeNestedFilter>;
  manualCorpusCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfManualContentSourceLinkingCollections = {
  __typename?: 'CFManualContentSourceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfManualContentSourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfManualContentSourceManualCorpusCollection = {
  __typename?: 'CFManualContentSourceManualCorpusCollection';
  items: Array<Maybe<CfManualContentSourceManualCorpusItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfManualContentSourceManualCorpusFilter = {
  AND: InputMaybe<Array<InputMaybe<CfManualContentSourceManualCorpusFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfManualContentSourceManualCorpusFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfManualContentSourceManualCorpusItem = CfEvent | CfFeaturedLink | CfGenericAdZone | CfNews | CfOffer | CfProductCollection | CfRetailer | CfService | CfStore | CfStory;

export enum CfManualContentSourceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModule = CfEntry & {
  __typename?: 'CFManualSolusModule';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  intent: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfManualSolusModuleLinkingCollections>;
  manualCorpusCollection: Maybe<CfManualSolusModuleManualCorpusCollection>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleCallToActionAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleIntentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleManualCorpusCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfManualSolusModuleManualCorpusFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/manualSolusModule) */
export type CfManualSolusModuleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfManualSolusModuleCollection = {
  __typename?: 'CFManualSolusModuleCollection';
  items: Array<Maybe<CfManualSolusModule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfManualSolusModuleFilter = {
  AND: InputMaybe<Array<InputMaybe<CfManualSolusModuleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfManualSolusModuleFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  intent: InputMaybe<Scalars['String']['input']>;
  intent_contains: InputMaybe<Scalars['String']['input']>;
  intent_exists: InputMaybe<Scalars['Boolean']['input']>;
  intent_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intent_not: InputMaybe<Scalars['String']['input']>;
  intent_not_contains: InputMaybe<Scalars['String']['input']>;
  intent_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manualCorpus: InputMaybe<CfCfmanualCorpusMultiTypeNestedFilter>;
  manualCorpusCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfManualSolusModuleLinkingCollections = {
  __typename?: 'CFManualSolusModuleLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  solusTemplateCollection: Maybe<CfSolusTemplateCollection>;
};


export type CfManualSolusModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfManualSolusModuleLinkingCollectionsSolusTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualSolusModuleLinkingCollectionsSolusTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfManualSolusModuleLinkingCollectionsSolusTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubjectAsc = 'subject_ASC',
  SubjectDesc = 'subject_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfManualSolusModuleManualCorpusCollection = {
  __typename?: 'CFManualSolusModuleManualCorpusCollection';
  items: Array<Maybe<CfManualSolusModuleManualCorpusItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfManualSolusModuleManualCorpusFilter = {
  AND: InputMaybe<Array<InputMaybe<CfManualSolusModuleManualCorpusFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfManualSolusModuleManualCorpusFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfManualSolusModuleManualCorpusItem = CfEvent | CfFeaturedLink | CfNews | CfOffer | CfProductCollection | CfRetailer | CfService | CfStore | CfStory;

export enum CfManualSolusModuleOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePage = CfEntry & {
  __typename?: 'CFNationalExperiencePage';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  categoriesCollection: Maybe<CfNationalExperiencePageCategoriesCollection>;
  contentfulMetadata: CfContentfulMetadata;
  featuredCategoriesCollection: Maybe<CfNationalExperiencePageFeaturedCategoriesCollection>;
  featuredCollectionsCollection: Maybe<CfNationalExperiencePageFeaturedCollectionsCollection>;
  featuredRetailersCollection: Maybe<CfNationalExperiencePageFeaturedRetailersCollection>;
  heroFeaturesCollection: Maybe<CfNationalExperiencePageHeroFeaturesCollection>;
  linkedFrom: Maybe<CfNationalExperiencePageLinkingCollections>;
  metaTitle: Maybe<Scalars['String']['output']>;
  modulesCollection: Maybe<CfNationalExperiencePageModulesCollection>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalExperiencePageCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeaturedLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageFeaturedCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalExperiencePageFeaturedCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeaturedLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageFeaturedCollectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalExperiencePageFeaturedCollectionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageFeaturedRetailersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalExperiencePageFeaturedRetailersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageHeroFeaturesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalExperiencePageHeroFeaturesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageMetaTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalExperiencePageModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalExperiencePage) */
export type CfNationalExperiencePageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfNationalExperiencePageCategoriesCollection = {
  __typename?: 'CFNationalExperiencePageCategoriesCollection';
  items: Array<Maybe<CfFeaturedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNationalExperiencePageCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColourAsc = 'textColour_ASC',
  TextColourDesc = 'textColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type CfNationalExperiencePageCollection = {
  __typename?: 'CFNationalExperiencePageCollection';
  items: Array<Maybe<CfNationalExperiencePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalExperiencePageFeaturedCategoriesCollection = {
  __typename?: 'CFNationalExperiencePageFeaturedCategoriesCollection';
  items: Array<Maybe<CfFeaturedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNationalExperiencePageFeaturedCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColourAsc = 'textColour_ASC',
  TextColourDesc = 'textColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type CfNationalExperiencePageFeaturedCollectionsCollection = {
  __typename?: 'CFNationalExperiencePageFeaturedCollectionsCollection';
  items: Array<Maybe<CfNationalExperiencePageFeaturedCollectionsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalExperiencePageFeaturedCollectionsFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalExperiencePageFeaturedCollectionsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalExperiencePageFeaturedCollectionsFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNationalExperiencePageFeaturedCollectionsItem = CfFeaturedLink | CfStory;

export type CfNationalExperiencePageFeaturedRetailersCollection = {
  __typename?: 'CFNationalExperiencePageFeaturedRetailersCollection';
  items: Array<Maybe<CfRetailer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNationalExperiencePageFeaturedRetailersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfNationalExperiencePageFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalExperiencePageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalExperiencePageFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories: InputMaybe<CfCfFeaturedLinkNestedFilter>;
  categoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  featuredCategories: InputMaybe<CfCfFeaturedLinkNestedFilter>;
  featuredCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuredCollections: InputMaybe<CfCffeaturedCollectionsMultiTypeNestedFilter>;
  featuredCollectionsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuredRetailers: InputMaybe<CfCfRetailerNestedFilter>;
  featuredRetailersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroFeatures: InputMaybe<CfCfheroFeaturesMultiTypeNestedFilter>;
  heroFeaturesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNationalExperiencePageHeroFeaturesCollection = {
  __typename?: 'CFNationalExperiencePageHeroFeaturesCollection';
  items: Array<Maybe<CfNationalExperiencePageHeroFeaturesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalExperiencePageHeroFeaturesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalExperiencePageHeroFeaturesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalExperiencePageHeroFeaturesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNationalExperiencePageHeroFeaturesItem = CfFeaturedLink | CfStory;

export type CfNationalExperiencePageLinkingCollections = {
  __typename?: 'CFNationalExperiencePageLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfNationalExperiencePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfNationalExperiencePageModulesCollection = {
  __typename?: 'CFNationalExperiencePageModulesCollection';
  items: Array<Maybe<CfNationalExperiencePageModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalExperiencePageModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalExperiencePageModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalExperiencePageModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfNationalExperiencePageModulesItem = CfBasicContent | CfDynamicContent | CfManualCollection | CfProductCollection;

export enum CfNationalExperiencePageOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepage = CfEntry & {
  __typename?: 'CFNationalHomepage';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderWDeviceLarge: Maybe<Scalars['CFJSON']['output']>;
  bynderWDeviceSmall: Maybe<Scalars['CFJSON']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  featuredCategoriesCollection: Maybe<CfNationalHomepageFeaturedCategoriesCollection>;
  featuredRetailersCollection: Maybe<CfNationalHomepageFeaturedRetailersCollection>;
  featuresCollection: Maybe<CfNationalHomepageFeaturesCollection>;
  linkedFrom: Maybe<CfNationalHomepageLinkingCollections>;
  modulesCollection: Maybe<CfNationalHomepageModulesCollection>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  privacyPolicy: Maybe<Scalars['String']['output']>;
  promotionModule: Maybe<CfPromotion>;
  promotionModulesCollection: Maybe<CfNationalHomepagePromotionModulesCollection>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  termsAndConditionsVersion: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  wDeviceLarge: Maybe<CfAsset>;
  wDeviceSmall: Maybe<CfAsset>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageBynderWDeviceLargeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageBynderWDeviceSmallArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageFeaturedCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalHomepageFeaturedCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeaturedLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageFeaturedRetailersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalHomepageFeaturedRetailersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageFeaturesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalHomepageFeaturesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalHomepageModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageNavigationMenuArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepagePrivacyPolicyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepagePromotionModuleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfPromotionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepagePromotionModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalHomepagePromotionModulesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfPromotionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageTermsAndConditionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageTermsAndConditionsVersionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageWDeviceLargeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalHomepage) */
export type CfNationalHomepageWDeviceSmallArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfNationalHomepageCollection = {
  __typename?: 'CFNationalHomepageCollection';
  items: Array<Maybe<CfNationalHomepage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalHomepageFeaturedCategoriesCollection = {
  __typename?: 'CFNationalHomepageFeaturedCategoriesCollection';
  items: Array<Maybe<CfFeaturedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNationalHomepageFeaturedCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColourAsc = 'textColour_ASC',
  TextColourDesc = 'textColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type CfNationalHomepageFeaturedRetailersCollection = {
  __typename?: 'CFNationalHomepageFeaturedRetailersCollection';
  items: Array<Maybe<CfRetailer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNationalHomepageFeaturedRetailersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfNationalHomepageFeaturesCollection = {
  __typename?: 'CFNationalHomepageFeaturesCollection';
  items: Array<Maybe<CfNationalHomepageFeaturesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalHomepageFeaturesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalHomepageFeaturesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalHomepageFeaturesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNationalHomepageFeaturesItem = CfFeaturedLink | CfStory;

export type CfNationalHomepageFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalHomepageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalHomepageFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderWDeviceLarge_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderWDeviceSmall_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuredCategories: InputMaybe<CfCfFeaturedLinkNestedFilter>;
  featuredCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  featuredRetailers: InputMaybe<CfCfRetailerNestedFilter>;
  featuredRetailersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  features: InputMaybe<CfCffeaturesMultiTypeNestedFilter>;
  featuresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicy_not: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionModule: InputMaybe<CfCfPromotionNestedFilter>;
  promotionModule_exists: InputMaybe<Scalars['Boolean']['input']>;
  promotionModules: InputMaybe<CfCfPromotionNestedFilter>;
  promotionModulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsVersion: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditionsVersion_gt: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_gte: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  termsAndConditionsVersion_lt: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_lte: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_not: InputMaybe<Scalars['Int']['input']>;
  termsAndConditionsVersion_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  termsAndConditions_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions_not: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wDeviceLarge_exists: InputMaybe<Scalars['Boolean']['input']>;
  wDeviceSmall_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfNationalHomepageLinkingCollections = {
  __typename?: 'CFNationalHomepageLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  storyCollection: Maybe<CfStoryCollection>;
};


export type CfNationalHomepageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfNationalHomepageLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalHomepageLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfNationalHomepageLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export type CfNationalHomepageModulesCollection = {
  __typename?: 'CFNationalHomepageModulesCollection';
  items: Array<Maybe<CfNationalHomepageModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalHomepageModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalHomepageModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalHomepageModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfNationalHomepageModulesItem = CfBasicContent | CfDynamicContent | CfManualCollection | CfProductCollection;

export enum CfNationalHomepageOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfNationalHomepagePromotionModulesCollection = {
  __typename?: 'CFNationalHomepagePromotionModulesCollection';
  items: Array<Maybe<CfPromotion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNationalHomepagePromotionModulesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalStorefront) */
export type CfNationalStorefront = CfEntry & {
  __typename?: 'CFNationalStorefront';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfNationalStorefrontLinkingCollections>;
  modulesCollection: Maybe<CfNationalStorefrontModulesCollection>;
  retailer: Maybe<CfRetailer>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalStorefront) */
export type CfNationalStorefrontBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalStorefront) */
export type CfNationalStorefrontLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalStorefront) */
export type CfNationalStorefrontModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalStorefrontModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/nationalStorefront) */
export type CfNationalStorefrontRetailerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfRetailerFilter>;
};

export type CfNationalStorefrontCollection = {
  __typename?: 'CFNationalStorefrontCollection';
  items: Array<Maybe<CfNationalStorefront>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalStorefrontFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalStorefrontFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalStorefrontFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailer: InputMaybe<CfCfRetailerNestedFilter>;
  retailer_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfNationalStorefrontLinkingCollections = {
  __typename?: 'CFNationalStorefrontLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfNationalStorefrontLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfNationalStorefrontModulesCollection = {
  __typename?: 'CFNationalStorefrontModulesCollection';
  items: Array<Maybe<CfNationalStorefrontModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNationalStorefrontModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNationalStorefrontModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNationalStorefrontModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfNationalStorefrontModulesItem = CfBasicContent | CfDynamicContent | CfManualCollection | CfProductCollection;

export enum CfNationalStorefrontOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNews = CfEntry & {
  __typename?: 'CFNews';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfNewsCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  enableNationalNews: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  experiencesCollection: Maybe<CfNewsExperiencesCollection>;
  hasModeratedImages: Maybe<Scalars['Boolean']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  highlightAttribute: Maybe<HighlightAttributes>;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<CfNewsLinkingCollections>;
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  profile: Maybe<CfProfile>;
  retailCategoriesCollection: Maybe<CfNewsRetailCategoriesCollection>;
  retailersCollection: Maybe<CfNewsRetailersCollection>;
  reviewStatus: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  showAt: Maybe<Scalars['CFDateTime']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sponsored: Maybe<Scalars['Boolean']['output']>;
  storesCollection: Maybe<CfNewsStoresCollection>;
  supportingImageSet: Maybe<CfSupportingImageSet>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfNewsTopicsCollection>;
  viewOption: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsEdmSubheadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsEdmSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsEdmTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsEnableNationalNewsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsHasModeratedImagesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsIsSensitiveContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsMemberExclusiveArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsProfileArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfProfileFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsRetailersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsRetailersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsReviewStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsShowAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsSponsoredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsSupportingImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfSupportingImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsSurfaceContentInChannelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/news) */
export type CfNewsViewOptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfNewsCentresCollection = {
  __typename?: 'CFNewsCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNewsCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfNewsCollection = {
  __typename?: 'CFNewsCollection';
  items: Array<Maybe<CfNews>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfNewsExperiencesCollection = {
  __typename?: 'CFNewsExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNewsExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfNewsFilter = {
  AND: InputMaybe<Array<InputMaybe<CfNewsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfNewsFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubheading: InputMaybe<Scalars['String']['input']>;
  edmSubheading_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubheading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading_not: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle: InputMaybe<Scalars['String']['input']>;
  edmTitle_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle_not: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalNews_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalNews_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalNews_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalNews_exists: InputMaybe<Scalars['Boolean']['input']>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_not: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  isSensitiveContent: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_not: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_exists: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_not: InputMaybe<Scalars['Boolean']['input']>;
  profile: InputMaybe<CfCfProfileNestedFilter>;
  profile_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailers: InputMaybe<CfCfRetailerNestedFilter>;
  retailersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus: InputMaybe<Scalars['String']['input']>;
  reviewStatus_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewStatus_not: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  supportingImageSet: InputMaybe<CfCfSupportingImageSetNestedFilter>;
  supportingImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  surfaceContentInChannel_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption: InputMaybe<Scalars['String']['input']>;
  viewOption_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewOption_not: InputMaybe<Scalars['String']['input']>;
  viewOption_not_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNewsLinkingCollections = {
  __typename?: 'CFNewsLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
};


export type CfNewsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfNewsLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfNewsLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfNewsLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfNewsLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfNewsLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfNewsLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfNewsLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfNewsLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfNewsLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfNewsLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfNewsLinkingCollectionsPartnerPortalPermissionCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum CfNewsOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export type CfNewsRetailCategoriesCollection = {
  __typename?: 'CFNewsRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNewsRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfNewsRetailersCollection = {
  __typename?: 'CFNewsRetailersCollection';
  items: Array<Maybe<CfRetailer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNewsRetailersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfNewsStoresCollection = {
  __typename?: 'CFNewsStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfNewsStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfNewsStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfNewsTopicsCollection = {
  __typename?: 'CFNewsTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfNewsTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/occurrence) */
export type CfOccurrence = CfEntry & {
  __typename?: 'CFOccurrence';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  endAt: Maybe<Scalars['CFDateTime']['output']>;
  linkedFrom: Maybe<CfOccurrenceLinkingCollections>;
  startAt: Maybe<Scalars['CFDateTime']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/occurrence) */
export type CfOccurrenceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/occurrence) */
export type CfOccurrenceEndAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/occurrence) */
export type CfOccurrenceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/occurrence) */
export type CfOccurrenceStartAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfOccurrenceCollection = {
  __typename?: 'CFOccurrenceCollection';
  items: Array<Maybe<CfOccurrence>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfOccurrenceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfOccurrenceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfOccurrenceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfOccurrenceLinkingCollections = {
  __typename?: 'CFOccurrenceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
};


export type CfOccurrenceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOccurrenceLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOccurrenceLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfOccurrenceLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfOccurrenceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOffer = CfEntry & {
  __typename?: 'CFOffer';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  branchDeepLink: Maybe<Scalars['String']['output']>;
  branchFallbackUrl: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfOfferCentresCollection>;
  cloOfferId: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  ctaType: Maybe<Scalars['String']['output']>;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  enableNationalOffer: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endAt: Maybe<Scalars['CFDateTime']['output']>;
  experiencesCollection: Maybe<CfOfferExperiencesCollection>;
  faq: Maybe<Scalars['String']['output']>;
  /** To be deprecated in favour of highlightAttribute */
  flags: Maybe<ItemEntryFlag>;
  hasModeratedImages: Maybe<Scalars['Boolean']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  highlightAttribute: Maybe<HighlightAttributes>;
  inCentrePresenceCheck: Maybe<Scalars['Boolean']['output']>;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  journeyBanner: Maybe<CfJourneyBanner>;
  linkedFrom: Maybe<CfOfferLinkingCollections>;
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  popupLocation: Maybe<Scalars['String']['output']>;
  promoQrCode: Maybe<Scalars['String']['output']>;
  promoSuccessBody: Maybe<Scalars['String']['output']>;
  promoSuccessTitle: Maybe<Scalars['String']['output']>;
  promotionType: Maybe<Scalars['String']['output']>;
  redeemablePromotion: Maybe<CfOfferRedeemablePromotion>;
  requiresQrCodeScan: Maybe<Scalars['Boolean']['output']>;
  retailCategoriesCollection: Maybe<CfOfferRetailCategoriesCollection>;
  reviewStatus: Maybe<Scalars['String']['output']>;
  sendSuccessEmail: Maybe<Scalars['Boolean']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  showAt: Maybe<Scalars['CFDateTime']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sponsored: Maybe<Scalars['Boolean']['output']>;
  startAt: Maybe<Scalars['CFDateTime']['output']>;
  storesCollection: Maybe<CfOfferStoresCollection>;
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  supportingImageSet: Maybe<CfSupportingImageSet>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: CfSys;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  termsAndConditionsFile: Maybe<CfAsset>;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfOfferTopicsCollection>;
  viewOption: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferBranchDeepLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferBranchFallbackUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferCloOfferIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferCtaTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferEdmSubheadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferEdmSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferEdmTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferEnableNationalOfferArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferEndAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferFaqArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferHasModeratedImagesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferInCentrePresenceCheckArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferIsSensitiveContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferJourneyBannerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfJourneyBannerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferMemberExclusiveArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferPopupLocationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferPromoQrCodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferPromoSuccessBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferPromoSuccessTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferPromotionTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferRedeemablePromotionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferRequiresQrCodeScanArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferReviewStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferSendSuccessEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferShowAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferSponsoredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferStartAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferSuccessEmailAdditionalCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferSupportingImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfSupportingImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferSurfaceContentInChannelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferTermsAndConditionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferTermsAndConditionsFileArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/offer) */
export type CfOfferViewOptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfOfferCentresCollection = {
  __typename?: 'CFOfferCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfOfferCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfOfferCollection = {
  __typename?: 'CFOfferCollection';
  items: Array<Maybe<CfOffer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfOfferExperiencesCollection = {
  __typename?: 'CFOfferExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfOfferExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfOfferFilter = {
  AND: InputMaybe<Array<InputMaybe<CfOfferFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfOfferFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchDeepLink: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_contains: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  branchDeepLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchDeepLink_not: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_not_contains: InputMaybe<Scalars['String']['input']>;
  branchDeepLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchFallbackUrl: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_contains: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  branchFallbackUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchFallbackUrl_not: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  branchFallbackUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloOfferId: InputMaybe<Scalars['String']['input']>;
  cloOfferId_contains: InputMaybe<Scalars['String']['input']>;
  cloOfferId_exists: InputMaybe<Scalars['Boolean']['input']>;
  cloOfferId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cloOfferId_not: InputMaybe<Scalars['String']['input']>;
  cloOfferId_not_contains: InputMaybe<Scalars['String']['input']>;
  cloOfferId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  ctaType: InputMaybe<Scalars['String']['input']>;
  ctaType_contains: InputMaybe<Scalars['String']['input']>;
  ctaType_exists: InputMaybe<Scalars['Boolean']['input']>;
  ctaType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaType_not: InputMaybe<Scalars['String']['input']>;
  ctaType_not_contains: InputMaybe<Scalars['String']['input']>;
  ctaType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading: InputMaybe<Scalars['String']['input']>;
  edmSubheading_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubheading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading_not: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle: InputMaybe<Scalars['String']['input']>;
  edmTitle_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle_not: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableNationalOffer_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  faq: InputMaybe<Scalars['String']['input']>;
  faq_contains: InputMaybe<Scalars['String']['input']>;
  faq_exists: InputMaybe<Scalars['Boolean']['input']>;
  faq_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq_not: InputMaybe<Scalars['String']['input']>;
  faq_not_contains: InputMaybe<Scalars['String']['input']>;
  faq_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasModeratedImages: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_exists: InputMaybe<Scalars['Boolean']['input']>;
  hasModeratedImages_not: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  inCentrePresenceCheck: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_exists: InputMaybe<Scalars['Boolean']['input']>;
  inCentrePresenceCheck_not: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_not: InputMaybe<Scalars['Boolean']['input']>;
  journeyBanner: InputMaybe<CfCfJourneyBannerNestedFilter>;
  journeyBanner_exists: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_exists: InputMaybe<Scalars['Boolean']['input']>;
  memberExclusive_not: InputMaybe<Scalars['Boolean']['input']>;
  popupLocation: InputMaybe<Scalars['String']['input']>;
  popupLocation_contains: InputMaybe<Scalars['String']['input']>;
  popupLocation_exists: InputMaybe<Scalars['Boolean']['input']>;
  popupLocation_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  popupLocation_not: InputMaybe<Scalars['String']['input']>;
  popupLocation_not_contains: InputMaybe<Scalars['String']['input']>;
  popupLocation_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoQrCode: InputMaybe<Scalars['String']['input']>;
  promoQrCode_contains: InputMaybe<Scalars['String']['input']>;
  promoQrCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  promoQrCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoQrCode_not: InputMaybe<Scalars['String']['input']>;
  promoQrCode_not_contains: InputMaybe<Scalars['String']['input']>;
  promoQrCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessBody: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  promoSuccessBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessBody_not: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_not_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessTitle: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  promoSuccessTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoSuccessTitle_not: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  promoSuccessTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionType: InputMaybe<Scalars['String']['input']>;
  promotionType_contains: InputMaybe<Scalars['String']['input']>;
  promotionType_exists: InputMaybe<Scalars['Boolean']['input']>;
  promotionType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionType_not: InputMaybe<Scalars['String']['input']>;
  promotionType_not_contains: InputMaybe<Scalars['String']['input']>;
  promotionType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redeemablePromotion_exists: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan_exists: InputMaybe<Scalars['Boolean']['input']>;
  requiresQRCodeScan_not: InputMaybe<Scalars['Boolean']['input']>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus: InputMaybe<Scalars['String']['input']>;
  reviewStatus_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  reviewStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewStatus_not: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  reviewStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sendSuccessEmail: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmail_not: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy_not: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supportingImageSet: InputMaybe<CfCfSupportingImageSetNestedFilter>;
  supportingImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  surfaceContentInChannel_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  termsAndConditions: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsFile_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions_not: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  termsAndConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption: InputMaybe<Scalars['String']['input']>;
  viewOption_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewOption_not: InputMaybe<Scalars['String']['input']>;
  viewOption_not_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfOfferLinkingCollections = {
  __typename?: 'CFOfferLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  journeyBannerCollection: Maybe<CfJourneyBannerCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
};


export type CfOfferLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOfferLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOfferLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOfferLinkingCollectionsJourneyBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferLinkingCollectionsJourneyBannerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOfferLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOfferLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfOfferLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfOfferLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfOfferLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfOfferLinkingCollectionsJourneyBannerCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfOfferLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfOfferLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfOfferLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfOfferLinkingCollectionsPartnerPortalPermissionCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum CfOfferOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export type CfOfferRedeemablePromotion = CfCardLinkedOffer | CfCompetition | CfInstantDraw | CfInstantEarn | CfPartnerCouponCode;

export type CfOfferRetailCategoriesCollection = {
  __typename?: 'CFOfferRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfOfferRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfOfferStoresCollection = {
  __typename?: 'CFOfferStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfOfferStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfOfferStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfOfferTopicsCollection = {
  __typename?: 'CFOfferTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfOfferTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Period of time parked and the rate that applies [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRate) */
export type CfParkingRate = CfEntry & {
  __typename?: 'CFParkingRate';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfParkingRateLinkingCollections>;
  rate: Maybe<Scalars['Float']['output']>;
  sys: CfSys;
  toInMinutes: Maybe<Scalars['Int']['output']>;
};


/** Period of time parked and the rate that applies [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRate) */
export type CfParkingRateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Period of time parked and the rate that applies [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRate) */
export type CfParkingRateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Period of time parked and the rate that applies [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRate) */
export type CfParkingRateRateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Period of time parked and the rate that applies [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRate) */
export type CfParkingRateToInMinutesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfParkingRateCollection = {
  __typename?: 'CFParkingRateCollection';
  items: Array<Maybe<CfParkingRate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfParkingRateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfParkingRateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfParkingRateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  rate: InputMaybe<Scalars['Float']['input']>;
  rate_exists: InputMaybe<Scalars['Boolean']['input']>;
  rate_gt: InputMaybe<Scalars['Float']['input']>;
  rate_gte: InputMaybe<Scalars['Float']['input']>;
  rate_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rate_lt: InputMaybe<Scalars['Float']['input']>;
  rate_lte: InputMaybe<Scalars['Float']['input']>;
  rate_not: InputMaybe<Scalars['Float']['input']>;
  rate_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  toInMinutes: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_exists: InputMaybe<Scalars['Boolean']['input']>;
  toInMinutes_gt: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_gte: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toInMinutes_lt: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_lte: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_not: InputMaybe<Scalars['Int']['input']>;
  toInMinutes_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CfParkingRateLinkingCollections = {
  __typename?: 'CFParkingRateLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  parkingRatesCardCollection: Maybe<CfParkingRatesCardCollection>;
};


export type CfParkingRateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfParkingRateLinkingCollectionsParkingRatesCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRateLinkingCollectionsParkingRatesCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfParkingRateLinkingCollectionsParkingRatesCardCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  OvernightRateAsc = 'overnightRate_ASC',
  OvernightRateDesc = 'overnightRate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfParkingRateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  RateAsc = 'rate_ASC',
  RateDesc = 'rate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ToInMinutesAsc = 'toInMinutes_ASC',
  ToInMinutesDesc = 'toInMinutes_DESC'
}

/** List of the rates that apply for given days [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRatesCard) */
export type CfParkingRatesCard = CfEntry & {
  __typename?: 'CFParkingRatesCard';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  days: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom: Maybe<CfParkingRatesCardLinkingCollections>;
  overnightRate: Maybe<Scalars['Float']['output']>;
  ratesCollection: Maybe<CfParkingRatesCardRatesCollection>;
  sys: CfSys;
};


/** List of the rates that apply for given days [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRatesCard) */
export type CfParkingRatesCardBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** List of the rates that apply for given days [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRatesCard) */
export type CfParkingRatesCardDaysArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** List of the rates that apply for given days [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRatesCard) */
export type CfParkingRatesCardLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** List of the rates that apply for given days [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRatesCard) */
export type CfParkingRatesCardOvernightRateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** List of the rates that apply for given days [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRatesCard) */
export type CfParkingRatesCardRatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRatesCardRatesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingRateFilter>;
};

export type CfParkingRatesCardCollection = {
  __typename?: 'CFParkingRatesCardCollection';
  items: Array<Maybe<CfParkingRatesCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfParkingRatesCardFilter = {
  AND: InputMaybe<Array<InputMaybe<CfParkingRatesCardFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfParkingRatesCardFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  days_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  days_exists: InputMaybe<Scalars['Boolean']['input']>;
  overnightRate: InputMaybe<Scalars['Float']['input']>;
  overnightRate_exists: InputMaybe<Scalars['Boolean']['input']>;
  overnightRate_gt: InputMaybe<Scalars['Float']['input']>;
  overnightRate_gte: InputMaybe<Scalars['Float']['input']>;
  overnightRate_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  overnightRate_lt: InputMaybe<Scalars['Float']['input']>;
  overnightRate_lte: InputMaybe<Scalars['Float']['input']>;
  overnightRate_not: InputMaybe<Scalars['Float']['input']>;
  overnightRate_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rates: InputMaybe<CfCfParkingRateNestedFilter>;
  ratesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfParkingRatesCardLinkingCollections = {
  __typename?: 'CFParkingRatesCardLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  parkingRulesCollection: Maybe<CfParkingRulesCollection>;
};


export type CfParkingRatesCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfParkingRatesCardLinkingCollectionsParkingRulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRatesCardLinkingCollectionsParkingRulesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfParkingRatesCardLinkingCollectionsParkingRulesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  FreeEntryTimeAsc = 'freeEntryTime_ASC',
  FreeEntryTimeDesc = 'freeEntryTime_DESC',
  FreeExitTimeAsc = 'freeExitTime_ASC',
  FreeExitTimeDesc = 'freeExitTime_DESC',
  SpecialConditionsAsc = 'specialConditions_ASC',
  SpecialConditionsDesc = 'specialConditions_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfParkingRatesCardOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  OvernightRateAsc = 'overnightRate_ASC',
  OvernightRateDesc = 'overnightRate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfParkingRatesCardRatesCollection = {
  __typename?: 'CFParkingRatesCardRatesCollection';
  items: Array<Maybe<CfParkingRate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfParkingRatesCardRatesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  RateAsc = 'rate_ASC',
  RateDesc = 'rate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ToInMinutesAsc = 'toInMinutes_ASC',
  ToInMinutesDesc = 'toInMinutes_DESC'
}

/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRules = CfEntry & {
  __typename?: 'CFParkingRules';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  cinemaValidation: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  freeEntryTime: Maybe<Scalars['String']['output']>;
  freeExitTime: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfParkingRulesLinkingCollections>;
  ratesCardsCollection: Maybe<CfParkingRulesRatesCardsCollection>;
  specialConditions: Maybe<Scalars['String']['output']>;
  startAt: Maybe<Scalars['CFDateTime']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesCinemaValidationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesFreeEntryTimeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesFreeExitTimeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesRatesCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRulesRatesCardsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingRatesCardFilter>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesSpecialConditionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesStartAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Centre Parking Rates and Rules [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingRules) */
export type CfParkingRulesTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfParkingRulesCollection = {
  __typename?: 'CFParkingRulesCollection';
  items: Array<Maybe<CfParkingRules>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfParkingRulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfParkingRulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfParkingRulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cinemaValidation: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_contains: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_exists: InputMaybe<Scalars['Boolean']['input']>;
  cinemaValidation_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cinemaValidation_not: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_not_contains: InputMaybe<Scalars['String']['input']>;
  cinemaValidation_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  freeEntryTime: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_contains: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  freeEntryTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeEntryTime_not: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_not_contains: InputMaybe<Scalars['String']['input']>;
  freeEntryTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeExitTime: InputMaybe<Scalars['String']['input']>;
  freeExitTime_contains: InputMaybe<Scalars['String']['input']>;
  freeExitTime_exists: InputMaybe<Scalars['Boolean']['input']>;
  freeExitTime_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeExitTime_not: InputMaybe<Scalars['String']['input']>;
  freeExitTime_not_contains: InputMaybe<Scalars['String']['input']>;
  freeExitTime_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ratesCards: InputMaybe<CfCfParkingRatesCardNestedFilter>;
  ratesCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  specialConditions: InputMaybe<Scalars['String']['input']>;
  specialConditions_contains: InputMaybe<Scalars['String']['input']>;
  specialConditions_exists: InputMaybe<Scalars['Boolean']['input']>;
  specialConditions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialConditions_not: InputMaybe<Scalars['String']['input']>;
  specialConditions_not_contains: InputMaybe<Scalars['String']['input']>;
  specialConditions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfParkingRulesLinkingCollections = {
  __typename?: 'CFParkingRulesLinkingCollections';
  centreCollection: Maybe<CfCentreCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  parkingTemplateCollection: Maybe<CfParkingTemplateCollection>;
};


export type CfParkingRulesLinkingCollectionsCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRulesLinkingCollectionsCentreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfParkingRulesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfParkingRulesLinkingCollectionsParkingTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRulesLinkingCollectionsParkingTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfParkingRulesLinkingCollectionsCentreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export enum CfParkingRulesLinkingCollectionsParkingTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfParkingRulesOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  FreeEntryTimeAsc = 'freeEntryTime_ASC',
  FreeEntryTimeDesc = 'freeEntryTime_DESC',
  FreeExitTimeAsc = 'freeExitTime_ASC',
  FreeExitTimeDesc = 'freeExitTime_DESC',
  SpecialConditionsAsc = 'specialConditions_ASC',
  SpecialConditionsDesc = 'specialConditions_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfParkingRulesRatesCardsCollection = {
  __typename?: 'CFParkingRulesRatesCardsCollection';
  items: Array<Maybe<CfParkingRatesCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfParkingRulesRatesCardsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  OvernightRateAsc = 'overnightRate_ASC',
  OvernightRateDesc = 'overnightRate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplate = CfEntry & {
  __typename?: 'CFParkingTemplate';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfParkingTemplateCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfParkingTemplateLinkingCollections>;
  modulesCollection: Maybe<CfParkingTemplateModulesCollection>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplateCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingTemplateCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplateModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingTemplateModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplateShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/parkingTemplate) */
export type CfParkingTemplateTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfParkingTemplateCentresCollection = {
  __typename?: 'CFParkingTemplateCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfParkingTemplateCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfParkingTemplateCollection = {
  __typename?: 'CFParkingTemplateCollection';
  items: Array<Maybe<CfParkingTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfParkingTemplateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfParkingTemplateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfParkingTemplateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfParkingTemplateLinkingCollections = {
  __typename?: 'CFParkingTemplateLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfParkingTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfParkingTemplateModulesCollection = {
  __typename?: 'CFParkingTemplateModulesCollection';
  items: Array<Maybe<CfParkingTemplateModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfParkingTemplateModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfParkingTemplateModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfParkingTemplateModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfParkingTemplateModulesItem = CfCarParkGroup | CfContentBlock | CfParkingRules | CfService;

export enum CfParkingTemplateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/partnerCouponCode) */
export type CfPartnerCouponCode = CfEntry & {
  __typename?: 'CFPartnerCouponCode';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfPartnerCouponCodeLinkingCollections>;
  successBodyRichText: Maybe<CfPartnerCouponCodeSuccessBodyRichText>;
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/partnerCouponCode) */
export type CfPartnerCouponCodeBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/partnerCouponCode) */
export type CfPartnerCouponCodeLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/partnerCouponCode) */
export type CfPartnerCouponCodeSuccessBodyRichTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/partnerCouponCode) */
export type CfPartnerCouponCodeSuccessEmailAdditionalCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfPartnerCouponCodeCollection = {
  __typename?: 'CFPartnerCouponCodeCollection';
  items: Array<Maybe<CfPartnerCouponCode>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfPartnerCouponCodeFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPartnerCouponCodeFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPartnerCouponCodeFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  successBodyRichText_contains: InputMaybe<Scalars['String']['input']>;
  successBodyRichText_exists: InputMaybe<Scalars['Boolean']['input']>;
  successBodyRichText_not_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  successEmailAdditionalCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successEmailAdditionalCopy_not: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  successEmailAdditionalCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfPartnerCouponCodeLinkingCollections = {
  __typename?: 'CFPartnerCouponCodeLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  offerCollection: Maybe<CfOfferCollection>;
};


export type CfPartnerCouponCodeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfPartnerCouponCodeLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPartnerCouponCodeLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfPartnerCouponCodeLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfPartnerCouponCodeOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfPartnerCouponCodeSuccessBodyRichText = {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichText';
  json: Scalars['CFJSON']['output'];
  links: CfPartnerCouponCodeSuccessBodyRichTextLinks;
};

export type CfPartnerCouponCodeSuccessBodyRichTextAssets = {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextAssets';
  block: Array<Maybe<CfAsset>>;
  hyperlink: Array<Maybe<CfAsset>>;
};

export type CfPartnerCouponCodeSuccessBodyRichTextEntries = {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextEntries';
  block: Array<Maybe<CfEntry>>;
  hyperlink: Array<Maybe<CfEntry>>;
  inline: Array<Maybe<CfEntry>>;
};

export type CfPartnerCouponCodeSuccessBodyRichTextLinks = {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextLinks';
  assets: CfPartnerCouponCodeSuccessBodyRichTextAssets;
  entries: CfPartnerCouponCodeSuccessBodyRichTextEntries;
  resources: CfPartnerCouponCodeSuccessBodyRichTextResources;
};

export type CfPartnerCouponCodeSuccessBodyRichTextResources = {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextResources';
  block: Array<CfPartnerCouponCodeSuccessBodyRichTextResourcesBlock>;
  hyperlink: Array<CfPartnerCouponCodeSuccessBodyRichTextResourcesHyperlink>;
  inline: Array<CfPartnerCouponCodeSuccessBodyRichTextResourcesInline>;
};

export type CfPartnerCouponCodeSuccessBodyRichTextResourcesBlock = CfResourceLink & {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextResourcesBlock';
  sys: CfResourceSys;
};

export type CfPartnerCouponCodeSuccessBodyRichTextResourcesHyperlink = CfResourceLink & {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextResourcesHyperlink';
  sys: CfResourceSys;
};

export type CfPartnerCouponCodeSuccessBodyRichTextResourcesInline = CfResourceLink & {
  __typename?: 'CFPartnerCouponCodeSuccessBodyRichTextResourcesInline';
  sys: CfResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSource = CfEntry & {
  __typename?: 'CFPersonalisedContentSource';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfPersonalisedContentSourceCentresCollection>;
  contentTemplatesCollection: Maybe<CfPersonalisedContentSourceContentTemplatesCollection>;
  contentTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: CfContentfulMetadata;
  count: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<CfPersonalisedContentSourceLinkingCollections>;
  method: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  variant: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPersonalisedContentSourceCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceContentTemplatesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPersonalisedContentSourceContentTemplatesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentTemplateFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceContentTypesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceCountArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceMethodArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/personalisedContentSource) */
export type CfPersonalisedContentSourceVariantArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfPersonalisedContentSourceCentresCollection = {
  __typename?: 'CFPersonalisedContentSourceCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfPersonalisedContentSourceCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfPersonalisedContentSourceCollection = {
  __typename?: 'CFPersonalisedContentSourceCollection';
  items: Array<Maybe<CfPersonalisedContentSource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfPersonalisedContentSourceContentTemplatesCollection = {
  __typename?: 'CFPersonalisedContentSourceContentTemplatesCollection';
  items: Array<Maybe<CfContentTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfPersonalisedContentSourceContentTemplatesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ChannelAsc = 'channel_ASC',
  ChannelDesc = 'channel_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CfPersonalisedContentSourceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPersonalisedContentSourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPersonalisedContentSourceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTemplates: InputMaybe<CfCfContentTemplateNestedFilter>;
  contentTemplatesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTypes_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTypes_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  count: InputMaybe<Scalars['Int']['input']>;
  count_exists: InputMaybe<Scalars['Boolean']['input']>;
  count_gt: InputMaybe<Scalars['Int']['input']>;
  count_gte: InputMaybe<Scalars['Int']['input']>;
  count_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_lt: InputMaybe<Scalars['Int']['input']>;
  count_lte: InputMaybe<Scalars['Int']['input']>;
  count_not: InputMaybe<Scalars['Int']['input']>;
  count_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  method: InputMaybe<Scalars['String']['input']>;
  method_contains: InputMaybe<Scalars['String']['input']>;
  method_exists: InputMaybe<Scalars['Boolean']['input']>;
  method_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  method_not: InputMaybe<Scalars['String']['input']>;
  method_not_contains: InputMaybe<Scalars['String']['input']>;
  method_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  variant: InputMaybe<Scalars['String']['input']>;
  variant_contains: InputMaybe<Scalars['String']['input']>;
  variant_exists: InputMaybe<Scalars['Boolean']['input']>;
  variant_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not: InputMaybe<Scalars['String']['input']>;
  variant_not_contains: InputMaybe<Scalars['String']['input']>;
  variant_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPersonalisedContentSourceLinkingCollections = {
  __typename?: 'CFPersonalisedContentSourceLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfPersonalisedContentSourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfPersonalisedContentSourceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  MethodAsc = 'method_ASC',
  MethodDesc = 'method_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollection = CfEntry & {
  __typename?: 'CFProductCollection';
  _id: Scalars['ID']['output'];
  allowAutoSurface: Maybe<Scalars['Boolean']['output']>;
  backendTitle: Maybe<Scalars['String']['output']>;
  blurbBody: Maybe<Scalars['String']['output']>;
  blurbTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  displayMode: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  h1Header: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfProductCollectionLinkingCollections>;
  pageTitle: Maybe<Scalars['String']['output']>;
  productsJson: Maybe<Scalars['CFJSON']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionAllowAutoSurfaceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionBlurbBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionBlurbTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionDisplayModeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionEdmSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionH1HeaderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/productCollection) */
export type CfProductCollectionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfProductCollectionCollection = {
  __typename?: 'CFProductCollectionCollection';
  items: Array<Maybe<CfProductCollection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfProductCollectionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfProductCollectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfProductCollectionFilter>>>;
  allowAutoSurface: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoSurface_exists: InputMaybe<Scalars['Boolean']['input']>;
  allowAutoSurface_not: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbBody: InputMaybe<Scalars['String']['input']>;
  blurbBody_contains: InputMaybe<Scalars['String']['input']>;
  blurbBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  blurbBody_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbBody_not: InputMaybe<Scalars['String']['input']>;
  blurbBody_not_contains: InputMaybe<Scalars['String']['input']>;
  blurbBody_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbTitle: InputMaybe<Scalars['String']['input']>;
  blurbTitle_contains: InputMaybe<Scalars['String']['input']>;
  blurbTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  blurbTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blurbTitle_not: InputMaybe<Scalars['String']['input']>;
  blurbTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  blurbTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displayMode: InputMaybe<Scalars['String']['input']>;
  displayMode_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayMode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_not: InputMaybe<Scalars['String']['input']>;
  displayMode_not_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  h1Header: InputMaybe<Scalars['String']['input']>;
  h1Header_contains: InputMaybe<Scalars['String']['input']>;
  h1Header_exists: InputMaybe<Scalars['Boolean']['input']>;
  h1Header_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  h1Header_not: InputMaybe<Scalars['String']['input']>;
  h1Header_not_contains: InputMaybe<Scalars['String']['input']>;
  h1Header_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsJson_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfProductCollectionLinkingCollections = {
  __typename?: 'CFProductCollectionLinkingCollections';
  cannedSearchCollection: Maybe<CfCannedSearchCollection>;
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  nationalStorefrontCollection: Maybe<CfNationalStorefrontCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfProductCollectionLinkingCollectionsCannedSearchCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsCannedSearchCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsNationalStorefrontCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsNationalStorefrontCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProductCollectionLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfProductCollectionLinkingCollectionsCannedSearchCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfProductCollectionLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfProductCollectionLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfProductCollectionLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfProductCollectionLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfProductCollectionLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfProductCollectionLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfProductCollectionLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfProductCollectionLinkingCollectionsNationalStorefrontCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfProductCollectionLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfProductCollectionOrder {
  AllowAutoSurfaceAsc = 'allowAutoSurface_ASC',
  AllowAutoSurfaceDesc = 'allowAutoSurface_DESC',
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BlurbTitleAsc = 'blurbTitle_ASC',
  BlurbTitleDesc = 'blurbTitle_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  H1HeaderAsc = 'h1Header_ASC',
  H1HeaderDesc = 'h1Header_DESC',
  PageTitleAsc = 'pageTitle_ASC',
  PageTitleDesc = 'pageTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfile = CfEntry & {
  __typename?: 'CFProfile';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderProfileImage: Maybe<Scalars['CFJSON']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  fullName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfProfileLinkingCollections>;
  profileImage: Maybe<CfAsset>;
  profileType: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  storesCollection: Maybe<CfProfileStoresCollection>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileBynderProfileImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileFullNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileProfileImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileProfileTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/profile) */
export type CfProfileStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProfileStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};

export type CfProfileCollection = {
  __typename?: 'CFProfileCollection';
  items: Array<Maybe<CfProfile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfProfileFilter = {
  AND: InputMaybe<Array<InputMaybe<CfProfileFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfProfileFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderProfileImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  fullName: InputMaybe<Scalars['String']['input']>;
  fullName_contains: InputMaybe<Scalars['String']['input']>;
  fullName_exists: InputMaybe<Scalars['Boolean']['input']>;
  fullName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullName_not: InputMaybe<Scalars['String']['input']>;
  fullName_not_contains: InputMaybe<Scalars['String']['input']>;
  fullName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  profileType: InputMaybe<Scalars['String']['input']>;
  profileType_contains: InputMaybe<Scalars['String']['input']>;
  profileType_exists: InputMaybe<Scalars['Boolean']['input']>;
  profileType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileType_not: InputMaybe<Scalars['String']['input']>;
  profileType_not_contains: InputMaybe<Scalars['String']['input']>;
  profileType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfProfileLinkingCollections = {
  __typename?: 'CFProfileLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  storyCollection: Maybe<CfStoryCollection>;
};


export type CfProfileLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProfileLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProfileLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfProfileLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProfileLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfProfileLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfProfileLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfProfileOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  ProfileTypeAsc = 'profileType_ASC',
  ProfileTypeDesc = 'profileType_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfProfileStoresCollection = {
  __typename?: 'CFProfileStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfProfileStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfProfileStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotion = CfEntry & {
  __typename?: 'CFPromotion';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderImage: Maybe<Scalars['CFJSON']['output']>;
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  heading: Maybe<Scalars['String']['output']>;
  image: Maybe<CfAsset>;
  linkedFrom: Maybe<CfPromotionLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionBynderImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionCallToActionAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotion) */
export type CfPromotionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfPromotionCollection = {
  __typename?: 'CFPromotionCollection';
  items: Array<Maybe<CfPromotion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfPromotionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPromotionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPromotionFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPromotionLinkingCollections = {
  __typename?: 'CFPromotionLinkingCollections';
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  promotionalTemplateCollection: Maybe<CfPromotionalTemplateCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfPromotionLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPromotionLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfPromotionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfPromotionLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPromotionLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfPromotionLinkingCollectionsPromotionalTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPromotionLinkingCollectionsPromotionalTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfPromotionLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPromotionLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfPromotionLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfPromotionLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfPromotionLinkingCollectionsPromotionalTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfPromotionLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfPromotionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplate = CfEntry & {
  __typename?: 'CFPromotionalTemplate';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endAt: Maybe<Scalars['CFDateTime']['output']>;
  linkedFrom: Maybe<CfPromotionalTemplateLinkingCollections>;
  metaTitle: Maybe<Scalars['String']['output']>;
  modulesCollection: Maybe<CfPromotionalTemplateModulesCollection>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  path: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  startAt: Maybe<Scalars['CFDateTime']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateEndAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateMetaTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfPromotionalTemplateModulesFilter>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateNavigationMenuArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplatePathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateStartAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Promotional template/universal landing page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/promotionalTemplate) */
export type CfPromotionalTemplateTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfPromotionalTemplateCollection = {
  __typename?: 'CFPromotionalTemplateCollection';
  items: Array<Maybe<CfPromotionalTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfPromotionalTemplateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPromotionalTemplateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPromotionalTemplateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  metaTitle: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu_exists: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPromotionalTemplateLinkingCollections = {
  __typename?: 'CFPromotionalTemplateLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfPromotionalTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfPromotionalTemplateModulesCollection = {
  __typename?: 'CFPromotionalTemplateModulesCollection';
  items: Array<Maybe<CfPromotionalTemplateModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfPromotionalTemplateModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPromotionalTemplateModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPromotionalTemplateModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfPromotionalTemplateModulesItem = CfComparisonModule | CfPromotion;

export enum CfPromotionalTemplateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestion = CfEntry & {
  __typename?: 'CFQuestion';
  _id: Scalars['ID']['output'];
  answersCollection: Maybe<CfQuestionAnswersCollection>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfQuestionLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestionAnswersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfQuestionAnswersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfAnswerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestionSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestionSubtitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/question) */
export type CfQuestionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfQuestionAnswersCollection = {
  __typename?: 'CFQuestionAnswersCollection';
  items: Array<Maybe<CfAnswer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfQuestionAnswersCollectionOrder {
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfQuestionCollection = {
  __typename?: 'CFQuestionCollection';
  items: Array<Maybe<CfQuestion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfQuestionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfQuestionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfQuestionFilter>>>;
  answers: InputMaybe<CfCfAnswerNestedFilter>;
  answersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle: InputMaybe<Scalars['String']['input']>;
  subtitle_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfQuestionLinkingCollections = {
  __typename?: 'CFQuestionLinkingCollections';
  competitionCollection: Maybe<CfCompetitionCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfQuestionLinkingCollectionsCompetitionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfQuestionLinkingCollectionsCompetitionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfQuestionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfQuestionLinkingCollectionsCompetitionCollectionOrder {
  FaqUrlAsc = 'faqUrl_ASC',
  FaqUrlDesc = 'faqUrl_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  SuccessTitleAsc = 'successTitle_ASC',
  SuccessTitleDesc = 'successTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfQuestionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubtitleAsc = 'subtitle_ASC',
  SubtitleDesc = 'subtitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfResourceLink = {
  sys: CfResourceSys;
};

export type CfResourceSys = {
  __typename?: 'CFResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategory = CfEntry & {
  __typename?: 'CFRetailCategory';
  _id: Scalars['ID']['output'];
  aliases: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  heroImageSet: Maybe<CfHeroImageSet>;
  level: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<CfRetailCategoryLinkingCollections>;
  parentCategory: Maybe<CfRetailCategory>;
  seoContentSchema: Maybe<Scalars['CFJSON']['output']>;
  seoTitle: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryAliasesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryLevelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryParentCategoryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategorySeoContentSchemaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategorySeoTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailCategory) */
export type CfRetailCategoryTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfRetailCategoryCollection = {
  __typename?: 'CFRetailCategoryCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfRetailCategoryFilter = {
  AND: InputMaybe<Array<InputMaybe<CfRetailCategoryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfRetailCategoryFilter>>>;
  aliases_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  level: InputMaybe<Scalars['Int']['input']>;
  level_exists: InputMaybe<Scalars['Boolean']['input']>;
  level_gt: InputMaybe<Scalars['Int']['input']>;
  level_gte: InputMaybe<Scalars['Int']['input']>;
  level_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  level_lt: InputMaybe<Scalars['Int']['input']>;
  level_lte: InputMaybe<Scalars['Int']['input']>;
  level_not: InputMaybe<Scalars['Int']['input']>;
  level_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  parentCategory: InputMaybe<CfCfRetailCategoryNestedFilter>;
  parentCategory_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoContentSchema_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle: InputMaybe<Scalars['String']['input']>;
  seoTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoTitle_not: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfRetailCategoryLinkingCollections = {
  __typename?: 'CFRetailCategoryLinkingCollections';
  automatedCollectionCollection: Maybe<CfAutomatedCollectionCollection>;
  centreCollection: Maybe<CfCentreCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  featuredCommerceCollection: Maybe<CfFeaturedCommerceCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  retailCategoryCollection: Maybe<CfRetailCategoryCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
  storeCollection: Maybe<CfStoreCollection>;
  storyCollection: Maybe<CfStoryCollection>;
  utilityPanelCollection: Maybe<CfUtilityPanelCollection>;
};


export type CfRetailCategoryLinkingCollectionsAutomatedCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsAutomatedCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsCentreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsFeaturedCommerceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsFeaturedCommerceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsRetailCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsRetailCategoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailCategoryLinkingCollectionsUtilityPanelCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryLinkingCollectionsUtilityPanelCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfRetailCategoryLinkingCollectionsAutomatedCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  ContentLimitAsc = 'contentLimit_ASC',
  ContentLimitDesc = 'contentLimit_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailCategoryLinkingCollectionsCentreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export enum CfRetailCategoryLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfRetailCategoryLinkingCollectionsFeaturedCommerceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailCategoryLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfRetailCategoryLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfRetailCategoryLinkingCollectionsRetailCategoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailCategoryLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfRetailCategoryLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfRetailCategoryLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfRetailCategoryLinkingCollectionsUtilityPanelCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfRetailCategoryOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailer = CfEntry & {
  __typename?: 'CFRetailer';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  callsToActionCollection: Maybe<CfRetailerCallsToActionCollection>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Scalars['String']['output']>;
  experiencesCollection: Maybe<CfRetailerExperiencesCollection>;
  facebook: Maybe<Scalars['String']['output']>;
  featuredFacetsCollection: Maybe<CfRetailerFeaturedFacetsCollection>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideReviews: Maybe<Scalars['Boolean']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  legacyIdentifier: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<CfRetailerLinkingCollections>;
  longDescription: Maybe<Scalars['String']['output']>;
  loyaltyProgramsCollection: Maybe<CfRetailerLoyaltyProgramsCollection>;
  marketplaceShopId: Maybe<Scalars['String']['output']>;
  marketplaceShopSlug: Maybe<Scalars['String']['output']>;
  paymentMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priceDescription: Maybe<Scalars['String']['output']>;
  retailCategoriesCollection: Maybe<CfRetailerRetailCategoriesCollection>;
  retailerLogoSet: Maybe<CfRetailerLogoSet>;
  retailerSizeGuide: Maybe<Scalars['String']['output']>;
  services: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settings: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfRetailerTopicsCollection>;
  twitter: Maybe<Scalars['String']['output']>;
  websiteAddress: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerCallsToActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerCallsToActionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCallToActionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerFacebookArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerFeaturedFacetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerFeaturedFacetsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeaturedLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerHideReviewsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerInstagramArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerLegacyIdentifierArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerLongDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerLoyaltyProgramsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLoyaltyProgramsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfLoyaltyProgramFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerMarketplaceShopIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerMarketplaceShopSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerPaymentMethodsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerPriceDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerRetailerLogoSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfRetailerLogoSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerRetailerSizeGuideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerServicesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerSettingsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerTwitterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailer) */
export type CfRetailerWebsiteAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfRetailerCallsToActionCollection = {
  __typename?: 'CFRetailerCallsToActionCollection';
  items: Array<Maybe<CfCallToAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfRetailerCallsToActionCollectionOrder {
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfRetailerCollection = {
  __typename?: 'CFRetailerCollection';
  items: Array<Maybe<CfRetailer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfRetailerExperiencesCollection = {
  __typename?: 'CFRetailerExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfRetailerExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfRetailerFeaturedFacetsCollection = {
  __typename?: 'CFRetailerFeaturedFacetsCollection';
  items: Array<Maybe<CfFeaturedLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfRetailerFeaturedFacetsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColourAsc = 'textColour_ASC',
  TextColourDesc = 'textColour_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type CfRetailerFilter = {
  AND: InputMaybe<Array<InputMaybe<CfRetailerFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfRetailerFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callsToAction: InputMaybe<CfCfCallToActionNestedFilter>;
  callsToActionCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country: InputMaybe<Scalars['String']['input']>;
  country_contains: InputMaybe<Scalars['String']['input']>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  country_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_not: InputMaybe<Scalars['String']['input']>;
  country_not_contains: InputMaybe<Scalars['String']['input']>;
  country_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredFacets: InputMaybe<CfCfFeaturedLinkNestedFilter>;
  featuredFacetsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_not: InputMaybe<Scalars['Boolean']['input']>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyIdentifier: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_exists: InputMaybe<Scalars['Boolean']['input']>;
  legacyIdentifier_gt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_gte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  legacyIdentifier_lt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_lte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  longDescription: InputMaybe<Scalars['String']['input']>;
  longDescription_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  longDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longDescription_not: InputMaybe<Scalars['String']['input']>;
  longDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loyaltyPrograms: InputMaybe<CfCfLoyaltyProgramNestedFilter>;
  loyaltyProgramsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShopId: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_exists: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShopId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceShopId_not: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_not_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceShopSlug: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_exists: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceShopSlug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceShopSlug_not: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_not_contains: InputMaybe<Scalars['String']['input']>;
  marketplaceShopSlug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription: InputMaybe<Scalars['String']['input']>;
  priceDescription_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription_not: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailerLogoSet: InputMaybe<CfCfRetailerLogoSetNestedFilter>;
  retailerLogoSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailerSizeGuide: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_contains: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailerSizeGuide_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailerSizeGuide_not: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_not_contains: InputMaybe<Scalars['String']['input']>;
  retailerSizeGuide_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_exists: InputMaybe<Scalars['Boolean']['input']>;
  settings: InputMaybe<Scalars['String']['input']>;
  settings_contains: InputMaybe<Scalars['String']['input']>;
  settings_exists: InputMaybe<Scalars['Boolean']['input']>;
  settings_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settings_not: InputMaybe<Scalars['String']['input']>;
  settings_not_contains: InputMaybe<Scalars['String']['input']>;
  settings_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress: InputMaybe<Scalars['String']['input']>;
  websiteAddress_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  websiteAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress_not: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfRetailerLinkingCollections = {
  __typename?: 'CFRetailerLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  nationalStorefrontCollection: Maybe<CfNationalStorefrontCollection>;
  storeCollection: Maybe<CfStoreCollection>;
};


export type CfRetailerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsNationalStorefrontCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsNationalStorefrontCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfRetailerLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfRetailerLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailerLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfRetailerLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailerLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailerLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailerLinkingCollectionsNationalStorefrontCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfRetailerLinkingCollectionsPartnerPortalPermissionCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum CfRetailerLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSet = CfEntry & {
  __typename?: 'CFRetailerLogoSet';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderColoured: Maybe<Scalars['CFJSON']['output']>;
  bynderTileBackground: Maybe<Scalars['CFJSON']['output']>;
  bynderTransparent: Maybe<Scalars['CFJSON']['output']>;
  coloured: Maybe<CfAsset>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfRetailerLogoSetLinkingCollections>;
  sys: CfSys;
  tileBackground: Maybe<CfAsset>;
  transparent: Maybe<CfAsset>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetBynderColouredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetBynderTileBackgroundArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetBynderTransparentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetColouredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetTileBackgroundArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/retailerLogoSet) */
export type CfRetailerLogoSetTransparentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfRetailerLogoSetCollection = {
  __typename?: 'CFRetailerLogoSetCollection';
  items: Array<Maybe<CfRetailerLogoSet>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfRetailerLogoSetFilter = {
  AND: InputMaybe<Array<InputMaybe<CfRetailerLogoSetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfRetailerLogoSetFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderColoured_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderTileBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  bynderTransparent_exists: InputMaybe<Scalars['Boolean']['input']>;
  coloured_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  tileBackground_exists: InputMaybe<Scalars['Boolean']['input']>;
  transparent_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfRetailerLogoSetLinkingCollections = {
  __typename?: 'CFRetailerLogoSetLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
};


export type CfRetailerLogoSetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfRetailerLogoSetLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLogoSetLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfRetailerLogoSetLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfRetailerLogoSetOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfRetailerLoyaltyProgramsCollection = {
  __typename?: 'CFRetailerLoyaltyProgramsCollection';
  items: Array<Maybe<CfLoyaltyProgram>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfRetailerLoyaltyProgramsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BrandBackgroundColorAsc = 'brandBackgroundColor_ASC',
  BrandBackgroundColorDesc = 'brandBackgroundColor_DESC',
  CanAddMembershipAsc = 'canAddMembership_ASC',
  CanAddMembershipDesc = 'canAddMembership_DESC',
  CanSignupAsc = 'canSignup_ASC',
  CanSignupDesc = 'canSignup_DESC',
  HasAccountLoginAsc = 'hasAccountLogin_ASC',
  HasAccountLoginDesc = 'hasAccountLogin_DESC',
  HasBarcodeAsc = 'hasBarcode_ASC',
  HasBarcodeDesc = 'hasBarcode_DESC',
  HasCardNumberAsc = 'hasCardNumber_ASC',
  HasCardNumberDesc = 'hasCardNumber_DESC',
  HasCardAsc = 'hasCard_ASC',
  HasCardDesc = 'hasCard_DESC',
  HasMembershipNumberAsc = 'hasMembershipNumber_ASC',
  HasMembershipNumberDesc = 'hasMembershipNumber_DESC',
  IsInverseAsc = 'isInverse_ASC',
  IsInverseDesc = 'isInverse_DESC',
  LegacyCardAssetImageAsc = 'legacyCardAssetImage_ASC',
  LegacyCardAssetImageDesc = 'legacyCardAssetImage_DESC',
  LoginUrlAsc = 'loginUrl_ASC',
  LoginUrlDesc = 'loginUrl_DESC',
  MembershipBarcodeFormatAsc = 'membershipBarcodeFormat_ASC',
  MembershipBarcodeFormatDesc = 'membershipBarcodeFormat_DESC',
  SignupUrlAsc = 'signupUrl_ASC',
  SignupUrlDesc = 'signupUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfRetailerOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfRetailerRetailCategoriesCollection = {
  __typename?: 'CFRetailerRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfRetailerRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfRetailerTopicsCollection = {
  __typename?: 'CFRetailerTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfRetailerTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** A list of items to present as suggestions in live search. [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/searchSuggestions) */
export type CfSearchSuggestions = CfEntry & {
  __typename?: 'CFSearchSuggestions';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  context: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfSearchSuggestionsLinkingCollections>;
  linksCollection: Maybe<CfSearchSuggestionsLinksCollection>;
  sys: CfSys;
};


/** A list of items to present as suggestions in live search. [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/searchSuggestions) */
export type CfSearchSuggestionsBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** A list of items to present as suggestions in live search. [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/searchSuggestions) */
export type CfSearchSuggestionsCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** A list of items to present as suggestions in live search. [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/searchSuggestions) */
export type CfSearchSuggestionsContextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** A list of items to present as suggestions in live search. [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/searchSuggestions) */
export type CfSearchSuggestionsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A list of items to present as suggestions in live search. [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/searchSuggestions) */
export type CfSearchSuggestionsLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSearchSuggestionsLinksFilter>;
};

export type CfSearchSuggestionsCollection = {
  __typename?: 'CFSearchSuggestionsCollection';
  items: Array<Maybe<CfSearchSuggestions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSearchSuggestionsFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSearchSuggestionsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSearchSuggestionsFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  context: InputMaybe<Scalars['String']['input']>;
  context_contains: InputMaybe<Scalars['String']['input']>;
  context_exists: InputMaybe<Scalars['Boolean']['input']>;
  context_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  context_not: InputMaybe<Scalars['String']['input']>;
  context_not_contains: InputMaybe<Scalars['String']['input']>;
  context_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  links: InputMaybe<CfCflinksMultiTypeNestedFilter>;
  linksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfSearchSuggestionsLinkingCollections = {
  __typename?: 'CFSearchSuggestionsLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfSearchSuggestionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfSearchSuggestionsLinksCollection = {
  __typename?: 'CFSearchSuggestionsLinksCollection';
  items: Array<Maybe<CfSearchSuggestionsLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSearchSuggestionsLinksFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSearchSuggestionsLinksFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSearchSuggestionsLinksFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSearchSuggestionsLinksItem = CfFeaturedLink | CfStore;

export enum CfSearchSuggestionsOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ContextAsc = 'context_ASC',
  ContextDesc = 'context_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/section) */
export type CfSection = CfEntry & {
  __typename?: 'CFSection';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  displayMode: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfSectionLinkingCollections>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/section) */
export type CfSectionBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/section) */
export type CfSectionDisplayModeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/section) */
export type CfSectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/section) */
export type CfSectionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfSectionCollection = {
  __typename?: 'CFSectionCollection';
  items: Array<Maybe<CfSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSectionFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSectionFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  displayMode: InputMaybe<Scalars['String']['input']>;
  displayMode_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayMode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayMode_not: InputMaybe<Scalars['String']['input']>;
  displayMode_not_contains: InputMaybe<Scalars['String']['input']>;
  displayMode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSectionLinkingCollections = {
  __typename?: 'CFSectionLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  giftcardTemplateCollection: Maybe<CfGiftcardTemplateCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSectionLinkingCollectionsGiftcardTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSectionLinkingCollectionsGiftcardTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSectionLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSectionLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfSectionLinkingCollectionsGiftcardTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionMetaDescriptionAsc = 'shortDescriptionMetaDescription_ASC',
  ShortDescriptionMetaDescriptionDesc = 'shortDescriptionMetaDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfSectionLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfSectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfService = CfEntry & {
  __typename?: 'CFService';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  category: Maybe<Scalars['String']['output']>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  landmarkDescription: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfServiceLinkingCollections>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  showAt: Maybe<Scalars['CFDateTime']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  store: Maybe<CfStore>;
  sys: CfSys;
  telephoneNumber: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceCategoryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceLandmarkDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServicePhysicalAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceShowAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceStoreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceTelephoneNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/service) */
export type CfServiceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfServiceCollection = {
  __typename?: 'CFServiceCollection';
  items: Array<Maybe<CfService>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfServiceFilter = {
  AND: InputMaybe<Array<InputMaybe<CfServiceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfServiceFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category: InputMaybe<Scalars['String']['input']>;
  category_contains: InputMaybe<Scalars['String']['input']>;
  category_exists: InputMaybe<Scalars['Boolean']['input']>;
  category_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_not: InputMaybe<Scalars['String']['input']>;
  category_not_contains: InputMaybe<Scalars['String']['input']>;
  category_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  landmarkDescription: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  landmarkDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription_not: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  store: InputMaybe<CfCfStoreNestedFilter>;
  store_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  telephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfServiceLinkingCollections = {
  __typename?: 'CFServiceLinkingCollections';
  centreCollection: Maybe<CfCentreCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  parkingTemplateCollection: Maybe<CfParkingTemplateCollection>;
};


export type CfServiceLinkingCollectionsCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceLinkingCollectionsCentreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfServiceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfServiceLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfServiceLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfServiceLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfServiceLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfServiceLinkingCollectionsParkingTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceLinkingCollectionsParkingTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfServiceLinkingCollectionsCentreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export enum CfServiceLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfServiceLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfServiceLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfServiceLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfServiceLinkingCollectionsParkingTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfServiceOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocial = CfEntry & {
  __typename?: 'CFSocial';
  _id: Scalars['ID']['output'];
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  endAt: Maybe<Scalars['CFDateTime']['output']>;
  linkedFrom: Maybe<CfSocialLinkingCollections>;
  startAt: Maybe<Scalars['CFDateTime']['output']>;
  storesCollection: Maybe<CfSocialStoresCollection>;
  supportingImageSet: Maybe<CfSupportingImageSet>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialEndAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialStartAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSocialStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialSupportingImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfSupportingImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/social) */
export type CfSocialTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfSocialCollection = {
  __typename?: 'CFSocialCollection';
  items: Array<Maybe<CfSocial>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/socialFeed) */
export type CfSocialFeed = CfEntry & {
  __typename?: 'CFSocialFeed';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfSocialFeedLinkingCollections>;
  stacklaWidget: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/socialFeed) */
export type CfSocialFeedBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/socialFeed) */
export type CfSocialFeedLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/socialFeed) */
export type CfSocialFeedStacklaWidgetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/socialFeed) */
export type CfSocialFeedTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfSocialFeedCollection = {
  __typename?: 'CFSocialFeedCollection';
  items: Array<Maybe<CfSocialFeed>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSocialFeedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSocialFeedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSocialFeedFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  stacklaWidget: InputMaybe<Scalars['String']['input']>;
  stacklaWidget_contains: InputMaybe<Scalars['String']['input']>;
  stacklaWidget_exists: InputMaybe<Scalars['Boolean']['input']>;
  stacklaWidget_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stacklaWidget_not: InputMaybe<Scalars['String']['input']>;
  stacklaWidget_not_contains: InputMaybe<Scalars['String']['input']>;
  stacklaWidget_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSocialFeedLinkingCollections = {
  __typename?: 'CFSocialFeedLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfSocialFeedLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSocialFeedLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSocialFeedLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfSocialFeedLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfSocialFeedOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfSocialFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSocialFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSocialFilter>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endAt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  endAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  endAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  endAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  startAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  startAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  startAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  supportingImageSet: InputMaybe<CfCfSupportingImageSetNestedFilter>;
  supportingImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSocialLinkingCollections = {
  __typename?: 'CFSocialLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfSocialLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfSocialLinkingCollectionsPartnerPortalPermissionCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum CfSocialOrder {
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfSocialStoresCollection = {
  __typename?: 'CFSocialStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfSocialStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfSocialStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplate = CfEntry & {
  __typename?: 'CFSolusTemplate';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfSolusTemplateLinkingCollections>;
  modulesCollection: Maybe<CfSolusTemplateModulesCollection>;
  scope: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  subject: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSolusTemplateModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateScopeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/solusTemplate) */
export type CfSolusTemplateSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfSolusTemplateCollection = {
  __typename?: 'CFSolusTemplateCollection';
  items: Array<Maybe<CfSolusTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSolusTemplateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSolusTemplateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSolusTemplateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope: InputMaybe<Scalars['String']['input']>;
  scope_contains: InputMaybe<Scalars['String']['input']>;
  scope_exists: InputMaybe<Scalars['Boolean']['input']>;
  scope_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_not: InputMaybe<Scalars['String']['input']>;
  scope_not_contains: InputMaybe<Scalars['String']['input']>;
  scope_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject: InputMaybe<Scalars['String']['input']>;
  subject_contains: InputMaybe<Scalars['String']['input']>;
  subject_exists: InputMaybe<Scalars['Boolean']['input']>;
  subject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject_not: InputMaybe<Scalars['String']['input']>;
  subject_not_contains: InputMaybe<Scalars['String']['input']>;
  subject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfSolusTemplateLinkingCollections = {
  __typename?: 'CFSolusTemplateLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfSolusTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfSolusTemplateModulesCollection = {
  __typename?: 'CFSolusTemplateModulesCollection';
  items: Array<Maybe<CfSolusTemplateModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSolusTemplateModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSolusTemplateModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSolusTemplateModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSolusTemplateModulesItem = CfManualSolusModule | CfStaticBannerSolusModule;

export enum CfSolusTemplateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubjectAsc = 'subject_ASC',
  SubjectDesc = 'subject_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModule = CfEntry & {
  __typename?: 'CFStaticBannerSolusModule';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  desktopImageUrl: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfStaticBannerSolusModuleLinkingCollections>;
  mobileImageUrl: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleCallToActionAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleDesktopImageUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleMobileImageUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticBannerSolusModule) */
export type CfStaticBannerSolusModuleTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfStaticBannerSolusModuleCollection = {
  __typename?: 'CFStaticBannerSolusModuleCollection';
  items: Array<Maybe<CfStaticBannerSolusModule>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfStaticBannerSolusModuleFilter = {
  AND: InputMaybe<Array<InputMaybe<CfStaticBannerSolusModuleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfStaticBannerSolusModuleFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionAddress_not: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  desktopImageUrl: InputMaybe<Scalars['String']['input']>;
  desktopImageUrl_contains: InputMaybe<Scalars['String']['input']>;
  desktopImageUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  desktopImageUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  desktopImageUrl_not: InputMaybe<Scalars['String']['input']>;
  desktopImageUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  desktopImageUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileImageUrl: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl_contains: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  mobileImageUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileImageUrl_not: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  mobileImageUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfStaticBannerSolusModuleLinkingCollections = {
  __typename?: 'CFStaticBannerSolusModuleLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  solusTemplateCollection: Maybe<CfSolusTemplateCollection>;
};


export type CfStaticBannerSolusModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStaticBannerSolusModuleLinkingCollectionsSolusTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStaticBannerSolusModuleLinkingCollectionsSolusTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfStaticBannerSolusModuleLinkingCollectionsSolusTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ScopeAsc = 'scope_ASC',
  ScopeDesc = 'scope_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SubjectAsc = 'subject_ASC',
  SubjectDesc = 'subject_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfStaticBannerSolusModuleOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DesktopImageUrlAsc = 'desktopImageUrl_ASC',
  DesktopImageUrlDesc = 'desktopImageUrl_DESC',
  MobileImageUrlAsc = 'mobileImageUrl_ASC',
  MobileImageUrlDesc = 'mobileImageUrl_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFile = CfEntry & {
  __typename?: 'CFStaticFile';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jsonContent: Maybe<Scalars['CFJSON']['output']>;
  linkedFrom: Maybe<CfStaticFileLinkingCollections>;
  path: Maybe<Scalars['String']['output']>;
  plainTextContent: Maybe<Scalars['String']['output']>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFileBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFileCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFileJsonContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFileLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFilePathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/staticFile) */
export type CfStaticFilePlainTextContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfStaticFileCollection = {
  __typename?: 'CFStaticFileCollection';
  items: Array<Maybe<CfStaticFile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfStaticFileFilter = {
  AND: InputMaybe<Array<InputMaybe<CfStaticFileFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfStaticFileFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  jsonContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plainTextContent: InputMaybe<Scalars['String']['input']>;
  plainTextContent_contains: InputMaybe<Scalars['String']['input']>;
  plainTextContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  plainTextContent_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  plainTextContent_not: InputMaybe<Scalars['String']['input']>;
  plainTextContent_not_contains: InputMaybe<Scalars['String']['input']>;
  plainTextContent_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfStaticFileLinkingCollections = {
  __typename?: 'CFStaticFileLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfStaticFileLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfStaticFileOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStore = CfEntry & {
  __typename?: 'CFStore';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderStoreFrontImage: Maybe<Scalars['CFJSON']['output']>;
  callsToActionCollection: Maybe<CfStoreCallsToActionCollection>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  emailAddress: Maybe<Scalars['String']['output']>;
  experiencesCollection: Maybe<CfStoreExperiencesCollection>;
  facebook: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  hideReviews: Maybe<Scalars['Boolean']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  landmarkDescription: Maybe<Scalars['String']['output']>;
  legacyIdentifier: Maybe<Scalars['Int']['output']>;
  level: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfStoreLinkingCollections>;
  longDescription: Maybe<Scalars['String']['output']>;
  mapIdentifier: Maybe<Scalars['String']['output']>;
  openAt: Maybe<Scalars['CFDateTime']['output']>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  parkingInstructions: Maybe<Scalars['String']['output']>;
  paymentMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  priceDescription: Maybe<Scalars['String']['output']>;
  reputationCode: Maybe<Scalars['String']['output']>;
  retailCategoriesCollection: Maybe<CfStoreRetailCategoriesCollection>;
  retailer: Maybe<CfRetailer>;
  services: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shopNumber: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  showAt: Maybe<Scalars['CFDateTime']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  specialStatus: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  storeFrontImage: Maybe<CfAsset>;
  storeType: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  telephoneNumber: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  titleWithOptionalStatus: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfStoreTopicsCollection>;
  twitter: Maybe<Scalars['String']['output']>;
  waypoint: Maybe<Scalars['String']['output']>;
  websiteAddress: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreBynderStoreFrontImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreCallsToActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreCallsToActionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCallToActionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreEmailAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreFacebookArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreHideReviewsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreInstagramArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreLandmarkDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreLegacyIdentifierArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreLevelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreLongDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreOpenAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreParkingInstructionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStorePaymentMethodsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStorePhysicalAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStorePriceDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreReputationCodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreRetailerArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfRetailerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreServicesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreShopNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreShowAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreSpecialStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreStatusArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreStoreFrontImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreStoreTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreTelephoneNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreTwitterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreWaypointArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/store) */
export type CfStoreWebsiteAddressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfStoreCallsToActionCollection = {
  __typename?: 'CFStoreCallsToActionCollection';
  items: Array<Maybe<CfCallToAction>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoreCallsToActionCollectionOrder {
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfStoreCollection = {
  __typename?: 'CFStoreCollection';
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfStoreExperiencesCollection = {
  __typename?: 'CFStoreExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoreExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfStoreFilter = {
  AND: InputMaybe<Array<InputMaybe<CfStoreFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfStoreFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderStoreFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  callsToAction: InputMaybe<CfCfCallToActionNestedFilter>;
  callsToActionCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  emailAddress: InputMaybe<Scalars['String']['input']>;
  emailAddress_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress_not: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  emailAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideReviews: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideReviews_not: InputMaybe<Scalars['Boolean']['input']>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  landmarkDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landmarkDescription_not: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  landmarkDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyIdentifier: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_exists: InputMaybe<Scalars['Boolean']['input']>;
  legacyIdentifier_gt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_gte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  legacyIdentifier_lt: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_lte: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not: InputMaybe<Scalars['Int']['input']>;
  legacyIdentifier_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  level: InputMaybe<Scalars['String']['input']>;
  level_contains: InputMaybe<Scalars['String']['input']>;
  level_exists: InputMaybe<Scalars['Boolean']['input']>;
  level_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_not: InputMaybe<Scalars['String']['input']>;
  level_not_contains: InputMaybe<Scalars['String']['input']>;
  level_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longDescription: InputMaybe<Scalars['String']['input']>;
  longDescription_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  longDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  longDescription_not: InputMaybe<Scalars['String']['input']>;
  longDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  longDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openAt: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  openAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  openAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  openAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  parkingInstructions: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_contains: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_exists: InputMaybe<Scalars['Boolean']['input']>;
  parkingInstructions_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parkingInstructions_not: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_not_contains: InputMaybe<Scalars['String']['input']>;
  parkingInstructions_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentMethods_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress: InputMaybe<Scalars['String']['input']>;
  physicalAddress_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  physicalAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  physicalAddress_not: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  physicalAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription: InputMaybe<Scalars['String']['input']>;
  priceDescription_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  priceDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceDescription_not: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  priceDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode: InputMaybe<Scalars['String']['input']>;
  reputationCode_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_exists: InputMaybe<Scalars['Boolean']['input']>;
  reputationCode_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reputationCode_not: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_contains: InputMaybe<Scalars['String']['input']>;
  reputationCode_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailer: InputMaybe<CfCfRetailerNestedFilter>;
  retailer_exists: InputMaybe<Scalars['Boolean']['input']>;
  services_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services_exists: InputMaybe<Scalars['Boolean']['input']>;
  shopNumber: InputMaybe<Scalars['String']['input']>;
  shopNumber_contains: InputMaybe<Scalars['String']['input']>;
  shopNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  shopNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shopNumber_not: InputMaybe<Scalars['String']['input']>;
  shopNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  shopNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialStatus: InputMaybe<Scalars['String']['input']>;
  specialStatus_contains: InputMaybe<Scalars['String']['input']>;
  specialStatus_exists: InputMaybe<Scalars['Boolean']['input']>;
  specialStatus_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialStatus_not: InputMaybe<Scalars['String']['input']>;
  specialStatus_not_contains: InputMaybe<Scalars['String']['input']>;
  specialStatus_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  status_contains: InputMaybe<Scalars['String']['input']>;
  status_exists: InputMaybe<Scalars['Boolean']['input']>;
  status_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_not: InputMaybe<Scalars['String']['input']>;
  status_not_contains: InputMaybe<Scalars['String']['input']>;
  status_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storeFrontImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  storeType: InputMaybe<Scalars['String']['input']>;
  storeType_contains: InputMaybe<Scalars['String']['input']>;
  storeType_exists: InputMaybe<Scalars['Boolean']['input']>;
  storeType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  storeType_not: InputMaybe<Scalars['String']['input']>;
  storeType_not_contains: InputMaybe<Scalars['String']['input']>;
  storeType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  telephoneNumber: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  telephoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  telephoneNumber_not: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  telephoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  waypoint: InputMaybe<Scalars['String']['input']>;
  waypoint_contains: InputMaybe<Scalars['String']['input']>;
  waypoint_exists: InputMaybe<Scalars['Boolean']['input']>;
  waypoint_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  waypoint_not: InputMaybe<Scalars['String']['input']>;
  waypoint_not_contains: InputMaybe<Scalars['String']['input']>;
  waypoint_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress: InputMaybe<Scalars['String']['input']>;
  websiteAddress_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_exists: InputMaybe<Scalars['Boolean']['input']>;
  websiteAddress_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteAddress_not: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_contains: InputMaybe<Scalars['String']['input']>;
  websiteAddress_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfStoreLinkingCollections = {
  __typename?: 'CFStoreLinkingCollections';
  carParkCollection: Maybe<CfCarParkCollection>;
  centreCollection: Maybe<CfCentreCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  featuredCommerceCollection: Maybe<CfFeaturedCommerceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  profileCollection: Maybe<CfProfileCollection>;
  searchSuggestionsCollection: Maybe<CfSearchSuggestionsCollection>;
  serviceCollection: Maybe<CfServiceCollection>;
  socialCollection: Maybe<CfSocialCollection>;
  storyCollection: Maybe<CfStoryCollection>;
};


export type CfStoreLinkingCollectionsCarParkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsCarParkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsCentreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsFeaturedCommerceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsFeaturedCommerceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsProfileCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsSearchSuggestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsSearchSuggestionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsServiceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsSocialCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsSocialCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoreLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfStoreLinkingCollectionsCarParkCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EntranceAsc = 'entrance_ASC',
  EntranceDesc = 'entrance_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LocationAsc = 'location_ASC',
  LocationDesc = 'location_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoreLinkingCollectionsCentreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export enum CfStoreLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfStoreLinkingCollectionsFeaturedCommerceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoreLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfStoreLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoreLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfStoreLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoreLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfStoreLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfStoreLinkingCollectionsProfileCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  ProfileTypeAsc = 'profileType_ASC',
  ProfileTypeDesc = 'profileType_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfStoreLinkingCollectionsSearchSuggestionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ContextAsc = 'context_ASC',
  ContextDesc = 'context_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfStoreLinkingCollectionsServiceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoreLinkingCollectionsSocialCollectionOrder {
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfStoreLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfStoreOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfStoreRetailCategoriesCollection = {
  __typename?: 'CFStoreRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoreRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfStoreTopicsCollection = {
  __typename?: 'CFStoreTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoreTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStory = CfEntry & {
  __typename?: 'CFStory';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfStoryCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  experiencesCollection: Maybe<CfStoryExperiencesCollection>;
  heroImageSet: Maybe<CfHeroImageSet>;
  hideAt: Maybe<Scalars['CFDateTime']['output']>;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<CfStoryLinkingCollections>;
  nationalCollection: Maybe<CfStoryNationalCollection>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  profilesCollection: Maybe<CfStoryProfilesCollection>;
  retailCategoriesCollection: Maybe<CfStoryRetailCategoriesCollection>;
  shortDescription: Maybe<Scalars['String']['output']>;
  showAt: Maybe<Scalars['CFDateTime']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sponsored: Maybe<Scalars['Boolean']['output']>;
  storesCollection: Maybe<CfStoryStoresCollection>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: CfSys;
  theEdit: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Maybe<Scalars['String']['output']>;
  topicsCollection: Maybe<CfStoryTopicsCollection>;
  viewOption: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryCallToActionLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryEdmSubheadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryEdmSubjectArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryEdmTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryExperiencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryExperiencesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryHideAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryIsSensitiveContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryNationalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryNationalCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalHomepageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryProfilesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryProfilesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfProfileFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryRetailCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryRetailCategoriesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryShowAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStorySlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStorySponsoredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryStoresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryStoresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStorySurfaceContentInChannelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryTheEditArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/story) */
export type CfStoryViewOptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfStoryCentresCollection = {
  __typename?: 'CFStoryCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoryCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfStoryCollection = {
  __typename?: 'CFStoryCollection';
  items: Array<Maybe<CfStory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfStoryExperiencesCollection = {
  __typename?: 'CFStoryExperiencesCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoryExperiencesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfStoryFilter = {
  AND: InputMaybe<Array<InputMaybe<CfStoryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfStoryFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionLabel_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionLabel_not: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionLabel_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  edmSubheading: InputMaybe<Scalars['String']['input']>;
  edmSubheading_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubheading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubheading_not: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubheading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject: InputMaybe<Scalars['String']['input']>;
  edmSubject_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmSubject_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmSubject_not: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_contains: InputMaybe<Scalars['String']['input']>;
  edmSubject_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle: InputMaybe<Scalars['String']['input']>;
  edmTitle_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  edmTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  edmTitle_not: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  edmTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experiences: InputMaybe<CfCfExperienceNestedFilter>;
  experiencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  hideAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  hideAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  hideAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  isSensitiveContent: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_exists: InputMaybe<Scalars['Boolean']['input']>;
  isSensitiveContent_not: InputMaybe<Scalars['Boolean']['input']>;
  national: InputMaybe<CfCfNationalHomepageNestedFilter>;
  nationalCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  profiles: InputMaybe<CfCfProfileNestedFilter>;
  profilesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  retailCategories: InputMaybe<CfCfRetailCategoryNestedFilter>;
  retailCategoriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  showAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  showAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  showAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  stores: InputMaybe<CfCfStoreNestedFilter>;
  storesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  surfaceContentInChannel_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surfaceContentInChannel_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  theEdit_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theEdit_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theEdit_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theEdit_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topics: InputMaybe<CfCfTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption: InputMaybe<Scalars['String']['input']>;
  viewOption_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_exists: InputMaybe<Scalars['Boolean']['input']>;
  viewOption_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewOption_not: InputMaybe<Scalars['String']['input']>;
  viewOption_not_contains: InputMaybe<Scalars['String']['input']>;
  viewOption_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfStoryLinkingCollections = {
  __typename?: 'CFStoryLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  exclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  genderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  manualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  manualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  nationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  nationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
};


export type CfStoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsExclusionsContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsManualContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsManualSolusModuleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsNationalExperiencePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfStoryLinkingCollectionsNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryLinkingCollectionsNationalHomepageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfStoryLinkingCollectionsExclusionsContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfStoryLinkingCollectionsGenderSegmentedManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfStoryLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoryLinkingCollectionsManualContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfStoryLinkingCollectionsManualSolusModuleCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  IntentAsc = 'intent_ASC',
  IntentDesc = 'intent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoryLinkingCollectionsNationalExperiencePageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoryLinkingCollectionsNationalHomepageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfStoryNationalCollection = {
  __typename?: 'CFStoryNationalCollection';
  items: Array<Maybe<CfNationalHomepage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoryNationalCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsAndConditionsVersionAsc = 'termsAndConditionsVersion_ASC',
  TermsAndConditionsVersionDesc = 'termsAndConditionsVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfStoryOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export type CfStoryProfilesCollection = {
  __typename?: 'CFStoryProfilesCollection';
  items: Array<Maybe<CfProfile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoryProfilesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  FullNameAsc = 'fullName_ASC',
  FullNameDesc = 'fullName_DESC',
  ProfileTypeAsc = 'profileType_ASC',
  ProfileTypeDesc = 'profileType_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfStoryRetailCategoriesCollection = {
  __typename?: 'CFStoryRetailCategoriesCollection';
  items: Array<Maybe<CfRetailCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoryRetailCategoriesCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfStoryStoresCollection = {
  __typename?: 'CFStoryStoresCollection';
  featuredStoreForCentre: Maybe<CfStore>;
  items: Array<Maybe<CfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};


export type CfStoryStoresCollectionFeaturedStoreForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};

export enum CfStoryStoresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export type CfStoryTopicsCollection = {
  __typename?: 'CFStoryTopicsCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfStoryTopicsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/supportingImageSet) */
export type CfSupportingImageSet = CfEntry & {
  __typename?: 'CFSupportingImageSet';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  bynderMedia: Maybe<Scalars['CFJSON']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  imagesCollection: Maybe<CfAssetCollection>;
  linkedFrom: Maybe<CfSupportingImageSetLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/supportingImageSet) */
export type CfSupportingImageSetBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/supportingImageSet) */
export type CfSupportingImageSetBynderMediaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/supportingImageSet) */
export type CfSupportingImageSetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/supportingImageSet) */
export type CfSupportingImageSetImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/supportingImageSet) */
export type CfSupportingImageSetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSupportingImageSetCollection = {
  __typename?: 'CFSupportingImageSetCollection';
  items: Array<Maybe<CfSupportingImageSet>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfSupportingImageSetFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSupportingImageSetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSupportingImageSetFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bynderMedia_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfSupportingImageSetLinkingCollections = {
  __typename?: 'CFSupportingImageSetLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  socialCollection: Maybe<CfSocialCollection>;
};


export type CfSupportingImageSetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSupportingImageSetLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSupportingImageSetLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSupportingImageSetLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSupportingImageSetLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSupportingImageSetLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSupportingImageSetLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfSupportingImageSetLinkingCollectionsSocialCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSupportingImageSetLinkingCollectionsSocialCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfSupportingImageSetLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfSupportingImageSetLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfSupportingImageSetLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfSupportingImageSetLinkingCollectionsSocialCollectionOrder {
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfSupportingImageSetOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfSys = {
  __typename?: 'CFSys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt: Maybe<Scalars['CFDateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested - mainly used for Apollo Federation. */
  locale: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['CFDateTime']['output']>;
  publishedVersion: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type CfSysFilter = {
  firstPublishedAt: InputMaybe<Scalars['CFDateTime']['input']>;
  firstPublishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  firstPublishedAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  firstPublishedAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  firstPublishedAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  firstPublishedAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  firstPublishedAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  firstPublishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt: InputMaybe<Scalars['CFDateTime']['input']>;
  publishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt: InputMaybe<Scalars['CFDateTime']['input']>;
  publishedAt_gte: InputMaybe<Scalars['CFDateTime']['input']>;
  publishedAt_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  publishedAt_lt: InputMaybe<Scalars['CFDateTime']['input']>;
  publishedAt_lte: InputMaybe<Scalars['CFDateTime']['input']>;
  publishedAt_not: InputMaybe<Scalars['CFDateTime']['input']>;
  publishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['CFDateTime']['input']>>>;
  publishedVersion: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplate = CfEntry & {
  __typename?: 'CFTemplate';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfTemplateCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfTemplateLinkingCollections>;
  modulesCollection: Maybe<CfTemplateModulesCollection>;
  path: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplateBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplateCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTemplateCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplateLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplateModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTemplateModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplatePathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplateShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/template) */
export type CfTemplateTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfTemplateCentresCollection = {
  __typename?: 'CFTemplateCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfTemplateCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfTemplateCollection = {
  __typename?: 'CFTemplateCollection';
  items: Array<Maybe<CfTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfTemplateFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTemplateFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTemplateFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  modules: InputMaybe<CfCfmodulesMultiTypeNestedFilter>;
  modulesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTemplateLinkingCollections = {
  __typename?: 'CFTemplateLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CfTemplateModulesCollection = {
  __typename?: 'CFTemplateModulesCollection';
  items: Array<Maybe<CfTemplateModulesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfTemplateModulesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTemplateModulesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTemplateModulesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfTemplateModulesItem = CfAutomatedCollection | CfBasicContent | CfCentreReviews | CfContentBlock | CfDynamicContent | CfIntroductions | CfManualCollection | CfProductCollection | CfPromotion | CfSection | CfSocialFeed | CfUtilityPanel;

export enum CfTemplateOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTerms = CfEntry & {
  __typename?: 'CFTerms';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom: Maybe<CfTermsLinkingCollections>;
  slug: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTermsBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTermsBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTermsCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTermsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTermsSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/terms) */
export type CfTermsTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfTermsCollection = {
  __typename?: 'CFTermsCollection';
  items: Array<Maybe<CfTerms>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfTermsFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTermsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTermsFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTermsLinkingCollections = {
  __typename?: 'CFTermsLinkingCollections';
  contentPageCollection: Maybe<CfContentPageCollection>;
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfTermsLinkingCollectionsContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTermsLinkingCollectionsContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTermsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfTermsLinkingCollectionsContentPageCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfTermsOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/timTest) */
export type CfTimTest = CfEntry & {
  __typename?: 'CFTimTest';
  _id: Scalars['ID']['output'];
  abc: Maybe<Scalars['String']['output']>;
  contentfulMetadata: CfContentfulMetadata;
  linkedFrom: Maybe<CfTimTestLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/timTest) */
export type CfTimTestAbcArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/timTest) */
export type CfTimTestLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTimTestCollection = {
  __typename?: 'CFTimTestCollection';
  items: Array<Maybe<CfTimTest>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfTimTestFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTimTestFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTimTestFilter>>>;
  abc: InputMaybe<Scalars['String']['input']>;
  abc_contains: InputMaybe<Scalars['String']['input']>;
  abc_exists: InputMaybe<Scalars['Boolean']['input']>;
  abc_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  abc_not: InputMaybe<Scalars['String']['input']>;
  abc_not_contains: InputMaybe<Scalars['String']['input']>;
  abc_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfTimTestLinkingCollections = {
  __typename?: 'CFTimTestLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfTimTestLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfTimTestOrder {
  AbcAsc = 'abc_ASC',
  AbcDesc = 'abc_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStrip = CfEntry & {
  __typename?: 'CFTopStrip';
  _id: Scalars['ID']['output'];
  actionText: Maybe<Scalars['String']['output']>;
  backendTitle: Maybe<Scalars['String']['output']>;
  backgroundColour: Maybe<Scalars['String']['output']>;
  backgroundImage: Maybe<CfAsset>;
  centresCollection: Maybe<CfTopStripCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  country: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  foregroundImage: Maybe<CfAsset>;
  linkedFrom: Maybe<CfTopStripLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: CfSys;
  url: Maybe<Scalars['String']['output']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripActionTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripBackgroundColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripBackgroundImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopStripCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripCountryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripForegroundImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Add a top strip to pages [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topStrip) */
export type CfTopStripUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfTopStripCentresCollection = {
  __typename?: 'CFTopStripCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfTopStripCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfTopStripCollection = {
  __typename?: 'CFTopStripCollection';
  items: Array<Maybe<CfTopStrip>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfTopStripFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTopStripFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTopStripFilter>>>;
  actionText: InputMaybe<Scalars['String']['input']>;
  actionText_contains: InputMaybe<Scalars['String']['input']>;
  actionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  actionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionText_not: InputMaybe<Scalars['String']['input']>;
  actionText_not_contains: InputMaybe<Scalars['String']['input']>;
  actionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColour: InputMaybe<Scalars['String']['input']>;
  backgroundColour_contains: InputMaybe<Scalars['String']['input']>;
  backgroundColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColour_not: InputMaybe<Scalars['String']['input']>;
  backgroundColour_not_contains: InputMaybe<Scalars['String']['input']>;
  backgroundColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  country_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_exists: InputMaybe<Scalars['Boolean']['input']>;
  foregroundImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTopStripLinkingCollections = {
  __typename?: 'CFTopStripLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfTopStripLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfTopStripOrder {
  ActionTextAsc = 'actionText_ASC',
  ActionTextDesc = 'actionText_DESC',
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BackgroundColourAsc = 'backgroundColour_ASC',
  BackgroundColourDesc = 'backgroundColour_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopic = CfEntry & {
  __typename?: 'CFTopic';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  centresCollection: Maybe<CfTopicCentresCollection>;
  contentfulMetadata: CfContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  linkedFrom: Maybe<CfTopicLinkingCollections>;
  parentTopic: Maybe<CfTopic>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sponsored: Maybe<Scalars['Boolean']['output']>;
  sys: CfSys;
  title: Maybe<Scalars['String']['output']>;
  topicType: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicBodyCopyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicCentresCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicCentresCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicHeroImageSetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicParentTopicArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicSponsoredArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/topic) */
export type CfTopicTopicTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type CfTopicCentresCollection = {
  __typename?: 'CFTopicCentresCollection';
  items: Array<Maybe<CfCentre>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfTopicCentresCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BusinessUnitCodeAsc = 'businessUnitCode_ASC',
  BusinessUnitCodeDesc = 'businessUnitCode_DESC',
  CarParkTypeAsc = 'carParkType_ASC',
  CarParkTypeDesc = 'carParkType_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  GooglePlacesIdAsc = 'googlePlacesId_ASC',
  GooglePlacesIdDesc = 'googlePlacesId_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  JibestreamVenueIdAsc = 'jibestreamVenueId_ASC',
  JibestreamVenueIdDesc = 'jibestreamVenueId_DESC',
  LatitudeAsc = 'latitude_ASC',
  LatitudeDesc = 'latitude_DESC',
  LongitudeAsc = 'longitude_ASC',
  LongitudeDesc = 'longitude_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PostcodeAsc = 'postcode_ASC',
  PostcodeDesc = 'postcode_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  SuburbAsc = 'suburb_ASC',
  SuburbDesc = 'suburb_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  ThemeColourAsc = 'themeColour_ASC',
  ThemeColourDesc = 'themeColour_DESC',
  TimeZoneAsc = 'timeZone_ASC',
  TimeZoneDesc = 'timeZone_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC'
}

export type CfTopicCollection = {
  __typename?: 'CFTopicCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfTopicFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTopicFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTopicFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy: InputMaybe<Scalars['String']['input']>;
  bodyCopy_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_not: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyCopy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centres: InputMaybe<CfCfCentreNestedFilter>;
  centresCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageSet: InputMaybe<CfCfHeroImageSetNestedFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  parentTopic: InputMaybe<CfCfTopicNestedFilter>;
  parentTopic_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sponsored: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_exists: InputMaybe<Scalars['Boolean']['input']>;
  sponsored_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicType_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfTopicLinkingCollections = {
  __typename?: 'CFTopicLinkingCollections';
  automatedCollectionCollection: Maybe<CfAutomatedCollectionCollection>;
  automatedContentSourceCollection: Maybe<CfAutomatedContentSourceCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  eventCollection: Maybe<CfEventCollection>;
  featuredCommerceCollection: Maybe<CfFeaturedCommerceCollection>;
  introductionsCollection: Maybe<CfIntroductionsCollection>;
  manualCollectionCollection: Maybe<CfManualCollectionCollection>;
  newsCollection: Maybe<CfNewsCollection>;
  offerCollection: Maybe<CfOfferCollection>;
  retailerCollection: Maybe<CfRetailerCollection>;
  storeCollection: Maybe<CfStoreCollection>;
  storyCollection: Maybe<CfStoryCollection>;
  topicCollection: Maybe<CfTopicCollection>;
  whatsHappeningFiltersCollection: Maybe<CfWhatsHappeningFiltersCollection>;
};


export type CfTopicLinkingCollectionsAutomatedCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsAutomatedCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsAutomatedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsAutomatedContentSourceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsEventCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsFeaturedCommerceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsFeaturedCommerceCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsIntroductionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsIntroductionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsManualCollectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsNewsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsOfferCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsRetailerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsStoreCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsStoryCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsTopicCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsTopicCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfTopicLinkingCollectionsWhatsHappeningFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicLinkingCollectionsWhatsHappeningFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfTopicLinkingCollectionsAutomatedCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  ContentLimitAsc = 'contentLimit_ASC',
  ContentLimitDesc = 'contentLimit_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfTopicLinkingCollectionsAutomatedContentSourceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountAsc = 'count_ASC',
  CountDesc = 'count_DESC',
  PrioritiseItemsRelevantTodayAsc = 'prioritiseItemsRelevantToday_ASC',
  PrioritiseItemsRelevantTodayDesc = 'prioritiseItemsRelevantToday_DESC',
  RotateContentTypesAsc = 'rotateContentTypes_ASC',
  RotateContentTypesDesc = 'rotateContentTypes_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TopicsSortOrFilterAsc = 'topicsSortOrFilter_ASC',
  TopicsSortOrFilterDesc = 'topicsSortOrFilter_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export enum CfTopicLinkingCollectionsEventCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  BookingDescriptionAsc = 'bookingDescription_ASC',
  BookingDescriptionDesc = 'bookingDescription_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HostedAsc = 'hosted_ASC',
  HostedDesc = 'hosted_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfTopicLinkingCollectionsFeaturedCommerceCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ExternalLinkAsc = 'externalLink_ASC',
  ExternalLinkDesc = 'externalLink_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfTopicLinkingCollectionsIntroductionsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfTopicLinkingCollectionsManualCollectionCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionAddressAsc = 'callToActionAddress_ASC',
  CallToActionAddressDesc = 'callToActionAddress_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  DisplayModeV2Asc = 'displayModeV2_ASC',
  DisplayModeV2Desc = 'displayModeV2_DESC',
  DisplayModeAsc = 'displayMode_ASC',
  DisplayModeDesc = 'displayMode_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfTopicLinkingCollectionsNewsCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfTopicLinkingCollectionsOfferCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CloOfferIdAsc = 'cloOfferId_ASC',
  CloOfferIdDesc = 'cloOfferId_DESC',
  CtaTypeAsc = 'ctaType_ASC',
  CtaTypeDesc = 'ctaType_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  EndAtAsc = 'endAt_ASC',
  EndAtDesc = 'endAt_DESC',
  FaqAsc = 'faq_ASC',
  FaqDesc = 'faq_DESC',
  HasModeratedImagesAsc = 'hasModeratedImages_ASC',
  HasModeratedImagesDesc = 'hasModeratedImages_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  InCentrePresenceCheckAsc = 'inCentrePresenceCheck_ASC',
  InCentrePresenceCheckDesc = 'inCentrePresenceCheck_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  MemberExclusiveAsc = 'memberExclusive_ASC',
  MemberExclusiveDesc = 'memberExclusive_DESC',
  PopupLocationAsc = 'popupLocation_ASC',
  PopupLocationDesc = 'popupLocation_DESC',
  PromoQrCodeAsc = 'promoQrCode_ASC',
  PromoQrCodeDesc = 'promoQrCode_DESC',
  PromoSuccessBodyAsc = 'promoSuccessBody_ASC',
  PromoSuccessBodyDesc = 'promoSuccessBody_DESC',
  PromoSuccessTitleAsc = 'promoSuccessTitle_ASC',
  PromoSuccessTitleDesc = 'promoSuccessTitle_DESC',
  PromotionTypeAsc = 'promotionType_ASC',
  PromotionTypeDesc = 'promotionType_DESC',
  RequiresQrCodeScanAsc = 'requiresQRCodeScan_ASC',
  RequiresQrCodeScanDesc = 'requiresQRCodeScan_DESC',
  ReviewStatusAsc = 'reviewStatus_ASC',
  ReviewStatusDesc = 'reviewStatus_DESC',
  SendSuccessEmailAsc = 'sendSuccessEmail_ASC',
  SendSuccessEmailDesc = 'sendSuccessEmail_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  StartAtAsc = 'startAt_ASC',
  StartAtDesc = 'startAt_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfTopicLinkingCollectionsRetailerCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  MarketplaceShopIdAsc = 'marketplaceShopId_ASC',
  MarketplaceShopIdDesc = 'marketplaceShopId_DESC',
  MarketplaceShopSlugAsc = 'marketplaceShopSlug_ASC',
  MarketplaceShopSlugDesc = 'marketplaceShopSlug_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  SettingsAsc = 'settings_ASC',
  SettingsDesc = 'settings_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfTopicLinkingCollectionsStoreCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  EmailAddressAsc = 'emailAddress_ASC',
  EmailAddressDesc = 'emailAddress_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  HideReviewsAsc = 'hideReviews_ASC',
  HideReviewsDesc = 'hideReviews_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LandmarkDescriptionAsc = 'landmarkDescription_ASC',
  LandmarkDescriptionDesc = 'landmarkDescription_DESC',
  LegacyIdentifierAsc = 'legacyIdentifier_ASC',
  LegacyIdentifierDesc = 'legacyIdentifier_DESC',
  LevelAsc = 'level_ASC',
  LevelDesc = 'level_DESC',
  OpenAtAsc = 'openAt_ASC',
  OpenAtDesc = 'openAt_DESC',
  ParkingInstructionsAsc = 'parkingInstructions_ASC',
  ParkingInstructionsDesc = 'parkingInstructions_DESC',
  PhysicalAddressAsc = 'physicalAddress_ASC',
  PhysicalAddressDesc = 'physicalAddress_DESC',
  PriceDescriptionAsc = 'priceDescription_ASC',
  PriceDescriptionDesc = 'priceDescription_DESC',
  ReputationCodeAsc = 'reputationCode_ASC',
  ReputationCodeDesc = 'reputationCode_DESC',
  ShopNumberAsc = 'shopNumber_ASC',
  ShopNumberDesc = 'shopNumber_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SpecialStatusAsc = 'specialStatus_ASC',
  SpecialStatusDesc = 'specialStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  StoreTypeAsc = 'storeType_ASC',
  StoreTypeDesc = 'storeType_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TelephoneNumberAsc = 'telephoneNumber_ASC',
  TelephoneNumberDesc = 'telephoneNumber_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  WaypointAsc = 'waypoint_ASC',
  WaypointDesc = 'waypoint_DESC',
  WebsiteAddressAsc = 'websiteAddress_ASC',
  WebsiteAddressDesc = 'websiteAddress_DESC'
}

export enum CfTopicLinkingCollectionsStoryCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  CallToActionLabelAsc = 'callToActionLabel_ASC',
  CallToActionLabelDesc = 'callToActionLabel_DESC',
  EdmSubheadingAsc = 'edmSubheading_ASC',
  EdmSubheadingDesc = 'edmSubheading_DESC',
  EdmSubjectAsc = 'edmSubject_ASC',
  EdmSubjectDesc = 'edmSubject_DESC',
  EdmTitleAsc = 'edmTitle_ASC',
  EdmTitleDesc = 'edmTitle_DESC',
  HideAtAsc = 'hideAt_ASC',
  HideAtDesc = 'hideAt_DESC',
  IsSensitiveContentAsc = 'isSensitiveContent_ASC',
  IsSensitiveContentDesc = 'isSensitiveContent_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  ShowAtAsc = 'showAt_ASC',
  ShowAtDesc = 'showAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  ViewOptionAsc = 'viewOption_ASC',
  ViewOptionDesc = 'viewOption_DESC'
}

export enum CfTopicLinkingCollectionsTopicCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfTopicLinkingCollectionsWhatsHappeningFiltersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfTopicOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/utilityPanel) */
export type CfUtilityPanel = CfEntry & {
  __typename?: 'CFUtilityPanel';
  _id: Scalars['ID']['output'];
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  backendTitle: Maybe<Scalars['String']['output']>;
  contentEntriesCollection: Maybe<CfUtilityPanelContentEntriesCollection>;
  contentfulMetadata: CfContentfulMetadata;
  heading: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<CfUtilityPanelLinkingCollections>;
  sys: CfSys;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/utilityPanel) */
export type CfUtilityPanelBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/utilityPanel) */
export type CfUtilityPanelContentEntriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfUtilityPanelContentEntriesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/utilityPanel) */
export type CfUtilityPanelHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/utilityPanel) */
export type CfUtilityPanelLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfUtilityPanelCollection = {
  __typename?: 'CFUtilityPanelCollection';
  items: Array<Maybe<CfUtilityPanel>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfUtilityPanelContentEntriesCollection = {
  __typename?: 'CFUtilityPanelContentEntriesCollection';
  items: Array<Maybe<CfUtilityPanelContentEntriesItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfUtilityPanelContentEntriesFilter = {
  AND: InputMaybe<Array<InputMaybe<CfUtilityPanelContentEntriesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfUtilityPanelContentEntriesFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heroImageSet_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfUtilityPanelContentEntriesItem = CfFeaturedLink | CfRetailCategory;

export type CfUtilityPanelFilter = {
  AND: InputMaybe<Array<InputMaybe<CfUtilityPanelFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfUtilityPanelFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentEntries: InputMaybe<CfCfcontentEntriesMultiTypeNestedFilter>;
  contentEntriesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<CfSysFilter>;
};

export type CfUtilityPanelLinkingCollections = {
  __typename?: 'CFUtilityPanelLinkingCollections';
  comparisonItemCollection: Maybe<CfComparisonItemCollection>;
  entryCollection: Maybe<CfEntryCollection>;
  templateCollection: Maybe<CfTemplateCollection>;
};


export type CfUtilityPanelLinkingCollectionsComparisonItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfUtilityPanelLinkingCollectionsComparisonItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfUtilityPanelLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CfUtilityPanelLinkingCollectionsTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfUtilityPanelLinkingCollectionsTemplateCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfUtilityPanelLinkingCollectionsComparisonItemCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ProductNameAsc = 'productName_ASC',
  ProductNameDesc = 'productName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CfUtilityPanelLinkingCollectionsTemplateCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CfUtilityPanelOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Customize the contents of the What's Happening Page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/whatsHappeningFilters) */
export type CfWhatsHappeningFilters = CfEntry & {
  __typename?: 'CFWhatsHappeningFilters';
  _id: Scalars['ID']['output'];
  backendTitle: Maybe<Scalars['String']['output']>;
  centre: Maybe<CfCentre>;
  contentfulMetadata: CfContentfulMetadata;
  experienceFiltersCollection: Maybe<CfWhatsHappeningFiltersExperienceFiltersCollection>;
  linkedFrom: Maybe<CfWhatsHappeningFiltersLinkingCollections>;
  sys: CfSys;
  topicFiltersCollection: Maybe<CfWhatsHappeningFiltersTopicFiltersCollection>;
};


/** Customize the contents of the What's Happening Page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/whatsHappeningFilters) */
export type CfWhatsHappeningFiltersBackendTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


/** Customize the contents of the What's Happening Page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/whatsHappeningFilters) */
export type CfWhatsHappeningFiltersCentreArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


/** Customize the contents of the What's Happening Page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/whatsHappeningFilters) */
export type CfWhatsHappeningFiltersExperienceFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfWhatsHappeningFiltersExperienceFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


/** Customize the contents of the What's Happening Page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/whatsHappeningFilters) */
export type CfWhatsHappeningFiltersLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Customize the contents of the What's Happening Page [See type definition](https://app.contentful.com/spaces/zzgnkgna3r3g/content_types/whatsHappeningFilters) */
export type CfWhatsHappeningFiltersTopicFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfWhatsHappeningFiltersTopicFiltersCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};

export type CfWhatsHappeningFiltersCollection = {
  __typename?: 'CFWhatsHappeningFiltersCollection';
  items: Array<Maybe<CfWhatsHappeningFilters>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CfWhatsHappeningFiltersExperienceFiltersCollection = {
  __typename?: 'CFWhatsHappeningFiltersExperienceFiltersCollection';
  items: Array<Maybe<CfExperience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfWhatsHappeningFiltersExperienceFiltersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CfWhatsHappeningFiltersFilter = {
  AND: InputMaybe<Array<InputMaybe<CfWhatsHappeningFiltersFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfWhatsHappeningFiltersFilter>>>;
  backendTitle: InputMaybe<Scalars['String']['input']>;
  backendTitle_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  backendTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backendTitle_not: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  backendTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  centre: InputMaybe<CfCfCentreNestedFilter>;
  centre_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<CfContentfulMetadataFilter>;
  experienceFilters: InputMaybe<CfCfExperienceNestedFilter>;
  experienceFiltersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<CfSysFilter>;
  topicFilters: InputMaybe<CfCfTopicNestedFilter>;
  topicFiltersCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfWhatsHappeningFiltersLinkingCollections = {
  __typename?: 'CFWhatsHappeningFiltersLinkingCollections';
  entryCollection: Maybe<CfEntryCollection>;
};


export type CfWhatsHappeningFiltersLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum CfWhatsHappeningFiltersOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type CfWhatsHappeningFiltersTopicFiltersCollection = {
  __typename?: 'CFWhatsHappeningFiltersTopicFiltersCollection';
  items: Array<Maybe<CfTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CfWhatsHappeningFiltersTopicFiltersCollectionOrder {
  BackendTitleAsc = 'backendTitle_ASC',
  BackendTitleDesc = 'backendTitle_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SponsoredAsc = 'sponsored_ASC',
  SponsoredDesc = 'sponsored_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CardSubstitutionInCentreRequestInput = {
  azureToken: Scalars['String']['input'];
  cancellationReason: DigitalGiftCardCancellationReason;
  cancellationReasonNote: InputMaybe<Scalars['String']['input']>;
  cardPanNumber: Scalars['String']['input'];
  centreCode: Scalars['String']['input'];
  gcmsPassword: Scalars['String']['input'];
  gcmsUsername: Scalars['String']['input'];
  referenceNumber: Scalars['String']['input'];
};

export type CardSubstitutionRequestAddressInput = {
  city: Scalars['String']['input'];
  company: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  postCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};

export type CardSubstitutionRequestInput = {
  azureToken: Scalars['String']['input'];
  cancellationReason: DigitalGiftCardCancellationReason;
  cancellationReasonNote: InputMaybe<Scalars['String']['input']>;
  centreCode: Scalars['String']['input'];
  deliveryAddress: CardSubstitutionRequestAddressInput;
  referenceNumber: Scalars['String']['input'];
};

export type CardSubstitutionResponse = {
  __typename?: 'CardSubstitutionResponse';
  activationCommsInfo: Scalars['String']['output'];
  emailAddress: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  purchaseId: Scalars['Int']['output'];
  referenceNumber: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  statusName: Scalars['String']['output'];
  streetAddress: Maybe<Scalars['String']['output']>;
  suburb: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type CardSubstitutionResponseOrError = CardSubstitutionResponse | Error;

export type Cart = {
  __typename?: 'Cart';
  baseAmount: Scalars['Float']['output'];
  cartAmount: Scalars['Float']['output'];
  coupons: Array<MarketplaceCouponV2>;
  currency: CurrencyCode;
  /** The cart id */
  id: Scalars['UUID']['output'];
  /** The items in the cart */
  items: Array<CartItem>;
  /** The promotions of the whole cart */
  promotionalDiscount: Maybe<Scalars['Float']['output']>;
  shippingCost: Scalars['Float']['output'];
};

export type CartItem = {
  category: Maybe<Scalars['String']['output']>;
  /** The id of the cart item in the commerce platform. */
  id: Scalars['ID']['output'];
  image: Maybe<ProductImage>;
  name: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  salesPrice: Maybe<Scalars['Float']['output']>;
  /** The SKU of the cart item in the commerce platform. */
  sku: Scalars['String']['output'];
};

/** Filter criteria for an Order search. */
export type CartItemFilter = {
  AND: InputMaybe<Array<CartItemFilter>>;
  OR: InputMaybe<Array<CartItemFilter>>;
  category: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  productId: InputMaybe<Scalars['Int']['input']>;
  salesPrice: InputMaybe<Scalars['Float']['input']>;
  sku: InputMaybe<Scalars['String']['input']>;
};

export type CartItemOption = {
  __typename?: 'CartItemOption';
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** The return type from `GetCartItem`. */
export type CartItemOrError = Error | GenericCartItem | GiftCardCartItem | MarketplaceCartItem;

/** The return type from `addProductToCart`. */
export type CartOrError = Cart | Error | InvalidInputError;

export type CashbackTransaction = {
  __typename?: 'CashbackTransaction';
  cashbackProvider: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type Centre = {
  __typename?: 'Centre';
  businessUnitCode: Maybe<Scalars['String']['output']>;
  centreName: Maybe<Scalars['String']['output']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  billingAddress: Maybe<Address>;
  cart: Maybe<CartOrError>;
  payment: Maybe<PaymentIntent>;
  total: Maybe<Scalars['Float']['output']>;
};

export type CheckoutOrder = {
  __typename?: 'CheckoutOrder';
  id: Scalars['ID']['output'];
};

/** The result of failing to claim a partner coupon code. */
export type ClaimPartnerCouponCodeFailure = {
  __typename?: 'ClaimPartnerCouponCodeFailure';
  message: Scalars['String']['output'];
  reason: ClaimPartnerCouponCodeFailureReason;
};

/** The reasons for failing to claim a partner coupon code. */
export enum ClaimPartnerCouponCodeFailureReason {
  Unknown = 'UNKNOWN'
}

/** Input object for claiming a partner coupon code. */
export type ClaimPartnerCouponCodeInput = {
  /** The relevant centre. */
  centreSlug: InputMaybe<Scalars['String']['input']>;
  /** Idempotency key to track unique requests. */
  idempotencyKey: InputMaybe<Scalars['String']['input']>;
  /** The ID of the offer. */
  offerId: Scalars['String']['input'];
};

/** The result of claiming a partner coupon code. */
export type ClaimPartnerCouponCodeResult = ClaimPartnerCouponCodeFailure | ClaimPartnerCouponCodeSuccess;

/** The result of successfully claiming a partner coupon code. */
export type ClaimPartnerCouponCodeSuccess = {
  __typename?: 'ClaimPartnerCouponCodeSuccess';
  coupon: Scalars['String']['output'];
};

export type ClaimPasswordResetTokenInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Object passed to the claimPromotionReward mutation. */
export type ClaimPromotionRewardInput = {
  /** Deprecated, being removed in future releases */
  bypassMemberLimit: InputMaybe<Scalars['Boolean']['input']>;
  /** The centre specified in the claim link. */
  centreSlug: InputMaybe<Scalars['String']['input']>;
  /** Check code to verify the validity of the claim link. */
  check: InputMaybe<Scalars['String']['input']>;
  /** Idempotency key to track unique requests. */
  idempotencyKey: InputMaybe<Scalars['String']['input']>;
  /** The ID of the offer in content service. */
  offerId: Scalars['String']['input'];
  /** How long the claim link is valid for in seconds. */
  validFor: Scalars['Int']['input'];
  /** When the claim link is valid from (unix time). */
  validFrom: Scalars['Int']['input'];
};

/** Object returned from the claimPromotionReward mutation. */
export type ClaimPromotionRewardOutput = {
  __typename?: 'ClaimPromotionRewardOutput';
  code: Scalars['Int']['output'];
  /** @deprecated removing in future release, please don't use */
  memberLimitBypassed: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  result: Maybe<ClaimPromotionRewardResult>;
};

/** A result from claiming a reward. */
export type ClaimPromotionRewardResult = {
  __typename?: 'ClaimPromotionRewardResult';
  content: ClaimPromotionRewardResultContent;
  coupon: Maybe<PromotionRewardCoupon>;
};

/** Result content which appears after claiming a reward. */
export type ClaimPromotionRewardResultContent = {
  __typename?: 'ClaimPromotionRewardResultContent';
  headline: Maybe<Scalars['String']['output']>;
  instruction: Maybe<Scalars['String']['output']>;
  moment: Maybe<Scalars['String']['output']>;
  type: ClaimPromotionRewardResultContentType;
};

/** The types of result contents which appear after claiming a reward. */
export enum ClaimPromotionRewardResultContentType {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type Classification = {
  __typename?: 'Classification';
  detail: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['String']['output']>;
};

/** Activated offer object return from CLO vendor */
export type CloActivatedOffer = {
  __typename?: 'CloActivatedOffer';
  id: Maybe<Scalars['String']['output']>;
};

/** Return type for activated offer list */
export type CloActivatedOffersResponse = CloResponse & {
  __typename?: 'CloActivatedOffersResponse';
  code: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  offers: Maybe<Array<Maybe<CloActivatedOffer>>>;
  successful: Maybe<Scalars['Boolean']['output']>;
};

/** Return type for the access token required to register a new card in CLO */
export type CloAddCardTokenResponse = CloResponse & {
  __typename?: 'CloAddCardTokenResponse';
  cardRegistrationUrl: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  programCode: Maybe<Scalars['String']['output']>;
  successful: Maybe<Scalars['Boolean']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type CloIsOfferActivatedResponse = CloResponse & {
  __typename?: 'CloIsOfferActivatedResponse';
  activated: Maybe<Scalars['Boolean']['output']>;
  code: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  successful: Maybe<Scalars['Boolean']['output']>;
};

/** Card Object returned from CLO vendor */
export type CloLinkedCard = {
  __typename?: 'CloLinkedCard';
  cardHolderName: Maybe<Scalars['String']['output']>;
  cardNumber: Maybe<Scalars['String']['output']>;
  expired: Maybe<Scalars['Boolean']['output']>;
  expiry: Maybe<Scalars['String']['output']>;
  expiryInDays: Maybe<Scalars['Int']['output']>;
  isPrimary: Maybe<Scalars['Boolean']['output']>;
  scheme: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type CloLinkedCardsResponse = CloResponse & {
  __typename?: 'CloLinkedCardsResponse';
  cards: Maybe<Array<Maybe<CloLinkedCard>>>;
  code: Maybe<Scalars['Int']['output']>;
  maxCardsAllowed: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  successful: Maybe<Scalars['Boolean']['output']>;
};

/** Base type for all CLO responses */
export type CloResponse = {
  code: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  successful: Maybe<Scalars['Boolean']['output']>;
};

/** A result of performing an update in CLO */
export type CloUpdateResponse = CloResponse & {
  __typename?: 'CloUpdateResponse';
  code: Maybe<Scalars['Int']['output']>;
  linkedCards: Maybe<CloLinkedCardsResponse>;
  message: Maybe<Scalars['String']['output']>;
  successful: Maybe<Scalars['Boolean']['output']>;
};

/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdmin = {
  __typename?: 'CommerceAdmin';
  bulkOrder: Maybe<BulkCartResponse>;
  centres: Array<Maybe<Centre>>;
  completedTransfersExport: Maybe<Array<TransfersExportResponse>>;
  deliveryServices: Maybe<CommerceAdminShipmentDeliveryServicesResponse>;
  dgcManualTransferAggregation: ManualTransferAggregationResponse;
  digitalGiftCard: CommerceAdminDigitalGiftCard;
  digitalGiftCardByReferenceNumber: Maybe<CommerceAdminDigitalGiftCard>;
  /** Get a manifest's files from Starshippit */
  getManifestFiles: Array<CommerceAdminManifestFile>;
  /** Get list of manifestable carriers from Starshippit */
  getManifestableCarriers: Maybe<CommerceAdminManifestableCarriersResponse>;
  listCompletedManualTransfers: Maybe<Array<ManualTransferAggregationResponse>>;
  marketplaceLogisticOrders: Maybe<Array<LogisticOrder>>;
  /** Loads a single order by the vendor's order ID */
  order: CommerceAdminOrder;
  orderEmailOptions: Maybe<Array<CommerceAdminEmailOption>>;
  pendingTransfersExport: Maybe<Array<TransfersExportResponse>>;
  searchBulkOrders: CommerceAdminBulkOrderSearch;
  /** Retrieve a paged collection of order items using filter & sort criteria. */
  searchDigitalGiftCards: CommerceAdminDigitalGiftCardSearch;
  /** Search for manifests from Starshippit by dispatch centre - each centre has their own account so you cannot search for manifests from multiple centres at once */
  searchManifests: Maybe<CommerceAdminManifestsResponse>;
  /** Retrieve a paged collection of westfield direct order items using filter & sort criteria. */
  searchWestfieldDirectOrders: CommerceAdminWestfieldDirectSearch;
  westFieldDirectOrder: CommerceAdminOrder;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminBulkOrderArgs = {
  cartReference: InputMaybe<Scalars['String']['input']>;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminCompletedTransfersExportArgs = {
  input: CompletedManualTransferExportInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminDeliveryServicesArgs = {
  shipment: CommerceAdminShipmentDeliveryServicesInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminDgcManualTransferAggregationArgs = {
  input: ManualTransferInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminDigitalGiftCardArgs = {
  id: Scalars['ID']['input'];
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminDigitalGiftCardByReferenceNumberArgs = {
  referenceNumber: Scalars['ID']['input'];
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminGetManifestFilesArgs = {
  dispatchCentre: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminGetManifestableCarriersArgs = {
  dispatchCentre: Scalars['String']['input'];
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminListCompletedManualTransfersArgs = {
  input: ManualTransferTypeInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminMarketplaceLogisticOrdersArgs = {
  input: LogisticOrderSearchInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminOrderArgs = {
  vendorOrderId: Scalars['Int']['input'];
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminOrderEmailOptionsArgs = {
  referenceNumber: Scalars['ID']['input'];
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminPendingTransfersExportArgs = {
  input: ManualTransferTypeInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminSearchBulkOrdersArgs = {
  input: CommerceAdminBulkOrderSearchInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminSearchDigitalGiftCardsArgs = {
  input: CommerceAdminDigitalGiftCardSearchInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminSearchManifestsArgs = {
  input: CommerceAdminSearchManifestsInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminSearchWestfieldDirectOrdersArgs = {
  input: CommerceAdminWestfieldDirectSearchInput;
};


/**
 * This type is the entry point for all administrative API operations.
 * Only authenticated ScentreGroup staff can access fields on this type.
 */
export type CommerceAdminWestFieldDirectOrderArgs = {
  id: Scalars['ID']['input'];
};

export type CommerceAdminAddressDetails = {
  __typename?: 'CommerceAdminAddressDetails';
  city: Maybe<Scalars['String']['output']>;
  company: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
};

/**
 * CommerceAdminAddressDetailsInput - comes from IOrder['shippingDetails']
 * See also: gql CommerceAdminAddressDetails
 */
export type CommerceAdminAddressDetailsInput = {
  city: InputMaybe<Scalars['String']['input']>;
  company: InputMaybe<Scalars['String']['input']>;
  country: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  phone: InputMaybe<Scalars['String']['input']>;
  postCode: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  street1: InputMaybe<Scalars['String']['input']>;
  street2: InputMaybe<Scalars['String']['input']>;
};

export type CommerceAdminBulkOrderFilter = {
  buyerEmail: InputMaybe<StringFilter>;
  buyerName: InputMaybe<StringFilter>;
  cartReference: InputMaybe<StringFilter>;
  clearedBy: InputMaybe<StringFilter>;
  orderReference: InputMaybe<StringFilter>;
  reviewStatus: InputMaybe<BulkOrderReviewStatusFilter>;
  reviewedBy: InputMaybe<StringFilter>;
  submittedBy: InputMaybe<StringFilter>;
};

export type CommerceAdminBulkOrderSearch = {
  __typename?: 'CommerceAdminBulkOrderSearch';
  /** The result returned by the Item search */
  results: Array<CommerceAdminBulkOrderSearchResult>;
  /** Zero-indexed offset in the collection from which results are fetched */
  skip: Scalars['Int']['output'];
  /** The total number of results returned from the collection */
  total: Scalars['Int']['output'];
};

export type CommerceAdminBulkOrderSearchInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sort: InputMaybe<Array<CommerceAdminBulkOrderSorting>>;
  where: InputMaybe<CommerceAdminBulkOrderFilter>;
};

export type CommerceAdminBulkOrderSearchResult = {
  __typename?: 'CommerceAdminBulkOrderSearchResult';
  buyerEmail: Maybe<Scalars['String']['output']>;
  buyerName: Maybe<Scalars['String']['output']>;
  cardSku: Maybe<Scalars['String']['output']>;
  cartReference: Maybe<Scalars['String']['output']>;
  clearedAt: Maybe<Scalars['Date']['output']>;
  clearedBy: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  numberOfCards: Maybe<Scalars['Int']['output']>;
  orderReference: Maybe<Scalars['String']['output']>;
  reviewStatus: Maybe<BulkOrderReviewStatus>;
  reviewedAt: Maybe<Scalars['Date']['output']>;
  reviewedBy: Maybe<Scalars['String']['output']>;
  serviceFeeSku: Maybe<Scalars['String']['output']>;
  submittedBy: Maybe<Scalars['String']['output']>;
  totalCardValue: Maybe<Scalars['Float']['output']>;
};

export enum CommerceAdminBulkOrderSortByField {
  BuyerEmail = 'buyerEmail',
  BuyerName = 'buyerName',
  CardSku = 'cardSku',
  CartReference = 'cartReference',
  ClearedAt = 'clearedAt',
  ClearedBy = 'clearedBy',
  CreatedAt = 'createdAt',
  NumberOfCards = 'numberOfCards',
  OrderReference = 'orderReference',
  ReviewStatus = 'reviewStatus',
  ReviewedAt = 'reviewedAt',
  ReviewedBy = 'reviewedBy',
  ServiceFeeSku = 'serviceFeeSku',
  SubmittedBy = 'submittedBy',
  TotalCardValue = 'totalCardValue'
}

export type CommerceAdminBulkOrderSorting = {
  direction: InputMaybe<SortDirection>;
  field: CommerceAdminBulkOrderSortByField;
};

export type CommerceAdminCreateShipmentInput = {
  carrier: Scalars['String']['input'];
  carrierOptions: Array<CommerceAdminShipmentCarrierOptionInput>;
  carrierServiceCode: Scalars['String']['input'];
  declaredValue: InputMaybe<Scalars['Float']['input']>;
  dispatchCentre: Scalars['String']['input'];
  insuranceValue: InputMaybe<Scalars['Float']['input']>;
  order: CommerceAdminShipmentOrderInput;
  packages: Array<CommerceAdminShipmentPackageInput>;
};

export type CommerceAdminCreateShipmentResponse = {
  __typename?: 'CommerceAdminCreateShipmentResponse';
  carrier: Maybe<Scalars['String']['output']>;
  carrierServiceCode: Maybe<Scalars['String']['output']>;
  dangerousGoods: Maybe<Scalars['Boolean']['output']>;
  declaredValue: Maybe<Scalars['Float']['output']>;
  dispatchCentre: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  order: Maybe<CommerceAdminShipmentOrderResponse>;
  packages: Maybe<CommerceAdminShipmentPackageResponse>;
  shipmentReference: Maybe<Scalars['String']['output']>;
  signatureRequired: Maybe<Scalars['Boolean']['output']>;
};

export type CommerceAdminDigitalGiftCard = {
  __typename?: 'CommerceAdminDigitalGiftCard';
  balance: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Maybe<Customer>;
  deliveryDate: Scalars['Date']['output'];
  displayStatus: Scalars['String']['output'];
  expirationDate: Maybe<Scalars['Date']['output']>;
  externalAccountId: Maybe<Scalars['Int']['output']>;
  externalEntityId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  indueStatus: Maybe<Scalars['String']['output']>;
  item: CommerceAdminDigitalGiftCardItem;
  itemId: Scalars['ID']['output'];
  linkCode: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  notifySender: Maybe<Scalars['Boolean']['output']>;
  pan: Maybe<Scalars['String']['output']>;
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  referenceNumber: Maybe<Scalars['ID']['output']>;
  scentregroupId: Maybe<Scalars['String']['output']>;
  senderEmail: Maybe<Scalars['String']['output']>;
  senderName: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  transactions: Array<CommerceAdminDigitalGiftCardTransaction>;
  updatedAt: Scalars['Date']['output'];
  value: Scalars['Float']['output'];
};

export type CommerceAdminDigitalGiftCardContactDetailInput = {
  email: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
};

export type CommerceAdminDigitalGiftCardFilter = {
  buyerEmail: InputMaybe<StringFilter>;
  buyerName: InputMaybe<StringFilter>;
  orderReference: InputMaybe<StringFilter>;
  orderType: InputMaybe<OrderTypeFilter>;
  recipientEmail: InputMaybe<StringFilter>;
  recipientName: InputMaybe<StringFilter>;
  referenceNumber: InputMaybe<StringFilter>;
  vendorOrderId: InputMaybe<IntFilter>;
  westfieldPlusEmail: InputMaybe<EqStringFilter>;
};

export type CommerceAdminDigitalGiftCardItem = {
  __typename?: 'CommerceAdminDigitalGiftCardItem';
  digitalGiftCards: Array<CommerceAdminDigitalGiftCard>;
  id: Scalars['ID']['output'];
  order: CommerceAdminOrder;
};

export type CommerceAdminDigitalGiftCardSearch = {
  __typename?: 'CommerceAdminDigitalGiftCardSearch';
  /** The result returned by the Item search */
  results: Array<CommerceAdminDigitalGiftCardSearchResult>;
  /** Zero-indexed offset in the collection from which results are fetched */
  skip: Scalars['Int']['output'];
  /** The total number of results returned from the collection */
  total: Scalars['Int']['output'];
};

/** This input type holds paging, filtering and ordering criteria for an Order search. */
export type CommerceAdminDigitalGiftCardSearchInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sort: InputMaybe<Array<CommerceAdminDigitialGiftCardSorting>>;
  where: InputMaybe<CommerceAdminDigitalGiftCardFilter>;
};

export type CommerceAdminDigitalGiftCardSearchResult = {
  __typename?: 'CommerceAdminDigitalGiftCardSearchResult';
  buyerEmail: Scalars['String']['output'];
  buyerName: Scalars['String']['output'];
  digitalGiftCardId: Maybe<Scalars['ID']['output']>;
  endOfDayBalance: Maybe<Scalars['Float']['output']>;
  orderReference: Scalars['ID']['output'];
  orderType: Scalars['String']['output'];
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  referenceNumber: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
  vendorOrderId: Maybe<Scalars['Int']['output']>;
};

/** Sort order criter for an Order search. */
export enum CommerceAdminDigitalGiftCardSortByField {
  BuyerEmail = 'buyerEmail',
  BuyerName = 'buyerName',
  CreatedAt = 'createdAt',
  FulfilmentLocation = 'fulfilmentLocation',
  OrderReference = 'orderReference',
  RecipientEmail = 'recipientEmail',
  RecipientName = 'recipientName',
  ReferenceNumber = 'referenceNumber',
  Status = 'status',
  VendorOrderId = 'vendorOrderId',
  WaitingOn = 'waitingOn'
}

export type CommerceAdminDigitalGiftCardTransaction = {
  __typename?: 'CommerceAdminDigitalGiftCardTransaction';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  digitalGiftCard: CommerceAdminDigitalGiftCard;
  digitalGiftCardId: Scalars['ID']['output'];
  runningBalance: Scalars['Float']['output'];
};

export type CommerceAdminDigitalGiftCardUpdateDeliveryInput = {
  date: Scalars['String']['input'];
  message: InputMaybe<Scalars['String']['input']>;
  notifySender: Scalars['Boolean']['input'];
  recipient: CommerceAdminDigitalGiftCardContactDetailInput;
  sender: CommerceAdminDigitalGiftCardContactDetailInput;
};

export type CommerceAdminDigitialGiftCardSorting = {
  direction: InputMaybe<SortDirection>;
  field: CommerceAdminDigitalGiftCardSortByField;
};

export type CommerceAdminEmailOption = {
  __typename?: 'CommerceAdminEmailOption';
  description: Maybe<Scalars['String']['output']>;
  name: EmailType;
};

/**
 * CommerceAdminManifest is a singular manfest of shipments from Starshippit
 * See the [Starshippit API Docs](https://api-docs.starshipit.com/#4961ecec-9175-4e55-ac4d-06cb0567c8ab) for more details
 */
export type CommerceAdminManifest = {
  __typename?: 'CommerceAdminManifest';
  /** The carrier for this manifest - Starshippit API provides a numeric ID for each carrier and we convert it to the name we generally use */
  carrier: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The manifest number on the centre's account */
  number: Scalars['Int']['output'];
  /** Total number of packages in the manifest */
  numberOfPackages: Scalars['Int']['output'];
  /** Total number of shipments in the manifest */
  numberOfShipments: Scalars['Int']['output'];
};

/** A file attached to a manifest. The contents are Base64 encoded and provided as a string in the fileData field. */
export type CommerceAdminManifestFile = {
  __typename?: 'CommerceAdminManifestFile';
  /** Base64 encoded file contents - make sure you check what the file type is */
  fileData: Scalars['String']['output'];
  /** Should generally be the PDF but may be other files here too */
  fileName: Scalars['String']['output'];
};

export type CommerceAdminManifestShipmentsInput = {
  /** The carrier to manifest the shipments for */
  carrier: Scalars['String']['input'];
  /** The dispatch centre to manifest the shipments for */
  dispatchCentre: Scalars['String']['input'];
};

export type CommerceAdminManifestShipmentsResponse = {
  __typename?: 'CommerceAdminManifestShipmentsResponse';
  /** The number of shipments in the manifest created */
  shipmentsManifested: Scalars['Int']['output'];
};

export type CommerceAdminManifestableCarrier = {
  __typename?: 'CommerceAdminManifestableCarrier';
  carrier: Scalars['String']['output'];
  carrierId: Scalars['Int']['output'];
  carrierName: Scalars['String']['output'];
};

export type CommerceAdminManifestableCarriersResponse = {
  __typename?: 'CommerceAdminManifestableCarriersResponse';
  carriers: Array<CommerceAdminManifestableCarrier>;
};

/** CommerceAdminManifestSearchResults is a list of manifests from Starshippit along with the total number of pages and total number of manifests */
export type CommerceAdminManifestsResponse = {
  __typename?: 'CommerceAdminManifestsResponse';
  /** The total number of manifests */
  count: Scalars['Int']['output'];
  /** The list of manifests on the given page based off the dipatch centre and responding with up to the given limit */
  manifests: Array<CommerceAdminManifest>;
  /** The total number of pages of manifests for the given limit */
  pages: Scalars['Int']['output'];
};

export type CommerceAdminManuallyUpdatePackageTrackingResponse = {
  __typename?: 'CommerceAdminManuallyUpdatePackageTrackingResponse';
  accepted: Scalars['Boolean']['output'];
};

export type CommerceAdminMutation = {
  __typename?: 'CommerceAdminMutation';
  addNoteToOrder: OrderNote;
  blockDigitalCard: CommerceAdminDigitalGiftCard;
  cancelDigitalCard: CommerceAdminDigitalGiftCard;
  cancelOrder: CommerceAdminDigitalGiftCard;
  clearOrder: Maybe<OrderReviewResult>;
  completeManualTransfer: ManualTransferAggregationResponse;
  createBulkCartUploadUrls: Maybe<BulkCartUploadUrlResponse>;
  createManualTransfer: ManualTransferAggregationResponse;
  createShipment: Maybe<CommerceAdminCreateShipmentResponse>;
  /** Create a manifest for Starshipit by carrier */
  manifestShipments: Maybe<CommerceAdminManifestShipmentsResponse>;
  manuallyUpdatePackageTracking: Maybe<CommerceAdminManuallyUpdatePackageTrackingResponse>;
  /** Request refund on order */
  marketplaceOrderReturn: Maybe<MarketplaceOrderRefundResponse>;
  processBulkCartFiles: Maybe<BulkCartProcessResponse>;
  reissueDigitalCard: ReissueResult;
  resendEmail: Maybe<EmailResponse>;
  resendMarketplaceOrderEmail: Maybe<EmailResponse>;
  reviewOrder: Maybe<OrderReviewResult>;
  substituteDigitalCard: CardSubstitutionResponseOrError;
  substituteInCentreDigitalCard: CardSubstitutionResponseOrError;
  unblockDigitalCard: CommerceAdminDigitalGiftCard;
  updateDigitalGiftCardDelivery: CommerceAdminDigitalGiftCard;
  updateMarketplaceOrderShippingDetails: UpdateMarketplaceOrderShippingDetailsResult;
  updateOrderItemStatus: UpdateOrderItemStatusResult;
  updateOrderStatus: UpdateOrderStatusResult;
  updateOrderUnreadNote: UpdateSuccessResult;
  updateParcelStatus: Parcel;
};


export type CommerceAdminMutationAddNoteToOrderArgs = {
  input: AddNoteToOrderInput;
};


export type CommerceAdminMutationBlockDigitalCardArgs = {
  referenceNumber: Scalars['ID']['input'];
};


export type CommerceAdminMutationCancelDigitalCardArgs = {
  cancellationReason: DigitalGiftCardCancellationReason;
  cancellationReasonNote: InputMaybe<Scalars['String']['input']>;
  centreCode: Scalars['String']['input'];
  referenceNumber: Scalars['ID']['input'];
};


export type CommerceAdminMutationCancelOrderArgs = {
  cancellationReason: DigitalGiftCardCancellationReason;
  cancellationReasonNote: InputMaybe<Scalars['String']['input']>;
  centreCode: Scalars['String']['input'];
  referenceNumber: Scalars['ID']['input'];
};


export type CommerceAdminMutationClearOrderArgs = {
  orderClearance: OrderClearanceInput;
};


export type CommerceAdminMutationCompleteManualTransferArgs = {
  input: CompleteManualTransferInput;
};


export type CommerceAdminMutationCreateBulkCartUploadUrlsArgs = {
  cartReference: Scalars['ID']['input'];
};


export type CommerceAdminMutationCreateManualTransferArgs = {
  input: ManualTransferInput;
};


export type CommerceAdminMutationCreateShipmentArgs = {
  shipment: CommerceAdminCreateShipmentInput;
};


export type CommerceAdminMutationManifestShipmentsArgs = {
  input: CommerceAdminManifestShipmentsInput;
};


export type CommerceAdminMutationManuallyUpdatePackageTrackingArgs = {
  trackingStatusUpdate: CommerceAdminTrackingStatusUpdateInput;
};


export type CommerceAdminMutationMarketplaceOrderReturnArgs = {
  input: Array<MarketplaceOrderReturnInput>;
};


export type CommerceAdminMutationProcessBulkCartFilesArgs = {
  input: ProcessBulkFileRequest;
};


export type CommerceAdminMutationReissueDigitalCardArgs = {
  cancellationReason: DigitalGiftCardCancellationReason;
  cancellationReasonNote: InputMaybe<Scalars['String']['input']>;
  centreCode: Scalars['String']['input'];
  referenceNumber: Scalars['ID']['input'];
};


export type CommerceAdminMutationResendEmailArgs = {
  input: InputMaybe<ResendEmailInput>;
};


export type CommerceAdminMutationResendMarketplaceOrderEmailArgs = {
  input: InputMaybe<ResendEmailInput>;
};


export type CommerceAdminMutationReviewOrderArgs = {
  orderReview: OrderReviewInput;
};


export type CommerceAdminMutationSubstituteDigitalCardArgs = {
  input: CardSubstitutionRequestInput;
};


export type CommerceAdminMutationSubstituteInCentreDigitalCardArgs = {
  input: CardSubstitutionInCentreRequestInput;
};


export type CommerceAdminMutationUnblockDigitalCardArgs = {
  referenceNumber: Scalars['ID']['input'];
};


export type CommerceAdminMutationUpdateDigitalGiftCardDeliveryArgs = {
  deliveryDetail: CommerceAdminDigitalGiftCardUpdateDeliveryInput;
  referenceNumber: Scalars['ID']['input'];
};


export type CommerceAdminMutationUpdateMarketplaceOrderShippingDetailsArgs = {
  input: UpdateMarketplaceOrderShippingDetailsInput;
};


export type CommerceAdminMutationUpdateOrderItemStatusArgs = {
  input: IUpdateOrderItemStatusInput;
};


export type CommerceAdminMutationUpdateOrderStatusArgs = {
  orderId: Scalars['ID']['input'];
  status: BigCommerceOrderStatus;
};


export type CommerceAdminMutationUpdateOrderUnreadNoteArgs = {
  orderId: Scalars['ID']['input'];
  unreadNote: Scalars['Boolean']['input'];
};


export type CommerceAdminMutationUpdateParcelStatusArgs = {
  id: Scalars['ID']['input'];
  status: ParcelStatus;
};

export type CommerceAdminOrder = {
  __typename?: 'CommerceAdminOrder';
  billingDetails: CommerceAdminAddressDetails;
  centre: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  items: Array<CommerceAdminDigitalGiftCardItem>;
  /** Raw logistic order data for this order */
  logisticOrders: Maybe<Array<LogisticOrder>>;
  notes: Maybe<Array<Maybe<OrderNote>>>;
  orderReference: Scalars['ID']['output'];
  /** Parcels for this order */
  parcels: Maybe<Array<Maybe<ParcelWithItems>>>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentProviderId: Maybe<Scalars['String']['output']>;
  paymentStatus: Maybe<Scalars['String']['output']>;
  pickupDate: Maybe<Scalars['DateTime']['output']>;
  scentregroupId: Maybe<Scalars['String']['output']>;
  /** Shipments for this order */
  shipments: Array<CommerceAdminShipmentWithItemsResponse>;
  shippingDetails: Maybe<CommerceAdminAddressDetails>;
  status: BigCommerceOrderStatus;
  totalIncTax: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
  unreadNote: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vendorCreatedAt: Maybe<Scalars['DateTime']['output']>;
  vendorOrderId: Maybe<Scalars['Int']['output']>;
  vendorUpdatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** CommerceAdminManifestSearchInput is the input for searching manifests from Starshippit with CommerceAdmin.searchManifests */
export type CommerceAdminSearchManifestsInput = {
  /** The dispatch centre to search for manifests for using the slug form of the centre name */
  dispatchCentre: Scalars['String']['input'];
  /** Default to 10, maximum is 250 - Starshippit API default is 50 */
  limit: InputMaybe<Scalars['Int']['input']>;
  /** Default to 0 - Starshippit API starts at 1 but we add 1 during the request */
  page: InputMaybe<Scalars['Int']['input']>;
};

export type CommerceAdminShipmentCarrierOption = {
  __typename?: 'CommerceAdminShipmentCarrierOption';
  defaultValue: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  value: Scalars['Boolean']['output'];
};

export type CommerceAdminShipmentCarrierOptionInput = {
  id: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type CommerceAdminShipmentDeliveryService = {
  __typename?: 'CommerceAdminShipmentDeliveryService';
  carrier: Scalars['String']['output'];
  carrierName: Scalars['String']['output'];
  carrierOptions: Maybe<Array<CommerceAdminShipmentCarrierOption>>;
  serviceCode: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  totalPrice: CommerceAdminShipmentMoney;
};

export type CommerceAdminShipmentDeliveryServicesInput = {
  dangerousGoods: InputMaybe<Scalars['Boolean']['input']>;
  declaredValue: InputMaybe<CommerceAdminShipmentMoneyInput>;
  dispatchCentre: Scalars['String']['input'];
  includePricing: InputMaybe<Scalars['Boolean']['input']>;
  insuranceValue: InputMaybe<Scalars['Float']['input']>;
  packages: Array<CommerceAdminShipmentPackageDimensions>;
  returnOrder: InputMaybe<Scalars['Boolean']['input']>;
  shippingDetails: CommerceAdminAddressDetailsInput;
};

export type CommerceAdminShipmentDeliveryServicesResponse = {
  __typename?: 'CommerceAdminShipmentDeliveryServicesResponse';
  defaultService: Maybe<CommerceAdminShipmentDeliveryService>;
  services: Array<CommerceAdminShipmentDeliveryService>;
};

export type CommerceAdminShipmentItemInput = {
  id: Scalars['String']['input'];
};

export type CommerceAdminShipmentItemResponse = {
  __typename?: 'CommerceAdminShipmentItemResponse';
  id: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  shippedItemIds: Array<Scalars['ID']['output']>;
};

export type CommerceAdminShipmentMoney = {
  __typename?: 'CommerceAdminShipmentMoney';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type CommerceAdminShipmentMoneyInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type CommerceAdminShipmentOrderInput = {
  id: Scalars['String']['input'];
  orderReference: Scalars['String']['input'];
};

export type CommerceAdminShipmentOrderResponse = {
  __typename?: 'CommerceAdminShipmentOrderResponse';
  id: Maybe<Scalars['String']['output']>;
  orderReference: Maybe<Scalars['String']['output']>;
};

export type CommerceAdminShipmentPackageDimensions = {
  height: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type CommerceAdminShipmentPackageInput = {
  height: Scalars['Float']['input'];
  items: Array<CommerceAdminShipmentItemInput>;
  length: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type CommerceAdminShipmentPackageResponse = {
  __typename?: 'CommerceAdminShipmentPackageResponse';
  height: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<CommerceAdminShipmentItemResponse>>>;
  length: Maybe<Scalars['Float']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type CommerceAdminShipmentPackageWithItemsResponse = {
  __typename?: 'CommerceAdminShipmentPackageWithItemsResponse';
  id: Scalars['ID']['output'];
  items: Array<CommerceAdminShipmentItemResponse>;
  printLabelUrl: Maybe<Scalars['String']['output']>;
  status: Maybe<CommerceAdminTrackingStatus>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  trackingUrl: Maybe<Scalars['String']['output']>;
};

export type CommerceAdminShipmentShippingDetailsInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2: InputMaybe<Scalars['String']['input']>;
};

export type CommerceAdminShipmentWithItemsResponse = {
  __typename?: 'CommerceAdminShipmentWithItemsResponse';
  carrier: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dispatchCentre: Scalars['String']['output'];
  packages: Array<CommerceAdminShipmentPackageWithItemsResponse>;
  shipmentReference: Scalars['String']['output'];
};

export enum CommerceAdminTrackingStatus {
  AttemptedDelivery = 'ATTEMPTED_DELIVERY',
  AwaitingCollection = 'AWAITING_COLLECTION',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Dispatched = 'DISPATCHED',
  Exception = 'EXCEPTION',
  InTransit = 'IN_TRANSIT',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PickupInStore = 'PICKUP_IN_STORE',
  Printed = 'PRINTED'
}

export type CommerceAdminTrackingStatusUpdateInput = {
  orderNumber: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
  trackingStatus: CommerceAdminTrackingStatus;
};

export type CommerceAdminWestfieldDirectFilter = {
  buyerEmail: InputMaybe<StringFilter>;
  buyerName: InputMaybe<StringFilter>;
  buyerPhone: InputMaybe<StringFilter>;
  dispatchLocation: InputMaybe<StringFilter>;
  fulfilmentLocation: InputMaybe<StringFilter>;
  fulfilmentType: InputMaybe<StringFilter>;
  orderReference: InputMaybe<StringFilter>;
  referenceNumber: InputMaybe<StringFilter>;
  retailer: InputMaybe<StringFilter>;
  sourceLocation: InputMaybe<StringFilter>;
  status: InputMaybe<StringFilter>;
  vendorOrderId: InputMaybe<IntFilter>;
  waitingOn: InputMaybe<StringFilter>;
  westfieldPlusEmail: InputMaybe<EqStringFilter>;
};

export type CommerceAdminWestfieldDirectItem = {
  __typename?: 'CommerceAdminWestfieldDirectItem';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  data: Maybe<IWestfieldDirectItemData>;
  destination: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  miraklOrderLineState: Maybe<MiraklOrderLineState>;
  name: Maybe<Scalars['String']['output']>;
  order: CommerceAdminOrder;
  priceExTax: Scalars['Float']['output'];
  priceIncTax: Scalars['Float']['output'];
  priceTax: Scalars['Float']['output'];
  quantity: Maybe<Scalars['Int']['output']>;
  refunds: Maybe<Array<Maybe<MarketplaceRefund>>>;
  shop: Maybe<MarketplaceShop>;
  sourceLocation: Maybe<Scalars['String']['output']>;
  status: Maybe<OrderItemStatus>;
  updatedAt: Scalars['Date']['output'];
  /** The product variant details of an item */
  variant: Maybe<MarketplaceProductVariant>;
  vendorItemId: Scalars['String']['output'];
};

export type CommerceAdminWestfieldDirectSearch = {
  __typename?: 'CommerceAdminWestfieldDirectSearch';
  /** The total number of results with a rejected status */
  rejected: Scalars['Int']['output'];
  /** The result returned by the Item search */
  results: Array<CommerceAdminWestfieldDirectSearchResult>;
  /** Zero-indexed offset in the collection from which results are fetched */
  skip: Scalars['Int']['output'];
  /** The total number of results returned from the collection */
  total: Scalars['Int']['output'];
};

/** This input type holds paging, filtering and ordering criteria for an Order search. */
export type CommerceAdminWestfieldDirectSearchInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sort: InputMaybe<Array<CommerceAdminDigitialGiftCardSorting>>;
  where: InputMaybe<CommerceAdminWestfieldDirectFilter>;
};

export type CommerceAdminWestfieldDirectSearchResult = {
  __typename?: 'CommerceAdminWestfieldDirectSearchResult';
  businessDaysOld: Scalars['String']['output'];
  buyerEmail: Scalars['String']['output'];
  buyerName: Scalars['String']['output'];
  buyerPhone: Scalars['String']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  dispatchLocations: Maybe<Scalars['String']['output']>;
  fulfilmentLocation: Scalars['String']['output'];
  fulfilmentType: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  orderReference: Scalars['ID']['output'];
  retailer: Scalars['String']['output'];
  sourceLocation: Maybe<Scalars['String']['output']>;
  status: ParcelStatus;
  unreadNote: Scalars['Boolean']['output'];
  vendorOrderId: Maybe<Scalars['Int']['output']>;
  waitingOn: Maybe<Scalars['String']['output']>;
};

/** Sort order criter for an Order search. */
export enum CommerceAdminWestfieldDirectSortByField {
  BuyerEmail = 'buyerEmail',
  BuyerName = 'buyerName',
  Centre = 'centre',
  OrderReference = 'orderReference',
  Retailer = 'retailer',
  VendorOrderId = 'vendorOrderId',
  WaitingOn = 'waitingOn'
}

export type CommerceAdminWestfieldDirectSorting = {
  direction: InputMaybe<SortDirection>;
  field: CommerceAdminWestfieldDirectSortByField;
};

export type Competition = {
  __typename?: 'Competition';
  contentfulOfferId: Scalars['String']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDailyDraw: Scalars['Boolean']['output'];
  startDate: Maybe<Scalars['DateTime']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * This type is the entry point for administrative API operations on competitions
 * Only authorised ScentreGroup staff with competition AD group can call
 */
export type CompetitionAdmin = {
  __typename?: 'CompetitionAdmin';
  authorization: CompetitionAdminAuthorization;
  competition: Maybe<Competition>;
  competitionEntries: Maybe<Array<Maybe<CompetitionEntry>>>;
  competitionExtracts: Maybe<Array<Maybe<CompetitionExtract>>>;
  competitions: Maybe<Array<Maybe<Competition>>>;
};


/**
 * This type is the entry point for administrative API operations on competitions
 * Only authorised ScentreGroup staff with competition AD group can call
 */
export type CompetitionAdminCompetitionArgs = {
  competitionId: Scalars['UUID']['input'];
};


/**
 * This type is the entry point for administrative API operations on competitions
 * Only authorised ScentreGroup staff with competition AD group can call
 */
export type CompetitionAdminCompetitionEntriesArgs = {
  input: CompetitionEntriesInput;
};


/**
 * This type is the entry point for administrative API operations on competitions
 * Only authorised ScentreGroup staff with competition AD group can call
 */
export type CompetitionAdminCompetitionExtractsArgs = {
  competitionId: Scalars['UUID']['input'];
};


/**
 * This type is the entry point for administrative API operations on competitions
 * Only authorised ScentreGroup staff with competition AD group can call
 */
export type CompetitionAdminCompetitionsArgs = {
  input: CompetitionsInput;
};

export type CompetitionAdminAuthorization = {
  __typename?: 'CompetitionAdminAuthorization';
  id_token: Scalars['String']['output'];
  preferred_username: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type CompetitionAdminMutation = {
  __typename?: 'CompetitionAdminMutation';
  authorization: CompetitionAdminAuthorization;
  createCompetition: Maybe<Competition>;
};


export type CompetitionAdminMutationCreateCompetitionArgs = {
  input: CompetitionInput;
};

export type CompetitionEntriesFilter = {
  centreSlug: InputMaybe<Scalars['String']['input']>;
  contentfulOfferId: InputMaybe<Scalars['String']['input']>;
  scentregroupId: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionEntriesInput = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where: InputMaybe<CompetitionEntriesFilter>;
};

export type CompetitionEntry = {
  __typename?: 'CompetitionEntry';
  centreSlug: Scalars['String']['output'];
  competitionEntryAnswers: Array<CompetitionEntryAnswer>;
  contentfulOfferId: Scalars['String']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  enteredAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  ipAddress: Maybe<Scalars['String']['output']>;
  isEligible: Scalars['Boolean']['output'];
  scentregroupId: Scalars['String']['output'];
  submittedBy: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CompetitionEntryAnswer = {
  __typename?: 'CompetitionEntryAnswer';
  questionId: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type CompetitionExtract = {
  __typename?: 'CompetitionExtract';
  competitionId: Scalars['String']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CompetitionExtractsInput = {
  competitionId: Scalars['String']['input'];
};

export type CompetitionInput = {
  contentfulOfferId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  isDailyDraw: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type CompetitionsFilter = {
  contentfulOfferId: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionsInput = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where: InputMaybe<CompetitionsFilter>;
};

export type CompleteManualTransferInput = {
  manualTransferType: ManualTransferType;
  reference: Scalars['String']['input'];
  toDate: Scalars['Date']['input'];
};

export type CompletedManualTransferExportInput = {
  manualTransferType: ManualTransferType;
  reference: Scalars['String']['input'];
};

export type Consent = {
  __typename?: 'Consent';
  emailMarketing: Maybe<Scalars['Boolean']['output']>;
  pushNotificationMarketing: Maybe<Scalars['Boolean']['output']>;
  targetedAdvertising: Maybe<Scalars['Boolean']['output']>;
};

export type ConsentInput = {
  emailMarketing: InputMaybe<Scalars['Boolean']['input']>;
  pushNotificationMarketing: InputMaybe<Scalars['Boolean']['input']>;
  targetedAdvertising: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentAnalyticsMetadata = {
  __typename?: 'ContentAnalyticsMetadata';
  correlationId: Maybe<Scalars['String']['output']>;
  promotion: Maybe<ContentAnalyticsPromotion>;
  title: Maybe<Scalars['String']['output']>;
};

export type ContentAnalyticsPromotion = {
  __typename?: 'ContentAnalyticsPromotion';
  creative: Maybe<Scalars['String']['output']>;
};

export type ContentOptions = {
  isMember: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentOrchestrationAnalyticsMetadata = ContentOrchestrationAnalyticsMetadataPersonalised | ContentOrchestrationAnalyticsMetadataStandard;

export type ContentOrchestrationAnalyticsMetadataBase = {
  displayId: Scalars['String']['output'];
  moduleSlug: Maybe<Scalars['String']['output']>;
};

export type ContentOrchestrationAnalyticsMetadataPersonalised = ContentOrchestrationAnalyticsMetadataBase & {
  __typename?: 'ContentOrchestrationAnalyticsMetadataPersonalised';
  displayId: Scalars['String']['output'];
  knownScgId: Scalars['Boolean']['output'];
  methodUsed: Scalars['String']['output'];
  moduleSlug: Maybe<Scalars['String']['output']>;
  primaryRank: Scalars['Int']['output'];
  secondaryRank: Scalars['Int']['output'];
};

export type ContentOrchestrationAnalyticsMetadataStandard = ContentOrchestrationAnalyticsMetadataBase & {
  __typename?: 'ContentOrchestrationAnalyticsMetadataStandard';
  displayId: Scalars['String']['output'];
  moduleSlug: Maybe<Scalars['String']['output']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CoordinateInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CreateOrderInput = {
  billingDetails: AddBillingDetails;
  cartId: Scalars['UUID']['input'];
  paymentIntentId: Scalars['ID']['input'];
};

export type CreatePasswordResetInput = {
  email: Scalars['String']['input'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  billingAddress: AddressDetails;
  /** brand of credit card */
  brand: Scalars['String']['output'];
  /** Date payment method was created */
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** Date payment method was last made default */
  defaultAt: Maybe<Scalars['DateTime']['output']>;
  /** Expiry month */
  expMonth: Scalars['Int']['output'];
  /** Expiry year */
  expYear: Scalars['Int']['output'];
  /** Last 4 digits on card */
  last4: Scalars['String']['output'];
  /** Stripe payment method ID */
  stripePaymentMethodId: Scalars['String']['output'];
  /** Date payment method was updated */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum CurrencyCode {
  Aud = 'AUD',
  Nzd = 'NZD'
}

export type Customer = {
  __typename?: 'Customer';
  acquisitionSources: Array<Scalars['String']['output']>;
  auth0: Maybe<Auth0Customer>;
  consent: Maybe<Consent>;
  customerCart: Maybe<CustomerCart>;
  directRewards: Maybe<DirectRewards>;
  email: Scalars['String']['output'];
  experiencePackages: Maybe<Array<ExperiencePackagePurchased>>;
  featureManagementTags: Array<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  hasMarketplaceOrders: Scalars['Boolean']['output'];
  isParkPlus: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  loyaltyProgramMemberships: Array<LoyaltyProgramMembership>;
  marketplaceOrder: Maybe<MarketplaceOrder>;
  marketplaceOrders: Maybe<Array<Maybe<MarketplaceOrder>>>;
  mobile: Maybe<Scalars['String']['output']>;
  onboarding: Maybe<Onboarding>;
  parkingProfile: Maybe<ParkingProfile>;
  preferences: Maybe<Preference>;
  primaryCentre: Maybe<SgcfCentre>;
  rewardsSummary: Maybe<RewardsSummary>;
  scentregroupId: Scalars['UUID']['output'];
  storedAddresses: Maybe<Array<Maybe<AddressDetails>>>;
  storedPaymentMethods: Maybe<Array<Maybe<CreditCard>>>;
  westfieldPlus: Maybe<WestfieldPlusData>;
};


export type CustomerLoyaltyProgramMembershipsArgs = {
  filter: InputMaybe<LoyaltyProgramMembershipFilter>;
};


export type CustomerMarketplaceOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type CustomerCart = {
  __typename?: 'CustomerCart';
  id: Scalars['UUID']['output'];
  itemCount: Scalars['Int']['output'];
};

export type CustomerDetailsInput = {
  email: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CustomerMobileNumberInput = {
  mobile: Scalars['String']['input'];
};

export type CustomerPasswordInput = {
  password: Scalars['String']['input'];
};

export type CustomerPrimaryCentreInput = {
  slug: Scalars['String']['input'];
};

export enum DayOfTheWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DetailedMovie = {
  __typename?: 'DetailedMovie';
  classification: Maybe<Classification>;
  genres: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  runTime: Maybe<Scalars['Int']['output']>;
  sessions: Maybe<Array<Session>>;
  synopsis: Maybe<Scalars['String']['output']>;
  timeZone: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trailerUrl: Maybe<Scalars['String']['output']>;
};

export type DigitalGiftCard = {
  __typename?: 'DigitalGiftCard';
  /**
   * The initial amount on the card.
   * @deprecated Use 'value'.
   */
  amount: Scalars['Float']['output'];
  /** The current available balance in the card's native currency. */
  balance: Scalars['Decimal']['output'];
  /** The native currency of the card. */
  currency: CurrencyCode;
  /** The original delivery date. */
  deliveryDate: Scalars['Date']['output'];
  /** If the card is hidden or not */
  displayStatus: DigitalGiftCardDisplayStatus;
  /** The expiry date applying to the card. */
  expirationDate: Scalars['Date']['output'];
  /** The expiry date in M-YYYY format. */
  expirationDateFormatted: Scalars['String']['output'];
  /** The message attached to the digital gift card purchase. */
  message: Maybe<Scalars['String']['output']>;
  /** Digital Gift Card obstucated pan. */
  pan: Scalars['String']['output'];
  /** The recipient email where the email was sent. */
  recipientEmail: Maybe<Scalars['String']['output']>;
  /** The recipient name. */
  recipientName: Maybe<Scalars['String']['output']>;
  /** Card's reference number */
  referenceNumber: Scalars['String']['output'];
  /** The sender name. */
  senderName: Maybe<Scalars['String']['output']>;
  /** The card status. */
  status: DigitalGiftCardStatus;
  /** Digital Gift Card transactions */
  transactions: Array<DigitalGiftCardTransaction>;
  /** The initial value on the card in its native currency. */
  value: Scalars['Decimal']['output'];
  /** Wallet reference. */
  walletReferences: Array<WalletReference>;
};


export type DigitalGiftCardWalletReferencesArgs = {
  walletType: InputMaybe<WalletType>;
};

export enum DigitalGiftCardCancellationReason {
  AppError = 'APP_ERROR',
  CardError = 'CARD_ERROR',
  CustomerRefundRequest = 'CUSTOMER_REFUND_REQUEST',
  DgcSentToChild = 'DGC_SENT_TO_CHILD',
  Dispute = 'DISPUTE',
  Fraud = 'FRAUD',
  InstructionsNotUnderstood = 'INSTRUCTIONS_NOT_UNDERSTOOD',
  NotWillingToSignup = 'NOT_WILLING_TO_SIGNUP',
  PersonalPreference = 'PERSONAL_PREFERENCE',
  UnsupportedDevice = 'UNSUPPORTED_DEVICE'
}

export enum DigitalGiftCardDisplayStatus {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export type DigitalGiftCardPin = {
  __typename?: 'DigitalGiftCardPIN';
  newPIN: Scalars['String']['output'];
};

export enum DigitalGiftCardStatus {
  /** The card is active and it's ready to use. */
  Active = 'ACTIVE',
  /** The card is blocked */
  Blocked = 'BLOCKED',
  /** The card has been cancelled before being created */
  Cancelled = 'CANCELLED',
  /** The card account is closed. */
  Closed = 'CLOSED',
  /** The card is created but it's not active. */
  Created = 'CREATED',
  /** The card is expired. */
  Expired = 'EXPIRED',
  /** Other status. */
  Other = 'OTHER',
  /** The card is to be created */
  Pending = 'PENDING',
  /** The card has been reissued */
  Reissued = 'REISSUED',
  /** The card has been substituted for a physical card */
  Substituted = 'SUBSTITUTED'
}

export type DigitalGiftCardTransaction = {
  __typename?: 'DigitalGiftCardTransaction';
  /** Amount transacted in the card's native currency. */
  amount: Scalars['Decimal']['output'];
  /** The date and time that the transaction was performed. */
  date: Scalars['DateTime']['output'];
  /** Transaction description. */
  description: Scalars['String']['output'];
  /** The digital gift card */
  digitalGiftCard: DigitalGiftCard;
  /** The available balance of the card in its native currency after the transaction. */
  runningBalance: Scalars['Decimal']['output'];
};

export type DigitalGiftCards = {
  __typename?: 'DigitalGiftCards';
  digitalGiftCards: Array<Maybe<DigitalGiftCard>>;
  /** The total number of visible and active cards (no expired). */
  totalActiveCards: Scalars['Int']['output'];
  /** The total balance for all the visible and active cards (no expired), collected by currency. */
  totalBalance: Array<Maybe<Money>>;
  /** The total number of hidden cards. */
  totalHiddenCards: Scalars['Int']['output'];
};

export type DirectOrderReward = {
  __typename?: 'DirectOrderReward';
  amount: Scalars['Decimal']['output'];
  batchId: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  orderReference: Maybe<Scalars['String']['output']>;
};

/** Rewards breakdown returned from the rewards query. */
export type DirectRewards = {
  __typename?: 'DirectRewards';
  issued: IssuedRewards;
  pending: PendingOrders;
  redeemed: RedeemedOrders;
};

export type DisplayAnalyticsMetadata = {
  __typename?: 'DisplayAnalyticsMetadata';
  correlationIds: Maybe<Array<Scalars['String']['output']>>;
  displayId: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['String']['output']>;
};

export type EditProductInput = {
  id: Scalars['ID']['input'];
  itemId: Scalars['UUID']['input'];
  marketplaceItem: InputMaybe<MarketplaceItemInput>;
  physicalGiftCardItem: InputMaybe<PhysicalGiftCardItemInput>;
  productItem: InputMaybe<ProductItemInput>;
  virtualGiftCardItem: InputMaybe<VirtualGiftCardItemInput>;
};

export type EmailResponse = {
  __typename?: 'EmailResponse';
  email: Maybe<Scalars['String']['output']>;
  error: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export enum EmailType {
  Activation = 'ACTIVATION',
  Confirmation = 'CONFIRMATION',
  Declined = 'DECLINED',
  InProgress = 'IN_PROGRESS',
  MarketplaceOrderConfirmation = 'MARKETPLACE_ORDER_CONFIRMATION',
  MarketplaceOrderReceived = 'MARKETPLACE_ORDER_RECEIVED'
}

/** Object passed to the enterCompetition mutation. */
export type EnterCompetitionInput = {
  /** The centre specified in the claim link. */
  centreSlug: Scalars['String']['input'];
  /** The ID of the offer in contentful */
  offerId: Scalars['String']['input'];
  /** The question Id and their customer entered values */
  questions: InputMaybe<Array<InputMaybe<QuestionInput>>>;
};

export type EnterInstantDrawInput = {
  centreSlug: Scalars['String']['input'];
  /** The offerid of the instant door draw in contentful */
  offerId: Scalars['String']['input'];
};

export type EqStringFilter = {
  eq: Scalars['String']['input'];
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
};

export type EventForBookingInquiry = {
  centreTitles: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  occurrenceIds: InputMaybe<Array<Scalars['String']['input']>>;
  occurrences: InputMaybe<Array<OccurrenceForBookingInquiry>>;
};

export type ExperiencePackage = {
  __typename?: 'ExperiencePackage';
  available: Maybe<Scalars['Int']['output']>;
  contentfulOfferId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offers: Maybe<Array<ExperiencePackageOffer>>;
  price: Scalars['Int']['output'];
  shortDescription: Scalars['String']['output'];
  termsAndConditions: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExperiencePackageAuthorization = {
  __typename?: 'ExperiencePackageAuthorization';
  id_token: Scalars['String']['output'];
  preferred_username: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type ExperiencePackageCoupons = {
  __typename?: 'ExperiencePackageCoupons';
  coupon: HoytsCoupon;
  expiryDate: Scalars['DateTime']['output'];
  offer: Maybe<ExperiencePackageOffer>;
  status: Scalars['String']['output'];
  store: Maybe<Store>;
};

export type ExperiencePackageInput = {
  centreSlug: Scalars['String']['input'];
  contentfulOfferId: InputMaybe<Scalars['String']['input']>;
  longDescription: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  shortDescription: Scalars['String']['input'];
  termsAndConditions: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExperiencePackageOffer = {
  __typename?: 'ExperiencePackageOffer';
  contentfulOfferId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longDescription: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shelfLife: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  store: Maybe<Store>;
  termsAndConditions: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExperiencePackageOfferInput = {
  contentfulOfferId: InputMaybe<Scalars['String']['input']>;
  contentfulStoreId: Scalars['String']['input'];
  experiencePackageId: Scalars['String']['input'];
  longDescription: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shelfLife: Scalars['String']['input'];
  shortDescription: Scalars['String']['input'];
  termsAndConditions: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExperiencePackagePurchased = {
  __typename?: 'ExperiencePackagePurchased';
  commerceOrderId: Scalars['String']['output'];
  coupons: Array<ExperiencePackageCoupons>;
  experiencePackage: ExperiencePackage;
};

export type ExperiencePackagesAdmin = {
  __typename?: 'ExperiencePackagesAdmin';
  authorization: ExperiencePackageAuthorization;
  experiencePackage: Maybe<ExperiencePackage>;
  experiencePackages: Maybe<Array<ExperiencePackage>>;
};


export type ExperiencePackagesAdminExperiencePackageArgs = {
  id: Scalars['String']['input'];
};


export type ExperiencePackagesAdminExperiencePackagesArgs = {
  centreSlug: Scalars['String']['input'];
};

export type ExperiencePackagesAdminMutation = {
  __typename?: 'ExperiencePackagesAdminMutation';
  authorization: ExperiencePackageAuthorization;
  createExperiencePackage: Maybe<ExperiencePackage>;
  createExperiencePackageOffer: Maybe<ExperiencePackageOffer>;
};


export type ExperiencePackagesAdminMutationCreateExperiencePackageArgs = {
  input: ExperiencePackageInput;
};


export type ExperiencePackagesAdminMutationCreateExperiencePackageOfferArgs = {
  input: ExperiencePackageOfferInput;
};

export type FeatureManagementCohortResult = {
  __typename?: 'FeatureManagementCohortResult';
  cohortName: Maybe<Scalars['String']['output']>;
  distribution: Scalars['Float']['output'];
  result: Maybe<Scalars['FeatureManagementResult']['output']>;
};

export type FeatureManagementFeature = {
  __typename?: 'FeatureManagementFeature';
  defaultResult: Maybe<Scalars['FeatureManagementResult']['output']>;
  featureSlug: Scalars['String']['output'];
  rules: Array<Maybe<FeatureManagementRule>>;
  type: Scalars['String']['output'];
};

export type FeatureManagementRule = {
  __typename?: 'FeatureManagementRule';
  condition: Scalars['FeatureManagementCondition']['output'];
  results: Array<Maybe<FeatureManagementCohortResult>>;
};

export type GenerateDigitalGiftCardPinInput = {
  referenceNumber: Scalars['String']['input'];
};

export type GenericCartItem = CartItem & {
  __typename?: 'GenericCartItem';
  category: Maybe<Scalars['String']['output']>;
  description: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The cart line item ID from the commerce platform. */
  id: Scalars['ID']['output'];
  image: Maybe<ProductImage>;
  listPrice: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  options: Maybe<Array<Maybe<CartItemOption>>>;
  productId: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  salesPrice: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
};

export type GenericOutput = {
  __typename?: 'GenericOutput';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Physical or virtual GiftCard cart item */
export type GiftCardCartItem = CartItem & {
  __typename?: 'GiftCardCartItem';
  /** The category of the product item in the cart. */
  category: Maybe<Scalars['String']['output']>;
  /** The id of the product in the commerce platform. */
  id: Scalars['ID']['output'];
  image: Maybe<ProductImage>;
  /** The name of the product item in the cart. */
  name: Maybe<Scalars['String']['output']>;
  /** Amount of items in the cart */
  productId: Maybe<Scalars['Int']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  /** Gift Card specific recipient details */
  recipientDetails: Maybe<RecipientDetails>;
  /** Cart item sales price. */
  salesPrice: Maybe<Scalars['Float']['output']>;
  /** The SKU of the product in the commerce platform. */
  sku: Scalars['String']['output'];
  /** The value of the Gift Card. */
  value: Scalars['Float']['output'];
};

export type GiftCardConstraints = {
  __typename?: 'GiftCardConstraints';
  maxDeliveryDateMonths: Scalars['Int']['output'];
  maxValue: Scalars['Int']['output'];
  minValue: Scalars['Int']['output'];
};

export enum GiftCardStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Other = 'OTHER',
  Pending = 'PENDING',
  Reissued = 'REISSUED',
  Substituted = 'SUBSTITUTED',
  ToBeCreated = 'TO_BE_CREATED',
  WaitingActivation = 'WAITING_ACTIVATION'
}

export type GiftCardStatusFilter = {
  is: InputMaybe<GiftCardStatus>;
};

export type GooglePushProvisioning = {
  __typename?: 'GooglePushProvisioning';
  encryptedPaymentInstrument: Scalars['String']['output'];
};

export enum HighlightAttributes {
  Memberexclusive = 'MEMBEREXCLUSIVE'
}

export enum HourStatus {
  Closed = 'CLOSED',
  Multiple = 'MULTIPLE',
  Normal = 'NORMAL',
  Overnight = 'OVERNIGHT'
}

export enum HourType {
  Special = 'SPECIAL',
  Standard = 'STANDARD'
}

export type HoytsCoupon = {
  __typename?: 'HoytsCoupon';
  barcodeType: Scalars['String']['output'];
  code: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  originalUrl: Scalars['String']['output'];
  pin: Scalars['String']['output'];
};

export type IUpdateOrderItemStatusInput = {
  itemIds: Array<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};

export type IWestfieldDirectItemData = {
  __typename?: 'IWestfieldDirectItemData';
  centre: Maybe<Scalars['String']['output']>;
  extras: Maybe<Scalars['String']['output']>;
  retailer: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['String']['output']>;
};

export type ImpressionEvent = {
  __typename?: 'ImpressionEvent';
  eventName: Maybe<Scalars['String']['output']>;
  eventUrl: Maybe<Scalars['String']['output']>;
};

export type ImpressionEventType = {
  __typename?: 'ImpressionEventType';
  eventName: Maybe<Scalars['String']['output']>;
  eventUrl: Maybe<Scalars['String']['output']>;
};

export type IncrementLoyaltyProgramMembershipViewCountInput = {
  id: Scalars['String']['input'];
};

export type InstantDrawResponse = {
  __typename?: 'InstantDrawResponse';
  couponCode: Maybe<Scalars['String']['output']>;
  message: Maybe<Message>;
  result: InstantPromotionResult;
};

export type InstantEarnResponse = {
  __typename?: 'InstantEarnResponse';
  couponCode: Maybe<Scalars['String']['output']>;
  message: Maybe<Message>;
  result: InstantPromotionResult;
};

export enum InstantPromotionResult {
  Lost = 'LOST',
  Pending = 'PENDING',
  ValidationError = 'VALIDATION_ERROR',
  Won = 'WON'
}

export type IntFilter = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
};

export type InvalidInputError = {
  __typename?: 'InvalidInputError';
  fields: Array<ValidationError>;
  message: Scalars['String']['output'];
};

export type Issue = {
  __typename?: 'Issue';
  severity: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Direct rewards breakdown. */
export type IssuedRewards = {
  __typename?: 'IssuedRewards';
  balance: Scalars['Decimal']['output'];
  rewards: Array<Maybe<DirectOrderReward>>;
};

/** To be deprecated in favour of enum HighlightAttributes */
export enum ItemEntryFlag {
  Memberexclusive = 'MEMBEREXCLUSIVE'
}

export type LogisticOrder = {
  __typename?: 'LogisticOrder';
  commercialOrderId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currencyIsoCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<CommerceAdminWestfieldDirectItem>;
  leadTimeToShip: Maybe<Scalars['Int']['output']>;
  orderId: Maybe<Scalars['String']['output']>;
  parcel: Maybe<Parcel>;
  shippingTypeCode: Maybe<Scalars['String']['output']>;
  shopId: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  totalCommission: Maybe<Scalars['Float']['output']>;
  totalPrice: Maybe<Scalars['Float']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  vendorCreatedAt: Maybe<Scalars['DateTime']['output']>;
  vendorUpdatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type LogisticOrderSearchInput = {
  centres: InputMaybe<Array<Scalars['String']['input']>>;
  states: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LoyaltyProgramMembership = {
  __typename?: 'LoyaltyProgramMembership';
  /**
   * The Barcode Value of the user's card.
   * Common field across both Memeberships (Branded Cards) & Custom Cards.
   * One of membershipNumber, barcodeValue or cardNumber is required on creation.
   */
  barcodeValue: Maybe<Scalars['String']['output']>;
  /**
   * The Card Number of the user's card.
   * Common field across both Memeberships (Branded Cards) & Custom Cards.
   * One of membershipNumber, barcodeValue or cardNumber is required on creation.
   */
  cardNumber: Maybe<Scalars['String']['output']>;
  /**
   * The Contentful Loyalty Program Entry ID. This is autogenerated by Contentful when the Loyalty Program is added to a Retailer.
   * Exclusive to Memberships (Branded Cards).
   */
  contentfulLoyaltyProgramId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * A user defined name for the Custom Card.
   * Exclusive to Custom Cards.
   */
  customCardName: Maybe<Scalars['String']['output']>;
  /** UID of this Membership in the Postgres DB */
  id: Scalars['String']['output'];
  /**
   * Computed by contentfulLoyaltyProgramId which is nullable.
   * Data is resolved by the Content Service subgraph. The data is **not** stored in any database in this microservice.
   * Exclusive to Memberships (Branded Cards).
   */
  loyaltyProgram: Maybe<CfLoyaltyProgram>;
  /**
   * The Membership Number of the participating user in the Loyalty Program.
   * Common field across both Memeberships (Branded Cards) & Custom Cards.
   * One of membershipNumber, barcodeValue or cardNumber is required on creation.
   */
  membershipNumber: Maybe<Scalars['String']['output']>;
  /** Count of the number of times this Membership has been viewed in detail (Detail View on mobile clients) */
  numberOfViews: Scalars['Int']['output'];
  /**
   * The name of the barcode format used to render the barcodeValue.
   * Memberships should use the CFLoyaltyProgram.membershipBarcodeFormat.
   * Exclusive to Custom Cards.
   */
  scannedBarcodeFormat: Maybe<Scalars['String']['output']>;
  /** UID of the user who owns this Membership */
  scentregroupId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltyProgramMembershipFilter = {
  id: InputMaybe<Scalars['String']['input']>;
};

export type ManualTransferAggregationResponse = {
  __typename?: 'ManualTransferAggregationResponse';
  amount: Scalars['Float']['output'];
  event: Scalars['String']['output'];
  fromAccount: Scalars['String']['output'];
  manualTransferType: ManualTransferType;
  reference: Maybe<Scalars['String']['output']>;
  status: ManualTransferStatus;
  toAccount: Scalars['String']['output'];
};

export type ManualTransferInput = {
  fromDate: InputMaybe<Scalars['Date']['input']>;
  manualTransferType: ManualTransferType;
  toDate: Scalars['Date']['input'];
};

export enum ManualTransferStatus {
  Complete = 'COMPLETE',
  New = 'NEW',
  None = 'NONE',
  Pending = 'PENDING'
}

export enum ManualTransferType {
  BulkIndueTransfer = 'BULK_INDUE_TRANSFER',
  CardCancellationIndueTransfer = 'CARD_CANCELLATION_INDUE_TRANSFER',
  CardCancellationTransfer = 'CARD_CANCELLATION_TRANSFER',
  DigitalExchangeTransfer = 'DIGITAL_EXCHANGE_TRANSFER'
}

export type ManualTransferTypeInput = {
  manualTransferType: ManualTransferType;
};

export type MarketplaceAdminAlgoliaIndexingResult = {
  __typename?: 'MarketplaceAdminAlgoliaIndexingResult';
  numberOfObjects: Scalars['Int']['output'];
};

export type MarketplaceAdminAuthorization = {
  __typename?: 'MarketplaceAdminAuthorization';
  roles: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type MarketplaceAdminExportResult = {
  __typename?: 'MarketplaceAdminExportResult';
  failures: Array<Maybe<Scalars['String']['output']>>;
  numberOfObjects: Scalars['Int']['output'];
};

export type MarketplaceAdminExportTaxonomyResult = {
  __typename?: 'MarketplaceAdminExportTaxonomyResult';
  numberOfCategories: Scalars['Int']['output'];
};

export type MarketplaceAdminMutation = {
  __typename?: 'MarketplaceAdminMutation';
  authorization: MarketplaceAdminAuthorization;
  exportOffers: Maybe<MarketplaceAdminExportResult>;
  exportProducts: Maybe<MarketplaceAdminExportResult>;
  exportShops: Maybe<MarketplaceAdminExportResult>;
  exportTaxonomy: Maybe<MarketplaceAdminExportTaxonomyResult>;
  /** @deprecated Pending replacement with more flexible interface */
  updateAlgolia: Maybe<MarketplaceAdminAlgoliaIndexingResult>;
};


export type MarketplaceAdminMutationExportOffersArgs = {
  includeInactiveOffers: InputMaybe<Scalars['Boolean']['input']>;
  lastRequestDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type MarketplaceAdminMutationExportProductsArgs = {
  updatedSince: InputMaybe<Scalars['DateTime']['input']>;
};


export type MarketplaceAdminMutationExportShopsArgs = {
  updatedSince: InputMaybe<Scalars['DateTime']['input']>;
};

export type MarketplaceAdminQuery = {
  __typename?: 'MarketplaceAdminQuery';
  authorization: MarketplaceAdminAuthorization;
};

export type MarketplaceBrandsAndCategoriesResult = {
  __typename?: 'MarketplaceBrandsAndCategoriesResult';
  /** list of category codes (slugs) which contain brands starting with the filter section criteria */
  activeCategories: Array<Scalars['String']['output']>;
  /** list of brand sections (A, B, C, ..., 0-9) which contain brands that match the filter category criteria */
  activeSections: Array<Scalars['String']['output']>;
  /** list of brands matching the filter criteria */
  brands: Array<MarketplaceProductsSearchResultBrand>;
  /** list of top level categories containing products with a brand */
  categories: Array<MarketplaceCategoryPathElement>;
};

/** Marketplace cart item */
export type MarketplaceCartItem = {
  __typename?: 'MarketplaceCartItem';
  /** The brand name of the product item in the cart. */
  brand: Maybe<Scalars['String']['output']>;
  /** The category of the product item in the cart. */
  category: Maybe<MarketplaceCategory>;
  /** Cart item discount price */
  discountPrice: Maybe<Scalars['Float']['output']>;
  /** Available fulfilment types */
  fulfilmentTypes: Maybe<Array<Maybe<MarketplaceFulfilmentType>>>;
  /** The id of the cart item in the commerce platform. */
  id: Scalars['ID']['output'];
  /** The product image */
  image: Maybe<ProductImage>;
  issues: Array<Maybe<MarketplaceCartItemIssue>>;
  /** Cart item list price */
  listPrice: Scalars['Float']['output'];
  /** The name of the product item in the cart. */
  name: Maybe<Scalars['String']['output']>;
  /** Option values of this marketplace cart item */
  optionValues: Array<Maybe<MarketplaceCartItemOptionValue>>;
  promotions: Array<Maybe<MarketplaceCartItemPromotion>>;
  /** Amount of items in the cart */
  quantity: Maybe<Scalars['Int']['output']>;
  /** The shop details in the marketplace platform. */
  shop: MarketplaceShop;
  /** The SKU of the product in the marketplace platform. */
  sku: Scalars['String']['output'];
  variant: Maybe<MarketplaceProductVariant>;
  /** The variant group code if it exists */
  variantGroupCode: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCartItemIssue = {
  __typename?: 'MarketplaceCartItemIssue';
  severity: MarketplaceCartItemIssueSeverity;
  type: MarketplaceCartItemIssueType;
};

export enum MarketplaceCartItemIssueSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum MarketplaceCartItemIssueType {
  LowStock = 'LOW_STOCK',
  NotEnoughStock = 'NOT_ENOUGH_STOCK',
  OutOfStock = 'OUT_OF_STOCK'
}

export type MarketplaceCartItemOptionValue = {
  __typename?: 'MarketplaceCartItemOptionValue';
  displayName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  optionId: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCartItemPromotion = {
  __typename?: 'MarketplaceCartItemPromotion';
  campaignId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceCartParcel = {
  __typename?: 'MarketplaceCartParcel';
  cartId: Maybe<Scalars['String']['output']>;
  fulfilmentLocation: Maybe<Scalars['String']['output']>;
  fulfilmentType: MarketplaceFulfilmentType;
  index: Maybe<Scalars['Int']['output']>;
  items: Array<MarketplaceCartParcelItem>;
  shippingCost: Maybe<Scalars['Float']['output']>;
  shippingTypeCode: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCartParcelItem = {
  __typename?: 'MarketplaceCartParcelItem';
  cartId: Maybe<Scalars['String']['output']>;
  cartItemId: Scalars['String']['output'];
  effectivePrice: Scalars['Float']['output'];
  index: Maybe<Scalars['Int']['output']>;
  offerId: Scalars['String']['output'];
  /** @deprecated use effectivePrice */
  offerPrice: Scalars['Float']['output'];
  parcelIndex: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
};

export type MarketplaceCategory = {
  __typename?: 'MarketplaceCategory';
  children: Array<MarketplaceCategory>;
  content: Maybe<SgcfDirectCategory>;
  googleCategoryId: Maybe<Scalars['String']['output']>;
  parent: Maybe<MarketplaceCategory>;
  path: Array<MarketplaceCategoryPathElement>;
  productTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
};

export type MarketplaceCategoryPathElement = {
  __typename?: 'MarketplaceCategoryPathElement';
  code: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MarketplaceCentreFulfilment = {
  __typename?: 'MarketplaceCentreFulfilment';
  cartItemsAvailable: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceCouponEligible = {
  __typename?: 'MarketplaceCouponEligible';
  campaignId: Scalars['String']['output'];
  code: Scalars['String']['output'];
};

export type MarketplaceCouponExpired = {
  __typename?: 'MarketplaceCouponExpired';
  campaignId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  errorCode: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCouponIneligible = {
  __typename?: 'MarketplaceCouponIneligible';
  campaignId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCouponInvalid = {
  __typename?: 'MarketplaceCouponInvalid';
  code: Scalars['String']['output'];
  errorCode: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCouponV2 = MarketplaceCouponEligible | MarketplaceCouponExpired | MarketplaceCouponIneligible | MarketplaceCouponInvalid;

export type MarketplaceFulfilmentDayRange = {
  __typename?: 'MarketplaceFulfilmentDayRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export enum MarketplaceFulfilmentType {
  ClickAndCollect = 'CLICK_AND_COLLECT',
  Delivery = 'DELIVERY'
}

export type MarketplaceInfoField = {
  __typename?: 'MarketplaceInfoField';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MarketplaceItem = {
  __typename?: 'MarketplaceItem';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  data: Maybe<IWestfieldDirectItemData>;
  destination: Maybe<Scalars['String']['output']>;
  digitalGiftCards: Array<CommerceAdminDigitalGiftCard>;
  id: Scalars['ID']['output'];
  itemIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  logisticOrderId: Maybe<Scalars['ID']['output']>;
  miraklOrderLineState: Maybe<MiraklOrderLineState>;
  name: Maybe<Scalars['String']['output']>;
  order: CommerceAdminOrder;
  originalPriceIncTax: Scalars['Float']['output'];
  priceExTax: Scalars['Float']['output'];
  priceIncTax: Scalars['Float']['output'];
  priceTax: Scalars['Float']['output'];
  promotions: Maybe<Array<MarketplaceCartItemPromotion>>;
  quantity: Scalars['Int']['output'];
  refunds: Maybe<Array<Maybe<MarketplaceRefund>>>;
  returnable: Maybe<Scalars['Boolean']['output']>;
  shippedItemIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  shop: Maybe<MarketplaceShop>;
  sourceLocation: Maybe<Scalars['String']['output']>;
  status: Maybe<MarketplaceItemStatus>;
  updatedAt: Scalars['Date']['output'];
  /** The product variant details of an item */
  variant: Maybe<MarketplaceProductVariant>;
  vendorItemId: Scalars['String']['output'];
  waitingOn: Maybe<Scalars['String']['output']>;
};

/** Marketplace product to add to a cart. */
export type MarketplaceItemInput = {
  /** The quantity of the product to add to the cart. */
  quantity: Scalars['Int']['input'];
  /** The shop id in the marketplace platform. */
  shopId: Scalars['Int']['input'];
  /** The SKU of the product in the marketplace platform. */
  sku: Scalars['String']['input'];
};

export enum MarketplaceItemStatus {
  Collected = 'COLLECTED',
  ItemInTransit = 'ITEM_IN_TRANSIT',
  Packed = 'PACKED'
}

export type MarketplaceOrder = {
  __typename?: 'MarketplaceOrder';
  billingAddress: Maybe<Address>;
  cashback: Maybe<MarketplaceOrderCashbackTransaction>;
  /** @deprecated coupons */
  coupon: Maybe<Scalars['String']['output']>;
  coupons: Maybe<Array<Maybe<MarketplaceCouponEligible>>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  parcels: Array<ParcelWithItems>;
  payment: Maybe<PaymentIntent>;
  paymentMethod: Scalars['String']['output'];
  /** @deprecated compute in client using original price */
  promotionalDiscount: Maybe<Scalars['Float']['output']>;
  promotions: Maybe<Array<MarketplaceCartItemPromotion>>;
  scentregroupId: Maybe<Scalars['String']['output']>;
  shippingAddress: Maybe<Address>;
  status: Scalars['String']['output'];
  totalIncTax: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MarketplaceOrderCashbackTransaction = {
  __typename?: 'MarketplaceOrderCashbackTransaction';
  provider: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type MarketplaceOrderParcel = {
  __typename?: 'MarketplaceOrderParcel';
  fulfilmentOption: MarketplaceParcelFulfilmentOption;
  id: Scalars['ID']['output'];
  items: Array<MarketplaceCartItem>;
  status: Scalars['String']['output'];
};

export type MarketplaceOrderRefund = {
  __typename?: 'MarketplaceOrderRefund';
  amount: Maybe<Scalars['Float']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  orderLineId: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  reasonCode: Maybe<Scalars['String']['output']>;
  refundId: Maybe<Scalars['String']['output']>;
  shippingAmount: Maybe<Scalars['Float']['output']>;
  shippingTaxes: Maybe<Array<Maybe<MarketplaceOrderTaxResp>>>;
  taxes: Maybe<Array<Maybe<MarketplaceOrderTaxResp>>>;
};

export type MarketplaceOrderRefundResponse = {
  __typename?: 'MarketplaceOrderRefundResponse';
  orderTaxMode: Maybe<Scalars['String']['output']>;
  refunds: Maybe<Array<Maybe<MarketplaceOrderRefund>>>;
};

export type MarketplaceOrderReturnInput = {
  centre: Scalars['String']['input'];
  orderLineId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  reasonCode: Scalars['String']['input'];
};

export type MarketplaceOrderTaxResp = {
  __typename?: 'MarketplaceOrderTaxResp';
  amount: Scalars['Float']['output'];
  code: Maybe<Scalars['String']['output']>;
  rate: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceParcel = {
  __typename?: 'MarketplaceParcel';
  availableFulfilmentOptions: Array<Maybe<MarketplaceParcelFulfilmentOption>>;
  fulfilmentType: MarketplaceFulfilmentType;
  id: Scalars['ID']['output'];
  items: Array<MarketplaceCartItem>;
  selectedFulfilmentOption: Maybe<MarketplaceParcelFulfilmentOption>;
};

export type MarketplaceParcelFulfilmentOption = {
  __typename?: 'MarketplaceParcelFulfilmentOption';
  cost: Maybe<Scalars['Float']['output']>;
  fulfilmentDayRange: MarketplaceFulfilmentDayRange;
  fulfilmentType: MarketplaceFulfilmentType;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type MarketplaceProduct = {
  __typename?: 'MarketplaceProduct';
  brand: Maybe<Scalars['String']['output']>;
  careInstructions: Maybe<Scalars['String']['output']>;
  category: MarketplaceCategory;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Field no longer supported */
  info: Array<Maybe<MarketplaceInfoField>>;
  options: Array<Maybe<MarketplaceProductOption>>;
  /** @deprecated Field no longer supported */
  returnable: Maybe<Scalars['Boolean']['output']>;
  shop: MarketplaceShop;
  title: Scalars['String']['output'];
  variants: Array<Maybe<MarketplaceProductVariant>>;
  warnings: Maybe<Scalars['String']['output']>;
  warranty: Maybe<Scalars['String']['output']>;
};

export type MarketplaceProductFacet = {
  __typename?: 'MarketplaceProductFacet';
  id: Scalars['ID']['output'];
  options: Array<Maybe<MarketplaceProductFacetOption>>;
  searchFieldPlaceholder: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: MarketplaceProductFacetType;
};


export type MarketplaceProductFacetOptionsArgs = {
  search: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceProductFacetOption = {
  __typename?: 'MarketplaceProductFacetOption';
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export enum MarketplaceProductFacetType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE'
}

export type MarketplaceProductImage = {
  __typename?: 'MarketplaceProductImage';
  description: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MarketplaceProductInformationEntry = MarketplaceProductInformationTable | MarketplaceProductInformationText;

export type MarketplaceProductInformationTable = {
  __typename?: 'MarketplaceProductInformationTable';
  entries: Maybe<Array<Maybe<MarketplaceProductInformationTableEntry>>>;
  label: Scalars['String']['output'];
};

export type MarketplaceProductInformationTableEntry = {
  __typename?: 'MarketplaceProductInformationTableEntry';
  label: Scalars['String']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type MarketplaceProductInformationText = {
  __typename?: 'MarketplaceProductInformationText';
  label: Scalars['String']['output'];
  text: Maybe<Scalars['String']['output']>;
};

export type MarketplaceProductOption = {
  __typename?: 'MarketplaceProductOption';
  displayName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductOptionType>;
  values: Maybe<Array<Maybe<MarketplaceProductOptionValue>>>;
  visualGuide: Maybe<MarketplaceVisualGuide>;
};

export enum MarketplaceProductOptionType {
  Dropdown = 'DROPDOWN'
}

export type MarketplaceProductOptionValue = {
  __typename?: 'MarketplaceProductOptionValue';
  colourHexCode: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type MarketplaceProductPromotion = {
  __typename?: 'MarketplaceProductPromotion';
  campaignId: Scalars['String']['output'];
  directPromotion: Maybe<SgcfDirectPromotion>;
  title: Scalars['String']['output'];
};

export type MarketplaceProductSpecifier = {
  id: Scalars['ID']['input'];
  shop: Scalars['Int']['input'];
};

export type MarketplaceProductVariant = {
  __typename?: 'MarketplaceProductVariant';
  brand: Maybe<Scalars['String']['output']>;
  category: Maybe<MarketplaceCategory>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  dangerousGoods: Maybe<Scalars['Boolean']['output']>;
  discountPrice: Maybe<Scalars['Float']['output']>;
  effectivePrice: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images: Array<Maybe<MarketplaceProductImage>>;
  information: Array<Maybe<MarketplaceProductInformationEntry>>;
  issues: Maybe<Array<Maybe<Issue>>>;
  objectID: Scalars['String']['output'];
  optionValues: Array<Maybe<MarketplaceProductVariantOption>>;
  originalPrice: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use 'originalPrice' and 'discountPrice' */
  price: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  returnable: Maybe<Scalars['Boolean']['output']>;
  sku: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variantGroupCode: Maybe<Scalars['String']['output']>;
};

export type MarketplaceProductVariantOption = {
  __typename?: 'MarketplaceProductVariantOption';
  displayName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  optionId: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type MarketplaceProductsFilter = {
  AND: InputMaybe<Array<MarketplaceProductsFilter>>;
  OR: InputMaybe<Array<MarketplaceProductsFilter>>;
  numeric: InputMaybe<MarketplaceProductsNumericFilter>;
  string: InputMaybe<MarketplaceProductsStringFilter>;
};

export type MarketplaceProductsNumericFilter = {
  attribute: Scalars['String']['input'];
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
};

export type MarketplaceProductsSearch = {
  __typename?: 'MarketplaceProductsSearch';
  count: Scalars['Int']['output'];
  indexName: Maybe<Scalars['String']['output']>;
  queryID: Maybe<Scalars['String']['output']>;
  results: Array<Maybe<MarketplaceProductsSearchResult>>;
};

export type MarketplaceProductsSearchInput = {
  filter: InputMaybe<MarketplaceProductsFilter>;
  order: MarketplaceProductsSearchOrder;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  query: InputMaybe<Scalars['String']['input']>;
};

export enum MarketplaceProductsSearchOrder {
  AlphaAsc = 'ALPHA_ASC',
  AlphaDesc = 'ALPHA_DESC',
  BrandAlphaAsc = 'BRAND_ALPHA_ASC',
  BrandAlphaDesc = 'BRAND_ALPHA_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Recent = 'RECENT',
  Recommended = 'RECOMMENDED',
  RecommendedBalanced = 'RECOMMENDED_BALANCED',
  RecommendedCombinedAnalytics = 'RECOMMENDED_COMBINED_ANALYTICS',
  RecommendedCombinedNoisy = 'RECOMMENDED_COMBINED_NOISY',
  RecommendedConversionBased = 'RECOMMENDED_CONVERSION_BASED',
  RecommendedCtrBased = 'RECOMMENDED_CTR_BASED'
}

export type MarketplaceProductsSearchResult = {
  __typename?: 'MarketplaceProductsSearchResult';
  brand: Maybe<MarketplaceProductsSearchResultBrand>;
  category: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categoryTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<Scalars['String']['output']>;
  issues: Maybe<Array<Maybe<Issue>>>;
  name: Scalars['String']['output'];
  objectID: Scalars['String']['output'];
  otherVariants: Array<MarketplaceProductsSearchResultVariant>;
  shop: MarketplaceShop;
  variant: MarketplaceProductsSearchResultVariant;
  variantGroupCode: Scalars['String']['output'];
};

export type MarketplaceProductsSearchResultBrand = {
  __typename?: 'MarketplaceProductsSearchResultBrand';
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type MarketplaceProductsSearchResultVariant = {
  __typename?: 'MarketplaceProductsSearchResultVariant';
  onSale: Scalars['Boolean']['output'];
  price: Maybe<MarketplaceProductsSearchResultVariantPrice>;
  shop: MarketplaceShop;
  sku: Scalars['String']['output'];
};

export type MarketplaceProductsSearchResultVariantPrice = {
  __typename?: 'MarketplaceProductsSearchResultVariantPrice';
  discountedPrice: Maybe<Scalars['Float']['output']>;
  effectivePrice: Scalars['Float']['output'];
  originalPrice: Scalars['Float']['output'];
};

export type MarketplaceProductsStringFilter = {
  attribute: Scalars['String']['input'];
  match: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceRefund = {
  __typename?: 'MarketplaceRefund';
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use miraklCreatedAt instead */
  createdDate: Scalars['DateTime']['output'];
  miraklCreatedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  return: Maybe<MarketplaceReturn>;
  state: MiraklRefundState;
  totalIncTax: Scalars['Float']['output'];
};

export type MarketplaceRefundReason = {
  __typename?: 'MarketplaceRefundReason';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type MarketplaceReturn = {
  __typename?: 'MarketplaceReturn';
  centre: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MarketplaceShippingConfiguration = {
  __typename?: 'MarketplaceShippingConfiguration';
  /** @deprecated free shipping no longer available */
  freeShippingThreshold: Scalars['Float']['output'];
  shippingCost: Scalars['Float']['output'];
};

export type MarketplaceShop = {
  __typename?: 'MarketplaceShop';
  /** The shop id */
  id: Scalars['Int']['output'];
  /** The shop name */
  name: Maybe<Scalars['String']['output']>;
  /** The retailer associated with this shop */
  retailer: Maybe<SgcfRetailer>;
  /** Open/closed state of this shop based on 'Closed from/to' dates */
  tradingState: MarketplaceShopTradingState;
};

export enum MarketplaceShopTradingState {
  Closed = 'CLOSED',
  ClosedPermanently = 'CLOSED_PERMANENTLY',
  Open = 'OPEN'
}

export type MarketplaceVisualGuide = {
  __typename?: 'MarketplaceVisualGuide';
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  body: Maybe<Scalars['String']['output']>;
  notificationType: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export enum MiraklOrderLineState {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  IncidentClosed = 'INCIDENT_CLOSED',
  IncidentOpen = 'INCIDENT_OPEN',
  PaymentCollected = 'PAYMENT_COLLECTED',
  Received = 'RECEIVED',
  Refunded = 'REFUNDED',
  Refused = 'REFUSED',
  Shipped = 'SHIPPED',
  Shipping = 'SHIPPING',
  Staging = 'STAGING',
  ToCollect = 'TO_COLLECT',
  WaitingAcceptance = 'WAITING_ACCEPTANCE',
  WaitingDebit = 'WAITING_DEBIT',
  WaitingDebitPayment = 'WAITING_DEBIT_PAYMENT'
}

export enum MiraklRefundState {
  Refunded = 'REFUNDED',
  WaitingRefund = 'WAITING_REFUND',
  WaitingRefundPayment = 'WAITING_REFUND_PAYMENT'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Decimal']['output'];
  currency: CurrencyCode;
};

export type Movie = {
  __typename?: 'Movie';
  classification: Maybe<Classification>;
  genres: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  sessions: Maybe<Array<Session>>;
  synopsis: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptSharePlateInvite: GenericOutput;
  acceptWestfieldPlusTermsAndConditions: Maybe<Scalars['Boolean']['output']>;
  activateDigitalGiftCard: DigitalGiftCard;
  addLoyaltyProgramMembership: LoyaltyProgramMembership;
  addParkingSavedCardIframe: Maybe<AddSavedCardIframe>;
  addPlate: GenericOutput;
  /** Add a product to a cart */
  addProductToCart: CartOrError;
  /** This the entry point for administration mutations. It requires an Azure JWT to access this and all fields below */
  admin: CommerceAdminMutation;
  applyParkingCinemaValidation: GenericOutput;
  /** Claim a partner coupon code. */
  claimPartnerCouponCode: ClaimPartnerCouponCodeResult;
  claimPasswordResetToken: Maybe<Scalars['Boolean']['output']>;
  /** Claim a promotion reward. */
  claimPromotionReward: Maybe<ClaimPromotionRewardOutput>;
  /** Activate an offer according to the cloOfferId. */
  cloActivateOffer: Maybe<CloUpdateResponse>;
  /** Returns the token required to register a new card with the CLO provider */
  cloGetAddCardToken: Maybe<CloAddCardTokenResponse>;
  /** Remove a linked card using the card token */
  cloRemoveLinkedCard: Maybe<CloUpdateResponse>;
  competitionAdmin: CompetitionAdminMutation;
  createCustomerPassword: Maybe<Scalars['Boolean']['output']>;
  /** Capture billing details and create order */
  createOrder: Maybe<CheckoutOrder>;
  createPasswordReset: Maybe<Scalars['Boolean']['output']>;
  deleteCustomerMobileNumber: Maybe<Scalars['Boolean']['output']>;
  deletePendingEmailChange: Maybe<Scalars['Boolean']['output']>;
  /** Enter a competition. */
  enterCompetition: Maybe<PromotionOutput>;
  /** Enter a instant door draw */
  enterInstantDraw: InstantDrawResponse;
  experiencePackagesAdmin: ExperiencePackagesAdminMutation;
  generateDigitalGiftCardPIN: DigitalGiftCardPin;
  incrementLoyaltyProgramMembershipViewCount: Maybe<LoyaltyProgramMembership>;
  /** Add third-party cashback transaction */
  marketplaceAddCashbackTransaction: CashbackTransaction;
  marketplaceAdmin: Maybe<MarketplaceAdminMutation>;
  /** Apply promo code */
  marketplaceApplyCouponCode: MarketplaceCouponV2;
  /** @deprecated Field no longer supported */
  optInMarketing: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  optOutMarketing: Maybe<Scalars['Boolean']['output']>;
  parkPlusTransition: Maybe<Scalars['Boolean']['output']>;
  /**
   * Remove a Membership to a LoyaltyProgram for a user.
   * Returns the removed Membership
   */
  removeLoyaltyProgramMembership: LoyaltyProgramMembership;
  removeParkingSavedCard: GenericOutput;
  /** Removes a payment method */
  removePaymentMethod: Maybe<CreditCard>;
  removePlate: GenericOutput;
  /** Remove a product from a cart */
  removeProductFromCart: Maybe<CartOrError>;
  /** Removes a stored address */
  removeStoredAddress: Maybe<AddressDetails>;
  resendVerificationLink: Maybe<Scalars['Boolean']['output']>;
  /** Saves a new address if no ID is supplied, or updates an existing address if there is an ID */
  saveAddress: Maybe<AddressDetails>;
  /** Saves a new, or updates an existing, payment method */
  savePaymentMethod: Maybe<CreditCard>;
  saveWalletReference: WalletReference;
  /** Sets the payment method as default */
  setDefaultPaymentMethod: Maybe<CreditCard>;
  sharePlate: SharePlateOutput;
  submitInstantEarn: InstantEarnResponse;
  unsharePlate: GenericOutput;
  unsubscribeCustomerWithEmail: Maybe<Scalars['Boolean']['output']>;
  unsubscribeCustomerWithPreferencesToken: Maybe<Scalars['Boolean']['output']>;
  /** Update an item in a cart */
  updateCartItem: CartOrError;
  updateCustomerConsent: Maybe<Consent>;
  updateCustomerDetails: Maybe<Scalars['Boolean']['output']>;
  updateCustomerMobileNumber: Maybe<Scalars['Boolean']['output']>;
  updateCustomerNameOnAllBillingAddresses: Maybe<Scalars['Boolean']['output']>;
  updateCustomerPreferences: Maybe<Preference>;
  updateCustomerPrimaryCentre: Maybe<Scalars['Boolean']['output']>;
  updateDigitalGiftCardDisplayStatus: DigitalGiftCard;
  updateLoyaltyProgramMembership: Maybe<LoyaltyProgramMembership>;
  valetPickup: GenericOutput;
  verifyCustomerMobileNumber: Maybe<Scalars['Boolean']['output']>;
  verifyPasswordResetToken: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptSharePlateInviteArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptWestfieldPlusTermsAndConditionsArgs = {
  input: TermsAndConditionsInput;
};


export type MutationActivateDigitalGiftCardArgs = {
  input: ActivateDigitalGiftCardInput;
};


export type MutationAddLoyaltyProgramMembershipArgs = {
  input: AddLoyaltyProgramMembershipInput;
};


export type MutationAddParkingSavedCardIframeArgs = {
  callbackUrl: Scalars['String']['input'];
};


export type MutationAddPlateArgs = {
  input: AddPlateInput;
};


export type MutationAddProductToCartArgs = {
  input: AddProductToCartInput;
};


export type MutationApplyParkingCinemaValidationArgs = {
  input: ApplyParkingCinemaValidation;
};


export type MutationClaimPartnerCouponCodeArgs = {
  input: ClaimPartnerCouponCodeInput;
};


export type MutationClaimPasswordResetTokenArgs = {
  input: ClaimPasswordResetTokenInput;
};


export type MutationClaimPromotionRewardArgs = {
  input: InputMaybe<ClaimPromotionRewardInput>;
};


export type MutationCloActivateOfferArgs = {
  cloOfferId: Scalars['String']['input'];
};


export type MutationCloRemoveLinkedCardArgs = {
  cardToken: Scalars['String']['input'];
};


export type MutationCreateCustomerPasswordArgs = {
  input: CustomerPasswordInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreatePasswordResetArgs = {
  input: CreatePasswordResetInput;
};


export type MutationEnterCompetitionArgs = {
  input: InputMaybe<EnterCompetitionInput>;
};


export type MutationEnterInstantDrawArgs = {
  input: EnterInstantDrawInput;
};


export type MutationGenerateDigitalGiftCardPinArgs = {
  input: GenerateDigitalGiftCardPinInput;
};


export type MutationIncrementLoyaltyProgramMembershipViewCountArgs = {
  input: IncrementLoyaltyProgramMembershipViewCountInput;
};


export type MutationMarketplaceAddCashbackTransactionArgs = {
  cashbackProvider: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type MutationMarketplaceApplyCouponCodeArgs = {
  couponCode: Scalars['String']['input'];
};


export type MutationParkPlusTransitionArgs = {
  input: ParkPlusTransitionInput;
};


export type MutationRemoveLoyaltyProgramMembershipArgs = {
  input: RemoveLoyaltyProgramMembershipInput;
};


export type MutationRemovePaymentMethodArgs = {
  input: RemovePaymentMethodInput;
};


export type MutationRemovePlateArgs = {
  input: RemovePlateInput;
};


export type MutationRemoveProductFromCartArgs = {
  input: RemoveProductFromCartInput;
};


export type MutationRemoveStoredAddressArgs = {
  input: RemoveStoredAddressInput;
};


export type MutationSaveAddressArgs = {
  input: SaveAddressInput;
};


export type MutationSavePaymentMethodArgs = {
  input: SavePaymentMethodInput;
};


export type MutationSaveWalletReferenceArgs = {
  input: SaveWalletReferenceInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  input: SetDefaultPaymentMethodInput;
};


export type MutationSharePlateArgs = {
  input: SharePlateInput;
};


export type MutationSubmitInstantEarnArgs = {
  input: SubmitInstantEarnInput;
};


export type MutationUnsharePlateArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnsubscribeCustomerWithEmailArgs = {
  input: UnsubscribeCustomerWithEmailInput;
};


export type MutationUnsubscribeCustomerWithPreferencesTokenArgs = {
  input: UnsubscribeCustomerWithPreferencesTokenInput;
};


export type MutationUpdateCartItemArgs = {
  input: EditProductInput;
};


export type MutationUpdateCustomerConsentArgs = {
  input: UpdateCustomerConsentInput;
};


export type MutationUpdateCustomerDetailsArgs = {
  input: CustomerDetailsInput;
};


export type MutationUpdateCustomerMobileNumberArgs = {
  input: CustomerMobileNumberInput;
};


export type MutationUpdateCustomerNameOnAllBillingAddressesArgs = {
  input: UpdateBillingAddressesNameInput;
};


export type MutationUpdateCustomerPreferencesArgs = {
  input: UpdateCustomerPreferencesInput;
};


export type MutationUpdateCustomerPrimaryCentreArgs = {
  input: CustomerPrimaryCentreInput;
};


export type MutationUpdateDigitalGiftCardDisplayStatusArgs = {
  input: UpdateDigitalGiftCardDisplayStatusInput;
};


export type MutationUpdateLoyaltyProgramMembershipArgs = {
  input: UpdateLoyaltyProgramMembershipInput;
};


export type MutationValetPickupArgs = {
  input: ValetPickupInput;
};


export type MutationVerifyCustomerMobileNumberArgs = {
  input: VerifyMobileNumberInput;
};


export type MutationVerifyPasswordResetTokenArgs = {
  input: VerifyPasswordResetTokenInput;
};

export type NotActiveDigitalGiftCard = {
  __typename?: 'NotActiveDigitalGiftCard';
  /** The native currency of the card. */
  currency: CurrencyCode;
  /** The original delivery date. */
  deliveryDate: Scalars['Date']['output'];
  /** The expiry date applying to the card. */
  expirationDate: Scalars['Date']['output'];
  /** The expiry date in M-YYYY format. */
  expirationDateFormatted: Scalars['String']['output'];
  /** The message attached to the digital gift card purchase. */
  message: Maybe<Scalars['String']['output']>;
  /** Digital Gift Card obstucated pan. */
  pan: Scalars['String']['output'];
  /** The recipient email where the email was sent. */
  recipientName: Maybe<Scalars['String']['output']>;
  /** Card's reference number */
  referenceNumber: Scalars['String']['output'];
  /** The sender name. */
  senderName: Maybe<Scalars['String']['output']>;
  /** The initial value on the card in its native currency. */
  value: Scalars['Decimal']['output'];
};

export type OccurrenceBookingInfo = {
  __typename?: 'OccurrenceBookingInfo';
  availableTickets: Scalars['Int']['output'];
  bookableId: Scalars['String']['output'];
  isBookingClosed: Scalars['Boolean']['output'];
  occurrenceId: Scalars['String']['output'];
  price: Money;
};

export type OccurrenceForBookingInquiry = {
  id: Scalars['String']['input'];
  startAt: Scalars['String']['input'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  web: Maybe<WebOnboarding>;
};

export type Order = {
  __typename?: 'Order';
  billingAddress: Maybe<Address>;
  category: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  items: Array<CartItem>;
  orderAmount: Scalars['Float']['output'];
  orderReference: Scalars['String']['output'];
  parcels: Maybe<Array<Maybe<MarketplaceOrderParcel>>>;
  paymentMethod: Scalars['String']['output'];
  paymentStatus: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderClearanceInput = {
  cartReference: Scalars['String']['input'];
  newStatus: OrderStatusInput;
  total: Scalars['Float']['input'];
};

/**
 * An OrderCollection represents a page of order search results.
 * The next page to fetch would have a skip value of total + skip + 1.
 */
export type OrderCollection = {
  __typename?: 'OrderCollection';
  /** The items returned by the Order search */
  items: Array<Order>;
  /** Zero-indexed offset in the collection from which items are fetched */
  skip: Scalars['Int']['output'];
  /** The total number of items returned from the collection */
  total: Scalars['Int']['output'];
};

/** This input type holds paging, filtering and ordering criteria for an Order search. */
export type OrderCollectionInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sort: InputMaybe<Array<InputMaybe<OrderSorting>>>;
  where: InputMaybe<OrderFilter>;
};

/** Filter criteria for an Order search. */
export type OrderFilter = {
  AND: InputMaybe<Array<OrderFilter>>;
  OR: InputMaybe<Array<OrderFilter>>;
  category: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  items: InputMaybe<CartItemFilter>;
  orderAmount: InputMaybe<Scalars['Float']['input']>;
  paymentMethod: InputMaybe<Scalars['String']['input']>;
  paymentStatus: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
};

/**
 * An ItemCollection represents a page of item search results.
 * The next page to fetch would have a skip value of total + skip + 1.
 */
export enum OrderItemStatus {
  Collected = 'COLLECTED',
  ItemInTransit = 'ITEM_IN_TRANSIT',
  Packed = 'PACKED'
}

export type OrderNote = {
  __typename?: 'OrderNote';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputType: OrderNoteType;
  note: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
};

export enum OrderNoteType {
  Manual = 'MANUAL',
  StatusUpdate = 'STATUS_UPDATE'
}

export type OrderReviewInput = {
  cartReference: Scalars['String']['input'];
  newStatus: OrderStatusInput;
  total: Scalars['Float']['input'];
};

export enum OrderReviewResponseStatus {
  Approved = 'APPROVED',
  ClearanceDeclined = 'CLEARANCE_DECLINED',
  NotCleared = 'NOT_CLEARED',
  NotReviewed = 'NOT_REVIEWED',
  ReviewDeclined = 'REVIEW_DECLINED'
}

export type OrderReviewResult = {
  __typename?: 'OrderReviewResult';
  cartReference: Scalars['String']['output'];
  clearedBy: Maybe<Scalars['String']['output']>;
  reviewedBy: Scalars['String']['output'];
  status: OrderReviewResponseStatus;
  submittedBy: Scalars['String']['output'];
};

/** Sort order criter for an Order search. */
export enum OrderSorting {
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  OrderAmountAsc = 'orderAmount_ASC',
  OrderAmountDesc = 'orderAmount_DESC',
  PaymentMethodAsc = 'paymentMethod_ASC',
  PaymentMethodDesc = 'paymentMethod_DESC',
  PaymentStatusAsc = 'paymentStatus_ASC',
  PaymentStatusDesc = 'paymentStatus_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC'
}

export enum OrderStatusInput {
  Approved = 'APPROVED',
  Declined = 'DECLINED'
}

export enum OrderType {
  DigitalGiftCard = 'DIGITAL_GIFT_CARD',
  DigitalGiftCardBulk = 'DIGITAL_GIFT_CARD_BULK'
}

export type OrderTypeFilter = {
  is: InputMaybe<OrderType>;
};

export type Parcel = {
  __typename?: 'Parcel';
  collectedAt: Maybe<Scalars['DateTime']['output']>;
  commercialOrderId: Maybe<Scalars['String']['output']>;
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  fulfilmentLocation: Maybe<Scalars['String']['output']>;
  fulfilmentType: Maybe<MarketplaceFulfilmentType>;
  id: Maybe<Scalars['String']['output']>;
  status: Maybe<ParcelStatus>;
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export enum ParcelStatus {
  Collected = 'COLLECTED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  ReadyToBeCollected = 'READY_TO_BE_COLLECTED',
  Refunded = 'REFUNDED',
  Rejected = 'REJECTED',
  Shipped = 'SHIPPED',
  WaitingAcceptance = 'WAITING_ACCEPTANCE'
}

export type ParcelWithItems = {
  __typename?: 'ParcelWithItems';
  centre: Maybe<CfCentre>;
  centreServicePageURL: Maybe<Scalars['String']['output']>;
  centreTitle: Maybe<Scalars['String']['output']>;
  collectedAt: Maybe<Scalars['DateTime']['output']>;
  commercialOrderId: Maybe<Scalars['String']['output']>;
  confirmedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  deliveredAt: Maybe<Scalars['DateTime']['output']>;
  fulfilmentDayRange: Maybe<MarketplaceFulfilmentDayRange>;
  fulfilmentLocation: Maybe<Scalars['String']['output']>;
  fulfilmentType: Maybe<MarketplaceFulfilmentType>;
  hasRefund: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  /** Grouped and filtered items in this parcel */
  items: Array<MarketplaceItem>;
  shippingCost: Scalars['Float']['output'];
  status: Maybe<ParcelStatus>;
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export type ParkPlusTransitionInput = {
  customerChoice: Scalars['String']['input'];
};

export type ParkingOwnedVehicle = ParkingVehicle & {
  __typename?: 'ParkingOwnedVehicle';
  isPrimary: Scalars['Boolean']['output'];
  parkerType: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  registeredIn: Scalars['String']['output'];
  shares: Maybe<Array<VehicleShare>>;
  type: ParkingVehicleType;
};

export type ParkingProfile = {
  __typename?: 'ParkingProfile';
  disabled: Maybe<Scalars['Boolean']['output']>;
  homeCentre: Maybe<Scalars['String']['output']>;
  parkerType: Scalars['String']['output'];
  retailer: Maybe<ParkingRetailer>;
  savedCard: Maybe<ParkingSavedCard>;
  vehicles: Array<ParkingVehicle>;
};

export type ParkingRetailer = {
  __typename?: 'ParkingRetailer';
  centreId: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  storeId: Maybe<Scalars['Int']['output']>;
};

export type ParkingSavedCard = {
  __typename?: 'ParkingSavedCard';
  cardType: Maybe<Scalars['String']['output']>;
  expiryMonth: Maybe<Scalars['Int']['output']>;
  expiryYear: Maybe<Scalars['Int']['output']>;
  partCardNumber: Maybe<Scalars['String']['output']>;
};

export type ParkingSession = {
  __typename?: 'ParkingSession';
  baseFreeParkingDurationInMinutes: Scalars['Int']['output'];
  carparkId: Maybe<Scalars['String']['output']>;
  discounts: Maybe<Array<ParkingSessionDiscount>>;
  enteredAt: Scalars['DateTime']['output'];
  enteredDeviceId: Maybe<Scalars['String']['output']>;
  freeParkingEndAt: Maybe<Scalars['DateTime']['output']>;
  freeParkingReason: Maybe<Scalars['String']['output']>;
  freeParkingStartAt: Maybe<Scalars['DateTime']['output']>;
  lastPaidAt: Maybe<Scalars['DateTime']['output']>;
  owedAmount: Maybe<Scalars['Float']['output']>;
  owedCurrency: Maybe<Scalars['String']['output']>;
  paidAmount: Maybe<Scalars['Float']['output']>;
  paidCurrency: Maybe<Scalars['String']['output']>;
  parkerType: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  plate: Scalars['String']['output'];
  tariffName: Maybe<Scalars['String']['output']>;
  tariffSchedule: Maybe<Array<Maybe<ParkingTariff>>>;
  timerNotificationOn: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<ParkingSessionType>;
  valetCheckedInAt: Maybe<Scalars['DateTime']['output']>;
  valetStatus: Maybe<Scalars['String']['output']>;
  valetTicketNumber: Maybe<Scalars['String']['output']>;
};

export type ParkingSessionDiscount = {
  __typename?: 'ParkingSessionDiscount';
  name: Scalars['String']['output'];
};

export enum ParkingSessionPaymentMethod {
  AutoCard = 'AUTO_CARD',
  Paystation = 'PAYSTATION'
}

export enum ParkingSessionType {
  Owned = 'owned',
  Shared = 'shared',
  Valet = 'valet'
}

export type ParkingSharedVehicle = ParkingVehicle & {
  __typename?: 'ParkingSharedVehicle';
  hasPaymentMethod: Scalars['Boolean']['output'];
  parkerType: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  registeredIn: Scalars['String']['output'];
  share: Maybe<VehicleShare>;
  type: ParkingVehicleType;
};

export type ParkingTariff = {
  __typename?: 'ParkingTariff';
  charge: Money;
  parkedHours: Scalars['Float']['output'];
};

export type ParkingVehicle = {
  parkerType: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  registeredIn: Scalars['String']['output'];
  type: ParkingVehicleType;
};

export enum ParkingVehicleType {
  Owned = 'owned',
  Shared = 'shared'
}

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  cardType: Maybe<Scalars['String']['output']>;
  clientSecret: Scalars['String']['output'];
  expMonth: Maybe<Scalars['Int']['output']>;
  expYear: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  last4: Maybe<Scalars['String']['output']>;
  paymentMethodId: Maybe<Scalars['String']['output']>;
};

/** Direct rewards breakdown. */
export type PendingOrders = {
  __typename?: 'PendingOrders';
  balance: Scalars['Decimal']['output'];
  orders: Array<Maybe<DirectOrderReward>>;
};

/** Physical gift card item to add to a cart. */
export type PhysicalGiftCardItemInput = {
  /** The id of the product in the commerce platform. */
  id: Scalars['ID']['input'];
  /** The recipient's details. */
  recipientDetails: PhysicalGiftCardRecipientDetails;
  /** The SKU of the product in the commerce platform. */
  sku: Scalars['String']['input'];
  /** The value of the Gift Card. */
  value: Scalars['Float']['input'];
};

export type PhysicalGiftCardRecipientDetails = {
  message: Scalars['String']['input'];
  recipientAddress: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
};

/** Sender and recipient details for physical giftcard items */
export type PhysicalRecipientDetails = RecipientDetails & {
  __typename?: 'PhysicalRecipientDetails';
  message: Scalars['String']['output'];
  recipientAddress: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
};

export type Preference = {
  __typename?: 'Preference';
  communicationFrequency: Maybe<PreferenceCommunicationFrequency>;
  interests: Maybe<Array<PreferenceInterest>>;
  pauseCommunications: Maybe<Scalars['DateTime']['output']>;
  sendExclusiveOffers: Maybe<Scalars['Boolean']['output']>;
};

export enum PreferenceCommunicationFrequency {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type PreferenceInput = {
  communicationFrequency: InputMaybe<PreferenceCommunicationFrequency>;
  interests: InputMaybe<Array<PreferenceInterest>>;
  pauseCommunications: InputMaybe<Scalars['DateTime']['input']>;
  sendExclusiveOffers: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PreferenceInterest {
  Beauty = 'BEAUTY',
  Fashion = 'FASHION',
  Music = 'MUSIC',
  Sports = 'SPORTS',
  Travel = 'TRAVEL'
}

export type ProcessBulkFileRequest = {
  cartReference: Scalars['ID']['input'];
  validateOnly: InputMaybe<Scalars['Boolean']['input']>;
};

export type Product = {
  __typename?: 'Product';
  constraints: Maybe<ProductConstraints>;
  customFields: Maybe<Array<Maybe<ProductCustomField>>>;
  description: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images: Maybe<Array<Maybe<ProductImage>>>;
  metaDescription: Maybe<Scalars['String']['output']>;
  metaKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  modifiers: Maybe<Array<Maybe<ProductModifier>>>;
  options: Maybe<Array<ProductOption>>;
  pageTitle: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  relatedProducts: Maybe<Array<Maybe<Product>>>;
  sku: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  variants: Maybe<Array<Maybe<ProductVariant>>>;
};

export type ProductConstraints = GiftCardConstraints;

export type ProductCustomField = {
  __typename?: 'ProductCustomField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  description: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** General product to add to a cart. */
export type ProductItemInput = {
  /** The id of the product in the commerce platform. */
  id: Scalars['ID']['input'];
  /** The selected modifier options of the product */
  options: InputMaybe<Array<ProductItemOptionInput>>;
  /** The quantity of the product to add to the cart. */
  quantity: Scalars['Int']['input'];
  /** The SKU of the product in the commerce platform. */
  sku: Scalars['String']['input'];
  /** The ID of the variant product in the commerce platform */
  variantId: InputMaybe<Scalars['Int']['input']>;
};

export type ProductItemOptionInput = {
  id: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ProductModifier = {
  __typename?: 'ProductModifier';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  values: Array<Maybe<ProductOptionValue>>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type: ProductOptionType;
  values: Array<Maybe<ProductOptionValue>>;
};

export enum ProductOptionType {
  Dropdown = 'DROPDOWN',
  RadioButtons = 'RADIO_BUTTONS',
  Rectangles = 'RECTANGLES',
  Swatch = 'SWATCH'
}

export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['Int']['output'];
  image: Maybe<ProductImage>;
  optionValues: Array<Maybe<ProductVariantOption>>;
  price: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
};

export type ProductVariantOption = {
  __typename?: 'ProductVariantOption';
  displayName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  label: Maybe<Scalars['String']['output']>;
  optionId: Maybe<Scalars['Int']['output']>;
};

export type PromotionContent = {
  __typename?: 'PromotionContent';
  headline: Maybe<Scalars['String']['output']>;
  instruction: Maybe<Scalars['String']['output']>;
  type: Maybe<PromotionContentType>;
};

export enum PromotionContentType {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type PromotionOutput = {
  __typename?: 'PromotionOutput';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  result: Maybe<PromotionResult>;
  successful: Maybe<Scalars['Boolean']['output']>;
};

export type PromotionResult = {
  __typename?: 'PromotionResult';
  content: Maybe<PromotionContent>;
  coupon: Maybe<PromotionRewardCoupon>;
};

/**
 * The value of the coupon and the required barcode standard for generation and
 * display.
 */
export type PromotionRewardCoupon = {
  __typename?: 'PromotionRewardCoupon';
  barcodeStandard: Maybe<PromotionRewardCouponBarcodeStandard>;
  value: Scalars['String']['output'];
};

/** Standards for generation and display of a 2D or 1D barcode. */
export enum PromotionRewardCouponBarcodeStandard {
  Codabar = 'CODABAR',
  Code39 = 'CODE39',
  Code128A = 'CODE128_A',
  Code128Auto = 'CODE128_AUTO',
  Code128B = 'CODE128_B',
  Code128C = 'CODE128_C',
  Ean_2 = 'EAN_2',
  Ean_5 = 'EAN_5',
  Ean_8 = 'EAN_8',
  Ean_13 = 'EAN_13',
  Itf = 'ITF',
  Itf_14 = 'ITF_14',
  Msi10 = 'MSI10',
  Msi11 = 'MSI11',
  Msi1010 = 'MSI1010',
  Msi1110 = 'MSI1110',
  Pharmacode = 'PHARMACODE',
  Qr = 'QR',
  UpcA = 'UPC_A',
  UpcE = 'UPC_E'
}

export type Query = {
  __typename?: 'Query';
  _commerceEmpty: Maybe<Scalars['String']['output']>;
  _contentEmpty: Maybe<Scalars['String']['output']>;
  addressPredictionDetails: Maybe<AddressPredictionDetails>;
  addressSearch: Maybe<Array<Maybe<AddressPrediction>>>;
  /** This the entry point for administration. It requires an Azure JWT to access this and all fields below */
  admin: CommerceAdmin;
  applePushProvisioning: ApplePushProvisioning;
  cart: Maybe<CartOrError>;
  cartItem: Maybe<CartItemOrError>;
  cfAnswer: Maybe<CfAnswer>;
  cfAnswerCollection: Maybe<CfAnswerCollection>;
  cfAsset: Maybe<CfAsset>;
  cfAssetCollection: Maybe<CfAssetCollection>;
  cfAutomatedCollection: Maybe<CfAutomatedCollection>;
  cfAutomatedCollectionCollection: Maybe<CfAutomatedCollectionCollection>;
  cfAutomatedContentSource: Maybe<CfAutomatedContentSource>;
  cfAutomatedContentSourceCollection: Maybe<CfAutomatedContentSourceCollection>;
  cfBasicContent: Maybe<CfBasicContent>;
  cfBasicContentCollection: Maybe<CfBasicContentCollection>;
  cfBrand: Maybe<CfBrand>;
  cfBrandCollection: Maybe<CfBrandCollection>;
  cfCallToAction: Maybe<CfCallToAction>;
  cfCallToActionCollection: Maybe<CfCallToActionCollection>;
  cfCannedSearch: Maybe<CfCannedSearch>;
  cfCannedSearchCollection: Maybe<CfCannedSearchCollection>;
  cfCarPark: Maybe<CfCarPark>;
  cfCarParkCollection: Maybe<CfCarParkCollection>;
  cfCarParkGroup: Maybe<CfCarParkGroup>;
  cfCarParkGroupCollection: Maybe<CfCarParkGroupCollection>;
  cfCardLinkedOffer: Maybe<CfCardLinkedOffer>;
  cfCardLinkedOfferCollection: Maybe<CfCardLinkedOfferCollection>;
  cfCentre: Maybe<CfCentre>;
  cfCentreCollection: Maybe<CfCentreCollection>;
  cfCentrePatternImageSet: Maybe<CfCentrePatternImageSet>;
  cfCentrePatternImageSetCollection: Maybe<CfCentrePatternImageSetCollection>;
  cfCentreReviews: Maybe<CfCentreReviews>;
  cfCentreReviewsCollection: Maybe<CfCentreReviewsCollection>;
  cfComparisonItem: Maybe<CfComparisonItem>;
  cfComparisonItemCollection: Maybe<CfComparisonItemCollection>;
  cfComparisonModule: Maybe<CfComparisonModule>;
  cfComparisonModuleCollection: Maybe<CfComparisonModuleCollection>;
  cfCompetition: Maybe<CfCompetition>;
  cfCompetitionCollection: Maybe<CfCompetitionCollection>;
  cfContentBlock: Maybe<CfContentBlock>;
  cfContentBlockCollection: Maybe<CfContentBlockCollection>;
  cfContentPage: Maybe<CfContentPage>;
  cfContentPageCollection: Maybe<CfContentPageCollection>;
  cfContentTemplate: Maybe<CfContentTemplate>;
  cfContentTemplateCollection: Maybe<CfContentTemplateCollection>;
  cfDigitalDirectory: Maybe<CfDigitalDirectory>;
  cfDigitalDirectoryCollection: Maybe<CfDigitalDirectoryCollection>;
  cfDirectCategory: Maybe<CfDirectCategory>;
  cfDirectCategoryCollection: Maybe<CfDirectCategoryCollection>;
  cfDirectCategoryRelatedLink: Maybe<CfDirectCategoryRelatedLink>;
  cfDirectCategoryRelatedLinkCollection: Maybe<CfDirectCategoryRelatedLinkCollection>;
  cfDirectPromotion: Maybe<CfDirectPromotion>;
  cfDirectPromotionCollection: Maybe<CfDirectPromotionCollection>;
  cfDynamicContent: Maybe<CfDynamicContent>;
  cfDynamicContentCollection: Maybe<CfDynamicContentCollection>;
  cfEntryCollection: Maybe<CfEntryCollection>;
  cfEvent: Maybe<CfEvent>;
  cfEventCollection: Maybe<CfEventCollection>;
  cfExclusionsContentSource: Maybe<CfExclusionsContentSource>;
  cfExclusionsContentSourceCollection: Maybe<CfExclusionsContentSourceCollection>;
  cfExperience: Maybe<CfExperience>;
  cfExperienceCollection: Maybe<CfExperienceCollection>;
  cfFeatureManagement: Maybe<CfFeatureManagement>;
  cfFeatureManagementCollection: Maybe<CfFeatureManagementCollection>;
  cfFeaturedCommerce: Maybe<CfFeaturedCommerce>;
  cfFeaturedCommerceCollection: Maybe<CfFeaturedCommerceCollection>;
  cfFeaturedLink: Maybe<CfFeaturedLink>;
  cfFeaturedLinkCollection: Maybe<CfFeaturedLinkCollection>;
  cfGenderSegmentedManualContentSource: Maybe<CfGenderSegmentedManualContentSource>;
  cfGenderSegmentedManualContentSourceCollection: Maybe<CfGenderSegmentedManualContentSourceCollection>;
  cfGenericAdZone: Maybe<CfGenericAdZone>;
  cfGenericAdZoneCollection: Maybe<CfGenericAdZoneCollection>;
  cfGiftcardTemplate: Maybe<CfGiftcardTemplate>;
  cfGiftcardTemplateCollection: Maybe<CfGiftcardTemplateCollection>;
  cfHeroImageSet: Maybe<CfHeroImageSet>;
  cfHeroImageSetCollection: Maybe<CfHeroImageSetCollection>;
  cfInstantDraw: Maybe<CfInstantDraw>;
  cfInstantDrawCollection: Maybe<CfInstantDrawCollection>;
  cfInstantEarn: Maybe<CfInstantEarn>;
  cfInstantEarnCollection: Maybe<CfInstantEarnCollection>;
  cfIntroductions: Maybe<CfIntroductions>;
  cfIntroductionsCollection: Maybe<CfIntroductionsCollection>;
  cfJourneyBanner: Maybe<CfJourneyBanner>;
  cfJourneyBannerCollection: Maybe<CfJourneyBannerCollection>;
  cfLoyaltyProgram: Maybe<CfLoyaltyProgram>;
  cfLoyaltyProgramCollection: Maybe<CfLoyaltyProgramCollection>;
  cfManualCollection: Maybe<CfManualCollection>;
  cfManualCollectionCollection: Maybe<CfManualCollectionCollection>;
  cfManualContentSource: Maybe<CfManualContentSource>;
  cfManualContentSourceCollection: Maybe<CfManualContentSourceCollection>;
  cfManualSolusModule: Maybe<CfManualSolusModule>;
  cfManualSolusModuleCollection: Maybe<CfManualSolusModuleCollection>;
  cfNationalExperiencePage: Maybe<CfNationalExperiencePage>;
  cfNationalExperiencePageCollection: Maybe<CfNationalExperiencePageCollection>;
  cfNationalHomepage: Maybe<CfNationalHomepage>;
  cfNationalHomepageCollection: Maybe<CfNationalHomepageCollection>;
  cfNationalStorefront: Maybe<CfNationalStorefront>;
  cfNationalStorefrontCollection: Maybe<CfNationalStorefrontCollection>;
  cfNews: Maybe<CfNews>;
  cfNewsCollection: Maybe<CfNewsCollection>;
  cfOccurrence: Maybe<CfOccurrence>;
  cfOccurrenceCollection: Maybe<CfOccurrenceCollection>;
  cfOffer: Maybe<CfOffer>;
  cfOfferCollection: Maybe<CfOfferCollection>;
  cfParkingRate: Maybe<CfParkingRate>;
  cfParkingRateCollection: Maybe<CfParkingRateCollection>;
  cfParkingRatesCard: Maybe<CfParkingRatesCard>;
  cfParkingRatesCardCollection: Maybe<CfParkingRatesCardCollection>;
  cfParkingRules: Maybe<CfParkingRules>;
  cfParkingRulesCollection: Maybe<CfParkingRulesCollection>;
  cfParkingTemplate: Maybe<CfParkingTemplate>;
  cfParkingTemplateCollection: Maybe<CfParkingTemplateCollection>;
  cfPersonalisedContentSource: Maybe<CfPersonalisedContentSource>;
  cfPersonalisedContentSourceCollection: Maybe<CfPersonalisedContentSourceCollection>;
  cfProductCollection: Maybe<CfProductCollection>;
  cfProductCollectionCollection: Maybe<CfProductCollectionCollection>;
  cfProfile: Maybe<CfProfile>;
  cfProfileCollection: Maybe<CfProfileCollection>;
  cfPromotion: Maybe<CfPromotion>;
  cfPromotionCollection: Maybe<CfPromotionCollection>;
  cfPromotionalTemplate: Maybe<CfPromotionalTemplate>;
  cfPromotionalTemplateCollection: Maybe<CfPromotionalTemplateCollection>;
  cfQuestion: Maybe<CfQuestion>;
  cfQuestionCollection: Maybe<CfQuestionCollection>;
  cfRetailCategory: Maybe<CfRetailCategory>;
  cfRetailCategoryCollection: Maybe<CfRetailCategoryCollection>;
  cfRetailer: Maybe<CfRetailer>;
  cfRetailerCollection: Maybe<CfRetailerCollection>;
  cfRetailerLogoSet: Maybe<CfRetailerLogoSet>;
  cfRetailerLogoSetCollection: Maybe<CfRetailerLogoSetCollection>;
  cfSearchSuggestions: Maybe<CfSearchSuggestions>;
  cfSearchSuggestionsCollection: Maybe<CfSearchSuggestionsCollection>;
  cfSection: Maybe<CfSection>;
  cfSectionCollection: Maybe<CfSectionCollection>;
  cfService: Maybe<CfService>;
  cfServiceCollection: Maybe<CfServiceCollection>;
  cfSocial: Maybe<CfSocial>;
  cfSocialCollection: Maybe<CfSocialCollection>;
  cfSocialFeed: Maybe<CfSocialFeed>;
  cfSocialFeedCollection: Maybe<CfSocialFeedCollection>;
  cfSolusTemplate: Maybe<CfSolusTemplate>;
  cfSolusTemplateCollection: Maybe<CfSolusTemplateCollection>;
  cfStaticBannerSolusModule: Maybe<CfStaticBannerSolusModule>;
  cfStaticBannerSolusModuleCollection: Maybe<CfStaticBannerSolusModuleCollection>;
  cfStaticFile: Maybe<CfStaticFile>;
  cfStaticFileCollection: Maybe<CfStaticFileCollection>;
  cfStore: Maybe<CfStore>;
  cfStoreCollection: Maybe<CfStoreCollection>;
  cfStory: Maybe<CfStory>;
  cfStoryCollection: Maybe<CfStoryCollection>;
  cfSupportingImageSet: Maybe<CfSupportingImageSet>;
  cfSupportingImageSetCollection: Maybe<CfSupportingImageSetCollection>;
  cfTemplate: Maybe<CfTemplate>;
  cfTemplateCollection: Maybe<CfTemplateCollection>;
  cfTerms: Maybe<CfTerms>;
  cfTermsCollection: Maybe<CfTermsCollection>;
  cfTimTest: Maybe<CfTimTest>;
  cfTimTestCollection: Maybe<CfTimTestCollection>;
  cfTopStrip: Maybe<CfTopStrip>;
  cfTopStripCollection: Maybe<CfTopStripCollection>;
  cfTopic: Maybe<CfTopic>;
  cfTopicCollection: Maybe<CfTopicCollection>;
  cfUtilityPanel: Maybe<CfUtilityPanel>;
  cfUtilityPanelCollection: Maybe<CfUtilityPanelCollection>;
  cfWhatsHappeningFilters: Maybe<CfWhatsHappeningFilters>;
  cfWhatsHappeningFiltersCollection: Maybe<CfWhatsHappeningFiltersCollection>;
  checkout: Maybe<Checkout>;
  /** Get the activated offer list */
  cloActivatedOffers: Maybe<CloActivatedOffersResponse>;
  /** Check offer is activated or not */
  cloIsOfferActivated: Maybe<CloIsOfferActivatedResponse>;
  /** Grab a list of all the cards linked by the customer in CLO */
  cloLinkedCards: Maybe<CloLinkedCardsResponse>;
  competitionAdmin: CompetitionAdmin;
  currentUser: Maybe<Customer>;
  digitalGiftCard: Maybe<DigitalGiftCard>;
  digitalGiftCards: DigitalGiftCards;
  eventBookingsInfo: Maybe<BookingInfoResult>;
  experiencePackagesAdmin: ExperiencePackagesAdmin;
  featureManagementFeatures: Array<Maybe<FeatureManagementFeature>>;
  fulfilmentCentreCollection: CfCentreCollection;
  googlePushProvisioning: Maybe<GooglePushProvisioning>;
  marketplaceAdmin: Maybe<MarketplaceAdminQuery>;
  marketplaceBrand: Maybe<MarketplaceProductsSearchResultBrand>;
  marketplaceBrands: Array<MarketplaceProductsSearchResultBrand>;
  marketplaceBrandsAndCategories: MarketplaceBrandsAndCategoriesResult;
  marketplaceCategory: Maybe<MarketplaceCategory>;
  marketplaceOrder: Maybe<MarketplaceOrder>;
  marketplaceProductByVariantGroupCode: Maybe<MarketplaceProduct>;
  marketplaceProductFacet: Maybe<MarketplaceProductFacet>;
  marketplaceProductFacets: Maybe<Array<Maybe<MarketplaceProductFacet>>>;
  marketplaceProductsByVariantGroupCode: Array<Maybe<MarketplaceProduct>>;
  marketplaceProductsSearch: MarketplaceProductsSearch;
  marketplaceRefundReasons: Array<MarketplaceRefundReason>;
  marketplaceShippingConfiguration: MarketplaceShippingConfiguration;
  marketplaceShop: Maybe<MarketplaceShop>;
  marketplaceShops: Array<MarketplaceShop>;
  notActiveDigitalGiftCard: Maybe<NotActiveDigitalGiftCard>;
  order: Maybe<Order>;
  parkingSessions: Maybe<Array<ParkingSession>>;
  product: Maybe<Product>;
  sgCentreMovies: Maybe<Array<Movie>>;
  sgCentrePageTemplate: Maybe<SgPageTemplate>;
  sgCentreQuickLinks: Array<SgPageTemplateContentEntry>;
  sgCentreStorefront: Maybe<SgPageTemplate>;
  sgCentreTradingHours: Maybe<Array<Maybe<TradingHourDay>>>;
  sgMovieDetails: Maybe<DetailedMovie>;
  sgNationalExperience: Maybe<SgPageTemplate>;
  sgNationalHomepage: Maybe<SgPageTemplate>;
  sgNationalPageTemplate: Maybe<SgPageTemplate>;
  sgNationalStorefront: Maybe<SgPageTemplate>;
  sgPageTemplateAdZoneContentEntries: Array<Maybe<SgPageTemplateContentEntry>>;
  sgPageTemplateAdZoneContentEntry: Maybe<SgPageTemplateContentEntry>;
  /** Select the retailerCategories facet in the sg_retailers collection in Typesense */
  sgRetailersFacetRetailerCategories: Array<Maybe<SgcfRetailCategory>>;
  /** Search the sg_retailers collection in Typesense */
  sgRetailersSearch: Maybe<SgRetailersSearchResponse>;
  sgStoreTradingHours: Maybe<Array<Maybe<TradingHourDay>>>;
  sgStoresForCentre: Maybe<Array<SgCentreStore>>;
  sharedPlate: Maybe<SharedPlate>;
  suburbs: Array<Maybe<AustralianSuburb>>;
  whatsOnCentre: Maybe<Array<Maybe<SearchResult>>>;
};


export type QueryAddressPredictionDetailsArgs = {
  addressSessionToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryAddressSearchArgs = {
  addressSessionToken: Scalars['String']['input'];
  countryIso2?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryApplePushProvisioningArgs = {
  certificates: ApplePushProvisioningCertificates;
  nonceCode: Scalars['Base64']['input'];
  nonceSignature: Scalars['Base64']['input'];
  referenceNumber: Scalars['String']['input'];
};


export type QueryCartArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCartItemArgs = {
  cartId: InputMaybe<Scalars['UUID']['input']>;
  itemId: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCfAnswerArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfAnswerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAnswerOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfAnswerFilter>;
};


export type QueryCfAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfAssetFilter>;
};


export type QueryCfAutomatedCollectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfAutomatedCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfAutomatedCollectionFilter>;
};


export type QueryCfAutomatedContentSourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfAutomatedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfAutomatedContentSourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfAutomatedContentSourceFilter>;
};


export type QueryCfBasicContentArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfBasicContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBasicContentOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfBasicContentFilter>;
};


export type QueryCfBrandArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfBrandCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfBrandOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfBrandFilter>;
};


export type QueryCfCallToActionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCallToActionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCallToActionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCallToActionFilter>;
};


export type QueryCfCannedSearchArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCannedSearchCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCannedSearchOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCannedSearchFilter>;
};


export type QueryCfCarParkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCarParkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCarParkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCarParkFilter>;
};


export type QueryCfCarParkGroupArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCarParkGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCarParkGroupOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCarParkGroupFilter>;
};


export type QueryCfCardLinkedOfferArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCardLinkedOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCardLinkedOfferOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCardLinkedOfferFilter>;
};


export type QueryCfCentreArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCentreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreFilter>;
};


export type QueryCfCentrePatternImageSetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCentrePatternImageSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentrePatternImageSetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentrePatternImageSetFilter>;
};


export type QueryCfCentreReviewsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCentreReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCentreReviewsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCentreReviewsFilter>;
};


export type QueryCfComparisonItemArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfComparisonItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfComparisonItemOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfComparisonItemFilter>;
};


export type QueryCfComparisonModuleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfComparisonModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfComparisonModuleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfComparisonModuleFilter>;
};


export type QueryCfCompetitionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfCompetitionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfCompetitionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfCompetitionFilter>;
};


export type QueryCfContentBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfContentBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentBlockFilter>;
};


export type QueryCfContentPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentPageFilter>;
};


export type QueryCfContentTemplateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfContentTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfContentTemplateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfContentTemplateFilter>;
};


export type QueryCfDigitalDirectoryArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfDigitalDirectoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDigitalDirectoryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfDigitalDirectoryFilter>;
};


export type QueryCfDirectCategoryArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfDirectCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDirectCategoryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfDirectCategoryFilter>;
};


export type QueryCfDirectCategoryRelatedLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfDirectCategoryRelatedLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDirectCategoryRelatedLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfDirectCategoryRelatedLinkFilter>;
};


export type QueryCfDirectPromotionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfDirectPromotionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDirectPromotionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfDirectPromotionFilter>;
};


export type QueryCfDynamicContentArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfDynamicContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfDynamicContentOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfDynamicContentFilter>;
};


export type QueryCfEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEntryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfEntryFilter>;
};


export type QueryCfEventArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfEventCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfEventOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfEventFilter>;
};


export type QueryCfExclusionsContentSourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfExclusionsContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExclusionsContentSourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExclusionsContentSourceFilter>;
};


export type QueryCfExperienceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfExperienceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfExperienceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfExperienceFilter>;
};


export type QueryCfFeatureManagementArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfFeatureManagementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeatureManagementOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeatureManagementFilter>;
};


export type QueryCfFeaturedCommerceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfFeaturedCommerceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedCommerceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeaturedCommerceFilter>;
};


export type QueryCfFeaturedLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfFeaturedLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfFeaturedLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfFeaturedLinkFilter>;
};


export type QueryCfGenderSegmentedManualContentSourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfGenderSegmentedManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenderSegmentedManualContentSourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGenderSegmentedManualContentSourceFilter>;
};


export type QueryCfGenericAdZoneArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfGenericAdZoneCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGenericAdZoneOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGenericAdZoneFilter>;
};


export type QueryCfGiftcardTemplateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfGiftcardTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfGiftcardTemplateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfGiftcardTemplateFilter>;
};


export type QueryCfHeroImageSetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfHeroImageSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfHeroImageSetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfHeroImageSetFilter>;
};


export type QueryCfInstantDrawArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfInstantDrawCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfInstantDrawOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfInstantDrawFilter>;
};


export type QueryCfInstantEarnArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfInstantEarnCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfInstantEarnOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfInstantEarnFilter>;
};


export type QueryCfIntroductionsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfIntroductionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfIntroductionsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfIntroductionsFilter>;
};


export type QueryCfJourneyBannerArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfJourneyBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfJourneyBannerOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfJourneyBannerFilter>;
};


export type QueryCfLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfLoyaltyProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfLoyaltyProgramOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfLoyaltyProgramFilter>;
};


export type QueryCfManualCollectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfManualCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfManualCollectionFilter>;
};


export type QueryCfManualContentSourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfManualContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualContentSourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfManualContentSourceFilter>;
};


export type QueryCfManualSolusModuleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfManualSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfManualSolusModuleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfManualSolusModuleFilter>;
};


export type QueryCfNationalExperiencePageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfNationalExperiencePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalExperiencePageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalExperiencePageFilter>;
};


export type QueryCfNationalHomepageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfNationalHomepageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalHomepageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalHomepageFilter>;
};


export type QueryCfNationalStorefrontArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfNationalStorefrontCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNationalStorefrontOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNationalStorefrontFilter>;
};


export type QueryCfNewsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfNewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfNewsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfNewsFilter>;
};


export type QueryCfOccurrenceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfOccurrenceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOccurrenceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfOccurrenceFilter>;
};


export type QueryCfOfferArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfOfferOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfOfferFilter>;
};


export type QueryCfParkingRateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfParkingRateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingRateFilter>;
};


export type QueryCfParkingRatesCardArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfParkingRatesCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRatesCardOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingRatesCardFilter>;
};


export type QueryCfParkingRulesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfParkingRulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingRulesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingRulesFilter>;
};


export type QueryCfParkingTemplateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfParkingTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfParkingTemplateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfParkingTemplateFilter>;
};


export type QueryCfPersonalisedContentSourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfPersonalisedContentSourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPersonalisedContentSourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfPersonalisedContentSourceFilter>;
};


export type QueryCfProductCollectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfProductCollectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProductCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfProductCollectionFilter>;
};


export type QueryCfProfileArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfProfileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfProfileOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfProfileFilter>;
};


export type QueryCfPromotionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfPromotionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPromotionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfPromotionFilter>;
};


export type QueryCfPromotionalTemplateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfPromotionalTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfPromotionalTemplateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfPromotionalTemplateFilter>;
};


export type QueryCfQuestionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfQuestionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfQuestionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfQuestionFilter>;
};


export type QueryCfRetailCategoryArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfRetailCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailCategoryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailCategoryFilter>;
};


export type QueryCfRetailerArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfRetailerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailerFilter>;
};


export type QueryCfRetailerLogoSetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfRetailerLogoSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfRetailerLogoSetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfRetailerLogoSetFilter>;
};


export type QueryCfSearchSuggestionsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfSearchSuggestionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSearchSuggestionsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSearchSuggestionsFilter>;
};


export type QueryCfSectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSectionFilter>;
};


export type QueryCfServiceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfServiceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfServiceFilter>;
};


export type QueryCfSocialArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfSocialCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSocialOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSocialFilter>;
};


export type QueryCfSocialFeedArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfSocialFeedCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSocialFeedOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSocialFeedFilter>;
};


export type QueryCfSolusTemplateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfSolusTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSolusTemplateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSolusTemplateFilter>;
};


export type QueryCfStaticBannerSolusModuleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfStaticBannerSolusModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStaticBannerSolusModuleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStaticBannerSolusModuleFilter>;
};


export type QueryCfStaticFileArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfStaticFileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStaticFileOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStaticFileFilter>;
};


export type QueryCfStoreArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfStoreCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoreOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoreFilter>;
};


export type QueryCfStoryArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfStoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfStoryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfStoryFilter>;
};


export type QueryCfSupportingImageSetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfSupportingImageSetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfSupportingImageSetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfSupportingImageSetFilter>;
};


export type QueryCfTemplateArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTemplateOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTemplateFilter>;
};


export type QueryCfTermsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfTermsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTermsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTermsFilter>;
};


export type QueryCfTimTestArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfTimTestCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTimTestOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTimTestFilter>;
};


export type QueryCfTopStripArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfTopStripCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopStripOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopStripFilter>;
};


export type QueryCfTopicArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfTopicCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfTopicOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfTopicFilter>;
};


export type QueryCfUtilityPanelArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfUtilityPanelCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfUtilityPanelOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfUtilityPanelFilter>;
};


export type QueryCfWhatsHappeningFiltersArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCfWhatsHappeningFiltersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<CfWhatsHappeningFiltersOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<CfWhatsHappeningFiltersFilter>;
};


export type QueryCheckoutArgs = {
  cartId: Scalars['UUID']['input'];
  currency: Scalars['String']['input'];
};


export type QueryCloIsOfferActivatedArgs = {
  cloOfferId: Scalars['String']['input'];
};


export type QueryDigitalGiftCardArgs = {
  referenceNumber: Scalars['ID']['input'];
};


export type QueryDigitalGiftCardsArgs = {
  displayStatus: InputMaybe<DigitalGiftCardDisplayStatus>;
  referenceNumbers: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryEventBookingsInfoArgs = {
  event: EventForBookingInquiry;
};


export type QueryFeatureManagementFeaturesArgs = {
  scope: Scalars['String']['input'];
};


export type QueryFulfilmentCentreCollectionArgs = {
  coordinate: InputMaybe<CoordinateInput>;
  limit: InputMaybe<Scalars['Int']['input']>;
  radius: InputMaybe<Scalars['Int']['input']>;
  suburb: InputMaybe<AustralianSuburbInput>;
};


export type QueryGooglePushProvisioningArgs = {
  clientDeviceID: Scalars['String']['input'];
  clientWalletAccountID: Scalars['String']['input'];
  clientWalletProvider: Scalars['String']['input'];
  referenceNumber: Scalars['String']['input'];
};


export type QueryMarketplaceBrandArgs = {
  slug: Scalars['String']['input'];
};


export type QueryMarketplaceBrandsAndCategoriesArgs = {
  category: InputMaybe<Scalars['String']['input']>;
  section: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceCategoryArgs = {
  filter: InputMaybe<MarketplaceProductsFilter>;
  path: Array<Scalars['String']['input']>;
  query: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceOrderArgs = {
  cartId: Scalars['UUID']['input'];
  orderReference: Scalars['ID']['input'];
};


export type QueryMarketplaceProductByVariantGroupCodeArgs = {
  id: Scalars['ID']['input'];
  shop: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketplaceProductFacetArgs = {
  categoryPath: Array<Scalars['String']['input']>;
  filter: InputMaybe<MarketplaceProductsFilter>;
  id: Scalars['String']['input'];
  query: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceProductFacetsArgs = {
  categoryPath: Array<Scalars['String']['input']>;
  filter: InputMaybe<MarketplaceProductsFilter>;
  query: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceProductsByVariantGroupCodeArgs = {
  specifiers: Array<MarketplaceProductSpecifier>;
};


export type QueryMarketplaceProductsSearchArgs = {
  input: InputMaybe<MarketplaceProductsSearchInput>;
};


export type QueryMarketplaceShopArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotActiveDigitalGiftCardArgs = {
  linkCode: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  cartId: Scalars['UUID']['input'];
  orderId: Scalars['ID']['input'];
};


export type QueryParkingSessionsArgs = {
  centreId: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySgCentreMoviesArgs = {
  centreSlug: Scalars['String']['input'];
};


export type QuerySgCentrePageTemplateArgs = {
  centreSlug: Scalars['String']['input'];
  locales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path: Scalars['String']['input'];
};


export type QuerySgCentreQuickLinksArgs = {
  centreSlug: Scalars['String']['input'];
};


export type QuerySgCentreStorefrontArgs = {
  centreSlug: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
};


export type QuerySgCentreTradingHoursArgs = {
  centreSlug: Scalars['String']['input'];
  endDate: InputMaybe<Scalars['Date']['input']>;
  startDate: InputMaybe<Scalars['Date']['input']>;
};


export type QuerySgMovieDetailsArgs = {
  centreSlug: Scalars['String']['input'];
  movieId: Scalars['String']['input'];
};


export type QuerySgNationalExperienceArgs = {
  country: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QuerySgNationalHomepageArgs = {
  country: Scalars['String']['input'];
};


export type QuerySgNationalPageTemplateArgs = {
  country: Scalars['String']['input'];
  locales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path: Scalars['String']['input'];
};


export type QuerySgNationalStorefrontArgs = {
  retailerId: Scalars['String']['input'];
};


export type QuerySgPageTemplateAdZoneContentEntriesArgs = {
  adZoneIds: Array<Scalars['String']['input']>;
  centreSlug: InputMaybe<Scalars['String']['input']>;
};


export type QuerySgPageTemplateAdZoneContentEntryArgs = {
  centreSlug: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QuerySgRetailersFacetRetailerCategoriesArgs = {
  filter: InputMaybe<SgRetailersSearchFilter>;
};


export type QuerySgRetailersSearchArgs = {
  filter: InputMaybe<SgRetailersSearchFilter>;
  limit: InputMaybe<Scalars['Int']['input']>;
  order: InputMaybe<Array<SgRetailersSearchOrder>>;
  skip: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySgStoreTradingHoursArgs = {
  centreSlug: Scalars['String']['input'];
  endDate: InputMaybe<Scalars['Date']['input']>;
  startDate: InputMaybe<Scalars['Date']['input']>;
  storeId: Scalars['String']['input'];
};


export type QuerySgStoresForCentreArgs = {
  centreSlug: Scalars['String']['input'];
};


export type QuerySharedPlateArgs = {
  token: Scalars['String']['input'];
};


export type QuerySuburbsArgs = {
  query: Scalars['String']['input'];
};


export type QueryWhatsOnCentreArgs = {
  centreId: Scalars['String']['input'];
  contentOptions?: InputMaybe<ContentOptions>;
  durationFromNow: InputMaybe<Scalars['String']['input']>;
  endAt: InputMaybe<Scalars['String']['input']>;
  startAt: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
};

/** key value pair of contentful questionId with it's answer */
export type QuestionInput = {
  /** The contentful question id */
  questionId: Scalars['String']['input'];
  /** the input or answer for the specific question */
  value: Scalars['String']['input'];
};

/** Sender and recipient details for giftcard items */
export type RecipientDetails = {
  message: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
};

/** Direct rewards breakdown. */
export type RedeemedOrders = {
  __typename?: 'RedeemedOrders';
  balance: Scalars['Decimal']['output'];
  orders: Array<Maybe<DirectOrderReward>>;
};

export type ReissueResult = {
  __typename?: 'ReissueResult';
  previous: CommerceAdminDigitalGiftCard;
  replacement: Maybe<CommerceAdminDigitalGiftCard>;
};

export type RemoveLoyaltyProgramMembershipInput = {
  id: Scalars['String']['input'];
  scentregroupId: InputMaybe<Scalars['String']['input']>;
};

export type RemovePaymentMethodInput = {
  stripePaymentMethodId: Scalars['String']['input'];
};

export type RemovePlateInput = {
  plate: Scalars['String']['input'];
  registeredIn: Scalars['String']['input'];
};

/** Input for removing a product from a cart. */
export type RemoveProductFromCartInput = {
  /** The ID of the cart to remove from. */
  cartId: Scalars['UUID']['input'];
  /** The item ID to remove from the cart. */
  itemId: Scalars['UUID']['input'];
};

export type RemoveStoredAddressInput = {
  id: Scalars['UUID']['input'];
};

export type ResendEmailInput = {
  emailAddress: InputMaybe<Scalars['String']['input']>;
  emailType: EmailType;
  /** This is the reference number for the card */
  referenceNumber: Scalars['String']['input'];
};

export type RewardsActivityEvent = {
  __typename?: 'RewardsActivityEvent';
  activeDate: Maybe<Scalars['DateTime']['output']>;
  amount: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  descriptionLine1: Maybe<Scalars['String']['output']>;
  descriptionLine2: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type RewardsSummary = {
  __typename?: 'RewardsSummary';
  activity: Maybe<Array<RewardsActivityEvent>>;
  burnMessage: Maybe<BurnMessage>;
  currentBalance: Scalars['Float']['output'];
  eligibleForGiftCard: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  pendingBalance: Scalars['Float']['output'];
};

export enum Role {
  DgcRole = 'DGC_ROLE',
  GcHoBankFin = 'GC_HO_BANK_FIN',
  GcHoBulk = 'GC_HO_BULK',
  GcHoCsr = 'GC_HO_CSR',
  GcHoFin = 'GC_HO_FIN',
  MembershipExperiencePackages = 'MEMBERSHIP_EXPERIENCE_PACKAGES',
  PlusCompetitions = 'PLUS_COMPETITIONS',
  WdpRole = 'WDP_ROLE',
  WdRole = 'WD_ROLE'
}

export type SgcfAnswer = SgcfEntry & {
  __typename?: 'SGCFAnswer';
  slug: Scalars['String']['output'];
  subtitle: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfAsset = {
  __typename?: 'SGCFAsset';
  description: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SgcfAutomatedCollection = SgcfEntry & {
  __typename?: 'SGCFAutomatedCollection';
  backendTitle: Scalars['String']['output'];
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  contentLimit: Scalars['Int']['output'];
  contentTypes: Array<Maybe<Scalars['String']['output']>>;
  displayMode: Scalars['String']['output'];
  displayModeV2: Maybe<Scalars['String']['output']>;
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  relatedContent: Maybe<Scalars['CFJSON']['output']>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Maybe<Scalars['String']['output']>;
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
};

export type SgcfAutomatedContentSource = SgcfEntry & {
  __typename?: 'SGCFAutomatedContentSource';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  contentTemplates: Array<Maybe<SgcfContentTemplate>>;
  contentTypes: Array<Maybe<Scalars['String']['output']>>;
  count: Scalars['Int']['output'];
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  prioritiseItemsRelevantToday: Scalars['Boolean']['output'];
  rotateContentTypes: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  topicsSortOrFilter: Maybe<Scalars['String']['output']>;
  variant: Maybe<Scalars['String']['output']>;
};

export type SgcfBasicContent = SgcfEntry & {
  __typename?: 'SGCFBasicContent';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Maybe<Scalars['String']['output']>;
  callsToAction: Maybe<Array<Maybe<SgcfCallToAction>>>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Maybe<Scalars['String']['output']>;
};

export type SgcfBrand = SgcfEntry & {
  __typename?: 'SGCFBrand';
  allowAutoSurface: Maybe<Scalars['Boolean']['output']>;
  backendTitle: Scalars['String']['output'];
  brandLinkUrl: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfCallToAction = SgcfEntry & {
  __typename?: 'SGCFCallToAction';
  address: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfCannedSearch = SgcfEntry & {
  __typename?: 'SGCFCannedSearch';
  backendTitle: Scalars['String']['output'];
  seoBlurb: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfCarPark = SgcfEntry & {
  __typename?: 'SGCFCarPark';
  backendTitle: Scalars['String']['output'];
  bestParkingFor: Maybe<Array<Maybe<SgcfStore>>>;
  centre: Maybe<SgcfCentre>;
  entrance: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  location: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  parkAssistMetadata: Maybe<Scalars['CFJSON']['output']>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfCarParkGroup = SgcfEntry & {
  __typename?: 'SGCFCarParkGroup';
  backendTitle: Scalars['String']['output'];
  carParks: Array<Maybe<SgcfCarPark>>;
  centre: SgcfCentre;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfCardLinkedOffer = SgcfEntry & {
  __typename?: 'SGCFCardLinkedOffer';
  backendTitle: Scalars['String']['output'];
  cloOfferId: Scalars['String']['output'];
  cloRewardType: Scalars['String']['output'];
  cloRewardValue: Scalars['Float']['output'];
  cloTransactionValueMaximum: Maybe<Scalars['Float']['output']>;
  cloTransactionValueMinimum: Maybe<Scalars['Float']['output']>;
  sys: SgcfSys;
};

export type SgcfCentre = SgcfEntry & {
  __typename?: 'SGCFCentre';
  backendTitle: Scalars['String']['output'];
  boundaries: Maybe<Scalars['CFJSON']['output']>;
  businessUnitCode: Maybe<Scalars['String']['output']>;
  bynderCentreFrontImage: Maybe<Scalars['CFJSON']['output']>;
  bynderDeckBackground: Maybe<Scalars['CFJSON']['output']>;
  carParkType: Scalars['String']['output'];
  centreFrontImage: Maybe<SgcfAsset>;
  centrePatternImageSet: Maybe<SgcfCentrePatternImageSet>;
  cinema: Maybe<SgcfStore>;
  conciergeService: Maybe<SgcfService>;
  country: Scalars['String']['output'];
  deckBackground: Maybe<SgcfAsset>;
  emailAddress: Scalars['String']['output'];
  facebook: Scalars['String']['output'];
  featureFlagsData: Maybe<Scalars['CFJSON']['output']>;
  features: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  googlePlacesId: Maybe<Scalars['String']['output']>;
  instagram: Scalars['String']['output'];
  jibestreamVenueId: Maybe<Scalars['Int']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  navigationMenu: Scalars['CFJSON']['output'];
  parkingAvailabilityDescription: Maybe<Scalars['String']['output']>;
  parkingOccupancy: Maybe<Scalars['CFJSON']['output']>;
  parkingRules: Maybe<Array<Maybe<SgcfParkingRules>>>;
  physicalAddress: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  reputationCode: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
  sys: SgcfSys;
  telephoneNumber: Scalars['String']['output'];
  themeColour: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  twitter: Scalars['String']['output'];
  utilityBoxRetailerCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
};

export type SgcfCentrePatternImageSet = SgcfEntry & {
  __typename?: 'SGCFCentrePatternImageSet';
  backendTitle: Scalars['String']['output'];
  bynderLarge: Maybe<Scalars['CFJSON']['output']>;
  bynderSmall: Maybe<Scalars['CFJSON']['output']>;
  large: Maybe<SgcfAsset>;
  small: Maybe<SgcfAsset>;
  sys: SgcfSys;
};

export type SgcfCentreReviews = SgcfEntry & {
  __typename?: 'SGCFCentreReviews';
  backendTitle: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfComparisonItem = SgcfEntry & {
  __typename?: 'SGCFComparisonItem';
  backendTitle: Scalars['String']['output'];
  callToAction: SgcfFeaturedLink;
  heroImageSet: SgcfHeroImageSet;
  productName: Scalars['String']['output'];
  sys: SgcfSys;
  utilityPanel: Maybe<SgcfUtilityPanel>;
  valuePropositions: Array<Maybe<Scalars['String']['output']>>;
};

export type SgcfComparisonModule = SgcfEntry & {
  __typename?: 'SGCFComparisonModule';
  backendTitle: Scalars['String']['output'];
  comparisonModule: Maybe<Array<Maybe<SgcfComparisonItem>>>;
  sys: SgcfSys;
};

export type SgcfCompetition = SgcfEntry & {
  __typename?: 'SGCFCompetition';
  faqUrl: Maybe<Scalars['String']['output']>;
  inCentrePresenceCheck: Scalars['Boolean']['output'];
  questions: Maybe<Array<Maybe<SgcfQuestion>>>;
  requiresQRCodeScan: Scalars['Boolean']['output'];
  sendSuccessEmail: Scalars['Boolean']['output'];
  successBody: Scalars['String']['output'];
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  successTitle: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfContentBlock = SgcfEntry & {
  __typename?: 'SGCFContentBlock';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfContentPage = SgcfEntry & {
  __typename?: 'SGCFContentPage';
  backendTitle: Scalars['String']['output'];
  country: Array<Maybe<Scalars['String']['output']>>;
  metaTitle: Maybe<Scalars['String']['output']>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  path: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfContentTemplate = SgcfEntry & {
  __typename?: 'SGCFContentTemplate';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  channel: Scalars['String']['output'];
  data: Scalars['CFJSON']['output'];
  scope: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
  variant: Maybe<Scalars['String']['output']>;
};

export type SgcfDigitalDirectory = SgcfEntry & {
  __typename?: 'SGCFDigitalDirectory';
  centre: Maybe<SgcfCentre>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfDirectCategory = SgcfEntry & {
  __typename?: 'SGCFDirectCategory';
  backendTitle: Scalars['String']['output'];
  blurbBody: Maybe<Scalars['String']['output']>;
  blurbTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Maybe<Scalars['String']['output']>;
  categoryPath: Scalars['String']['output'];
  displaySiblingLinks: Scalars['Boolean']['output'];
  h1Header: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  metaDescription: Maybe<Scalars['String']['output']>;
  pageTitle: Scalars['String']['output'];
  relatedLinks: Maybe<Array<Maybe<SgcfDirectCategoryRelatedLink>>>;
  sys: SgcfSys;
};

export type SgcfDirectCategoryRelatedLink = SgcfEntry & {
  __typename?: 'SGCFDirectCategoryRelatedLink';
  backendTitle: Scalars['String']['output'];
  displayMode: Scalars['String']['output'];
  label: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfDirectPromotion = SgcfEntry & {
  __typename?: 'SGCFDirectPromotion';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<SgcfHeroImageSet>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  talonOneId: Maybe<Scalars['String']['output']>;
  termsAndConditions: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SgcfDynamicContent = SgcfEntry & {
  __typename?: 'SGCFDynamicContent';
  backendTitle: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfEntry = {
  sys: SgcfSys;
};

export type SgcfEvent = SgcfEntry & {
  __typename?: 'SGCFEvent';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Scalars['String']['output'];
  bookingDescription: Maybe<Scalars['String']['output']>;
  callsToAction: Maybe<Array<Maybe<SgcfCallToAction>>>;
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  hasModeratedImages: Maybe<Scalars['Boolean']['output']>;
  heroImageSet: SgcfHeroImageSet;
  hosted: Maybe<Scalars['String']['output']>;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  landmarkDescription: Maybe<Scalars['String']['output']>;
  level: Maybe<Scalars['String']['output']>;
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  occurrenceMeta: Maybe<Scalars['CFJSON']['output']>;
  occurrences: Array<Maybe<SgcfOccurrence>>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  priceDescription: Maybe<Scalars['String']['output']>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  reviewStatus: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sponsored: Maybe<Scalars['Boolean']['output']>;
  stores: Maybe<Array<Maybe<SgcfStore>>>;
  supportingImageSet: Maybe<SgcfSupportingImageSet>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: SgcfSys;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  viewOption: Maybe<Scalars['String']['output']>;
};

export type SgcfExclusionsContentSource = SgcfEntry & {
  __typename?: 'SGCFExclusionsContentSource';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  contentTemplates: Array<Maybe<SgcfContentTemplate>>;
  sys: SgcfSys;
  variant: Maybe<Scalars['String']['output']>;
};

export type SgcfExperience = SgcfEntry & {
  __typename?: 'SGCFExperience';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Maybe<Scalars['String']['output']>;
  heroImageSet: SgcfHeroImageSet;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfFeatureManagement = SgcfEntry & {
  __typename?: 'SGCFFeatureManagement';
  featureSlug: Scalars['String']['output'];
  json: Scalars['CFJSON']['output'];
  scope: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfFeaturedCommerce = SgcfEntry & {
  __typename?: 'SGCFFeaturedCommerce';
  backendTitle: Scalars['String']['output'];
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  externalLink: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<SgcfHeroImageSet>;
  priceDescription: Maybe<Scalars['String']['output']>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  shortDescription: Maybe<Scalars['String']['output']>;
  stores: Maybe<Array<Maybe<SgcfStore>>>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
};

export type SgcfFeaturedLink = SgcfEntry & {
  __typename?: 'SGCFFeaturedLink';
  backendTitle: Scalars['String']['output'];
  callToActionLabel: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<SgcfHeroImageSet>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  textColour: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SgcfGenderSegmentedManualContentSource = SgcfEntry & {
  __typename?: 'SGCFGenderSegmentedManualContentSource';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  contentTemplates: Array<Maybe<SgcfContentTemplate>>;
  count: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  variant: Maybe<Scalars['String']['output']>;
};

export type SgcfGenericAdZone = SgcfEntry & {
  __typename?: 'SGCFGenericAdZone';
  adTypes: Array<Maybe<Scalars['String']['output']>>;
  backendTitle: Scalars['String']['output'];
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  siteId: Scalars['String']['output'];
  sys: SgcfSys;
  zoneId: Scalars['String']['output'];
};

export type SgcfGiftcardTemplate = SgcfEntry & {
  __typename?: 'SGCFGiftcardTemplate';
  backendTitle: Scalars['String']['output'];
  path: Scalars['String']['output'];
  shortDescriptionMetaDescription: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfHeroImageSet = SgcfEntry & {
  __typename?: 'SGCFHeroImageSet';
  backendTitle: Scalars['String']['output'];
  bynderMaster: Maybe<Scalars['CFJSON']['output']>;
  bynderMasterCinemagraph: Maybe<Scalars['CFJSON']['output']>;
  bynderPoster: Maybe<Scalars['CFJSON']['output']>;
  bynderSquare: Maybe<Scalars['CFJSON']['output']>;
  bynderStandard: Maybe<Scalars['CFJSON']['output']>;
  description: Scalars['String']['output'];
  master: Maybe<SgcfAsset>;
  masterCinemagraph: Maybe<SgcfAsset>;
  masterSupportingColour: Maybe<Scalars['String']['output']>;
  poster: Maybe<SgcfAsset>;
  publishableStatus: Scalars['String']['output'];
  square: Maybe<SgcfAsset>;
  squareSupportingColour: Maybe<Scalars['String']['output']>;
  standard: Maybe<SgcfAsset>;
  standardSupportingColour: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
};

export type SgcfInstantDraw = SgcfEntry & {
  __typename?: 'SGCFInstantDraw';
  backendTitle: Scalars['String']['output'];
  callToAction: Scalars['String']['output'];
  drumRollAnimation: Maybe<Scalars['String']['output']>;
  faqUrl: Maybe<Scalars['String']['output']>;
  inCentrePresenceCheck: Scalars['Boolean']['output'];
  prizeCount: Maybe<Scalars['Float']['output']>;
  sendSuccessEmail: Scalars['Boolean']['output'];
  successBody: Maybe<Scalars['String']['output']>;
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  successTitle: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  unluckyScreenAnimation: Maybe<Scalars['String']['output']>;
  unluckySubTitle: Maybe<Scalars['String']['output']>;
  unluckyTitle: Maybe<Scalars['String']['output']>;
};

export type SgcfIntroductions = SgcfEntry & {
  __typename?: 'SGCFIntroductions';
  backendTitle: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfJourneyBanner = SgcfEntry & {
  __typename?: 'SGCFJourneyBanner';
  description: Scalars['String']['output'];
  imageSet: Maybe<SgcfHeroImageSet>;
  offerToOpen: Maybe<SgcfOffer>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfLoyaltyProgram = SgcfEntry & {
  __typename?: 'SGCFLoyaltyProgram';
  androidAppBundleId: Maybe<Scalars['String']['output']>;
  backendTitle: Scalars['String']['output'];
  brandBackgroundColor: Maybe<Scalars['String']['output']>;
  canAddMembership: Scalars['Boolean']['output'];
  canSignup: Scalars['Boolean']['output'];
  cardAssetImage: Maybe<Scalars['CFJSON']['output']>;
  description: Scalars['String']['output'];
  hasAccountLogin: Scalars['Boolean']['output'];
  hasBarcode: Scalars['Boolean']['output'];
  hasCard: Scalars['Boolean']['output'];
  hasCardNumber: Scalars['Boolean']['output'];
  hasMembershipNumber: Scalars['Boolean']['output'];
  iosAppName: Maybe<Scalars['String']['output']>;
  iosAppStoreId: Maybe<Scalars['String']['output']>;
  iosAppUrlScheme: Maybe<Scalars['String']['output']>;
  isInverse: Maybe<Scalars['Boolean']['output']>;
  legacyCardAssetImage: Maybe<Scalars['String']['output']>;
  loginUrl: Maybe<Scalars['String']['output']>;
  membershipBarcodeFormat: Maybe<Scalars['String']['output']>;
  signupUrl: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfManualCollection = SgcfEntry & {
  __typename?: 'SGCFManualCollection';
  backendTitle: Scalars['String']['output'];
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  displayMode: Scalars['String']['output'];
  displayModeV2: Maybe<Scalars['String']['output']>;
  relatedContent: Maybe<Scalars['CFJSON']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Maybe<Scalars['String']['output']>;
};

export type SgcfManualContentSource = SgcfEntry & {
  __typename?: 'SGCFManualContentSource';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  contentTemplates: Array<Maybe<SgcfContentTemplate>>;
  count: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  variant: Maybe<Scalars['String']['output']>;
};

export type SgcfManualSolusModule = SgcfEntry & {
  __typename?: 'SGCFManualSolusModule';
  backendTitle: Scalars['String']['output'];
  callToActionAddress: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  intent: Scalars['String']['output'];
  sys: SgcfSys;
  title: Maybe<Scalars['String']['output']>;
};

export type SgcfNationalExperiencePage = SgcfEntry & {
  __typename?: 'SGCFNationalExperiencePage';
  backendTitle: Scalars['String']['output'];
  categories: Maybe<Array<Maybe<SgcfFeaturedLink>>>;
  featuredCategories: Maybe<Array<Maybe<SgcfFeaturedLink>>>;
  featuredRetailers: Maybe<Array<Maybe<SgcfRetailer>>>;
  metaTitle: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfNationalHomepage = SgcfEntry & {
  __typename?: 'SGCFNationalHomepage';
  backendTitle: Scalars['String']['output'];
  bynderWDeviceLarge: Maybe<Scalars['CFJSON']['output']>;
  bynderWDeviceSmall: Maybe<Scalars['CFJSON']['output']>;
  country: Array<Maybe<Scalars['String']['output']>>;
  featuredCategories: Maybe<Array<Maybe<SgcfFeaturedLink>>>;
  featuredRetailers: Maybe<Array<Maybe<SgcfRetailer>>>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  privacyPolicy: Scalars['String']['output'];
  promotionModule: SgcfPromotion;
  promotionModules: Maybe<Array<Maybe<SgcfPromotion>>>;
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  termsAndConditions: Scalars['String']['output'];
  termsAndConditionsVersion: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  wDeviceLarge: Maybe<SgcfAsset>;
  wDeviceSmall: Maybe<SgcfAsset>;
};

export type SgcfNationalStorefront = SgcfEntry & {
  __typename?: 'SGCFNationalStorefront';
  backendTitle: Scalars['String']['output'];
  retailer: SgcfRetailer;
  sys: SgcfSys;
};

export type SgcfNews = SgcfEntry & {
  __typename?: 'SGCFNews';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Scalars['String']['output'];
  centres: Array<Maybe<SgcfCentre>>;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  hasModeratedImages: Maybe<Scalars['Boolean']['output']>;
  heroImageSet: SgcfHeroImageSet;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  profile: Maybe<SgcfProfile>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  reviewStatus: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sponsored: Maybe<Scalars['Boolean']['output']>;
  stores: Maybe<Array<Maybe<SgcfStore>>>;
  supportingImageSet: Maybe<SgcfSupportingImageSet>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  viewOption: Maybe<Scalars['String']['output']>;
};

export type SgcfOccurrence = SgcfEntry & {
  __typename?: 'SGCFOccurrence';
  backendTitle: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfOffer = SgcfEntry & {
  __typename?: 'SGCFOffer';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Maybe<Scalars['String']['output']>;
  branchDeepLink: Maybe<Scalars['String']['output']>;
  branchFallbackUrl: Maybe<Scalars['String']['output']>;
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  cloOfferId: Maybe<Scalars['String']['output']>;
  ctaType: Maybe<Scalars['String']['output']>;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  enableNationalOffer: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  faq: Maybe<Scalars['String']['output']>;
  hasModeratedImages: Maybe<Scalars['Boolean']['output']>;
  heroImageSet: SgcfHeroImageSet;
  inCentrePresenceCheck: Maybe<Scalars['Boolean']['output']>;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  journeyBanner: Maybe<SgcfJourneyBanner>;
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  popupLocation: Maybe<Scalars['String']['output']>;
  promoQrCode: Maybe<Scalars['String']['output']>;
  promoSuccessBody: Maybe<Scalars['String']['output']>;
  promoSuccessTitle: Maybe<Scalars['String']['output']>;
  promotionType: Maybe<Scalars['String']['output']>;
  requiresQRCodeScan: Maybe<Scalars['Boolean']['output']>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  reviewStatus: Maybe<Scalars['String']['output']>;
  sendSuccessEmail: Maybe<Scalars['Boolean']['output']>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sponsored: Maybe<Scalars['Boolean']['output']>;
  stores: Array<Maybe<SgcfStore>>;
  successEmailAdditionalCopy: Maybe<Scalars['String']['output']>;
  supportingImageSet: Maybe<SgcfSupportingImageSet>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: SgcfSys;
  termsAndConditions: Maybe<Scalars['String']['output']>;
  termsAndConditionsFile: Maybe<SgcfAsset>;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  viewOption: Maybe<Scalars['String']['output']>;
};

export type SgcfParkingRate = SgcfEntry & {
  __typename?: 'SGCFParkingRate';
  backendTitle: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  sys: SgcfSys;
  toInMinutes: Maybe<Scalars['Int']['output']>;
};

export type SgcfParkingRatesCard = SgcfEntry & {
  __typename?: 'SGCFParkingRatesCard';
  backendTitle: Scalars['String']['output'];
  days: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overnightRate: Scalars['Float']['output'];
  rates: Maybe<Array<Maybe<SgcfParkingRate>>>;
  sys: SgcfSys;
};

export type SgcfParkingRules = SgcfEntry & {
  __typename?: 'SGCFParkingRules';
  backendTitle: Scalars['String']['output'];
  cinemaValidation: Maybe<Scalars['String']['output']>;
  freeEntryTime: Maybe<Scalars['String']['output']>;
  freeExitTime: Maybe<Scalars['String']['output']>;
  ratesCards: Maybe<Array<Maybe<SgcfParkingRatesCard>>>;
  specialConditions: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfParkingTemplate = SgcfEntry & {
  __typename?: 'SGCFParkingTemplate';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfPartnerCouponCode = SgcfEntry & {
  __typename?: 'SGCFPartnerCouponCode';
  backendTitle: Scalars['String']['output'];
  successEmailAdditionalCopy: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfPersonalisedContentSource = SgcfEntry & {
  __typename?: 'SGCFPersonalisedContentSource';
  backendTitle: Scalars['String']['output'];
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  contentTemplates: Array<Maybe<SgcfContentTemplate>>;
  contentTypes: Array<Maybe<Scalars['String']['output']>>;
  count: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  variant: Maybe<Scalars['String']['output']>;
};

export type SgcfProductCollection = SgcfEntry & {
  __typename?: 'SGCFProductCollection';
  allowAutoSurface: Scalars['Boolean']['output'];
  backendTitle: Scalars['String']['output'];
  blurbBody: Maybe<Scalars['String']['output']>;
  blurbTitle: Maybe<Scalars['String']['output']>;
  bodyCopy: Scalars['String']['output'];
  displayMode: Scalars['String']['output'];
  edmSubject: Maybe<Scalars['String']['output']>;
  h1Header: Scalars['String']['output'];
  heroImageSet: SgcfHeroImageSet;
  pageTitle: Scalars['String']['output'];
  productsJson: Scalars['CFJSON']['output'];
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfProfile = SgcfEntry & {
  __typename?: 'SGCFProfile';
  backendTitle: Scalars['String']['output'];
  bynderProfileImage: Maybe<Scalars['CFJSON']['output']>;
  fullName: Scalars['String']['output'];
  profileImage: Maybe<SgcfAsset>;
  profileType: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  stores: Maybe<Array<Maybe<SgcfStore>>>;
  sys: SgcfSys;
};

export type SgcfPromotion = SgcfEntry & {
  __typename?: 'SGCFPromotion';
  backendTitle: Scalars['String']['output'];
  bynderImage: Maybe<Scalars['CFJSON']['output']>;
  callToActionAddress: Scalars['String']['output'];
  callToActionLabel: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  image: Maybe<SgcfAsset>;
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfPromotionalTemplate = SgcfEntry & {
  __typename?: 'SGCFPromotionalTemplate';
  backendTitle: Scalars['String']['output'];
  country: Array<Maybe<Scalars['String']['output']>>;
  metaTitle: Maybe<Scalars['String']['output']>;
  navigationMenu: Maybe<Scalars['CFJSON']['output']>;
  path: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfQuestion = SgcfEntry & {
  __typename?: 'SGCFQuestion';
  answers: Maybe<Array<Maybe<SgcfAnswer>>>;
  backendTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfRetailCategory = SgcfEntry & {
  __typename?: 'SGCFRetailCategory';
  aliases: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  backendTitle: Scalars['String']['output'];
  heroImageSet: Maybe<SgcfHeroImageSet>;
  level: Maybe<Scalars['Int']['output']>;
  parentCategory: Maybe<SgcfRetailCategory>;
  seoContentSchema: Maybe<Scalars['CFJSON']['output']>;
  seoTitle: Maybe<Scalars['String']['output']>;
  /**
   * when part of a search facet selection (eg. Query.sgRetailersFacetRetailerCategories)
   * indicates the count of documents matching the search criteria
   */
  sgFacetCount: Maybe<Scalars['Int']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfRetailer = SgcfEntry & {
  __typename?: 'SGCFRetailer';
  backendTitle: Scalars['String']['output'];
  callsToAction: Maybe<Array<Maybe<SgcfCallToAction>>>;
  country: Scalars['String']['output'];
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  facebook: Maybe<Scalars['String']['output']>;
  featuredFacets: Maybe<Array<Maybe<SgcfFeaturedLink>>>;
  heroImageSet: Maybe<SgcfHeroImageSet>;
  hideReviews: Maybe<Scalars['Boolean']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  legacyIdentifier: Maybe<Scalars['Int']['output']>;
  longDescription: Maybe<Scalars['String']['output']>;
  loyaltyPrograms: Maybe<Array<Maybe<SgcfLoyaltyProgram>>>;
  marketplaceShopId: Maybe<Scalars['String']['output']>;
  marketplaceShopSlug: Maybe<Scalars['String']['output']>;
  nationalStorefront: Maybe<SgcfNationalStorefront>;
  paymentMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priceDescription: Maybe<Scalars['String']['output']>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  retailerLogoSet: Maybe<SgcfRetailerLogoSet>;
  retailerSizeGuide: Maybe<Scalars['String']['output']>;
  services: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settings: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** The list of stores from the retailer document in the sg_retailers collection in Typesense */
  storesFromRetailersSearch: Maybe<SgStoresFromRetailersSearchResponse>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  twitter: Maybe<Scalars['String']['output']>;
  websiteAddress: Maybe<Scalars['String']['output']>;
};


export type SgcfRetailerStoresFromRetailersSearchArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
};

export type SgcfRetailerLogoSet = SgcfEntry & {
  __typename?: 'SGCFRetailerLogoSet';
  backendTitle: Scalars['String']['output'];
  bynderColoured: Maybe<Scalars['CFJSON']['output']>;
  bynderTileBackground: Maybe<Scalars['CFJSON']['output']>;
  bynderTransparent: Maybe<Scalars['CFJSON']['output']>;
  coloured: Maybe<SgcfAsset>;
  sys: SgcfSys;
  tileBackground: Maybe<SgcfAsset>;
  transparent: Maybe<SgcfAsset>;
};

export type SgcfSearchSuggestions = SgcfEntry & {
  __typename?: 'SGCFSearchSuggestions';
  backendTitle: Scalars['String']['output'];
  centre: Maybe<SgcfCentre>;
  context: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
};

export type SgcfSection = SgcfEntry & {
  __typename?: 'SGCFSection';
  backendTitle: Scalars['String']['output'];
  displayMode: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfService = SgcfEntry & {
  __typename?: 'SGCFService';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Scalars['String']['output'];
  category: Maybe<Scalars['String']['output']>;
  centre: SgcfCentre;
  heroImageSet: Maybe<SgcfHeroImageSet>;
  landmarkDescription: Maybe<Scalars['String']['output']>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  store: Maybe<SgcfStore>;
  sys: SgcfSys;
  telephoneNumber: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SgcfSocial = SgcfEntry & {
  __typename?: 'SGCFSocial';
  description: Scalars['String']['output'];
  stores: Array<Maybe<SgcfStore>>;
  supportingImageSet: Maybe<SgcfSupportingImageSet>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfSocialFeed = SgcfEntry & {
  __typename?: 'SGCFSocialFeed';
  backendTitle: Scalars['String']['output'];
  stacklaWidget: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfSolusTemplate = SgcfEntry & {
  __typename?: 'SGCFSolusTemplate';
  backendTitle: Scalars['String']['output'];
  centre: Maybe<SgcfCentre>;
  scope: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  sys: SgcfSys;
};

export type SgcfStaticBannerSolusModule = SgcfEntry & {
  __typename?: 'SGCFStaticBannerSolusModule';
  backendTitle: Scalars['String']['output'];
  callToActionAddress: Scalars['String']['output'];
  callToActionLabel: Scalars['String']['output'];
  desktopImageUrl: Scalars['String']['output'];
  mobileImageUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfStaticFile = SgcfEntry & {
  __typename?: 'SGCFStaticFile';
  backendTitle: Scalars['String']['output'];
  country: Array<Maybe<Scalars['String']['output']>>;
  jsonContent: Maybe<Scalars['CFJSON']['output']>;
  path: Scalars['String']['output'];
  plainTextContent: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
};

export type SgcfStore = SgcfEntry & {
  __typename?: 'SGCFStore';
  backendTitle: Scalars['String']['output'];
  bynderStoreFrontImage: Maybe<Scalars['CFJSON']['output']>;
  callsToAction: Maybe<Array<Maybe<SgcfCallToAction>>>;
  centre: SgcfCentre;
  emailAddress: Maybe<Scalars['String']['output']>;
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  facebook: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<SgcfHeroImageSet>;
  hideReviews: Maybe<Scalars['Boolean']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  landmarkDescription: Maybe<Scalars['String']['output']>;
  legacyIdentifier: Maybe<Scalars['Int']['output']>;
  level: Maybe<Scalars['String']['output']>;
  longDescription: Maybe<Scalars['String']['output']>;
  parkingInstructions: Maybe<Scalars['String']['output']>;
  paymentMethods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  physicalAddress: Maybe<Scalars['String']['output']>;
  priceDescription: Maybe<Scalars['String']['output']>;
  reputationCode: Maybe<Scalars['String']['output']>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  retailer: SgcfRetailer;
  services: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shopNumber: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  specialStatus: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  storeFrontImage: Maybe<SgcfAsset>;
  storeType: Scalars['String']['output'];
  sys: SgcfSys;
  telephoneNumber: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  twitter: Maybe<Scalars['String']['output']>;
  waypoint: Maybe<Scalars['String']['output']>;
  websiteAddress: Maybe<Scalars['String']['output']>;
};

export type SgcfStory = SgcfEntry & {
  __typename?: 'SGCFStory';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Maybe<Scalars['String']['output']>;
  callToActionLabel: Maybe<Scalars['String']['output']>;
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  edmSubheading: Maybe<Scalars['String']['output']>;
  edmSubject: Maybe<Scalars['String']['output']>;
  edmTitle: Maybe<Scalars['String']['output']>;
  experiences: Maybe<Array<Maybe<SgcfExperience>>>;
  heroImageSet: SgcfHeroImageSet;
  isSensitiveContent: Maybe<Scalars['Boolean']['output']>;
  national: Maybe<Array<Maybe<SgcfNationalHomepage>>>;
  profiles: Maybe<Array<Maybe<SgcfProfile>>>;
  retailCategories: Maybe<Array<Maybe<SgcfRetailCategory>>>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sponsored: Maybe<Scalars['Boolean']['output']>;
  stores: Maybe<Array<Maybe<SgcfStore>>>;
  surfaceContentInChannel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: SgcfSys;
  theEdit: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  topics: Maybe<Array<Maybe<SgcfTopic>>>;
  viewOption: Maybe<Scalars['String']['output']>;
};

export type SgcfSupportingImageSet = SgcfEntry & {
  __typename?: 'SGCFSupportingImageSet';
  backendTitle: Scalars['String']['output'];
  bynderMedia: Maybe<Scalars['CFJSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  images: Maybe<Array<Maybe<SgcfAsset>>>;
  sys: SgcfSys;
};

export type SgcfSys = {
  __typename?: 'SGCFSys';
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
};

export type SgcfTemplate = SgcfEntry & {
  __typename?: 'SGCFTemplate';
  backendTitle: Scalars['String']['output'];
  centres: Array<Maybe<SgcfCentre>>;
  path: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfTerms = SgcfEntry & {
  __typename?: 'SGCFTerms';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Scalars['String']['output'];
  country: Array<Maybe<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
};

export type SgcfTopStrip = SgcfEntry & {
  __typename?: 'SGCFTopStrip';
  actionText: Scalars['String']['output'];
  backendTitle: Scalars['String']['output'];
  backgroundColour: Maybe<Scalars['String']['output']>;
  backgroundImage: Maybe<SgcfAsset>;
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  country: Array<Maybe<Scalars['String']['output']>>;
  foregroundImage: SgcfAsset;
  shortDescription: Scalars['String']['output'];
  sys: SgcfSys;
  url: Scalars['String']['output'];
};

export type SgcfTopic = SgcfEntry & {
  __typename?: 'SGCFTopic';
  backendTitle: Scalars['String']['output'];
  bodyCopy: Maybe<Scalars['String']['output']>;
  centres: Maybe<Array<Maybe<SgcfCentre>>>;
  description: Maybe<Scalars['String']['output']>;
  heroImageSet: SgcfHeroImageSet;
  parentTopic: Maybe<SgcfTopic>;
  shortDescription: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sponsored: Scalars['Boolean']['output'];
  sys: SgcfSys;
  title: Scalars['String']['output'];
  topicType: Array<Maybe<Scalars['String']['output']>>;
};

export type SgcfUtilityPanel = SgcfEntry & {
  __typename?: 'SGCFUtilityPanel';
  backendTitle: Scalars['String']['output'];
  heading: Maybe<Scalars['String']['output']>;
  sys: SgcfSys;
};

export type SgcfWhatsHappeningFilters = SgcfEntry & {
  __typename?: 'SGCFWhatsHappeningFilters';
  backendTitle: Scalars['String']['output'];
  centre: SgcfCentre;
  experienceFilters: Maybe<Array<Maybe<SgcfExperience>>>;
  sys: SgcfSys;
  topicFilters: Maybe<Array<Maybe<SgcfTopic>>>;
};

export type SgCentreStore = {
  __typename?: 'SGCentreStore';
  categories: Array<SgRetailCategory>;
  id: Scalars['ID']['output'];
  landmarkDescription: Maybe<Scalars['String']['output']>;
  legacyIdentifier: Maybe<Scalars['Int']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  longDescription: Maybe<Scalars['String']['output']>;
  paymentMethods: Array<Scalars['String']['output']>;
  retailer: Maybe<SgRetailer>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SgGenericTodayItemEntry = {
  __typename?: 'SGGenericTodayItemEntry';
  adConfig: Maybe<AdConfig>;
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  clickUrl: Maybe<Scalars['String']['output']>;
  heroImageSet: Maybe<CfHeroImageSet>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  title: Maybe<Scalars['String']['output']>;
};

export type SgPageTemplate = {
  __typename?: 'SGPageTemplate';
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  metaTitle: Maybe<Scalars['String']['output']>;
  modules: Array<Maybe<SgPageTemplateModule>>;
  shortDescription: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SgPageTemplateAdZone = {
  __typename?: 'SGPageTemplateAdZone';
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
};

export type SgPageTemplateBasicContent = {
  __typename?: 'SGPageTemplateBasicContent';
  bodyCopy: Maybe<Scalars['String']['output']>;
  callsToAction: Array<SgPageTemplateCallToAction>;
  shortDescription: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SgPageTemplateCallToAction = {
  __typename?: 'SGPageTemplateCallToAction';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SgPageTemplateContentCollection = {
  __typename?: 'SGPageTemplateContentCollection';
  analyticsMetadata: Maybe<DisplayAnalyticsMetadata>;
  callToAction: Maybe<SgPageTemplateCallToAction>;
  items: Array<Maybe<SgPageTemplateContentCollectionItem>>;
  kind: SgPageTemplateContentCollectionKind;
  shortDescription: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type SgPageTemplateContentCollectionItem = SgPageTemplateAdZone | SgPageTemplateContentEntry;

export enum SgPageTemplateContentCollectionKind {
  Banner = 'BANNER',
  CategoryGrid = 'CATEGORY_GRID',
  ColourCards = 'COLOUR_CARDS',
  Feature = 'FEATURE',
  InlineDeck = 'INLINE_DECK',
  Spotlight = 'SPOTLIGHT',
  StoreGrid = 'STORE_GRID',
  UtilityPanel = 'UTILITY_PANEL',
  WhatsHappeningDeck = 'WHATS_HAPPENING_DECK'
}

export type SgPageTemplateContentEntry = {
  __typename?: 'SGPageTemplateContentEntry';
  adConfig: Maybe<AdConfigType>;
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  callToAction: SgPageTemplateCallToAction;
  highlightAttribute: Maybe<HighlightAttributes>;
  image: SgPageTemplateImage;
  kind: Scalars['String']['output'];
  memberExclusive: Maybe<Scalars['Boolean']['output']>;
  orchestrationAnalyticsMetadata: Maybe<ContentOrchestrationAnalyticsMetadata>;
  secondaryImage: Maybe<SgPageTemplateImage>;
  shortDescription: Maybe<Scalars['String']['output']>;
  supplementaryText: Maybe<Scalars['String']['output']>;
  textColour: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SgPageTemplateDynamicContent = {
  __typename?: 'SGPageTemplateDynamicContent';
  kind: Scalars['String']['output'];
};

export type SgPageTemplateImage = {
  __typename?: 'SGPageTemplateImage';
  alt: Maybe<Scalars['String']['output']>;
  analyticsMetadata: Maybe<ContentAnalyticsMetadata>;
  cinemagraphUrl: Maybe<Scalars['String']['output']>;
  supportingColour: Maybe<Scalars['String']['output']>;
  type: SgPageTemplateImageType;
  url: Scalars['String']['output'];
};

export enum SgPageTemplateImageType {
  Square = 'SQUARE',
  Wide = 'WIDE'
}

export type SgPageTemplateModule = SgPageTemplateBasicContent | SgPageTemplateContentCollection | SgPageTemplateDynamicContent;

export type SgRetailCategory = {
  __typename?: 'SGRetailCategory';
  id: Scalars['ID']['output'];
  level: Maybe<Scalars['Int']['output']>;
  parentId: Maybe<Scalars['ID']['output']>;
  seoContentSchema: Maybe<Scalars['CFJSON']['output']>;
  seoTitle: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SgRetailer = {
  __typename?: 'SGRetailer';
  id: Scalars['ID']['output'];
  paymentMethods: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SgRetailersSearchFilter = {
  /** Australia | New Zealand */
  country: InputMaybe<Scalars['String']['input']>;
  retailCategoryIds: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SgRetailersSearchOrder {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type SgRetailersSearchResponse = {
  __typename?: 'SGRetailersSearchResponse';
  items: Array<Maybe<SgcfRetailer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SgStoresFromRetailersSearchResponse = {
  __typename?: 'SGStoresFromRetailersSearchResponse';
  items: Array<Maybe<SgcfStore>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SaveAddressInput = {
  address: AddressInput;
  /** Optional: updates existing if supplied, inserts new if not supplied */
  id: InputMaybe<Scalars['UUID']['input']>;
  /**
   * If true sets this address to the default.
   * If false and this is the first address, it will still become default.
   * If false, does not unset this address if it was already default.
   * You can not unset a default address, you can only set another to true.
   */
  isDefault: Scalars['Boolean']['input'];
};

export type SavePaymentMethodInput = {
  billingAddress: AddressInput;
  /**
   * If true sets this payment method to the default.
   * If false and this is the first payment method, it will still become default.
   * If false, does not unset this payment method if it was already default.
   * You can not unset a default payment method, you can only set another to true.
   */
  isDefault: InputMaybe<Scalars['Boolean']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
};

export type SaveWalletReferenceInput = {
  cardReferenceNumber: Scalars['String']['input'];
  walletReference: Scalars['String']['input'];
  walletType: WalletType;
};

export type SearchResult = CfEvent | CfOffer;

export type Session = {
  __typename?: 'Session';
  bookingUrl: Maybe<Scalars['String']['output']>;
  startTime: Maybe<Scalars['String']['output']>;
};

export type SetDefaultPaymentMethodInput = {
  stripePaymentMethodId: Scalars['String']['input'];
};

export type SharePlateInput = {
  email: Scalars['String']['input'];
  plate: Scalars['String']['input'];
  registeredIn: Scalars['String']['input'];
};

export type SharePlateOutput = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SharePlateOutputFailure = SharePlateOutput & {
  __typename?: 'SharePlateOutputFailure';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SharePlateOutputSuccess = SharePlateOutput & {
  __typename?: 'SharePlateOutputSuccess';
  invitationDays: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SharedPlate = {
  __typename?: 'SharedPlate';
  email: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  registeredIn: Scalars['String']['output'];
  state: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ShippingAddressInput = {
  address1: Scalars['String']['input'];
  address2: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  state: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};

export type ShippingAddressInputMinimal = {
  address1: Scalars['String']['input'];
  address2: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  postCode: Scalars['String']['input'];
  state: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['String']['input'];
  suburb: Scalars['String']['input'];
};

export type ShippingOption = {
  __typename?: 'ShippingOption';
  additionalDescription: Maybe<Scalars['String']['output']>;
  cost: Maybe<Scalars['Float']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  transitTime: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Store = {
  __typename?: 'Store';
  contentfulStoreId: Scalars['String']['output'];
};

export type StringFilter = {
  contains: InputMaybe<Scalars['String']['input']>;
  eq: InputMaybe<Scalars['String']['input']>;
  ignoreCase: InputMaybe<Scalars['Boolean']['input']>;
  in: InputMaybe<Array<Scalars['String']['input']>>;
  prefix: InputMaybe<Scalars['String']['input']>;
  suffix: InputMaybe<Scalars['String']['input']>;
};

export type SubmitInstantEarnInput = {
  centreSlug: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
};

export type TermsAndConditionsInput = {
  version: Scalars['String']['input'];
};

export type TodayItem = CfEntryTodayItem | CfFeaturedEntryTodayItem;

export type TodayItemCollection = {
  __typename?: 'TodayItemCollection';
  items: Array<Maybe<TodayItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TradingHourDay = {
  __typename?: 'TradingHourDay';
  closingTime: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  dayOfTheWeek: DayOfTheWeek;
  description: Maybe<Scalars['String']['output']>;
  hourStatus: Maybe<HourStatus>;
  hourType: Maybe<HourType>;
  isClosed: Scalars['Boolean']['output'];
  openingTime: Scalars['String']['output'];
};

/** The statuses for transaction type */
export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type TransfersExportResponse = {
  __typename?: 'TransfersExportResponse';
  dgcReferenceNumber: Scalars['String']['output'];
  initialCardValue: Maybe<Scalars['Float']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderReference: Maybe<Scalars['String']['output']>;
  orderTotal: Scalars['Float']['output'];
  transferAmount: Scalars['Float']['output'];
  vendorOrderId: Maybe<Scalars['Int']['output']>;
};

export type UnsubscribeCustomerWithEmailInput = {
  channel: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type UnsubscribeCustomerWithPreferencesTokenInput = {
  channel: Scalars['String']['input'];
  encryptedEmail: Scalars['String']['input'];
  preferencesToken: Scalars['String']['input'];
};

export type UnsubscribeWithEmailInput = {
  channel: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type UnsubscribeWithPreferencesTokenInput = {
  channel: Scalars['String']['input'];
  encryptedEmail: Scalars['String']['input'];
  preferencesToken: Scalars['String']['input'];
};

export type UpdateCustomerConsentInput = {
  channel: Scalars['String']['input'];
  consent: ConsentInput;
};

export type UpdateCustomerPreferencesInput = {
  channel: Scalars['String']['input'];
  preferences: PreferenceInput;
};

export type UpdateDigitalGiftCardDisplayStatusInput = {
  displayStatus: DigitalGiftCardDisplayStatus;
  referenceNumber: Scalars['String']['input'];
};

export type UpdateItemQuantityInput = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpdateItemSourceLocationResult = {
  __typename?: 'UpdateItemSourceLocationResult';
  updateSuccess: Scalars['Boolean']['output'];
};

export type UpdateLoyaltyProgramMembershipInput = {
  barcodeValue: InputMaybe<Scalars['String']['input']>;
  cardNumber: InputMaybe<Scalars['String']['input']>;
  customCardName: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  membershipNumber: InputMaybe<Scalars['String']['input']>;
  scannedBarcodeFormat: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMarketplaceOrderShippingDetailsInput = {
  city: InputMaybe<Scalars['String']['input']>;
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  postCode: InputMaybe<Scalars['String']['input']>;
  state: InputMaybe<Scalars['String']['input']>;
  street1: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMarketplaceOrderShippingDetailsResult = {
  __typename?: 'UpdateMarketplaceOrderShippingDetailsResult';
  success: Scalars['Boolean']['output'];
};

export type UpdateOrderItemStatusResult = {
  __typename?: 'UpdateOrderItemStatusResult';
  updatedItems: Array<CommerceAdminWestfieldDirectItem>;
};

export type UpdateOrderStatusResult = {
  __typename?: 'UpdateOrderStatusResult';
  id: Scalars['ID']['output'];
  status: BigCommerceOrderStatus;
};

export type UpdateSuccessResult = {
  __typename?: 'UpdateSuccessResult';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ValetPickupInput = {
  centreId: Scalars['String']['input'];
  plate: Scalars['String']['input'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  errorCode: Maybe<ValidationErrorCode>;
  message: Scalars['String']['output'];
  property: Maybe<Scalars['String']['output']>;
};

export enum ValidationErrorCode {
  DuplicateData = 'DuplicateData',
  FieldCannotBeBlank = 'FieldCannotBeBlank',
  InvalidFormat = 'InvalidFormat',
  MissingRequiredField = 'MissingRequiredField'
}

export type VehicleShare = {
  __typename?: 'VehicleShare';
  email: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type VerifyMobileNumberInput = {
  code: Scalars['String']['input'];
};

export type VerifyPasswordResetTokenInput = {
  token: Scalars['String']['input'];
};

/** Options for delivery of virtual giftcard item */
export enum VirtualGiftCardDeliveryMethod {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Virtual gift card item to add to a cart. */
export type VirtualGiftCardItemInput = {
  /** The id of the product in the commerce platform. */
  id: Scalars['ID']['input'];
  /** The recipient's details. */
  recipientDetails: VirtualGiftCardRecipientDetails;
  /** The SKU of the product in the commerce platform. */
  sku: Scalars['String']['input'];
  /** The value of the Gift Card. */
  value: Scalars['Float']['input'];
};

export type VirtualGiftCardRecipientDetails = {
  deliveryDate: Scalars['Date']['input'];
  deliveryMethod: VirtualGiftCardDeliveryMethod;
  message: InputMaybe<Scalars['String']['input']>;
  recipientEmail: InputMaybe<Scalars['String']['input']>;
  recipientMobileNumber: InputMaybe<Scalars['String']['input']>;
  recipientName: InputMaybe<Scalars['String']['input']>;
  senderName: InputMaybe<Scalars['String']['input']>;
};

/** Sender and recipient details for virtual giftcard items */
export type VirtualRecipientDetails = RecipientDetails & {
  __typename?: 'VirtualRecipientDetails';
  deliveryDate: Scalars['Date']['output'];
  deliveryMethod: VirtualGiftCardDeliveryMethod;
  message: Maybe<Scalars['String']['output']>;
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientMobileNumber: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  senderName: Maybe<Scalars['String']['output']>;
};

export type WalletReference = {
  __typename?: 'WalletReference';
  referenceCode: Scalars['String']['output'];
  walletType: WalletType;
};

export enum WalletType {
  AppleWallet = 'APPLE_WALLET',
  GooglePay = 'GOOGLE_PAY'
}

export type WebOnboarding = {
  __typename?: 'WebOnboarding';
  required: Array<Scalars['String']['output']>;
  reviewRequired: Array<Scalars['String']['output']>;
};

export type WestfieldPlusData = {
  __typename?: 'WestfieldPlusData';
  emailMarketingOptIn: Maybe<Scalars['Boolean']['output']>;
  emailMarketingOptInAt: Maybe<Scalars['String']['output']>;
  parkPlusTransitionAcceptedAt: Maybe<Scalars['String']['output']>;
  parkPlusTransitionRejectedAt: Maybe<Scalars['String']['output']>;
  termsAndConditionsAcceptedAt: Maybe<Scalars['String']['output']>;
  termsAndConditionsVersion: Maybe<Scalars['String']['output']>;
};

export type UpdateBillingAddressesNameInput = {
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
};

export type DeletePendingEmailChangeMutationVariables = Exact<{ [key: string]: never; }>;


export type DeletePendingEmailChangeMutation = { __typename?: 'Mutation', deletePendingEmailChange: boolean | null };

export type ContentDetailStoreFragment = { __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null };

export type GetCinemaDetailQueryVariables = Exact<{
  centreId: Scalars['String']['input'];
}>;


export type GetCinemaDetailQuery = { __typename?: 'Query', centreCinema: { __typename?: 'CFCentre', cinema: { __typename: 'CFStore', title: string | null, shortDescription: string | null, longDescription: string | null, telephoneNumber: string | null, websiteAddress: string | null, physicalAddress: string | null, landmarkDescription: string | null, parkingInstructions: string | null, paymentMethods: Array<string | null> | null, services: Array<string | null> | null, legacyIdentifier: number | null, slug: string | null, status: string | null, storeTitle: string | null, bodyCopy: string | null, phoneNumber: string | null, nearestLocation: string | null, sys: { __typename?: 'CFSys', id: string }, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, retailer: { __typename?: 'CFRetailer', slug: string | null, websiteAddress: string | null, paymentMethods: Array<string | null> | null, marketplaceShopId: string | null, shortDescription: string | null, longDescription: string | null, sys: { __typename?: 'CFSys', id: string }, linkedFrom: { __typename?: 'CFRetailerLinkingCollections', nationalStorefrontCollection: { __typename?: 'CFNationalStorefrontCollection', items: Array<{ __typename?: 'CFNationalStorefront', backendTitle: string | null } | null> } | null } | null, retailerLogoSet: { __typename?: 'CFRetailerLogoSet', coloured: { __typename?: 'CFAsset', url: string | null } | null } | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, retailCategoriesCollection: { __typename?: 'CFRetailerRetailCategoriesCollection', items: Array<{ __typename?: 'CFRetailCategory', heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null } | null> } | null } | null, retailCategoriesCollection: { __typename?: 'CFStoreRetailCategoriesCollection', items: Array<{ __typename?: 'CFRetailCategory', heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null } | null> } | null, storeFrontImage: { __typename?: 'CFAsset', url: string | null } | null, callsToActionCollection: { __typename?: 'CFStoreCallsToActionCollection', items: Array<{ __typename?: 'CFCallToAction', category: string | null, address: string | null } | null> } | null } | null } | null };

export type GetContentPageQueryVariables = Exact<{
  path: Scalars['String']['input'];
  country: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetContentPageQuery = { __typename?: 'Query', cfContentPageCollection: { __typename?: 'CFContentPageCollection', items: Array<{ __typename?: 'CFContentPage', path: string | null, country: Array<string | null> | null, title: string | null, shortDescription: string | null, navigationMenu: any | null, metaTitle: string | null, sys: { __typename?: 'CFSys', id: string }, modulesCollection: { __typename?: 'CFContentPageModulesCollection', items: Array<{ __typename?: 'CFBasicContent' } | { __typename?: 'CFComparisonModule', comparisonModuleCollection: { __typename?: 'CFComparisonModuleComparisonModuleCollection', items: Array<{ __typename?: 'CFComparisonItem', productName: string | null, valuePropositions: Array<string | null> | null, sys: { __typename?: 'CFSys', id: string }, heroImageSet: { __typename?: 'CFHeroImageSet', description: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, callToAction: { __typename?: 'CFFeaturedLink', url: string | null, title: string | null, sys: { __typename?: 'CFSys', id: string } } | null, utilityPanel: { __typename?: 'CFUtilityPanel', heading: string | null, contentEntriesCollection: { __typename?: 'CFUtilityPanelContentEntriesCollection', items: Array<{ __typename?: 'CFFeaturedLink', url: string | null, title: string | null } | { __typename?: 'CFRetailCategory' } | null> } | null } | null } | null> } | null } | { __typename?: 'CFDynamicContent' } | { __typename?: 'CFManualCollection' } | { __typename?: 'CFProductCollection' } | { __typename?: 'CFPromotion', title: string | null, heading: string | null, shortDescription: string | null, callToActionLabel: string | null, callToActionAddress: string | null, sys: { __typename?: 'CFSys', id: string }, image: { __typename?: 'CFAsset', url: string | null, title: string | null, description: string | null } | null } | { __typename?: 'CFTerms', title: string | null, slug: string | null, country: Array<string | null> | null, bodyCopy: string | null, sys: { __typename?: 'CFSys', id: string } } | null> } | null } | null> } | null };

export type GetEventDetailQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GetEventDetailQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', event: { __typename: 'CFEvent', title: string | null, slug: string | null, shortDescription: string | null, bodyCopy: string | null, priceDescription: string | null, level: string | null, hosted: string | null, termsAndConditions: string | null, sponsored: boolean | null, physicalAddress: string | null, startAt: any | null, endAt: any | null, showAt: any | null, hideAt: any | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, callsToActionCollection: { __typename?: 'CFEventCallsToActionCollection', items: Array<{ __typename?: 'CFCallToAction', category: string | null, address: string | null } | null> } | null, occurrencesCollection: { __typename?: 'CFEventOccurrencesCollection', total: number, items: Array<{ __typename?: 'CFOccurrence', startAt: any | null, endAt: any | null } | null> } | null, storesCollection: { __typename?: 'CFEventStoresCollection', featuredStoreForCentre: { __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null, items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null } | null } | null> } | null };

export type GetMovieDetailQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  movieId: Scalars['String']['input'];
}>;


export type GetMovieDetailQuery = { __typename?: 'Query', movies: Array<{ __typename?: 'Movie', id: number, title: string, imageUrl: string | null, genres: Array<string> | null, classification: { __typename?: 'Classification', rating: string | null } | null, sessions: Array<{ __typename?: 'Session', startTime: string | null }> | null }> | null, movie: { __typename: 'DetailedMovie', id: number, title: string, imageUrl: string | null, runTime: number | null, synopsis: string | null, genres: Array<string> | null, trailerUrl: string | null, sessions: Array<{ __typename?: 'Session', startTime: string | null, bookingUrl: string | null }> | null, classification: { __typename?: 'Classification', rating: string | null } | null } | null };

export type GetMoviesQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
}>;


export type GetMoviesQuery = { __typename?: 'Query', movies: Array<{ __typename?: 'Movie', id: number, title: string, imageUrl: string | null, genres: Array<string> | null, classification: { __typename?: 'Classification', rating: string | null } | null, sessions: Array<{ __typename?: 'Session', startTime: string | null }> | null }> | null };

export type GetNationalNewsDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNationalNewsDetailQuery = { __typename?: 'Query', news: { __typename: 'CFNews', title: string | null, slug: string | null, shortDescription: string | null, bodyCopy: string | null, enableNationalNews: Array<string | null> | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, hideAt: any | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, storesCollection: { __typename?: 'CFNewsStoresCollection', items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null, sys: { __typename?: 'CFSys', id: string, firstPublishedAt: any | null, publishedAt: any | null } } | null };

export type GetNationalOfferDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNationalOfferDetailQuery = { __typename?: 'Query', nationalOffer: { __typename: 'CFOffer', title: string | null, bodyCopy: string | null, slug: string | null, shortDescription: string | null, startAt: any | null, hideAt: any | null, endAt: any | null, termsAndConditions: string | null, enableNationalOffer: Array<string | null> | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, sys: { __typename?: 'CFSys', id: string }, storesCollection: { __typename?: 'CFOfferStoresCollection', items: Array<{ __typename?: 'CFStore', retailer: { __typename?: 'CFRetailer', slug: string | null, sys: { __typename?: 'CFSys', id: string }, linkedFrom: { __typename?: 'CFRetailerLinkingCollections', nationalStorefrontCollection: { __typename?: 'CFNationalStorefrontCollection', items: Array<{ __typename?: 'CFNationalStorefront', backendTitle: string | null } | null> } | null } | null } | null } | null> } | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, journeyBanner: { __typename?: 'CFJourneyBanner', title: string | null, description: string | null, imageSet: { __typename?: 'CFHeroImageSet', backendTitle: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, offerToOpen: { __typename?: 'CFOffer', sys: { __typename?: 'CFSys', id: string } } | null } | null } | null };

export type GetNewsDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
  centreSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNewsDetailQuery = { __typename?: 'Query', news: { __typename: 'CFNews', title: string | null, slug: string | null, shortDescription: string | null, bodyCopy: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, hideAt: any | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, storesCollection: { __typename?: 'CFNewsStoresCollection', featuredStoreForCentre: { __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null, items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null, sys: { __typename?: 'CFSys', firstPublishedAt: any | null, publishedAt: any | null } } | null };

export type GetOfferDetailQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type GetOfferDetailQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', offer: { __typename?: 'CFOffer', bodyCopy: string | null, title: string | null, slug: string | null, shortDescription: string | null, startAt: any | null, endAt: any | null, showAt: any | null, hideAt: any | null, termsAndConditions: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, storesCollection: { __typename?: 'CFOfferStoresCollection', featuredStoreForCentre: { __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null, items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, journeyBanner: { __typename?: 'CFJourneyBanner', title: string | null, description: string | null, imageSet: { __typename?: 'CFHeroImageSet', backendTitle: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, offerToOpen: { __typename?: 'CFOffer', sys: { __typename?: 'CFSys', id: string } } | null } | null } | null } | null> } | null };

export type GetParkingDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetParkingDetailQuery = { __typename?: 'Query', cfCentre: { __typename?: 'CFCentre', linkedFrom: { __typename?: 'CFCentreLinkingCollections', parkingTemplateCollection: { __typename?: 'CFParkingTemplateCollection', items: Array<{ __typename?: 'CFParkingTemplate', modulesCollection: { __typename?: 'CFParkingTemplateModulesCollection', items: Array<{ __typename: 'CFCarParkGroup', title: string | null, sys: { __typename?: 'CFSys', id: string }, carParksCollection: { __typename?: 'CFCarParkGroupCarParksCollection', items: Array<{ __typename?: 'CFCarPark', title: string | null, location: string | null, entrance: string | null, latitude: number | null, longitude: number | null, sys: { __typename?: 'CFSys', id: string }, bestParkingForCollection: { __typename?: 'CFCarParkBestParkingForCollection', items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, sys: { __typename?: 'CFSys', id: string } } | null> } | null } | null> } | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null } | { __typename: 'CFContentBlock', title: string | null, bodyCopy: string | null, sys: { __typename?: 'CFSys', id: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null } | { __typename: 'CFParkingRules', title: string | null, freeEntryTime: string | null, freeExitTime: string | null, cinemaValidation: string | null, specialConditions: string | null, sys: { __typename?: 'CFSys', id: string }, ratesCardsCollection: { __typename?: 'CFParkingRulesRatesCardsCollection', items: Array<{ __typename?: 'CFParkingRatesCard', days: Array<string | null> | null, overnightRate: number | null, sys: { __typename?: 'CFSys', id: string }, ratesCollection: { __typename?: 'CFParkingRatesCardRatesCollection', items: Array<{ __typename?: 'CFParkingRate', rate: number | null, backendTitle: string | null, toInMinutes: number | null, sys: { __typename?: 'CFSys', id: string } } | null> } | null } | null> } | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null } | { __typename: 'CFService', title: string | null, bodyCopy: string | null, sys: { __typename?: 'CFSys', id: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null } | null> } | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, position: string | null, correlationIds: Array<string> | null } | null } | null> } | null } | null } | null };

export type CarParkGroupModuleFragment = { __typename?: 'CFCarParkGroup', title: string | null, carParksCollection: { __typename?: 'CFCarParkGroupCarParksCollection', items: Array<{ __typename?: 'CFCarPark', title: string | null, location: string | null, entrance: string | null, latitude: number | null, longitude: number | null, sys: { __typename?: 'CFSys', id: string }, bestParkingForCollection: { __typename?: 'CFCarParkBestParkingForCollection', items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, sys: { __typename?: 'CFSys', id: string } } | null> } | null } | null> } | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null };

export type ServiceModuleFragment = { __typename?: 'CFService', title: string | null, bodyCopy: string | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null };

export type ContentBlockModuleFragment = { __typename?: 'CFContentBlock', title: string | null, bodyCopy: string | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null };

export type ParkingRulesModuleFragment = { __typename?: 'CFParkingRules', title: string | null, freeEntryTime: string | null, freeExitTime: string | null, cinemaValidation: string | null, specialConditions: string | null, ratesCardsCollection: { __typename?: 'CFParkingRulesRatesCardsCollection', items: Array<{ __typename?: 'CFParkingRatesCard', days: Array<string | null> | null, overnightRate: number | null, sys: { __typename?: 'CFSys', id: string }, ratesCollection: { __typename?: 'CFParkingRatesCardRatesCollection', items: Array<{ __typename?: 'CFParkingRate', rate: number | null, backendTitle: string | null, toInMinutes: number | null, sys: { __typename?: 'CFSys', id: string } } | null> } | null } | null> } | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null };

export type DisplayMetadataFragment = { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, position: string | null, correlationIds: Array<string> | null };

export type GetServiceDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetServiceDetailQuery = { __typename?: 'Query', service: { __typename?: 'CFService', title: string | null, slug: string | null, shortDescription: string | null, bodyCopy: string | null, category: string | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null } | null };

export type GetStoreDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStoreDetailQuery = { __typename?: 'Query', store: { __typename: 'CFStore', slug: string | null, status: string | null, shortDescription: string | null, longDescription: string | null, paymentMethods: Array<string | null> | null, telephoneNumber: string | null, websiteAddress: string | null, physicalAddress: string | null, landmarkDescription: string | null, parkingInstructions: string | null, services: Array<string | null> | null, legacyIdentifier: number | null, title: string | null, sys: { __typename?: 'CFSys', id: string }, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, retailer: { __typename?: 'CFRetailer', slug: string | null, title: string | null, websiteAddress: string | null, paymentMethods: Array<string | null> | null, marketplaceShopId: string | null, shortDescription: string | null, longDescription: string | null, sys: { __typename?: 'CFSys', id: string }, linkedFrom: { __typename?: 'CFRetailerLinkingCollections', nationalStorefrontCollection: { __typename?: 'CFNationalStorefrontCollection', items: Array<{ __typename?: 'CFNationalStorefront', backendTitle: string | null } | null> } | null, storeCollection: { __typename?: 'CFStoreCollection', items: Array<{ __typename?: 'CFStore', slug: string | null, physicalAddress: string | null, landmarkDescription: string | null, legacyIdentifier: number | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', slug: string | null, title: string | null, state: string | null } | null } | null> } | null } | null, retailerLogoSet: { __typename?: 'CFRetailerLogoSet', coloured: { __typename?: 'CFAsset', url: string | null } | null } | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, retailCategoriesCollection: { __typename?: 'CFRetailerRetailCategoriesCollection', items: Array<{ __typename?: 'CFRetailCategory', title: string | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null } | null> } | null } | null, retailCategoriesCollection: { __typename?: 'CFStoreRetailCategoriesCollection', items: Array<{ __typename?: 'CFRetailCategory', title: string | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null } | null> } | null, storeFrontImage: { __typename?: 'CFAsset', url: string | null } | null, callsToActionCollection: { __typename?: 'CFStoreCallsToActionCollection', items: Array<{ __typename?: 'CFCallToAction', category: string | null, address: string | null } | null> } | null } | null };

export type GetStoryDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
  centreSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStoryDetailQuery = { __typename?: 'Query', story: { __typename: 'CFStory', title: string | null, theEdit: Array<string | null> | null, slug: string | null, shortDescription: string | null, bodyCopy: string | null, hideAt: any | null, sys: { __typename?: 'CFSys', id: string, publishedAt: any | null, firstPublishedAt: any | null }, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, storesCollection: { __typename?: 'CFStoryStoresCollection', featuredStoreForCentre: { __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null, items: Array<{ __typename?: 'CFStore', title: string | null, slug: string | null, status: string | null, physicalAddress: string | null, telephoneNumber: string | null, websiteAddress: string | null, storeTitle: string | null, nearestLocation: string | null, phoneNumber: string | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null } | null };

export type SaveAddressMutationVariables = Exact<{
  input: SaveAddressInput;
}>;


export type SaveAddressMutation = { __typename?: 'Mutation', saveAddress: { __typename?: 'AddressDetails', id: any } | null };

export type ClaimPasswordResetTokenMutationVariables = Exact<{
  input: ClaimPasswordResetTokenInput;
}>;


export type ClaimPasswordResetTokenMutation = { __typename?: 'Mutation', claimPasswordResetToken: boolean | null };

export type CreatePasswordResetMutationVariables = Exact<{
  input: CreatePasswordResetInput;
}>;


export type CreatePasswordResetMutation = { __typename?: 'Mutation', createPasswordReset: boolean | null };

export type DeleteCustomerMobileNumberMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCustomerMobileNumberMutation = { __typename?: 'Mutation', deleteCustomerMobileNumber: boolean | null };

export type MarketplaceApplyCouponCodeMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type MarketplaceApplyCouponCodeMutation = { __typename?: 'Mutation', coupon: { __typename: 'MarketplaceCouponEligible', campaignId: string, code: string } | { __typename: 'MarketplaceCouponExpired', campaignId: string, code: string, errorCode: string | null } | { __typename: 'MarketplaceCouponIneligible', campaignId: string, code: string, message: string | null } | { __typename: 'MarketplaceCouponInvalid', code: string, errorCode: string | null } };

export type UpdateCustomerDetailsMutationVariables = Exact<{
  input: CustomerDetailsInput;
}>;


export type UpdateCustomerDetailsMutation = { __typename?: 'Mutation', updateCustomerDetails: boolean | null };

export type CreateCustomerPasswordMutationVariables = Exact<{
  input: CustomerPasswordInput;
}>;


export type CreateCustomerPasswordMutation = { __typename?: 'Mutation', createCustomerPassword: boolean | null };

export type RemovePaymentMethodMutationVariables = Exact<{
  input: RemovePaymentMethodInput;
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: { __typename?: 'CreditCard', stripePaymentMethodId: string } | null };

export type RemoveStoredAddressMutationVariables = Exact<{
  input: RemoveStoredAddressInput;
}>;


export type RemoveStoredAddressMutation = { __typename?: 'Mutation', removeStoredAddress: { __typename?: 'AddressDetails', id: any } | null };

export type SavePaymentMethodMutationVariables = Exact<{
  input: SavePaymentMethodInput;
}>;


export type SavePaymentMethodMutation = { __typename?: 'Mutation', savePaymentMethod: { __typename?: 'CreditCard', stripePaymentMethodId: string } | null };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  input: SetDefaultPaymentMethodInput;
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: { __typename?: 'CreditCard', stripePaymentMethodId: string } | null };

export type UnsubscribeCustomerWithEmailMutationVariables = Exact<{
  input: UnsubscribeCustomerWithEmailInput;
}>;


export type UnsubscribeCustomerWithEmailMutation = { __typename?: 'Mutation', unsubscribeCustomerWithEmail: boolean | null };

export type UnsubscribeCustomerWithPreferencesTokenMutationVariables = Exact<{
  input: UnsubscribeCustomerWithPreferencesTokenInput;
}>;


export type UnsubscribeCustomerWithPreferencesTokenMutation = { __typename?: 'Mutation', unsubscribeCustomerWithPreferencesToken: boolean | null };

export type UpdateCustomerConsentMutationVariables = Exact<{
  input: UpdateCustomerConsentInput;
}>;


export type UpdateCustomerConsentMutation = { __typename?: 'Mutation', updateCustomerConsent: { __typename?: 'Consent', emailMarketing: boolean | null, pushNotificationMarketing: boolean | null, targetedAdvertising: boolean | null } | null };

export type UpdateCustomerMobileNumberMutationVariables = Exact<{
  input: CustomerMobileNumberInput;
}>;


export type UpdateCustomerMobileNumberMutation = { __typename?: 'Mutation', updateCustomerMobileNumber: boolean | null };

export type UpdateCustomerPrimaryCentreMutationVariables = Exact<{
  input: CustomerPrimaryCentreInput;
}>;


export type UpdateCustomerPrimaryCentreMutation = { __typename?: 'Mutation', updateCustomerPrimaryCentre: boolean | null };

export type VerifyCustomerMobileNumberMutationVariables = Exact<{
  input: VerifyMobileNumberInput;
}>;


export type VerifyCustomerMobileNumberMutation = { __typename?: 'Mutation', verifyCustomerMobileNumber: boolean | null };

export type VerifyPasswordResetTokenMutationVariables = Exact<{
  input: VerifyPasswordResetTokenInput;
}>;


export type VerifyPasswordResetTokenMutation = { __typename?: 'Mutation', verifyPasswordResetToken: boolean | null };

export type PageTemplateContentEntryFragment = { __typename?: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null };

export type PageTemplateFragment = { __typename?: 'SGPageTemplate', title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> };

export type GetCentrePageTemplateQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  path: Scalars['String']['input'];
}>;


export type GetCentrePageTemplateQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', title: string | null } | null> } | null, template: { __typename?: 'SGPageTemplate', title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> } | null };

export type GetCentreStorefrontQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
}>;


export type GetCentreStorefrontQuery = { __typename?: 'Query', template: { __typename?: 'SGPageTemplate', title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> } | null };

export type GetNationalExperiencePageTemplateQueryVariables = Exact<{
  country: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type GetNationalExperiencePageTemplateQuery = { __typename?: 'Query', template: { __typename?: 'SGPageTemplate', metaTitle: string | null, title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> } | null };

export type GetNationalHomepagePageTemplateQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type GetNationalHomepagePageTemplateQuery = { __typename?: 'Query', template: { __typename?: 'SGPageTemplate', title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> } | null };

export type GetNationalPageTemplateQueryVariables = Exact<{
  country: Scalars['String']['input'];
  path: Scalars['String']['input'];
}>;


export type GetNationalPageTemplateQuery = { __typename?: 'Query', template: { __typename?: 'SGPageTemplate', title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> } | null };

export type GetNationalStoreDirectoryQueryVariables = Exact<{
  skip: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  order: SgRetailersSearchOrder;
  filter: InputMaybe<SgRetailersSearchFilter>;
}>;


export type GetNationalStoreDirectoryQuery = { __typename?: 'Query', sgRetailersSearch: { __typename?: 'SGRetailersSearchResponse', total: number, items: Array<{ __typename?: 'SGCFRetailer', title: string, slug: string, sys: { __typename?: 'SGCFSys', id: string, spaceId: string }, retailerLogoSet: { __typename?: 'SGCFRetailerLogoSet', coloured: { __typename?: 'SGCFAsset', url: string } | null } | null, retailCategories: Array<{ __typename?: 'SGCFRetailCategory', title: string, level: number | null, sys: { __typename?: 'SGCFSys', id: string }, parentCategory: { __typename?: 'SGCFRetailCategory', sys: { __typename?: 'SGCFSys', id: string } } | null } | null> | null, storesFromRetailersSearch: { __typename?: 'SGStoresFromRetailersSearchResponse', total: number, items: Array<{ __typename?: 'SGCFStore', slug: string, sys: { __typename?: 'SGCFSys', id: string }, centre: { __typename?: 'SGCFCentre', slug: string } } | null> } | null, nationalStorefront: { __typename?: 'SGCFNationalStorefront', sys: { __typename?: 'SGCFSys', id: string } } | null } | null> } | null };

export type GetNationalStorefrontQueryVariables = Exact<{
  retailerId: Scalars['String']['input'];
}>;


export type GetNationalStorefrontQuery = { __typename?: 'Query', template: { __typename?: 'SGPageTemplate', title: string, shortDescription: string | null, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', displayId: string | null, correlationIds: Array<string> | null, position: string | null } | null, modules: Array<{ __typename: 'SGPageTemplateBasicContent', title: string | null, shortDescription: string | null, bodyCopy: string | null, callsToAction: Array<{ __typename?: 'SGPageTemplateCallToAction', url: string, label: string }> } | { __typename: 'SGPageTemplateContentCollection', shortDescription: string | null, title: string | null, contentCollectionKind: SgPageTemplateContentCollectionKind, analyticsMetadata: { __typename?: 'DisplayAnalyticsMetadata', correlationIds: Array<string> | null, displayId: string | null, position: string | null } | null, items: Array<{ __typename: 'SGPageTemplateAdZone', id: string } | { __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null>, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string } | null } | { __typename: 'SGPageTemplateDynamicContent', dynamicContentKind: string } | null> } | null };

export type GetPageTemplateAdZoneContentEntriesQueryVariables = Exact<{
  adZoneIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  centreSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPageTemplateAdZoneContentEntriesQuery = { __typename?: 'Query', contentEntries: Array<{ __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null } | null> };

export type RetailCategoryCollectionWithImageQueryVariables = Exact<{
  where: InputMaybe<CfRetailCategoryFilter>;
}>;


export type RetailCategoryCollectionWithImageQuery = { __typename?: 'Query', cfRetailCategoryCollection: { __typename?: 'CFRetailCategoryCollection', items: Array<{ __typename?: 'CFRetailCategory', title: string | null, sys: { __typename?: 'CFSys', id: string }, heroImageSet: { __typename?: 'CFHeroImageSet', master: { __typename?: 'CFAsset', url: string | null, title: string | null } | null, square: { __typename?: 'CFAsset', url: string | null, title: string | null } | null } | null } | null> } | null };

export type RetailCategoryCollectionQueryVariables = Exact<{
  filter: InputMaybe<SgRetailersSearchFilter>;
}>;


export type RetailCategoryCollectionQuery = { __typename?: 'Query', sgRetailersFacetRetailerCategories: Array<{ __typename?: 'SGCFRetailCategory', title: string, shortDescription: string | null, level: number | null, sys: { __typename?: 'SGCFSys', id: string }, parentCategory: { __typename?: 'SGCFRetailCategory', sys: { __typename?: 'SGCFSys', id: string } } | null } | null> };

export type GetActiveDirectPromotionsTermsAndConditionsQueryVariables = Exact<{
  startingOnOrBefore: Scalars['CFDateTime']['input'];
  endingOnOrAfter: Scalars['CFDateTime']['input'];
}>;


export type GetActiveDirectPromotionsTermsAndConditionsQuery = { __typename?: 'Query', cfDirectPromotionCollection: { __typename?: 'CFDirectPromotionCollection', items: Array<{ __typename?: 'CFDirectPromotion', talonOneId: string | null, title: string | null, termsAndConditions: string | null } | null> } | null };

export type GetAllCentreSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCentreSlugsQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', slug: string | null, country: string | null } | null> } | null };

export type GetCentreBySlugQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
}>;


export type GetCentreBySlugQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', slug: string | null, title: string | null, status: string | null, features: Array<string | null> | null, longitude: number | null, latitude: number | null, navigationMenu: any | null, timeZone: string | null, facebook: string | null, instagram: string | null, jibestreamVenueId: number | null, physicalAddress: string | null, country: string | null, state: string | null, suburb: string | null, postcode: string | null, telephoneNumber: string | null, emailAddress: string | null, sys: { __typename?: 'CFSys', id: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null } | null> } | null };

export type GetCentreQuickLinksQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
}>;


export type GetCentreQuickLinksQuery = { __typename?: 'Query', quickLinks: Array<{ __typename: 'SGPageTemplateContentEntry', kind: string, title: string, shortDescription: string | null, supplementaryText: string | null, textColour: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, image: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null }, secondaryImage: { __typename?: 'SGPageTemplateImage', type: SgPageTemplateImageType, url: string, alt: string | null, supportingColour: string | null, cinemagraphUrl: string | null } | null, callToAction: { __typename?: 'SGPageTemplateCallToAction', url: string, label: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, adConfig: { __typename?: 'AdConfigType', sponsor: string | null, impressionEvents: Array<{ __typename?: 'ImpressionEventType', eventUrl: string | null, eventName: string | null } | null> | null } | null, orchestrationAnalyticsMetadata: { __typename: 'ContentOrchestrationAnalyticsMetadataPersonalised', displayId: string, moduleSlug: string | null, primaryRank: number, secondaryRank: number, methodUsed: string, knownScgId: boolean } | { __typename: 'ContentOrchestrationAnalyticsMetadataStandard', displayId: string, moduleSlug: string | null } | null }> };

export type EventCollectionQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  now: InputMaybe<Scalars['CFDateTime']['input']>;
}>;


export type EventCollectionQuery = { __typename?: 'Query', cfEventCollection: { __typename?: 'CFEventCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'CFEvent', title: string | null, slug: string | null, shortDescription: string | null, centresCollection: { __typename?: 'CFEventCentresCollection', items: Array<{ __typename?: 'CFCentre', title: string | null, slug: string | null, country: string | null } | null> } | null, heroImageSet: { __typename?: 'CFHeroImageSet', backendTitle: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, sys: { __typename?: 'CFSys', id: string, publishedAt: any | null } } | null> } | null };

export type GetFeatureManagementCollectionV2QueryVariables = Exact<{
  scope: Scalars['String']['input'];
}>;


export type GetFeatureManagementCollectionV2Query = { __typename?: 'Query', featureManagementFeatures: Array<{ __typename?: 'FeatureManagementFeature', featureSlug: string, type: string, defaultResult: any | null, rules: Array<{ __typename?: 'FeatureManagementRule', condition: any, results: Array<{ __typename?: 'FeatureManagementCohortResult', distribution: number, cohortName: string | null, result: any | null } | null> } | null> } | null> };

export type GetFeatureManagementCollectionQueryVariables = Exact<{
  scope: Scalars['String']['input'];
  featureSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFeatureManagementCollectionQuery = { __typename?: 'Query', cfFeatureManagementCollection: { __typename?: 'CFFeatureManagementCollection', total: number, items: Array<{ __typename?: 'CFFeatureManagement', scope: string | null, featureSlug: string | null, json: any | null } | null> } | null };

export type GetNationalStorefrontRetailerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNationalStorefrontRetailerQuery = { __typename?: 'Query', retailer: { __typename?: 'CFRetailer', marketplaceShopSlug: string | null, title: string | null, slug: string | null, country: string | null, shortDescription: string | null, longDescription: string | null, heroImageSet: { __typename?: 'CFHeroImageSet', masterSupportingColour: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, retailerLogoSet: { __typename?: 'CFRetailerLogoSet', coloured: { __typename?: 'CFAsset', url: string | null } | null } | null, linkedFrom: { __typename?: 'CFRetailerLinkingCollections', storeCollection: { __typename?: 'CFStoreCollection', items: Array<{ __typename?: 'CFStore', slug: string | null, physicalAddress: string | null, landmarkDescription: string | null, legacyIdentifier: number | null, sys: { __typename?: 'CFSys', id: string }, centre: { __typename?: 'CFCentre', slug: string | null, title: string | null } | null } | null> } | null } | null } | null };

export type NewsCollectionQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  now: InputMaybe<Scalars['CFDateTime']['input']>;
}>;


export type NewsCollectionQuery = { __typename?: 'Query', cfNewsCollection: { __typename?: 'CFNewsCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'CFNews', title: string | null, slug: string | null, shortDescription: string | null, heroImageSet: { __typename?: 'CFHeroImageSet', backendTitle: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, centresCollection: { __typename?: 'CFNewsCentresCollection', items: Array<{ __typename?: 'CFCentre', title: string | null, slug: string | null, country: string | null } | null> } | null, sys: { __typename?: 'CFSys', id: string, publishedAt: any | null } } | null> } | null };

export type OffersCollectionQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  now: InputMaybe<Scalars['CFDateTime']['input']>;
}>;


export type OffersCollectionQuery = { __typename?: 'Query', cfOfferCollection: { __typename?: 'CFOfferCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'CFOffer', title: string | null, slug: string | null, shortDescription: string | null, heroImageSet: { __typename?: 'CFHeroImageSet', backendTitle: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, centresCollection: { __typename?: 'CFOfferCentresCollection', items: Array<{ __typename?: 'CFCentre', title: string | null, slug: string | null, country: string | null } | null> } | null, sys: { __typename?: 'CFSys', id: string, publishedAt: any | null } } | null> } | null };

export type GetOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', currentUser: { __typename?: 'Customer', scentregroupId: any, marketplaceOrder: { __typename?: 'MarketplaceOrder', id: string, orderReference: string, totalIncTax: number, createdAt: any, status: string, payment: { __typename?: 'PaymentIntent', cardType: string | null, last4: string | null, expMonth: number | null, expYear: number | null } | null, billingAddress: { __typename?: 'Address', firstName: string, lastName: string, email: string, phone: string, address1: string, suburb: string, state: string | null, postCode: string, country: string | null } | null, shippingAddress: { __typename?: 'Address', firstName: string, lastName: string, email: string, phone: string, address1: string, suburb: string, state: string | null, postCode: string, country: string | null } | null, parcels: Array<{ __typename?: 'ParcelWithItems', id: string | null, status: ParcelStatus | null, hasRefund: boolean | null, confirmedAt: any | null, fulfilmentType: MarketplaceFulfilmentType | null, shippingCost: number, fulfilmentLocation: string | null, centreTitle: string | null, centreServicePageURL: string | null, collectedAt: any | null, deliveredAt: any | null, fulfilmentDayRange: { __typename?: 'MarketplaceFulfilmentDayRange', min: number, max: number } | null, items: Array<{ __typename?: 'MarketplaceItem', quantity: number, priceIncTax: number, originalPriceIncTax: number, shop: { __typename?: 'MarketplaceShop', name: string | null } | null, variant: { __typename?: 'MarketplaceProductVariant', id: string, title: string, brand: string | null, sku: string, price: number | null, returnable: boolean | null, images: Array<{ __typename?: 'MarketplaceProductImage', url: string, description: string | null } | null>, optionValues: Array<{ __typename?: 'MarketplaceProductVariantOption', id: string | null, optionId: string | null, displayName: string | null, value: string | null } | null> } | null, promotions: Array<{ __typename?: 'MarketplaceCartItemPromotion', campaignId: string, title: string }> | null }> }> } | null } | null };

export type GetOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersQuery = { __typename?: 'Query', currentUser: { __typename?: 'Customer', scentregroupId: any, marketplaceOrders: Array<{ __typename?: 'MarketplaceOrder', id: string, orderReference: string, totalIncTax: number, status: string, createdAt: any, parcels: Array<{ __typename?: 'ParcelWithItems', id: string | null, status: ParcelStatus | null, hasRefund: boolean | null, items: Array<{ __typename?: 'MarketplaceItem', quantity: number, variant: { __typename?: 'MarketplaceProductVariant', images: Array<{ __typename?: 'MarketplaceProductImage', url: string, description: string | null } | null> } | null }> }> } | null> | null } | null };

export type GetStaticFileQueryVariables = Exact<{
  path: Scalars['String']['input'];
  country: Scalars['String']['input'];
}>;


export type GetStaticFileQuery = { __typename?: 'Query', cfStaticFileCollection: { __typename?: 'CFStaticFileCollection', items: Array<{ __typename?: 'CFStaticFile', plainTextContent: string | null, jsonContent: any | null } | null> } | null };

export type GetStoresForCentreQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
}>;


export type GetStoresForCentreQuery = { __typename?: 'Query', storesForCentre: Array<{ __typename?: 'SGCentreStore', id: string, title: string, slug: string, logoUrl: string | null, longDescription: string | null, landmarkDescription: string | null, paymentMethods: Array<string>, legacyIdentifier: number | null, categories: Array<{ __typename?: 'SGRetailCategory', title: string, seoTitle: string, seoContentSchema: any | null, shortDescription: string, parentId: string | null, level: number | null, id: string }>, retailer: { __typename?: 'SGRetailer', paymentMethods: Array<string> } | null }> | null, cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', sys: { __typename?: 'CFSys', spaceId: string } } | null> } | null };

export type StoryCollectionQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  now: InputMaybe<Scalars['CFDateTime']['input']>;
}>;


export type StoryCollectionQuery = { __typename?: 'Query', cfStoryCollection: { __typename?: 'CFStoryCollection', total: number, skip: number, limit: number, items: Array<{ __typename: 'CFStory', title: string | null, slug: string | null, shortDescription: string | null, theEdit: Array<string | null> | null, heroImageSet: { __typename?: 'CFHeroImageSet', backendTitle: string | null, master: { __typename?: 'CFAsset', url: string | null } | null } | null, centresCollection: { __typename?: 'CFStoryCentresCollection', items: Array<{ __typename?: 'CFCentre', title: string | null, slug: string | null, country: string | null } | null> } | null, sys: { __typename?: 'CFSys', id: string, publishedAt: any | null } } | null> } | null };

export type GetTheEditStoriesQueryVariables = Exact<{
  country: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  time: Scalars['CFDateTime']['input'];
}>;


export type GetTheEditStoriesQuery = { __typename?: 'Query', storyPage: { __typename?: 'CFStoryCollection', total: number, limit: number, skip: number, items: Array<{ __typename?: 'CFStory', title: string | null, slug: string | null, hideAt: any | null, showAt: any | null, sys: { __typename?: 'CFSys', id: string }, heroImageSet: { __typename?: 'CFHeroImageSet', master: { __typename?: 'CFAsset', url: string | null } | null } | null } | null> } | null };

export type GetTopStripQueryVariables = Exact<{
  country: InputMaybe<Scalars['String']['input']>;
  isCentre: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTopStripQuery = { __typename?: 'Query', cfTopStripCollection: { __typename?: 'CFTopStripCollection', items: Array<{ __typename?: 'CFTopStrip', actionText: string | null, backgroundColour: string | null, shortDescription: string | null, url: string | null, backendTitle: string | null, backgroundImage: { __typename?: 'CFAsset', url: string | null } | null, foregroundImage: { __typename?: 'CFAsset', url: string | null } | null, centresCollection: { __typename?: 'CFTopStripCentresCollection', items: Array<{ __typename?: 'CFCentre', slug: string | null } | null> } | null } | null> } | null };

export type GetTradingHoursForCentreQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  startDate: InputMaybe<Scalars['Date']['input']>;
  endDate: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetTradingHoursForCentreQuery = { __typename?: 'Query', tradingHours: Array<{ __typename?: 'TradingHourDay', date: any, dayOfTheWeek: DayOfTheWeek, hourType: HourType | null, hourStatus: HourStatus | null, openingTime: string, closingTime: string, description: string | null, isClosed: boolean } | null> | null };

export type GetTradingHoursForStoreQueryVariables = Exact<{
  centreSlug: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
  startDate: InputMaybe<Scalars['Date']['input']>;
  endDate: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetTradingHoursForStoreQuery = { __typename?: 'Query', tradingHours: Array<{ __typename?: 'TradingHourDay', date: any, dayOfTheWeek: DayOfTheWeek, hourType: HourType | null, hourStatus: HourStatus | null, openingTime: string, closingTime: string, description: string | null, isClosed: boolean } | null> | null };

export type GetUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountQuery = { __typename?: 'Query', currentUser: { __typename?: 'Customer', scentregroupId: any, firstName: string | null, lastName: string | null, email: string, mobile: string | null, featureManagementTags: Array<string>, hasMarketplaceOrders: boolean, isParkPlus: boolean | null, acquisitionSources: Array<string>, onboarding: { __typename?: 'Onboarding', web: { __typename?: 'WebOnboarding', required: Array<string> } | null } | null, auth0: { __typename?: 'Auth0Customer', defaultConnection: Auth0ConnectionType | null } | null, storedPaymentMethods: Array<{ __typename?: 'CreditCard', stripePaymentMethodId: string, defaultAt: any | null, brand: string, expMonth: number, expYear: number, last4: string, createdAt: any | null, billingAddress: { __typename?: 'AddressDetails', id: any, createdAt: any, firstName: string, lastName: string, streetAddress: string, suburb: string, state: string, postcode: string, country: string } } | null> | null, storedAddresses: Array<{ __typename?: 'AddressDetails', id: any, firstName: string, lastName: string, streetAddress: string, suburb: string, state: string, postcode: string, country: string, defaultAt: any | null, createdAt: any } | null> | null, parkingProfile: { __typename?: 'ParkingProfile', homeCentre: string | null, disabled: boolean | null, parkerType: string, retailer: { __typename?: 'ParkingRetailer', name: string | null, storeId: number | null, centreId: string | null } | null, vehicles: Array<{ __typename?: 'ParkingOwnedVehicle', plate: string, registeredIn: string } | { __typename?: 'ParkingSharedVehicle', plate: string, registeredIn: string }> } | null, westfieldPlus: { __typename?: 'WestfieldPlusData', termsAndConditionsVersion: string | null, termsAndConditionsAcceptedAt: string | null, emailMarketingOptIn: boolean | null, emailMarketingOptInAt: string | null, parkPlusTransitionAcceptedAt: string | null, parkPlusTransitionRejectedAt: string | null } | null, consent: { __typename?: 'Consent', emailMarketing: boolean | null, pushNotificationMarketing: boolean | null, targetedAdvertising: boolean | null } | null, primaryCentre: { __typename?: 'SGCFCentre', slug: string } | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'Customer', firstName: string | null, lastName: string | null, email: string, scentregroupId: any, hasMarketplaceOrders: boolean, onboarding: { __typename?: 'Onboarding', web: { __typename?: 'WebOnboarding', required: Array<string> } | null } | null, storedPaymentMethods: Array<{ __typename?: 'CreditCard', stripePaymentMethodId: string, brand: string, expMonth: number, expYear: number, last4: string, defaultAt: any | null, createdAt: any | null, billingAddress: { __typename?: 'AddressDetails', id: any, firstName: string, lastName: string, streetAddress: string, suburb: string, state: string, postcode: string, country: string, createdAt: any, defaultAt: any | null } } | null> | null, storedAddresses: Array<{ __typename?: 'AddressDetails', id: any, firstName: string, lastName: string, streetAddress: string, suburb: string, state: string, postcode: string, country: string, defaultAt: any | null, createdAt: any } | null> | null } | null };

export type GetWestfieldDirectRetailerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWestfieldDirectRetailerQuery = { __typename?: 'Query', cfRetailerCollection: { __typename?: 'CFRetailerCollection', items: Array<{ __typename?: 'CFRetailer', retailerSizeGuide: string | null } | null> } | null };

export type WhatsOnFiltersCentreQueryVariables = Exact<{
  centreId: Scalars['String']['input'];
}>;


export type WhatsOnFiltersCentreQuery = { __typename?: 'Query', cfCentre: { __typename?: 'CFCentre', linkedFrom: { __typename?: 'CFCentreLinkingCollections', whatsHappeningFiltersCollection: { __typename?: 'CFWhatsHappeningFiltersCollection', items: Array<{ __typename?: 'CFWhatsHappeningFilters', backendTitle: string | null, topicFiltersCollection: { __typename?: 'CFWhatsHappeningFiltersTopicFiltersCollection', items: Array<{ __typename?: 'CFTopic', title: string | null } | null> } | null, experienceFiltersCollection: { __typename?: 'CFWhatsHappeningFiltersExperienceFiltersCollection', items: Array<{ __typename?: 'CFExperience', title: string | null } | null> } | null } | null> } | null } | null } | null };

export type WhatsOnCentreQueryVariables = Exact<{
  centreId: Scalars['String']['input'];
  durationFromNow: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
}>;


export type WhatsOnCentreQuery = { __typename?: 'Query', whatsOnCentre: Array<{ __typename: 'CFEvent', title: string | null, slug: string | null, shortDescription: string | null, physicalAddress: string | null, hosted: string | null, level: string | null, priceDescription: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, occurrencesCollection: { __typename?: 'CFEventOccurrencesCollection', items: Array<{ __typename?: 'CFOccurrence', startAt: any | null, endAt: any | null } | null> } | null, topicsCollection: { __typename?: 'CFEventTopicsCollection', items: Array<{ __typename?: 'CFTopic', title: string | null } | null> } | null, experiencesCollection: { __typename?: 'CFEventExperiencesCollection', items: Array<{ __typename?: 'CFExperience', title: string | null } | null> } | null, callsToActionCollection: { __typename?: 'CFEventCallsToActionCollection', items: Array<{ __typename?: 'CFCallToAction', category: string | null, address: string | null } | null> } | null, storesCollection: { __typename?: 'CFEventStoresCollection', items: Array<{ __typename?: 'CFStore', title: string | null, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null, sys: { __typename?: 'CFSys', id: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, heroImageSet: { __typename?: 'CFHeroImageSet', description: string | null, master: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null, square: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null } | null } | { __typename: 'CFOffer', title: string | null, startAt: any | null, hideAt: any | null, showAt: any | null, endAt: any | null, slug: string | null, memberExclusive: boolean | null, highlightAttribute: HighlightAttributes | null, topicsCollection: { __typename?: 'CFOfferTopicsCollection', items: Array<{ __typename?: 'CFTopic', title: string | null } | null> } | null, experiencesCollection: { __typename?: 'CFOfferExperiencesCollection', items: Array<{ __typename?: 'CFExperience', title: string | null } | null> } | null, storesCollection: { __typename?: 'CFOfferStoresCollection', items: Array<{ __typename?: 'CFStore', title: string | null, centre: { __typename?: 'CFCentre', sys: { __typename?: 'CFSys', id: string } } | null } | null> } | null, sys: { __typename?: 'CFSys', id: string }, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, heroImageSet: { __typename?: 'CFHeroImageSet', description: string | null, master: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null, square: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null } | null } | null> | null };

export type CfEvent_HappeningsImageFragment = { __typename?: 'CFEvent', heroImageSet: { __typename?: 'CFHeroImageSet', description: string | null, master: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null, square: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null } | null };

export type CfOffer_HappeningsImageFragment = { __typename?: 'CFOffer', heroImageSet: { __typename?: 'CFHeroImageSet', description: string | null, master: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null, square: { __typename?: 'CFAsset', title: string | null, description: string | null, url: string | null } | null } | null };

export type SharedCentreDetailsFragment = { __typename?: 'CFCentre', navigationMenu: any | null, features: Array<string | null> | null, facebook: string | null, instagram: string | null, jibestreamVenueId: number | null, physicalAddress: string | null, postcode: string | null, telephoneNumber: string | null, emailAddress: string | null, title: string | null, slug: string | null, status: string | null, country: string | null, suburb: string | null, state: string | null, timeZone: string | null, latitude: number | null, longitude: number | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, cinema: { __typename?: 'CFStore', sys: { __typename?: 'CFSys', id: string } } | null, sys: { __typename?: 'CFSys', id: string }, centreFrontImage: { __typename?: 'CFAsset', url: string | null } | null };

export type SharedCentreFragment = { __typename?: 'CFCentre', title: string | null, slug: string | null, status: string | null, country: string | null, suburb: string | null, state: string | null, timeZone: string | null, latitude: number | null, longitude: number | null, sys: { __typename?: 'CFSys', id: string }, centreFrontImage: { __typename?: 'CFAsset', url: string | null } | null };

export type CentreDetailsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  country: Scalars['String']['input'];
}>;


export type CentreDetailsQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', navigationMenu: any | null, features: Array<string | null> | null, facebook: string | null, instagram: string | null, jibestreamVenueId: number | null, physicalAddress: string | null, postcode: string | null, telephoneNumber: string | null, emailAddress: string | null, title: string | null, slug: string | null, status: string | null, country: string | null, suburb: string | null, state: string | null, timeZone: string | null, latitude: number | null, longitude: number | null, analyticsMetadata: { __typename?: 'ContentAnalyticsMetadata', correlationId: string | null, title: string | null, promotion: { __typename?: 'ContentAnalyticsPromotion', creative: string | null } | null } | null, cinema: { __typename?: 'CFStore', sys: { __typename?: 'CFSys', id: string } } | null, sys: { __typename?: 'CFSys', id: string }, centreFrontImage: { __typename?: 'CFAsset', url: string | null } | null } | null> } | null };

export type CentreQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CentreQuery = { __typename?: 'Query', cfCentreCollection: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', title: string | null, slug: string | null, status: string | null, country: string | null, suburb: string | null, state: string | null, timeZone: string | null, latitude: number | null, longitude: number | null, sys: { __typename?: 'CFSys', id: string }, centreFrontImage: { __typename?: 'CFAsset', url: string | null } | null } | null> } | null };

export type GlobalStaticDataQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type GlobalStaticDataQuery = { __typename?: 'Query', giftCards: { __typename?: 'CFContentPageCollection', items: Array<{ __typename?: 'CFContentPage', navigationMenu: any | null, title: string | null, sys: { __typename?: 'CFSys', id: string } } | null> } | null, nationalHomepage: { __typename?: 'CFNationalHomepageCollection', items: Array<{ __typename?: 'CFNationalHomepage', navigationMenu: any | null } | null> } | null, centres: { __typename?: 'CFCentreCollection', items: Array<{ __typename?: 'CFCentre', title: string | null, slug: string | null, status: string | null, country: string | null, suburb: string | null, state: string | null, timeZone: string | null, latitude: number | null, longitude: number | null, sys: { __typename?: 'CFSys', id: string }, centreFrontImage: { __typename?: 'CFAsset', url: string | null } | null } | null> } | null };

export const ContentDetailStoreFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentDetailStore"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}}]}}]} as unknown as DocumentNode<ContentDetailStoreFragment, unknown>;
export const CarParkGroupModuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarParkGroupModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCarParkGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"carParksCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"entrance"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"bestParkingForCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}}]} as unknown as DocumentNode<CarParkGroupModuleFragment, unknown>;
export const ServiceModuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFService"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}}]} as unknown as DocumentNode<ServiceModuleFragment, unknown>;
export const ContentBlockModuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentBlockModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFContentBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}}]} as unknown as DocumentNode<ContentBlockModuleFragment, unknown>;
export const ParkingRulesModuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParkingRulesModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFParkingRules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"freeEntryTime"}},{"kind":"Field","name":{"kind":"Name","value":"freeExitTime"}},{"kind":"Field","name":{"kind":"Name","value":"cinemaValidation"}},{"kind":"Field","name":{"kind":"Name","value":"specialConditions"}},{"kind":"Field","name":{"kind":"Name","value":"ratesCardsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"overnightRate"}},{"kind":"Field","name":{"kind":"Name","value":"ratesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"toInMinutes"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}}]} as unknown as DocumentNode<ParkingRulesModuleFragment, unknown>;
export const DisplayMetadataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisplayMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DisplayAnalyticsMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}}]}}]} as unknown as DocumentNode<DisplayMetadataFragment, unknown>;
export const PageTemplateContentEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}}]} as unknown as DocumentNode<PageTemplateContentEntryFragment, unknown>;
export const PageTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}}]} as unknown as DocumentNode<PageTemplateFragment, unknown>;
export const CfEvent_HappeningsImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CFEvent_HappeningsImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"square"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CfEvent_HappeningsImageFragment, unknown>;
export const CfOffer_HappeningsImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CFOffer_HappeningsImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"square"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CfOffer_HappeningsImageFragment, unknown>;
export const SharedCentreFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"centreFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SharedCentreFragment, unknown>;
export const SharedCentreDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentreDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sharedCentre"}},{"kind":"Field","name":{"kind":"Name","value":"navigationMenu"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jibestreamVenueId"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"cinema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"centreFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SharedCentreDetailsFragment, unknown>;
export const DeletePendingEmailChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePendingEmailChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePendingEmailChange"}}]}}]} as unknown as DocumentNode<DeletePendingEmailChangeMutation, DeletePendingEmailChangeMutationVariables>;
export const GetCinemaDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCinemaDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"centreCinema"},"name":{"kind":"Name","value":"cfCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cinema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"preview"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"bodyCopy"},"name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"parkingInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"legacyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nationalStorefrontCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceShopId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerLogoSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coloured"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"retailCategoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCategoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callsToActionCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCinemaDetailQuery, GetCinemaDetailQueryVariables>;
export const GetContentPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContentPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfContentPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_contains_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"navigationMenu"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}},{"kind":"Field","name":{"kind":"Name","value":"modulesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFTerms"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFPromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"callToActionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"callToActionAddress"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFComparisonModule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparisonModuleCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"valuePropositions"}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"utilityPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"contentEntriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFFeaturedLink"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetContentPageQuery, GetContentPageQueryVariables>;
export const GetEventDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"hosted"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callsToActionCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"showAt"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"occurrencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredStoreForCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentDetailStore"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}}]}}]} as unknown as DocumentNode<GetEventDetailQuery, GetEventDetailQueryVariables>;
export const GetMovieDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMovieDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"movieId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"movies"},"name":{"kind":"Name","value":"sgCentreMovies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"genres"}},{"kind":"Field","name":{"kind":"Name","value":"classification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"movie"},"name":{"kind":"Name","value":"sgMovieDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"movieId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"movieId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"runTime"}},{"kind":"Field","name":{"kind":"Name","value":"synopsis"}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"bookingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"genres"}},{"kind":"Field","name":{"kind":"Name","value":"classification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trailerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetMovieDetailQuery, GetMovieDetailQueryVariables>;
export const GetMoviesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMovies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"movies"},"name":{"kind":"Name","value":"sgCentreMovies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"genres"}},{"kind":"Field","name":{"kind":"Name","value":"classification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}}]}}]} as unknown as DocumentNode<GetMoviesQuery, GetMoviesQueryVariables>;
export const GetNationalNewsDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalNewsDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"news"},"name":{"kind":"Name","value":"cfNews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"enableNationalNews"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentDetailStore"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}}]}}]} as unknown as DocumentNode<GetNationalNewsDetailQuery, GetNationalNewsDetailQueryVariables>;
export const GetNationalOfferDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalOfferDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nationalOffer"},"name":{"kind":"Name","value":"cfOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nationalStorefrontCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enableNationalOffer"}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"journeyBanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offerToOpen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalOfferDetailQuery, GetNationalOfferDetailQueryVariables>;
export const GetNewsDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewsDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"news"},"name":{"kind":"Name","value":"cfNews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredStoreForCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentDetailStore"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}}]}}]} as unknown as DocumentNode<GetNewsDetailQuery, GetNewsDetailQueryVariables>;
export const GetOfferDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOfferDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"showAt"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredStoreForCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"journeyBanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offerToOpen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentDetailStore"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}}]}}]} as unknown as DocumentNode<GetOfferDetailQuery, GetOfferDetailQueryVariables>;
export const GetParkingDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParkingDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parkingTemplateCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modulesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarParkGroupModule"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceModule"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContentBlockModule"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ParkingRulesModule"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisplayMetadata"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarParkGroupModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCarParkGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"carParksCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"entrance"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"bestParkingForCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFService"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContentBlockModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFContentBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ParkingRulesModule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFParkingRules"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"freeEntryTime"}},{"kind":"Field","name":{"kind":"Name","value":"freeExitTime"}},{"kind":"Field","name":{"kind":"Name","value":"cinemaValidation"}},{"kind":"Field","name":{"kind":"Name","value":"specialConditions"}},{"kind":"Field","name":{"kind":"Name","value":"ratesCardsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"overnightRate"}},{"kind":"Field","name":{"kind":"Name","value":"ratesCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"toInMinutes"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisplayMetadata"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DisplayAnalyticsMetadata"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}}]}}]} as unknown as DocumentNode<GetParkingDetailQuery, GetParkingDetailQueryVariables>;
export const GetServiceDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"service"},"name":{"kind":"Name","value":"cfService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetServiceDetailQuery, GetServiceDetailQueryVariables>;
export const GetStoreDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoreDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"store"},"name":{"kind":"Name","value":"cfStore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nationalStorefrontCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"legacyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceShopId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerLogoSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coloured"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"retailCategoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCategoriesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"parkingInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"legacyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"callsToActionCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStoreDetailQuery, GetStoreDetailQueryVariables>;
export const GetStoryDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoryDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"story"},"name":{"kind":"Name","value":"cfStory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"theEdit"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstPublishedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredStoreForCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentDetailStore"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentDetailStore"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFStore"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"storeTitle"},"name":{"kind":"Name","value":"titleWithOptionalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"nearestLocation"},"name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumber"},"name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteAddress"}}]}}]} as unknown as DocumentNode<GetStoryDetailQuery, GetStoryDetailQueryVariables>;
export const SaveAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveAddressMutation, SaveAddressMutationVariables>;
export const ClaimPasswordResetTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimPasswordResetToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClaimPasswordResetTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimPasswordResetToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ClaimPasswordResetTokenMutation, ClaimPasswordResetTokenMutationVariables>;
export const CreatePasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePasswordResetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPasswordReset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>;
export const DeleteCustomerMobileNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCustomerMobileNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCustomerMobileNumber"}}]}}]} as unknown as DocumentNode<DeleteCustomerMobileNumberMutation, DeleteCustomerMobileNumberMutationVariables>;
export const MarketplaceApplyCouponCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarketplaceApplyCouponCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"coupon"},"name":{"kind":"Name","value":"marketplaceApplyCouponCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceCouponInvalid"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceCouponExpired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceCouponEligible"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceCouponIneligible"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MarketplaceApplyCouponCodeMutation, MarketplaceApplyCouponCodeMutationVariables>;
export const UpdateCustomerDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateCustomerDetailsMutation, UpdateCustomerDetailsMutationVariables>;
export const CreateCustomerPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateCustomerPasswordMutation, CreateCustomerPasswordMutationVariables>;
export const RemovePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovePaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}}]}}]}}]} as unknown as DocumentNode<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const RemoveStoredAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveStoredAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveStoredAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeStoredAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveStoredAddressMutation, RemoveStoredAddressMutationVariables>;
export const SavePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SavePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavePaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}}]}}]}}]} as unknown as DocumentNode<SavePaymentMethodMutation, SavePaymentMethodMutationVariables>;
export const SetDefaultPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetDefaultPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetDefaultPaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setDefaultPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}}]}}]}}]} as unknown as DocumentNode<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const UnsubscribeCustomerWithEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeCustomerWithEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsubscribeCustomerWithEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsubscribeCustomerWithEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UnsubscribeCustomerWithEmailMutation, UnsubscribeCustomerWithEmailMutationVariables>;
export const UnsubscribeCustomerWithPreferencesTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeCustomerWithPreferencesToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnsubscribeCustomerWithPreferencesTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsubscribeCustomerWithPreferencesToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UnsubscribeCustomerWithPreferencesTokenMutation, UnsubscribeCustomerWithPreferencesTokenMutationVariables>;
export const UpdateCustomerConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerConsentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"pushNotificationMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAdvertising"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerConsentMutation, UpdateCustomerConsentMutationVariables>;
export const UpdateCustomerMobileNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerMobileNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerMobileNumberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerMobileNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateCustomerMobileNumberMutation, UpdateCustomerMobileNumberMutationVariables>;
export const UpdateCustomerPrimaryCentreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerPrimaryCentre"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerPrimaryCentreInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerPrimaryCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateCustomerPrimaryCentreMutation, UpdateCustomerPrimaryCentreMutationVariables>;
export const VerifyCustomerMobileNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyCustomerMobileNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyMobileNumberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyCustomerMobileNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<VerifyCustomerMobileNumberMutation, VerifyCustomerMobileNumberMutationVariables>;
export const VerifyPasswordResetTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyPasswordResetToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyPasswordResetTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPasswordResetToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<VerifyPasswordResetTokenMutation, VerifyPasswordResetTokenMutationVariables>;
export const GetCentrePageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCentrePageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"template"},"name":{"kind":"Name","value":"sgCentrePageTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}}]} as unknown as DocumentNode<GetCentrePageTemplateQuery, GetCentrePageTemplateQueryVariables>;
export const GetCentreStorefrontDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCentreStorefront"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"template"},"name":{"kind":"Name","value":"sgCentreStorefront"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}}]} as unknown as DocumentNode<GetCentreStorefrontQuery, GetCentreStorefrontQueryVariables>;
export const GetNationalExperiencePageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalExperiencePageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"template"},"name":{"kind":"Name","value":"sgNationalExperience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"metaTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalExperiencePageTemplateQuery, GetNationalExperiencePageTemplateQueryVariables>;
export const GetNationalHomepagePageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalHomepagePageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"template"},"name":{"kind":"Name","value":"sgNationalHomepage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalHomepagePageTemplateQuery, GetNationalHomepagePageTemplateQueryVariables>;
export const GetNationalPageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalPageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"template"},"name":{"kind":"Name","value":"sgNationalPageTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalPageTemplateQuery, GetNationalPageTemplateQueryVariables>;
export const GetNationalStoreDirectoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalStoreDirectory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SGRetailersSearchOrder"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SGRetailersSearchFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sgRetailersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"order"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spaceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"retailerLogoSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coloured"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storesFromRetailersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nationalStorefront"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalStoreDirectoryQuery, GetNationalStoreDirectoryQueryVariables>;
export const GetNationalStorefrontDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalStorefront"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"template"},"name":{"kind":"Name","value":"sgNationalStorefront"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateBasicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"bodyCopy"}},{"kind":"Field","name":{"kind":"Name","value":"callsToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentCollection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentCollectionKind"},"name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationIds"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateAdZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateDynamicContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dynamicContentKind"},"name":{"kind":"Name","value":"kind"}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalStorefrontQuery, GetNationalStorefrontQueryVariables>;
export const GetPageTemplateAdZoneContentEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPageTemplateAdZoneContentEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adZoneIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentEntries"},"name":{"kind":"Name","value":"sgPageTemplateAdZoneContentEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"adZoneIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adZoneIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}}]} as unknown as DocumentNode<GetPageTemplateAdZoneContentEntriesQuery, GetPageTemplateAdZoneContentEntriesQueryVariables>;
export const RetailCategoryCollectionWithImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailCategoryCollectionWithImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CFRetailCategoryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfRetailCategoryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"square"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailCategoryCollectionWithImageQuery, RetailCategoryCollectionWithImageQueryVariables>;
export const RetailCategoryCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailCategoryCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SGRetailersSearchFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sgRetailersFacetRetailerCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailCategoryCollectionQuery, RetailCategoryCollectionQueryVariables>;
export const GetActiveDirectPromotionsTermsAndConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveDirectPromotionsTermsAndConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startingOnOrBefore"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endingOnOrAfter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfDirectPromotionCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startingOnOrBefore"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endingOnOrAfter"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"startDate_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"talonOneId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveDirectPromotionsTermsAndConditionsQuery, GetActiveDirectPromotionsTermsAndConditionsQueryVariables>;
export const GetAllCentreSlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCentreSlugs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllCentreSlugsQuery, GetAllCentreSlugsQueryVariables>;
export const GetCentreBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCentreBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"navigationMenu"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jibestreamVenueId"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]} as unknown as DocumentNode<GetCentreBySlugQuery, GetCentreBySlugQueryVariables>;
export const GetCentreQuickLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCentreQuickLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"quickLinks"},"name":{"kind":"Name","value":"sgCentreQuickLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pageTemplateContentEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pageTemplateContentEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SGPageTemplateContentEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryText"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"supportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"cinemagraphUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textColour"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sponsor"}},{"kind":"Field","name":{"kind":"Name","value":"impressionEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventUrl"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}},{"kind":"Field","name":{"kind":"Name","value":"orchestrationAnalyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataStandard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentOrchestrationAnalyticsMetadataPersonalised"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"moduleSlug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryRank"}},{"kind":"Field","name":{"kind":"Name","value":"methodUsed"}},{"kind":"Field","name":{"kind":"Name","value":"knownScgId"}}]}}]}}]}}]} as unknown as DocumentNode<GetCentreQuickLinksQuery, GetCentreQuickLinksQueryVariables>;
export const EventCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfEventCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_firstPublishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showAt_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideAt_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSensitiveContent_not"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"surfaceContentInChannel_contains_some"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"web","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewOption_contains"},"value":{"kind":"StringValue","value":"Everyone","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"centresCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EventCollectionQuery, EventCollectionQueryVariables>;
export const GetFeatureManagementCollectionV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeatureManagementCollectionV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scope"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureManagementFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scope"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureSlug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"defaultResult"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cohortName"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFeatureManagementCollectionV2Query, GetFeatureManagementCollectionV2QueryVariables>;
export const GetFeatureManagementCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeatureManagementCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scope"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featureSlug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfFeatureManagementCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scope"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"featureSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featureSlug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"featureSlug"}},{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeatureManagementCollectionQuery, GetFeatureManagementCollectionQueryVariables>;
export const GetNationalStorefrontRetailerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNationalStorefrontRetailer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"retailer"},"name":{"kind":"Name","value":"cfRetailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceShopSlug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterSupportingColour"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerLogoSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coloured"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"legacyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNationalStorefrontRetailerQuery, GetNationalStorefrontRetailerQueryVariables>;
export const NewsCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfNewsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_firstPublishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showAt_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideAt_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSensitiveContent_not"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"surfaceContentInChannel_contains_some"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"web","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewOption_contains"},"value":{"kind":"StringValue","value":"Everyone","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"centresCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsCollectionQuery, NewsCollectionQueryVariables>;
export const OffersCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OffersCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfOfferCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_firstPublishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showAt_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideAt_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSensitiveContent_not"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"surfaceContentInChannel_contains_some"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"web","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewOption_contains"},"value":{"kind":"StringValue","value":"Everyone","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"centresCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OffersCollectionQuery, OffersCollectionQueryVariables>;
export const GetOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scentregroupId"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncTax"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hasRefund"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilmentType"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCost"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilmentLocation"}},{"kind":"Field","name":{"kind":"Name","value":"fulfilmentDayRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"centreTitle"}},{"kind":"Field","name":{"kind":"Name","value":"centreServicePageURL"}},{"kind":"Field","name":{"kind":"Name","value":"collectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredAt"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceIncTax"}},{"kind":"Field","name":{"kind":"Name","value":"originalPriceIncTax"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"returnable"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optionValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optionId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scentregroupId"}},{"kind":"Field","name":{"kind":"Name","value":"marketplaceOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"totalIncTax"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"parcels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hasRefund"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetStaticFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStaticFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfStaticFileCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_contains_some"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"country"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plainTextContent"}},{"kind":"Field","name":{"kind":"Name","value":"jsonContent"}}]}}]}}]}}]} as unknown as DocumentNode<GetStaticFileQuery, GetStaticFileQueryVariables>;
export const GetStoresForCentreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoresForCentre"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"storesForCentre"},"name":{"kind":"Name","value":"sgStoresForCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}},{"kind":"Field","name":{"kind":"Name","value":"landmarkDescription"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"legacyIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoContentSchema"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spaceId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStoresForCentreQuery, GetStoresForCentreQueryVariables>;
export const StoryCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoryCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfStoryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"sys_firstPublishedAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showAt_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideAt_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isSensitiveContent_not"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"surfaceContentInChannel_contains_some"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"web","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewOption_contains"},"value":{"kind":"StringValue","value":"Everyone","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"theEdit"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"centresCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StoryCollectionQuery, StoryCollectionQueryVariables>;
export const GetTheEditStoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTheEditStories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CFDateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"storyPage"},"name":{"kind":"Name","value":"cfStoryCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theEdit_contains_all"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"country"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showAt_exists"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"showAt_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hideAt_exists"},"value":{"kind":"BooleanValue","value":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hideAt_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"sys_firstPublishedAt_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"showAt"}},{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTheEditStoriesQuery, GetTheEditStoriesQueryVariables>;
export const GetTopStripDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTopStrip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCentre"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfTopStripCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_contains_all"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"country"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"centresCollection_exists"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCentre"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"sys_publishedAt_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionText"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColour"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"foregroundImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"centresCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}}]}}]}}]}}]} as unknown as DocumentNode<GetTopStripQuery, GetTopStripQueryVariables>;
export const GetTradingHoursForCentreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTradingHoursForCentre"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tradingHours"},"name":{"kind":"Name","value":"sgCentreTradingHours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfTheWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hourType"}},{"kind":"Field","name":{"kind":"Name","value":"hourStatus"}},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isClosed"}}]}}]}}]} as unknown as DocumentNode<GetTradingHoursForCentreQuery, GetTradingHoursForCentreQueryVariables>;
export const GetTradingHoursForStoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTradingHoursForStore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tradingHours"},"name":{"kind":"Name","value":"sgStoreTradingHours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfTheWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hourType"}},{"kind":"Field","name":{"kind":"Name","value":"hourStatus"}},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isClosed"}}]}}]}}]} as unknown as DocumentNode<GetTradingHoursForStoreQuery, GetTradingHoursForStoreQueryVariables>;
export const GetUserAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scentregroupId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"featureManagementTags"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"auth0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultConnection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAt"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storedAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasMarketplaceOrders"}},{"kind":"Field","name":{"kind":"Name","value":"parkingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homeCentre"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"parkerType"}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"centreId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plate"}},{"kind":"Field","name":{"kind":"Name","value":"registeredIn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"westfieldPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termsAndConditionsVersion"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditionsAcceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"emailMarketingOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"emailMarketingOptInAt"}},{"kind":"Field","name":{"kind":"Name","value":"parkPlusTransitionAcceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"parkPlusTransitionRejectedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isParkPlus"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionSources"}},{"kind":"Field","name":{"kind":"Name","value":"consent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"pushNotificationMarketing"}},{"kind":"Field","name":{"kind":"Name","value":"targetedAdvertising"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryCentre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserAccountQuery, GetUserAccountQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"scentregroupId"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"required"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storedAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasMarketplaceOrders"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetWestfieldDirectRetailerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWestfieldDirectRetailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfRetailerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"StringValue","value":"westfield-online","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerSizeGuide"}}]}}]}}]}}]} as unknown as DocumentNode<GetWestfieldDirectRetailerQuery, GetWestfieldDirectRetailerQueryVariables>;
export const WhatsOnFiltersCentreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatsOnFiltersCentre"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whatsHappeningFiltersCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backendTitle"}},{"kind":"Field","name":{"kind":"Name","value":"topicFiltersCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"experienceFiltersCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WhatsOnFiltersCentreQuery, WhatsOnFiltersCentreQueryVariables>;
export const WhatsOnCentreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatsOnCentre"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"centreId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"durationFromNow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whatsOnCentre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centreId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"centreId"}}},{"kind":"Argument","name":{"kind":"Name","value":"durationFromNow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"durationFromNow"}}},{"kind":"Argument","name":{"kind":"Name","value":"timeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"occurrencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"topicsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"experiencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CFEvent_HappeningsImage"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"hosted"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"}},{"kind":"Field","name":{"kind":"Name","value":"callsToActionCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"hideAt"}},{"kind":"Field","name":{"kind":"Name","value":"showAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"topicsCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"experiencesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CFOffer_HappeningsImage"}},{"kind":"Field","name":{"kind":"Name","value":"storesCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"centre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberExclusive"}},{"kind":"Field","name":{"kind":"Name","value":"highlightAttribute"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CFEvent_HappeningsImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"square"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CFOffer_HappeningsImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroImageSet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"master"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"square"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<WhatsOnCentreQuery, WhatsOnCentreQueryVariables>;
export const CentreDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CentreDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sharedCentreDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"centreFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentreDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sharedCentre"}},{"kind":"Field","name":{"kind":"Name","value":"navigationMenu"}},{"kind":"Field","name":{"kind":"Name","value":"features"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"correlationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"promotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creative"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jibestreamVenueId"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"telephoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"cinema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CentreDetailsQuery, CentreDetailsQueryVariables>;
export const CentreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Centre"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sharedCentre"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"centreFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<CentreQuery, CentreQueryVariables>;
export const GlobalStaticDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalStaticData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"giftCards"},"name":{"kind":"Name","value":"cfContentPageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"gift-cards","block":false}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_contains_all"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"country"}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"navigationMenu"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nationalHomepage"},"name":{"kind":"Name","value":"cfNationalHomepageCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_contains_all"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"country"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationMenu"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"centres"},"name":{"kind":"Name","value":"cfCentreCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status_not"},"value":{"kind":"StringValue","value":"Closed","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"sharedCentre"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"sharedCentre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CFCentre"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"suburb"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"centreFrontImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GlobalStaticDataQuery, GlobalStaticDataQueryVariables>;